/* tslint:disable */
/* eslint-disable */
/**
 * ZuzHQ Main Server
 * Primary API for ZuzHQ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptInvitationRequest
 */
export interface AcceptInvitationRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AcceptInvitationRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
}
/**
 * 
 * @export
 * @interface AddDefectRequest
 */
export interface AddDefectRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddDefectRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'checklist_item_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddDefectRequest
     */
    'severity': string;
}
/**
 * 
 * @export
 * @interface AddMemberRequest
 */
export interface AddMemberRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddMemberRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddMemberRequest
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddMemberRequest
     */
    'userUnid': string;
}
/**
 * 
 * @export
 * @interface AddSettlementsRequest
 */
export interface AddSettlementsRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddSettlementsRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddSettlementsRequest
     */
    'settlement_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface AddStopRequest
 */
export interface AddStopRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddStopRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsAddressCreate}
     * @memberof AddStopRequest
     */
    'address': RequestsAddressCreate;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'appointment_end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'appointment_start': string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'appointment_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddStopRequest
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'loading_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddStopRequest
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AddStopRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {Array<RequestsReference>}
     * @memberof AddStopRequest
     */
    'reference_numbers'?: Array<RequestsReference>;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {RequestsStopCreate}
     * @memberof AddStopRequest
     */
    'stop': RequestsStopCreate;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'street1': string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof AddStopRequest
     */
    'zip': string;
}
/**
 * 
 * @export
 * @interface AddWorkOrderTaskLaborRequest
 */
export interface AddWorkOrderTaskLaborRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'hours': number;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'performed_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskLaborRequest
     */
    'technician_name'?: string | null;
}
/**
 * 
 * @export
 * @interface AddWorkOrderTaskPartRequest
 */
export interface AddWorkOrderTaskPartRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AddWorkOrderTaskPartRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskPartRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddWorkOrderTaskPartRequest
     */
    'part_id': string;
    /**
     * 
     * @type {number}
     * @memberof AddWorkOrderTaskPartRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AddWorkOrderTaskPartRequest
     */
    'unit_cost'?: number | null;
}
/**
 * 
 * @export
 * @interface AssignRelayTransactionRequest
 */
export interface AssignRelayTransactionRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AssignRelayTransactionRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof AssignRelayTransactionRequest
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRelayTransactionRequest
     */
    'loadId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRelayTransactionRequest
     */
    'truckId'?: string | null;
}
/**
 * 
 * @export
 * @interface AssignRequest
 */
export interface AssignRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof AssignRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof AssignRequest
     */
    'carrier_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRequest
     */
    'dispatch_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignRequest
     */
    'driver_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AssignRequest
     */
    'notify_driver'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRequest
     */
    'trailer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignRequest
     */
    'truck_id'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkSaveRequest
 */
export interface BulkSaveRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof BulkSaveRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof BulkSaveRequest
     */
    'category': string;
    /**
     * 
     * @type {Array<RequestsBulkMappingEntry>}
     * @memberof BulkSaveRequest
     */
    'mappings': Array<RequestsBulkMappingEntry>;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ChangePasswordRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'oldPassword': string;
}
/**
 * 
 * @export
 * @interface CloneLoadRequest
 */
export interface CloneLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CloneLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CloneLoadRequest
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloneLoadRequest
     */
    'pickup_date'?: string | null;
}
/**
 * 
 * @export
 * @interface CompleteWorkOrderRequest
 */
export interface CompleteWorkOrderRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CompleteWorkOrderRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CompleteWorkOrderRequest
     */
    'completed_date': string;
    /**
     * 
     * @type {string}
     * @memberof CompleteWorkOrderRequest
     */
    'next_service_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompleteWorkOrderRequest
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteWorkOrderRequest
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteWorkOrderRequest
     */
    'technician_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompleteWorkOrderRequest
     */
    'vendor_invoice'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfirmDocumentUploadRequest
 */
export interface ConfirmDocumentUploadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ConfirmDocumentUploadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'documentType': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmDocumentUploadRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfirmDocumentUploadRequest
     */
    'sizeBytes': number;
}
/**
 * 
 * @export
 * @interface ConfirmForgotPasswordRequest
 */
export interface ConfirmForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmForgotPasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ConfirmSignUpRequest
 */
export interface ConfirmSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSignUpRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSignUpRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ConnectRelayRequest
 */
export interface ConnectRelayRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ConnectRelayRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ConnectRelayRequest
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof ConnectRelayRequest
     */
    'apiKey': string;
}
/**
 * 
 * @export
 * @interface ConvertQuoteRequest
 */
export interface ConvertQuoteRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ConvertQuoteRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ConvertQuoteRequest
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConvertQuoteRequest
     */
    'pickup_date'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCarrierRequest
 */
export interface CreateCarrierRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateCarrierRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof CreateCarrierRequest
     */
    'address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'cargo_insurance_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCarrierRequest
     */
    'cargo_insurance_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'cargo_insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'cargo_insurance_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {RequestsContact}
     * @memberof CreateCarrierRequest
     */
    'dispatch_contact'?: RequestsContact;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'dispatch_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'dispatch_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'dot_number': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'ein'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCarrierRequest
     */
    'equipment_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'fax'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCarrierRequest
     */
    'has_hazmat'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCarrierRequest
     */
    'has_team_drivers'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCarrierRequest
     */
    'has_twic'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'legal_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'liability_insurance_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCarrierRequest
     */
    'liability_insurance_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'liability_insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'liability_insurance_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'mc_number': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'phone': string;
    /**
     * 
     * @type {RequestsContact}
     * @memberof CreateCarrierRequest
     */
    'primary_contact'?: RequestsContact;
    /**
     * 
     * @type {number}
     * @memberof CreateCarrierRequest
     */
    'quick_pay_discount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'scac'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCarrierRequest
     */
    'service_regions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'workers_comp_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'workers_comp_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCarrierRequest
     */
    'workers_comp_provider'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCustomerContactRequest
 */
export interface CreateCustomerContactRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateCustomerContactRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomerContactRequest
     */
    'is_primary'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerContactRequest
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCustomerRequest
 */
export interface CreateCustomerRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateCustomerRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof CreateCustomerRequest
     */
    'billing_address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'code'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCustomerRequest
     */
    'commodity_types'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateCustomerRequest
     */
    'credit_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'dot_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'industry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'invoice_delivery_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'legal_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'mc_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof CreateCustomerRequest
     */
    'physical_address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'sales_rep_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'tax_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerRequest
     */
    'website'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDriverRecurringChargeRequest
 */
export interface CreateDriverRecurringChargeRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'effective_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'frequency': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRecurringChargeRequest
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface CreateDriverRequest
 */
export interface CreateDriverRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateDriverRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'cdl_class'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDriverRequest
     */
    'cdl_endorsements'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'cdl_expiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'cdl_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'cdl_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'hire_date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'medical_card_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'medical_expiration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDriverRequest
     */
    'pay_rate': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'pay_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'terminal_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDriverRequest
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface CreateExpenseRequest
 */
export interface CreateExpenseRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateExpenseRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof CreateExpenseRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'card_last_four'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'payment_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'receipt_doc_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateExpenseRequest
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFactoringBatchRequest
 */
export interface CreateFactoringBatchRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateFactoringBatchRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFactoringBatchRequest
     */
    'invoice_unids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateFactoringBatchRequest
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFormTemplateRequest
 */
export interface CreateFormTemplateRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateFormTemplateRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFormTemplateRequest
     */
    'event_types'?: Array<string>;
    /**
     * 
     * @type {Array<RequestsCreateYardFormFieldRequest>}
     * @memberof CreateFormTemplateRequest
     */
    'fields': Array<RequestsCreateYardFormFieldRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFormTemplateRequest
     */
    'is_active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFormTemplateRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    'yard_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateFuelPurchaseRequest
 */
export interface CreateFuelPurchaseRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateFuelPurchaseRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'fuel_card_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'fuel_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFuelPurchaseRequest
     */
    'gallons': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFuelPurchaseRequest
     */
    'price_per_gallon': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'purchase_date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFuelPurchaseRequest
     */
    'total_amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFuelPurchaseRequest
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateInspectionRequest
 */
export interface CreateInspectionRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateInspectionRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'checklist_items'?: string | null;
    /**
     * 
     * @type {Array<RequestsChecklistItemResult>}
     * @memberof CreateInspectionRequest
     */
    'checklist_results'?: Array<RequestsChecklistItemResult>;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'defects'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'driver_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'driver_signature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'inspected_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'inspection_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateInspectionRequest
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'overall_condition'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateInspectionRequest
     */
    'reefer_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'trailer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateInspectionRequest
     */
    'truck_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateInvitationRequest
 */
export interface CreateInvitationRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateInvitationRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationRequest
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateLoadCheckCallRequest
 */
export interface CreateLoadCheckCallRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateLoadCheckCallRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadCheckCallRequest
     */
    'check_call_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadCheckCallRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadCheckCallRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadCheckCallRequest
     */
    'return_temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadCheckCallRequest
     */
    'setpoint_temperature'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadCheckCallRequest
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadCheckCallRequest
     */
    'stop_id'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateLoadRequest
 */
export interface CreateLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'account_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'commodity_class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'customer_sale_agent_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'customer_service_user_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'empty_miles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLoadRequest
     */
    'hazmat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'load_planner_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'pallet_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'parse_document_unid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'piece_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'po_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'previous_stop_load_id'?: string | null;
    /**
     * 
     * @type {RequestsLoadRateCreate}
     * @memberof CreateLoadRequest
     */
    'rate'?: RequestsLoadRateCreate;
    /**
     * 
     * @type {Array<RequestsReference>}
     * @memberof CreateLoadRequest
     */
    'references'?: Array<RequestsReference>;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'sales_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'special_instructions'?: string | null;
    /**
     * 
     * @type {Array<RequestsStopCreate>}
     * @memberof CreateLoadRequest
     */
    'stops': Array<RequestsStopCreate>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLoadRequest
     */
    'team_required'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLoadRequest
     */
    'trip_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLoadRequest
     */
    'weight_lbs'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateMaintenanceRequest
 */
export interface CreateMaintenanceRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateMaintenanceRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'engine_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'equipment_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'interval_days'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'interval_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'interval_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'maintenance_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'next_due_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'next_due_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'next_due_odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMaintenanceRequest
     */
    'recurring'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateMaintenanceRequest
     */
    'reefer_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'scheduled_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMaintenanceRequest
     */
    'vmrs_code'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateMappingRequest
 */
export interface CreateMappingRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateMappingRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'category': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMappingRequest
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'qbExpenseAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'qbExpenseAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'qbRevenueAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'qbRevenueAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMappingRequest
     */
    'tag': string;
}
/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateOrganizationRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsOrganizationAddress}
     * @memberof CreateOrganizationRequest
     */
    'address'?: RequestsOrganizationAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'businessMode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'dateFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'distanceUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'dotNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'legalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'mcNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'scac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'taxId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOrganizationRequest
     */
    'timeZoneOffsetMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    'timeZoneText': string;
}
/**
 * 
 * @export
 * @interface CreatePartRequest
 */
export interface CreatePartRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreatePartRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'binLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'maximumStock'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'minimumStock'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'partNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'preferredSupplier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'quantityOnHand'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'reorderQuantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'unitCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequest
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'warrantyMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePartRequest
     */
    'warrantyMonths'?: number | null;
}
/**
 * 
 * @export
 * @interface CreatePaystubRequest
 */
export interface CreatePaystubRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreatePaystubRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof CreatePaystubRequest
     */
    'credits'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePaystubRequest
     */
    'driver_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaystubRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePaystubRequest
     */
    'pay_date'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePaystubRequest
     */
    'settlement_ids'?: Array<string>;
    /**
     * 
     * @type {Array<RequestsPaystubTaxItemRequest>}
     * @memberof CreatePaystubRequest
     */
    'tax_items'?: Array<RequestsPaystubTaxItemRequest>;
}
/**
 * 
 * @export
 * @interface CreateQuoteRequest
 */
export interface CreateQuoteRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateQuoteRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'accessorials'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'customer_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'customer_rate': number;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'destination_city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'destination_state': string;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'destination_zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'fuel_surcharge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateQuoteRequest
     */
    'hazmat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'origin_city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'origin_state': string;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'origin_zip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'total_miles'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'valid_from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateQuoteRequest
     */
    'valid_until'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateQuoteRequest
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateRecurringLoadRequest
 */
export interface CreateRecurringLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateRecurringLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'customer_id': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'day_interval'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'default_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'delivery_time_hour'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'destination_city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'destination_state': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'generate_lead_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'month_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'origin_city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'origin_state': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'pickup_time_hour'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'recurrence_pattern': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecurringLoadRequest
     */
    'skip_dates'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'start_date': string;
    /**
     * 
     * @type {Array<RequestsCreateRecurringLoadStopRequest>}
     * @memberof CreateRecurringLoadRequest
     */
    'stops': Array<RequestsCreateRecurringLoadStopRequest>;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringLoadRequest
     */
    'template_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringLoadRequest
     */
    'transit_days'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecurringLoadRequest
     */
    'week_days'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateSpotRequest
 */
export interface CreateSpotRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateSpotRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSpotRequest
     */
    'spot_type': string;
}
/**
 * 
 * @export
 * @interface CreateStripeCheckoutRequest
 */
export interface CreateStripeCheckoutRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateStripeCheckoutRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCheckoutRequest
     */
    'customerEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCheckoutRequest
     */
    'organizationUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCheckoutRequest
     */
    'planUnid': string;
}
/**
 * 
 * @export
 * @interface CreateTechnicianRequest
 */
export interface CreateTechnicianRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateTechnicianRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'certifications'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'hire_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTechnicianRequest
     */
    'hourly_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTechnicianRequest
     */
    'labor_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTechnicianRequest
     */
    'specializations'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateTemplateRequest
 */
export interface CreateTemplateRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateTemplateRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'default_fuel_surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'default_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'delivery_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'estimated_miles'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTemplateRequest
     */
    'hazmat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateRequest
     */
    'pickup_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTemplateRequest
     */
    'required_endorsements'?: Array<string>;
    /**
     * 
     * @type {Array<RequestsCreateLoadTemplateStopRequest>}
     * @memberof CreateTemplateRequest
     */
    'stops': Array<RequestsCreateLoadTemplateStopRequest>;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateRequest
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateTrailerNoteRequest
 */
export interface CreateTrailerNoteRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateTrailerNoteRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerNoteRequest
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface CreateTrailerRequest
 */
export interface CreateTrailerRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateTrailerRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrailerRequest
     */
    'air_ride'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'axles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'cubic_feet'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'current_value'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'door_height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'door_width'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrailerRequest
     */
    'e_tracks'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'gps_device_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'gps_provider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'inspection_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'lease_company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'lease_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'length': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'license_plate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'license_plate_state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrailerRequest
     */
    'lift_gate'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'load_locks'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'make': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'max_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'monthly_payment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'owner_driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'ownership'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'pallet_positions'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'purchase_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'purchase_price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'reefer_make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'reefer_model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'reefer_serial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'registration_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'tare_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'trailer_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'unit_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrailerRequest
     */
    'vented'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTrailerRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTrailerRequest
     */
    'year': number;
}
/**
 * 
 * @export
 * @interface CreateTruckRequest
 */
export interface CreateTruckRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateTruckRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'current_value'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'eld_device_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'eld_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'engine_make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'engine_model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'fifth_wheel_height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'fuel_capacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'fuel_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'gvwr'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'horsepower'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'inspection_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'insurance_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'lease_company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'lease_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'license_plate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'license_plate_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'make': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'monthly_payment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'owner_driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'ownership'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'purchase_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'purchase_price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'registration_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'transmission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'truck_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'unit_number': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTruckRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'wheel_base'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateTruckRequest
     */
    'year': number;
}
/**
 * 
 * @export
 * @interface CreateWorkOrderFromDefectRequest
 */
export interface CreateWorkOrderFromDefectRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'assigned_to_technician_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'is_internal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'priority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'vendor_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromDefectRequest
     */
    'vendor_phone'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateWorkOrderFromMaintenanceRequest
 */
export interface CreateWorkOrderFromMaintenanceRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'is_internal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'priority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'vendor_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderFromMaintenanceRequest
     */
    'vendor_phone'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateWorkOrderRequest
 */
export interface CreateWorkOrderRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateWorkOrderRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'assigned_to_technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'due_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'equipment_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderRequest
     */
    'estimated_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderRequest
     */
    'estimated_labor_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderRequest
     */
    'estimated_parts_cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'inspection_defect_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'inspection_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkOrderRequest
     */
    'is_internal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderRequest
     */
    'odometer_reported'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'priority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'reported_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'reported_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'scheduled_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'scheduled_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'symptoms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'vendor_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'vendor_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderRequest
     */
    'vendor_phone'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateWorkOrderTaskRequest
 */
export interface CreateWorkOrderTaskRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateWorkOrderTaskRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderTaskRequest
     */
    'assigned_to_technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderTaskRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderTaskRequest
     */
    'estimated_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderTaskRequest
     */
    'estimated_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderTaskRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkOrderTaskRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderTaskRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkOrderTaskRequest
     */
    'vmrs_code'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateYardRequest
 */
export interface CreateYardRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof CreateYardRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {any}
     * @memberof CreateYardRequest
     */
    'address'?: any;
    /**
     * 
     * @type {number}
     * @memberof CreateYardRequest
     */
    'capacity_trailers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateYardRequest
     */
    'capacity_trucks'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateYardRequest
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateYardRequest
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateYardRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateYardRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateYardRequest
     */
    'radius_meters'?: number | null;
}
/**
 * 
 * @export
 * @interface EstimateLoadRequest
 */
export interface EstimateLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof EstimateLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'driverPayRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLoadRequest
     */
    'driverPayType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLoadRequest
     */
    'driverType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLoadRequest
     */
    'driverUnid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'estimatedHoursForLoad'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'estimatedTolls'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'factoringFeePercent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'fuelPricePerGallon'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'fuelSurcharge'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'insurancePerMile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'lineHaul'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'maintenancePerMile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'mpg'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLoadRequest
     */
    'routePreference'?: string | null;
    /**
     * 
     * @type {Array<RequestsCalculatorStop>}
     * @memberof EstimateLoadRequest
     */
    'stops': Array<RequestsCalculatorStop>;
    /**
     * 
     * @type {number}
     * @memberof EstimateLoadRequest
     */
    'targetMarginPercent'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EstimateLoadRequest
     */
    'truckUnid'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneratePDFRequest
 */
export interface GeneratePDFRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof GeneratePDFRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratePDFRequest
     */
    'document_unids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateRecurringLoadRequest
 */
export interface GenerateRecurringLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof GenerateRecurringLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof GenerateRecurringLoadRequest
     */
    'pickup_date'?: string | null;
}
/**
 * 
 * @export
 * @interface GetCarrierRateHistoryRequest
 */
export interface GetCarrierRateHistoryRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof GetCarrierRateHistoryRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof GetCarrierRateHistoryRequest
     */
    'destCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCarrierRateHistoryRequest
     */
    'destState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCarrierRateHistoryRequest
     */
    'originCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetCarrierRateHistoryRequest
     */
    'originState': string;
    /**
     * 
     * @type {string}
     * @memberof GetCarrierRateHistoryRequest
     */
    'period'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetCarrierRateHistoryRequest
     */
    'radius'?: number | null;
}
/**
 * 
 * @export
 * @interface GetDocumentUploadUrlRequest
 */
export interface GetDocumentUploadUrlRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof GetDocumentUploadUrlRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentUploadUrlRequest
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentUploadUrlRequest
     */
    'documentType': string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentUploadUrlRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentUploadUrlRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDocumentUploadUrlRequest
     */
    'filename': string;
}
/**
 * 
 * @export
 * @interface HandleQBCallbackRequest
 */
export interface HandleQBCallbackRequest {
    /**
     * 
     * @type {string}
     * @memberof HandleQBCallbackRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof HandleQBCallbackRequest
     */
    'realmId': string;
    /**
     * 
     * @type {string}
     * @memberof HandleQBCallbackRequest
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface HandleSamsaraCallbackRequest
 */
export interface HandleSamsaraCallbackRequest {
    /**
     * 
     * @type {string}
     * @memberof HandleSamsaraCallbackRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof HandleSamsaraCallbackRequest
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface HandleStripeWebhookRequest
 */
export interface HandleStripeWebhookRequest {
    /**
     * 
     * @type {RequestsWithStripeSignature}
     * @memberof HandleStripeWebhookRequest
     */
    'WithStripeSignature'?: RequestsWithStripeSignature;
}
/**
 * 
 * @export
 * @interface HandlersSocialLoginURLResponse
 */
export interface HandlersSocialLoginURLResponse {
    /**
     * 
     * @type {HandlersSocialLoginURLResponseData}
     * @memberof HandlersSocialLoginURLResponse
     */
    'data'?: HandlersSocialLoginURLResponseData;
    /**
     * 
     * @type {string}
     * @memberof HandlersSocialLoginURLResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandlersSocialLoginURLResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface HandlersSocialLoginURLResponseData
 */
export interface HandlersSocialLoginURLResponseData {
    /**
     * 
     * @type {string}
     * @memberof HandlersSocialLoginURLResponseData
     */
    'loginURL'?: string;
}
/**
 * 
 * @export
 * @interface HandlersTokenExchangeResponse
 */
export interface HandlersTokenExchangeResponse {
    /**
     * 
     * @type {HandlersTokenExchangeResponseData}
     * @memberof HandlersTokenExchangeResponse
     */
    'data'?: HandlersTokenExchangeResponseData;
    /**
     * 
     * @type {string}
     * @memberof HandlersTokenExchangeResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandlersTokenExchangeResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface HandlersTokenExchangeResponseData
 */
export interface HandlersTokenExchangeResponseData {
    /**
     * 
     * @type {ResponsesUserAuth}
     * @memberof HandlersTokenExchangeResponseData
     */
    'userAuth'?: ResponsesUserAuth;
}
/**
 * 
 * @export
 * @interface ImportFuelPurchasesRequest
 */
export interface ImportFuelPurchasesRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ImportFuelPurchasesRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<RequestsCreateFuelRequest>}
     * @memberof ImportFuelPurchasesRequest
     */
    'purchases': Array<RequestsCreateFuelRequest>;
}
/**
 * 
 * @export
 * @interface InitiatePhoneSignInRequest
 */
export interface InitiatePhoneSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof InitiatePhoneSignInRequest
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface LogEventRequest
 */
export interface LogEventRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof LogEventRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'condition'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogEventRequest
     */
    'document_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'equipment_type': string;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'event_type': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LogEventRequest
     */
    'form_responses'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof LogEventRequest
     */
    'loaded'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'occurred_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'seal_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LogEventRequest
     */
    'sealed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'spot_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'spot_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'trailer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEventRequest
     */
    'truck_id'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginInUserWithPasswordRequest
 */
export interface LoginInUserWithPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginInUserWithPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginInUserWithPasswordRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginInUserWithPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ManualMatchFleetrockUnitRequest
 */
export interface ManualMatchFleetrockUnitRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ManualMatchFleetrockUnitRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ManualMatchFleetrockUnitRequest
     */
    'fleetrockId': string;
    /**
     * 
     * @type {string}
     * @memberof ManualMatchFleetrockUnitRequest
     */
    'truckUnid': string;
}
/**
 * 
 * @export
 * @interface ManualMatchRelayDriverRequest
 */
export interface ManualMatchRelayDriverRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ManualMatchRelayDriverRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ManualMatchRelayDriverRequest
     */
    'driverUnid': string;
    /**
     * 
     * @type {string}
     * @memberof ManualMatchRelayDriverRequest
     */
    'relayDriverId': string;
}
/**
 * 
 * @export
 * @interface MapAccountsRequest
 */
export interface MapAccountsRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof MapAccountsRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<RequestsQBAccountMappingEntry>}
     * @memberof MapAccountsRequest
     */
    'mappings': Array<RequestsQBAccountMappingEntry>;
}
/**
 * 
 * @export
 * @interface ParseDocumentRequest
 */
export interface ParseDocumentRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ParseDocumentRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ParseDocumentRequest
     */
    'document_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParseDocumentRequest
     */
    'document_unid': string;
}
/**
 * 
 * @export
 * @interface RecordTenderResponseRequest
 */
export interface RecordTenderResponseRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof RecordTenderResponseRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'driverPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'loadId': string;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'response': string;
    /**
     * 
     * @type {string}
     * @memberof RecordTenderResponseRequest
     */
    'truckNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface ReorderStopsRequest
 */
export interface ReorderStopsRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ReorderStopsRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderStopsRequest
     */
    'stop_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface RequestsAccessorialCharge
 */
export interface RequestsAccessorialCharge {
    /**
     * 
     * @type {number}
     * @memberof RequestsAccessorialCharge
     */
    'amount': number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsAccessorialCharge
     */
    'billable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsAccessorialCharge
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsAccessorialCharge
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsAccessorialCharge
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface RequestsAddress
 */
export interface RequestsAddress {
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddress
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface RequestsAddressCreate
 */
export interface RequestsAddressCreate {
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestsAddressCreate
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsAddressCreate
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'street1': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsAddressCreate
     */
    'zip': string;
}
/**
 * 
 * @export
 * @interface RequestsBulkMappingEntry
 */
export interface RequestsBulkMappingEntry {
    /**
     * 
     * @type {boolean}
     * @memberof RequestsBulkMappingEntry
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestsBulkMappingEntry
     */
    'qbExpenseAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsBulkMappingEntry
     */
    'qbExpenseAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsBulkMappingEntry
     */
    'qbRevenueAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsBulkMappingEntry
     */
    'qbRevenueAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsBulkMappingEntry
     */
    'tag': string;
}
/**
 * 
 * @export
 * @interface RequestsCalculatorStop
 */
export interface RequestsCalculatorStop {
    /**
     * 
     * @type {string}
     * @memberof RequestsCalculatorStop
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCalculatorStop
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCalculatorStop
     */
    'street1': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCalculatorStop
     */
    'zip': string;
}
/**
 * 
 * @export
 * @interface RequestsChecklistItemResult
 */
export interface RequestsChecklistItemResult {
    /**
     * 
     * @type {string}
     * @memberof RequestsChecklistItemResult
     */
    'category': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestsChecklistItemResult
     */
    'document_unids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RequestsChecklistItemResult
     */
    'item': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsChecklistItemResult
     */
    'notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsChecklistItemResult
     */
    'passed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestsChecklistItemResult
     */
    'severity'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestsContact
 */
export interface RequestsContact {
    /**
     * 
     * @type {string}
     * @memberof RequestsContact
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsContact
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsContact
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface RequestsCreateFuelRequest
 */
export interface RequestsCreateFuelRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'Authorization': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'OrganizationUnid': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'fuel_card_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'fuel_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateFuelRequest
     */
    'gallons': number;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateFuelRequest
     */
    'price_per_gallon': number;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'purchase_date': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateFuelRequest
     */
    'total_amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateFuelRequest
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestsCreateLoadTemplateStopRequest
 */
export interface RequestsCreateLoadTemplateStopRequest {
    /**
     * 
     * @type {RequestsAddress}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'address': RequestsAddress;
    /**
     * 
     * @type {RequestsContact}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'contact'?: RequestsContact;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'default_window_end_hour'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'default_window_start_hour'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'estimated_duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'miles_to_next'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'photos_required'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'pod_required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'signature_required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'stop_number': number;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateLoadTemplateStopRequest
     */
    'stop_type': string;
}
/**
 * 
 * @export
 * @interface RequestsCreateRecurringLoadStopRequest
 */
export interface RequestsCreateRecurringLoadStopRequest {
    /**
     * 
     * @type {RequestsAddress}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'address': RequestsAddress;
    /**
     * 
     * @type {RequestsContact}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'contact'?: RequestsContact;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'day_offset'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'stop_number': number;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'stop_type': string;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateRecurringLoadStopRequest
     */
    'time_hour'?: number;
}
/**
 * 
 * @export
 * @interface RequestsCreateYardFormFieldRequest
 */
export interface RequestsCreateYardFormFieldRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'default_value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'field_type': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'label': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsCreateYardFormFieldRequest
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface RequestsEventIntelligenceEventItem
 */
export interface RequestsEventIntelligenceEventItem {
    /**
     * 
     * @type {string}
     * @memberof RequestsEventIntelligenceEventItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsEventIntelligenceEventItem
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface RequestsLoadRateCreate
 */
export interface RequestsLoadRateCreate {
    /**
     * 
     * @type {Array<RequestsAccessorialCharge>}
     * @memberof RequestsLoadRateCreate
     */
    'accessorials'?: Array<RequestsAccessorialCharge>;
    /**
     * 
     * @type {number}
     * @memberof RequestsLoadRateCreate
     */
    'fuel_surcharge'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsLoadRateCreate
     */
    'fuel_surcharge_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsLoadRateCreate
     */
    'line_haul'?: number | null;
}
/**
 * 
 * @export
 * @interface RequestsOrganizationAddress
 */
export interface RequestsOrganizationAddress {
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsOrganizationAddress
     */
    'street'?: string;
}
/**
 * 
 * @export
 * @interface RequestsPaystubTaxItemRequest
 */
export interface RequestsPaystubTaxItemRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestsPaystubTaxItemRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof RequestsPaystubTaxItemRequest
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsPaystubTaxItemRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface RequestsQBAccountMappingEntry
 */
export interface RequestsQBAccountMappingEntry {
    /**
     * 
     * @type {string}
     * @memberof RequestsQBAccountMappingEntry
     */
    'qbAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsQBAccountMappingEntry
     */
    'qbAccountName': string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsQBAccountMappingEntry
     */
    'syncEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestsQBAccountMappingEntry
     */
    'tmsCategory': string;
}
/**
 * 
 * @export
 * @interface RequestsReference
 */
export interface RequestsReference {
    /**
     * 
     * @type {string}
     * @memberof RequestsReference
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsReference
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface RequestsSettlementItemRequest
 */
export interface RequestsSettlementItemRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestsSettlementItemRequest
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'load_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsSettlementItemRequest
     */
    'load_revenue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'pay_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsSettlementItemRequest
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsSettlementItemRequest
     */
    'rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestsSettlementItemRequest
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsSettlementItemRequest
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface RequestsStopCreate
 */
export interface RequestsStopCreate {
    /**
     * 
     * @type {RequestsAddressCreate}
     * @memberof RequestsStopCreate
     */
    'address': RequestsAddressCreate;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'appointment_end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'appointment_start': string;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'appointment_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'loading_type'?: string | null;
    /**
     * 
     * @type {Array<RequestsReference>}
     * @memberof RequestsStopCreate
     */
    'reference_numbers'?: Array<RequestsReference>;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestsStopCreate
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface RequestsWithCognitoAuth
 */
export interface RequestsWithCognitoAuth {
    /**
     * 
     * @type {string}
     * @memberof RequestsWithCognitoAuth
     */
    'Authorization': string;
}
/**
 * 
 * @export
 * @interface RequestsWithCognitoIDToken
 */
export interface RequestsWithCognitoIDToken {
    /**
     * 
     * @type {string}
     * @memberof RequestsWithCognitoIDToken
     */
    'IDToken': string;
}
/**
 * 
 * @export
 * @interface RequestsWithStripeSignature
 */
export interface RequestsWithStripeSignature {
    /**
     * 
     * @type {string}
     * @memberof RequestsWithStripeSignature
     */
    'StripeSignature'?: string;
}
/**
 * 
 * @export
 * @interface ResendConfirmationCodeRequest
 */
export interface ResendConfirmationCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendConfirmationCodeRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ResolveDefectRequest
 */
export interface ResolveDefectRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof ResolveDefectRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof ResolveDefectRequest
     */
    'resolution': string;
    /**
     * 
     * @type {string}
     * @memberof ResolveDefectRequest
     */
    'resolved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResolveDefectRequest
     */
    'work_order_id'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegration
 */
export interface ResponsesAPIKeyIntegration {
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'integration'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'integrationUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegration
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegrationData
 */
export interface ResponsesAPIKeyIntegrationData {
    /**
     * 
     * @type {ResponsesAPIKeyIntegration}
     * @memberof ResponsesAPIKeyIntegrationData
     */
    'integration'?: ResponsesAPIKeyIntegration;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegrationInfo
 */
export interface ResponsesAPIKeyIntegrationInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'integration'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'integrationUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'unid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAPIKeyIntegrationInfo
     */
    'userId'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegrationListData
 */
export interface ResponsesAPIKeyIntegrationListData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAPIKeyIntegrationListData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesAPIKeyIntegrationInfo>}
     * @memberof ResponsesAPIKeyIntegrationListData
     */
    'integrations'?: Array<ResponsesAPIKeyIntegrationInfo>;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegrationListResponse
 */
export interface ResponsesAPIKeyIntegrationListResponse {
    /**
     * 
     * @type {ResponsesAPIKeyIntegrationListData}
     * @memberof ResponsesAPIKeyIntegrationListResponse
     */
    'data'?: ResponsesAPIKeyIntegrationListData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAPIKeyIntegrationResponse
 */
export interface ResponsesAPIKeyIntegrationResponse {
    /**
     * 
     * @type {ResponsesAPIKeyIntegrationData}
     * @memberof ResponsesAPIKeyIntegrationResponse
     */
    'data'?: ResponsesAPIKeyIntegrationData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAPIKeyIntegrationResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAccessorialCharge
 */
export interface ResponsesAccessorialCharge {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAccessorialCharge
     */
    'amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesAccessorialCharge
     */
    'billable'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAccessorialCharge
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAccessorialCharge
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAccessorialCharge
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAccessorialCharge
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesActiveLoadSummary
 */
export interface ResponsesActiveLoadSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'destination_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'destination_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'equipment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'load_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'origin_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'origin_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesActiveLoadSummary
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAddress
 */
export interface ResponsesAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAddress
     */
    'line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAddress
     */
    'line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAddress
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAgingBucket
 */
export interface ResponsesAgingBucket {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingBucket
     */
    'current'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingBucket
     */
    'days_1_30'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingBucket
     */
    'days_31_60'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingBucket
     */
    'days_61_90'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingBucket
     */
    'days_90_plus'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesAgingCustomer
 */
export interface ResponsesAgingCustomer {
    /**
     * 
     * @type {ResponsesAgingBucket}
     * @memberof ResponsesAgingCustomer
     */
    'aging'?: ResponsesAgingBucket;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAgingCustomer
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAgingCustomer
     */
    'customer_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingCustomer
     */
    'total_outstanding'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesAgingReportResponse
 */
export interface ResponsesAgingReportResponse {
    /**
     * 
     * @type {ResponsesAgingReportResponseData}
     * @memberof ResponsesAgingReportResponse
     */
    'data'?: ResponsesAgingReportResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAgingReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAgingReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAgingReportResponseData
 */
export interface ResponsesAgingReportResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesAgingReportResponseData
     */
    'as_of_date'?: string;
    /**
     * 
     * @type {Array<ResponsesAgingCustomer>}
     * @memberof ResponsesAgingReportResponseData
     */
    'by_customer'?: Array<ResponsesAgingCustomer>;
    /**
     * 
     * @type {ResponsesAgingBucket}
     * @memberof ResponsesAgingReportResponseData
     */
    'summary'?: ResponsesAgingBucket;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAgingReportResponseData
     */
    'total_outstanding'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesAppliedRates
 */
export interface ResponsesAppliedRates {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAppliedRates
     */
    'driverPayRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAppliedRates
     */
    'driverPaySource'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAppliedRates
     */
    'driverPayType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAppliedRates
     */
    'driverType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAppliedRates
     */
    'fuelPricePerGallon'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAppliedRates
     */
    'fuelPriceSource'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAppliedRates
     */
    'insurancePerMile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAppliedRates
     */
    'maintenancePerMile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAppliedRates
     */
    'mpg'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAppliedRates
     */
    'mpgSource'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAssetLocationResponse
 */
export interface ResponsesAssetLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesAssetLocationResponse
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAssetLocationResponse
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAssetLocationResponse
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAssetLocationResponse
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAssetLocationResponse
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAssetLocationResponse
     */
    'odometerMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAssetLocationResponse
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAssetLocationResponse
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAssetLocationResponse
     */
    'updatedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableCarrier
 */
export interface ResponsesAvailableCarrier {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAvailableCarrier
     */
    'avgRating'?: number;
    /**
     * 
     * @type {ResponsesCarrierContact}
     * @memberof ResponsesAvailableCarrier
     */
    'contact'?: ResponsesCarrierContact;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesAvailableCarrier
     */
    'equipmentTypes'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAvailableCarrier
     */
    'historicalLoads'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableCarrier
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableCarrier
     */
    'lastUsed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableCarrier
     */
    'mcNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableCarrier
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAvailableCarrier
     */
    'onTimeRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableCarrier
     */
    'safetyRating'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableDriversResponse
 */
export interface ResponsesAvailableDriversResponse {
    /**
     * 
     * @type {ResponsesAvailableDriversResponseData}
     * @memberof ResponsesAvailableDriversResponse
     */
    'data'?: ResponsesAvailableDriversResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableDriversResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableDriversResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableDriversResponseData
 */
export interface ResponsesAvailableDriversResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverAvailability>}
     * @memberof ResponsesAvailableDriversResponseData
     */
    'drivers'?: Array<ResponsesDriverAvailability>;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTrailer
 */
export interface ResponsesAvailableTrailer {
    /**
     * 
     * @type {number}
     * @memberof ResponsesAvailableTrailer
     */
    'length'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesAvailableTrailer
     */
    'liftGate'?: boolean;
    /**
     * 
     * @type {ResponsesLocation}
     * @memberof ResponsesAvailableTrailer
     */
    'location'?: ResponsesLocation;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrailer
     */
    'trailerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrailer
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrailer
     */
    'unitNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTrailersResponse
 */
export interface ResponsesAvailableTrailersResponse {
    /**
     * 
     * @type {ResponsesAvailableTrailersResponseData}
     * @memberof ResponsesAvailableTrailersResponse
     */
    'data'?: ResponsesAvailableTrailersResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrailersResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrailersResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTrailersResponseData
 */
export interface ResponsesAvailableTrailersResponseData {
    /**
     * 
     * @type {Array<ResponsesAvailableTrailer>}
     * @memberof ResponsesAvailableTrailersResponseData
     */
    'trailers'?: Array<ResponsesAvailableTrailer>;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTruck
 */
export interface ResponsesAvailableTruck {
    /**
     * 
     * @type {ResponsesLocation}
     * @memberof ResponsesAvailableTruck
     */
    'location'?: ResponsesLocation;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTruck
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTruck
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTruck
     */
    'truckType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTruck
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTruck
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesAvailableTruck
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTrucksResponse
 */
export interface ResponsesAvailableTrucksResponse {
    /**
     * 
     * @type {ResponsesAvailableTrucksResponseData}
     * @memberof ResponsesAvailableTrucksResponse
     */
    'data'?: ResponsesAvailableTrucksResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrucksResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesAvailableTrucksResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesAvailableTrucksResponseData
 */
export interface ResponsesAvailableTrucksResponseData {
    /**
     * 
     * @type {Array<ResponsesAvailableTruck>}
     * @memberof ResponsesAvailableTrucksResponseData
     */
    'trucks'?: Array<ResponsesAvailableTruck>;
}
/**
 * 
 * @export
 * @interface ResponsesCDLInfo
 */
export interface ResponsesCDLInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'class'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'issue_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCDLInfo
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrier
 */
export interface ResponsesCarrier {
    /**
     * 
     * @type {ResponsesCarrierAddress}
     * @memberof ResponsesCarrier
     */
    'address'?: ResponsesCarrierAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'authorityDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'authorityStatus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'avgDaysToPayment'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'cargoInsuranceExpiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'cargoInsuranceLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'cargoInsurancePolicy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'cargoInsuranceProvider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'claimsAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'claimsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'crashTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'dba'?: string | null;
    /**
     * 
     * @type {ResponsesCarrierContact}
     * @memberof ResponsesCarrier
     */
    'dispatchContact'?: ResponsesCarrierContact;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'dispatchEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'dispatchPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'dotNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'driverCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'ein'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'fax'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'fleetSize'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'hasHazmat'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'hasTeamDrivers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'hasTwic'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'inspectionTotal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'lastVerifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'legalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'liabilityInsuranceExpiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'liabilityInsuranceLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'liabilityInsurancePolicy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'liabilityInsuranceProvider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'mcNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'outOfServicePercent'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'paymentTerms'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'phone'?: string;
    /**
     * 
     * @type {ResponsesCarrierContact}
     * @memberof ResponsesCarrier
     */
    'primaryContact'?: ResponsesCarrierContact;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'quickPayDiscount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'ratingNotes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'rmisVerified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'saferWatchVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'safetyRating'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'safetyRatingDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'scac'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesCarrier
     */
    'serviceRegions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'taxId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrier
     */
    'totalPaid'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'verifiedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrier
     */
    'w9OnFile'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'workersCompExpiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'workersCompPolicy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrier
     */
    'workersCompProvider'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierAddress
 */
export interface ResponsesCarrierAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierAddress
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierContact
 */
export interface ResponsesCarrierContact {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierContact
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierContact
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierContact
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierListResponse
 */
export interface ResponsesCarrierListResponse {
    /**
     * 
     * @type {ResponsesCarrierListResponseData}
     * @memberof ResponsesCarrierListResponse
     */
    'data'?: ResponsesCarrierListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierListResponseData
 */
export interface ResponsesCarrierListResponseData {
    /**
     * 
     * @type {Array<ResponsesCarrierSummary>}
     * @memberof ResponsesCarrierListResponseData
     */
    'carriers'?: Array<ResponsesCarrierSummary>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesCarrierListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierPerformanceMetrics
 */
export interface ResponsesCarrierPerformanceMetrics {
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'avgRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'avgResponseTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'claimsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'completedLoads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'declineRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'onTimeDelivery'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'onTimePickup'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierPerformanceMetrics
     */
    'totalLoads'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierPerformanceResponse
 */
export interface ResponsesCarrierPerformanceResponse {
    /**
     * 
     * @type {ResponsesCarrierPerformanceResponseData}
     * @memberof ResponsesCarrierPerformanceResponse
     */
    'data'?: ResponsesCarrierPerformanceResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierPerformanceResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierPerformanceResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierPerformanceResponseData
 */
export interface ResponsesCarrierPerformanceResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierPerformanceResponseData
     */
    'carrierId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierPerformanceResponseData
     */
    'carrierName'?: string;
    /**
     * 
     * @type {ResponsesCarrierPerformanceMetrics}
     * @memberof ResponsesCarrierPerformanceResponseData
     */
    'metrics'?: ResponsesCarrierPerformanceMetrics;
    /**
     * 
     * @type {ResponsesTimePeriod}
     * @memberof ResponsesCarrierPerformanceResponseData
     */
    'period'?: ResponsesTimePeriod;
    /**
     * 
     * @type {Array<ResponsesCarrierRecentLoad>}
     * @memberof ResponsesCarrierPerformanceResponseData
     */
    'recentLoads'?: Array<ResponsesCarrierRecentLoad>;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierRateHistoryResponse
 */
export interface ResponsesCarrierRateHistoryResponse {
    /**
     * 
     * @type {ResponsesCarrierRateHistoryResponseData}
     * @memberof ResponsesCarrierRateHistoryResponse
     */
    'data'?: ResponsesCarrierRateHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRateHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRateHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierRateHistoryResponseData
 */
export interface ResponsesCarrierRateHistoryResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRateHistoryResponseData
     */
    'carrierId'?: string;
    /**
     * 
     * @type {Array<ResponsesRateHistoryEntry>}
     * @memberof ResponsesCarrierRateHistoryResponseData
     */
    'history'?: Array<ResponsesRateHistoryEntry>;
    /**
     * 
     * @type {ResponsesCarrierRateHistoryResponseDataLane}
     * @memberof ResponsesCarrierRateHistoryResponseData
     */
    'lane'?: ResponsesCarrierRateHistoryResponseDataLane;
    /**
     * 
     * @type {ResponsesRateHistoryStats}
     * @memberof ResponsesCarrierRateHistoryResponseData
     */
    'stats'?: ResponsesRateHistoryStats;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierRateHistoryResponseDataLane
 */
export interface ResponsesCarrierRateHistoryResponseDataLane {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRateHistoryResponseDataLane
     */
    'destination'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRateHistoryResponseDataLane
     */
    'origin'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierRecentLoad
 */
export interface ResponsesCarrierRecentLoad {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRecentLoad
     */
    'deliveredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRecentLoad
     */
    'destination'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRecentLoad
     */
    'loadNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrierRecentLoad
     */
    'onTime'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierRecentLoad
     */
    'origin'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCarrierRecentLoad
     */
    'rate'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierResponse
 */
export interface ResponsesCarrierResponse {
    /**
     * 
     * @type {ResponsesCarrierResponseData}
     * @memberof ResponsesCarrierResponse
     */
    'data'?: ResponsesCarrierResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierResponseData
 */
export interface ResponsesCarrierResponseData {
    /**
     * 
     * @type {ResponsesCarrier}
     * @memberof ResponsesCarrierResponseData
     */
    'carrier'?: ResponsesCarrier;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierSummary
 */
export interface ResponsesCarrierSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierSummary
     */
    'mc_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierSummary
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierVerificationResponse
 */
export interface ResponsesCarrierVerificationResponse {
    /**
     * 
     * @type {ResponsesCarrierVerificationResponseData}
     * @memberof ResponsesCarrierVerificationResponse
     */
    'data'?: ResponsesCarrierVerificationResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCarrierVerificationResponseData
 */
export interface ResponsesCarrierVerificationResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'authorityStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'insuranceCurrent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'safetyRating'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'verificationSource'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCarrierVerificationResponseData
     */
    'verifiedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesChecklistTemplateCategory
 */
export interface ResponsesChecklistTemplateCategory {
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateCategory
     */
    'category'?: string;
    /**
     * 
     * @type {Array<ResponsesChecklistTemplateItem>}
     * @memberof ResponsesChecklistTemplateCategory
     */
    'items'?: Array<ResponsesChecklistTemplateItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateCategory
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesChecklistTemplateItem
 */
export interface ResponsesChecklistTemplateItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateItem
     */
    'item'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateItem
     */
    'itemId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesChecklistTemplateResponse
 */
export interface ResponsesChecklistTemplateResponse {
    /**
     * 
     * @type {ResponsesChecklistTemplateResponseData}
     * @memberof ResponsesChecklistTemplateResponse
     */
    'data'?: ResponsesChecklistTemplateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesChecklistTemplateResponseData
 */
export interface ResponsesChecklistTemplateResponseData {
    /**
     * 
     * @type {Array<ResponsesChecklistTemplateCategory>}
     * @memberof ResponsesChecklistTemplateResponseData
     */
    'categories'?: Array<ResponsesChecklistTemplateCategory>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateResponseData
     */
    'inspectionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesChecklistTemplateResponseData
     */
    'vehicleType'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesComplianceStatus
 */
export interface ResponsesComplianceStatus {
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'cdl_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'drug_test_status'?: string;
    /**
     * 
     * @type {Array<ResponsesExpiringItem>}
     * @memberof ResponsesComplianceStatus
     */
    'expiring_items'?: Array<ResponsesExpiringItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'medical_status'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesComplianceStatus
     */
    'missing_documents'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'mvr_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'overall_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesComplianceStatus
     */
    'training_status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesContact
 */
export interface ResponsesContact {
    /**
     * 
     * @type {string}
     * @memberof ResponsesContact
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesContact
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesContact
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCostBreakdown
 */
export interface ResponsesCostBreakdown {
    /**
     * 
     * @type {number}
     * @memberof ResponsesCostBreakdown
     */
    'costPerMile'?: number;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'driverPay'?: ResponsesCostItem;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'factoring'?: ResponsesCostItem;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'fuelCost'?: ResponsesCostItem;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'insurance'?: ResponsesCostItem;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'maintenance'?: ResponsesCostItem;
    /**
     * 
     * @type {ResponsesCostItem}
     * @memberof ResponsesCostBreakdown
     */
    'tolls'?: ResponsesCostItem;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCostBreakdown
     */
    'totalCost'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesCostItem
 */
export interface ResponsesCostItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesCostItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCostItem
     */
    'formula'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCustomer
 */
export interface ResponsesCustomer {
    /**
     * 
     * @type {ResponsesCustomerAddress}
     * @memberof ResponsesCustomer
     */
    'billing_address'?: ResponsesCustomerAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'code'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesCustomer
     */
    'commodity_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomer
     */
    'credit_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'credit_status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomer
     */
    'credit_used'?: number | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesCustomer
     */
    'custom_fields'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'customer_since'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'dba'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'dot_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'factoring_company_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'industry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'invoice_delivery_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'invoice_grouping'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'legal_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomer
     */
    'loads_ytd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'mc_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'phone'?: string | null;
    /**
     * 
     * @type {ResponsesCustomerAddress}
     * @memberof ResponsesCustomer
     */
    'physical_address'?: ResponsesCustomerAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesCustomer
     */
    'required_documents'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomer
     */
    'revenue_ytd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'sales_rep_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'tax_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomer
     */
    'website'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerAddress
 */
export interface ResponsesCustomerAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerAddress
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerListResponse
 */
export interface ResponsesCustomerListResponse {
    /**
     * 
     * @type {ResponsesCustomerListResponseData}
     * @memberof ResponsesCustomerListResponse
     */
    'data'?: ResponsesCustomerListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerListResponseData
 */
export interface ResponsesCustomerListResponseData {
    /**
     * 
     * @type {Array<ResponsesCustomerSummary>}
     * @memberof ResponsesCustomerListResponseData
     */
    'customers'?: Array<ResponsesCustomerSummary>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesCustomerListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerResponse
 */
export interface ResponsesCustomerResponse {
    /**
     * 
     * @type {ResponsesCustomerResponseData}
     * @memberof ResponsesCustomerResponse
     */
    'data'?: ResponsesCustomerResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerResponseData
 */
export interface ResponsesCustomerResponseData {
    /**
     * 
     * @type {ResponsesCustomer}
     * @memberof ResponsesCustomerResponseData
     */
    'customer'?: ResponsesCustomer;
}
/**
 * 
 * @export
 * @interface ResponsesCustomerSummary
 */
export interface ResponsesCustomerSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomerSummary
     */
    'credit_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'credit_status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomerSummary
     */
    'credit_used'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomerSummary
     */
    'loads_ytd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesCustomerSummary
     */
    'revenue_ytd'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesCustomerSummary
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardExpenses
 */
export interface ResponsesDashboardExpenses {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'driver_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'fuel'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'insurance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'maintenance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'other'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardExpenses
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardKPIs
 */
export interface ResponsesDashboardKPIs {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardKPIs
     */
    'avg_miles_per_load'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardKPIs
     */
    'avg_rate_per_mile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardKPIs
     */
    'avg_revenue_per_load'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardKPIs
     */
    'loads_delivered'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardProfitability
 */
export interface ResponsesDashboardProfitability {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardProfitability
     */
    'gross_margin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardProfitability
     */
    'gross_profit'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardProfitability
     */
    'net_margin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardProfitability
     */
    'net_profit'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardReportResponse
 */
export interface ResponsesDashboardReportResponse {
    /**
     * 
     * @type {ResponsesDashboardReportResponseData}
     * @memberof ResponsesDashboardReportResponse
     */
    'data'?: ResponsesDashboardReportResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDashboardReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDashboardReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardReportResponseData
 */
export interface ResponsesDashboardReportResponseData {
    /**
     * 
     * @type {ResponsesDashboardExpenses}
     * @memberof ResponsesDashboardReportResponseData
     */
    'expenses'?: ResponsesDashboardExpenses;
    /**
     * 
     * @type {ResponsesDashboardKPIs}
     * @memberof ResponsesDashboardReportResponseData
     */
    'kpis'?: ResponsesDashboardKPIs;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDashboardReportResponseData
     */
    'period'?: string;
    /**
     * 
     * @type {ResponsesDashboardProfitability}
     * @memberof ResponsesDashboardReportResponseData
     */
    'profitability'?: ResponsesDashboardProfitability;
    /**
     * 
     * @type {ResponsesDashboardRevenue}
     * @memberof ResponsesDashboardReportResponseData
     */
    'revenue'?: ResponsesDashboardRevenue;
}
/**
 * 
 * @export
 * @interface ResponsesDashboardRevenue
 */
export interface ResponsesDashboardRevenue {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardRevenue
     */
    'collected'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardRevenue
     */
    'delivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardRevenue
     */
    'invoiced'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDashboardRevenue
     */
    'outstanding'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDefectResponse
 */
export interface ResponsesDefectResponse {
    /**
     * 
     * @type {ResponsesDefectResponseData}
     * @memberof ResponsesDefectResponse
     */
    'data'?: ResponsesDefectResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDefectResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDefectResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDefectResponseData
 */
export interface ResponsesDefectResponseData {
    /**
     * 
     * @type {ResponsesInspectionDefect}
     * @memberof ResponsesDefectResponseData
     */
    'defect'?: ResponsesInspectionDefect;
}
/**
 * 
 * @export
 * @interface ResponsesDocument
 */
export interface ResponsesDocument {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'documentType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDocument
     */
    'expirationAlertSent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocument
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocument
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocument
     */
    'uploadedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentDownloadUrlData
 */
export interface ResponsesDocumentDownloadUrlData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentDownloadUrlData
     */
    'downloadUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentDownloadUrlData
     */
    'expiresAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentDownloadUrlResponse
 */
export interface ResponsesDocumentDownloadUrlResponse {
    /**
     * 
     * @type {ResponsesDocumentDownloadUrlData}
     * @memberof ResponsesDocumentDownloadUrlResponse
     */
    'data'?: ResponsesDocumentDownloadUrlData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentDownloadUrlResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentDownloadUrlResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentMetadata
 */
export interface ResponsesDocumentMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentMetadata
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentMetadata
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocumentMetadata
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentMetadata
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentParse
 */
export interface ResponsesDocumentParse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'approved_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDocumentParse
     */
    'auto_detected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocumentParse
     */
    'confidence'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'created_invoice_unid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'created_load_unid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'document_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'document_unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'error_message'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesDocumentParse
     */
    'extracted_fields'?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocumentParse
     */
    'processing_ms'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParse
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDocumentParse
     */
    'warnings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentParseResponse
 */
export interface ResponsesDocumentParseResponse {
    /**
     * 
     * @type {ResponsesDocumentParseResponseData}
     * @memberof ResponsesDocumentParseResponse
     */
    'data'?: ResponsesDocumentParseResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParseResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentParseResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentParseResponseData
 */
export interface ResponsesDocumentParseResponseData {
    /**
     * 
     * @type {ResponsesDocumentParse}
     * @memberof ResponsesDocumentParseResponseData
     */
    'parse'?: ResponsesDocumentParse;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentResponse
 */
export interface ResponsesDocumentResponse {
    /**
     * 
     * @type {ResponsesDocumentResponseData}
     * @memberof ResponsesDocumentResponse
     */
    'data'?: ResponsesDocumentResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentResponseData
 */
export interface ResponsesDocumentResponseData {
    /**
     * 
     * @type {ResponsesDocument}
     * @memberof ResponsesDocumentResponseData
     */
    'document'?: ResponsesDocument;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentUploadUrlData
 */
export interface ResponsesDocumentUploadUrlData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentUploadUrlData
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentUploadUrlData
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentUploadUrlData
     */
    'uploadUrl'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentUploadUrlResponse
 */
export interface ResponsesDocumentUploadUrlResponse {
    /**
     * 
     * @type {ResponsesDocumentUploadUrlData}
     * @memberof ResponsesDocumentUploadUrlResponse
     */
    'data'?: ResponsesDocumentUploadUrlData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentUploadUrlResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentUploadUrlResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentsResponse
 */
export interface ResponsesDocumentsResponse {
    /**
     * 
     * @type {ResponsesDocumentsResponseData}
     * @memberof ResponsesDocumentsResponse
     */
    'data'?: ResponsesDocumentsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDocumentsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDocumentsResponseData
 */
export interface ResponsesDocumentsResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDocumentsResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesDocument>}
     * @memberof ResponsesDocumentsResponseData
     */
    'documents'?: Array<ResponsesDocument>;
}
/**
 * 
 * @export
 * @interface ResponsesDriver
 */
export interface ResponsesDriver {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'CDLClass'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'CDLExpiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'CDLNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'CDLState'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'HOSDrivingRemaining'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'HOSStatus'?: string | null;
    /**
     * 
     * @type {Array<ResponsesActiveLoadSummary>}
     * @memberof ResponsesDriver
     */
    'activeLoads'?: Array<ResponsesActiveLoadSummary>;
    /**
     * 
     * @type {ResponsesDriverAddress}
     * @memberof ResponsesDriver
     */
    'address'?: ResponsesDriverAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriver
     */
    'cdlEndorsements'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriver
     */
    'commPrefEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriver
     */
    'commPrefPush'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'driverNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'driverType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'hireDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriver
     */
    'invitationAccepted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'locationCity'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'locationLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'locationLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'locationState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'locationUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'medicalCardNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'medicalExpiration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'minimumGuarantee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'payRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'payType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriver
     */
    'perDiem'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'relayDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'terminationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriver
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverAddress
 */
export interface ResponsesDriverAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAddress
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverAvailability
 */
export interface ResponsesDriverAvailability {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriverAvailability
     */
    'cdlEndorsements'?: Array<string>;
    /**
     * 
     * @type {ResponsesGeoLocation}
     * @memberof ResponsesDriverAvailability
     */
    'current_location'?: ResponsesGeoLocation;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverAvailability
     */
    'distance_to_pickup_miles'?: number | null;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesDriverAvailability
     */
    'driver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriverAvailability
     */
    'equipment_match'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAvailability
     */
    'home_time_due'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverAvailability
     */
    'hos_available_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverAvailability
     */
    'hos_drive_remaining'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverAvailability
     */
    'next_available'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverAvailability
     */
    'preference_match_score'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesDriverCredentials
 */
export interface ResponsesDriverCredentials {
    /**
     * 
     * @type {ResponsesCDLInfo}
     * @memberof ResponsesDriverCredentials
     */
    'cdl'?: ResponsesCDLInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriverCredentials
     */
    'endorsements'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriverCredentials
     */
    'equipment_certifications'?: Array<string>;
    /**
     * 
     * @type {ResponsesMedicalCardInfo}
     * @memberof ResponsesDriverCredentials
     */
    'medical_card'?: ResponsesMedicalCardInfo;
    /**
     * 
     * @type {ResponsesPassportInfo}
     * @memberof ResponsesDriverCredentials
     */
    'passport'?: ResponsesPassportInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriverCredentials
     */
    'restrictions'?: Array<string>;
    /**
     * 
     * @type {ResponsesTWICInfo}
     * @memberof ResponsesDriverCredentials
     */
    'twic'?: ResponsesTWICInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverDetail
 */
export interface ResponsesDriverDetail {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'CDLClass'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'CDLExpiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'CDLNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'CDLState'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'HOSDrivingRemaining'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'HOSStatus'?: string | null;
    /**
     * 
     * @type {Array<ResponsesActiveLoadSummary>}
     * @memberof ResponsesDriverDetail
     */
    'activeLoads'?: Array<ResponsesActiveLoadSummary>;
    /**
     * 
     * @type {ResponsesAddress}
     * @memberof ResponsesDriverDetail
     */
    'address'?: ResponsesAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'avatarUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesDriverDetail
     */
    'cdlEndorsements'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriverDetail
     */
    'commPrefEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriverDetail
     */
    'commPrefPush'?: boolean;
    /**
     * 
     * @type {ResponsesComplianceStatus}
     * @memberof ResponsesDriverDetail
     */
    'compliance'?: ResponsesComplianceStatus;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesDriverCredentials}
     * @memberof ResponsesDriverDetail
     */
    'credentials'?: ResponsesDriverCredentials;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'driverNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'driverType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'email'?: string;
    /**
     * 
     * @type {ResponsesEmergencyContact}
     * @memberof ResponsesDriverDetail
     */
    'emergency_contact'?: ResponsesEmergencyContact;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'hireDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesDriverDetail
     */
    'invitationAccepted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'locationCity'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'locationLatitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'locationLongitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'locationState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'locationUpdatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'medicalCardNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'medicalExpiration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'minimumGuarantee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'payRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'payType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'pay_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'pay_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverDetail
     */
    'perDiem'?: number | null;
    /**
     * 
     * @type {ResponsesDriverPerformanceSummary}
     * @memberof ResponsesDriverDetail
     */
    'performance'?: ResponsesDriverPerformanceSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'relayDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'ssn_last4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'terminationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetail
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverDetailResponse
 */
export interface ResponsesDriverDetailResponse {
    /**
     * 
     * @type {ResponsesDriverDetailResponseData}
     * @memberof ResponsesDriverDetailResponse
     */
    'data'?: ResponsesDriverDetailResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetailResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverDetailResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverDetailResponseData
 */
export interface ResponsesDriverDetailResponseData {
    /**
     * 
     * @type {ResponsesDriverDetail}
     * @memberof ResponsesDriverDetailResponseData
     */
    'driver'?: ResponsesDriverDetail;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSClockEntry
 */
export interface ResponsesDriverHOSClockEntry {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'breakRemainingMs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'cycleRemainingMs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'cycleTomorrowMs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'cycleViolationMs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'driveRemainingMs'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'dutyStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'recordedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'samsaraVehicleId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'shiftDrivingViolationMs'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'shiftRemainingMs'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockEntry
     */
    'vehicleName'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSClockHistoryResponse
 */
export interface ResponsesDriverHOSClockHistoryResponse {
    /**
     * 
     * @type {ResponsesDriverHOSClockHistoryResponseData}
     * @memberof ResponsesDriverHOSClockHistoryResponse
     */
    'data'?: ResponsesDriverHOSClockHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSClockHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSClockHistoryResponseData
 */
export interface ResponsesDriverHOSClockHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverHOSClockEntry>}
     * @memberof ResponsesDriverHOSClockHistoryResponseData
     */
    'entries'?: Array<ResponsesDriverHOSClockEntry>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverHOSClockHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSLogEntry
 */
export interface ResponsesDriverHOSLogEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'durationSeconds'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'enteredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'exitedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSLogEntry
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSTimelineResponse
 */
export interface ResponsesDriverHOSTimelineResponse {
    /**
     * 
     * @type {ResponsesDriverHOSTimelineResponseData}
     * @memberof ResponsesDriverHOSTimelineResponse
     */
    'data'?: ResponsesDriverHOSTimelineResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSTimelineResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverHOSTimelineResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverHOSTimelineResponseData
 */
export interface ResponsesDriverHOSTimelineResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverHOSTimelineResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesDriverHOSLogEntry>}
     * @memberof ResponsesDriverHOSTimelineResponseData
     */
    'timeline'?: Array<ResponsesDriverHOSLogEntry>;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLatestHOSClockResponse
 */
export interface ResponsesDriverLatestHOSClockResponse {
    /**
     * 
     * @type {ResponsesDriverLatestHOSClockResponseData}
     * @memberof ResponsesDriverLatestHOSClockResponse
     */
    'data'?: ResponsesDriverLatestHOSClockResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLatestHOSClockResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLatestHOSClockResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLatestHOSClockResponseData
 */
export interface ResponsesDriverLatestHOSClockResponseData {
    /**
     * 
     * @type {ResponsesDriverHOSClockEntry}
     * @memberof ResponsesDriverLatestHOSClockResponseData
     */
    'entry'?: ResponsesDriverHOSClockEntry;
}
/**
 * 
 * @export
 * @interface ResponsesDriverListResponse
 */
export interface ResponsesDriverListResponse {
    /**
     * 
     * @type {ResponsesDriverListResponseData}
     * @memberof ResponsesDriverListResponse
     */
    'data'?: ResponsesDriverListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverListResponseData
 */
export interface ResponsesDriverListResponseData {
    /**
     * 
     * @type {Array<ResponsesDriver>}
     * @memberof ResponsesDriverListResponseData
     */
    'drivers'?: Array<ResponsesDriver>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLocationHistoryResponse
 */
export interface ResponsesDriverLocationHistoryResponse {
    /**
     * 
     * @type {ResponsesDriverLocationHistoryResponseData}
     * @memberof ResponsesDriverLocationHistoryResponse
     */
    'data'?: ResponsesDriverLocationHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLocationHistoryResponseData
 */
export interface ResponsesDriverLocationHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverLocationPoint>}
     * @memberof ResponsesDriverLocationHistoryResponseData
     */
    'locations'?: Array<ResponsesDriverLocationPoint>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverLocationHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLocationPoint
 */
export interface ResponsesDriverLocationPoint {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationPoint
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationPoint
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'load_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'odometer_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationPoint
     */
    'recorded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationPoint
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationPoint
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationPoint
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesDriverLocationResponse
 */
export interface ResponsesDriverLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'currentLoadUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'currentVehicleName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'currentVehicleUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'driverNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverLocationResponse
     */
    'hosDrivingRemaining'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'hosStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'lastName'?: string;
    /**
     * 
     * @type {ResponsesAssetLocationResponse}
     * @memberof ResponsesDriverLocationResponse
     */
    'location'?: ResponsesAssetLocationResponse;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'samsaraDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverLocationResponse
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverPerformanceMetric
 */
export interface ResponsesDriverPerformanceMetric {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'avg_miles_per_day'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'driver_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'driver_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'load_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'on_time_delivery'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'revenue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'total_miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceMetric
     */
    'utilization'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDriverPerformanceReportResponse
 */
export interface ResponsesDriverPerformanceReportResponse {
    /**
     * 
     * @type {ResponsesDriverPerformanceReportResponseData}
     * @memberof ResponsesDriverPerformanceReportResponse
     */
    'data'?: ResponsesDriverPerformanceReportResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverPerformanceReportResponseData
 */
export interface ResponsesDriverPerformanceReportResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverPerformanceMetric>}
     * @memberof ResponsesDriverPerformanceReportResponseData
     */
    'drivers'?: Array<ResponsesDriverPerformanceMetric>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceReportResponseData
     */
    'period_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverPerformanceReportResponseData
     */
    'period_start'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverPerformanceSummary
 */
export interface ResponsesDriverPerformanceSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceSummary
     */
    'fuel_mpg'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceSummary
     */
    'loads_30_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceSummary
     */
    'miles_30_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceSummary
     */
    'on_time_pct'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverPerformanceSummary
     */
    'safety_score'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDriverRecurringChargeItem
 */
export interface ResponsesDriverRecurringChargeItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'effective_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'last_applied_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'updated_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverRecurringChargeItem
     */
    'usage_count'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDriverRecurringChargeListResponse
 */
export interface ResponsesDriverRecurringChargeListResponse {
    /**
     * 
     * @type {ResponsesDriverRecurringChargeListResponseData}
     * @memberof ResponsesDriverRecurringChargeListResponse
     */
    'data'?: ResponsesDriverRecurringChargeListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverRecurringChargeListResponseData
 */
export interface ResponsesDriverRecurringChargeListResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverRecurringChargeItem>}
     * @memberof ResponsesDriverRecurringChargeListResponseData
     */
    'charges'?: Array<ResponsesDriverRecurringChargeItem>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverRecurringChargeListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverRecurringChargeResponse
 */
export interface ResponsesDriverRecurringChargeResponse {
    /**
     * 
     * @type {ResponsesDriverRecurringChargeResponseData}
     * @memberof ResponsesDriverRecurringChargeResponse
     */
    'data'?: ResponsesDriverRecurringChargeResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverRecurringChargeResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverRecurringChargeResponseData
 */
export interface ResponsesDriverRecurringChargeResponseData {
    /**
     * 
     * @type {ResponsesDriverRecurringChargeItem}
     * @memberof ResponsesDriverRecurringChargeResponseData
     */
    'charge'?: ResponsesDriverRecurringChargeItem;
}
/**
 * 
 * @export
 * @interface ResponsesDriverResponse
 */
export interface ResponsesDriverResponse {
    /**
     * 
     * @type {ResponsesDriverResponseData}
     * @memberof ResponsesDriverResponse
     */
    'data'?: ResponsesDriverResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverResponseData
 */
export interface ResponsesDriverResponseData {
    /**
     * 
     * @type {ResponsesDriver}
     * @memberof ResponsesDriverResponseData
     */
    'driver'?: ResponsesDriver;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementListResponse
 */
export interface ResponsesDriverSettlementListResponse {
    /**
     * 
     * @type {ResponsesDriverSettlementListResponseData}
     * @memberof ResponsesDriverSettlementListResponse
     */
    'data'?: ResponsesDriverSettlementListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementListResponseData
 */
export interface ResponsesDriverSettlementListResponseData {
    /**
     * 
     * @type {Array<ResponsesDriverSettlementSummary>}
     * @memberof ResponsesDriverSettlementListResponseData
     */
    'driver_settlements'?: Array<ResponsesDriverSettlementSummary>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesDriverSettlementListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementStatsResponse
 */
export interface ResponsesDriverSettlementStatsResponse {
    /**
     * 
     * @type {ResponsesDriverSettlementStatsResponseData}
     * @memberof ResponsesDriverSettlementStatsResponse
     */
    'data'?: ResponsesDriverSettlementStatsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementStatsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementStatsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementStatsResponseData
 */
export interface ResponsesDriverSettlementStatsResponseData {
    /**
     * 
     * @type {ResponsesDriverSettlementStatusStats}
     * @memberof ResponsesDriverSettlementStatsResponseData
     */
    'pending'?: ResponsesDriverSettlementStatusStats;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementStatusStats
 */
export interface ResponsesDriverSettlementStatusStats {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementStatusStats
     */
    'settlement_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementStatusStats
     */
    'total_net_pay'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSettlementSummary
 */
export interface ResponsesDriverSettlementSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'accessorial_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'bonus_pay'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementSummary
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementSummary
     */
    'driver_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSettlementSummary
     */
    'driver_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'gross_earnings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'load_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'net_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'settlement_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'total_deductions'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesDriverSettlementSummary
     */
    'total_reimbursements'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesDriverSummary
 */
export interface ResponsesDriverSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSummary
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSummary
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSummary
     */
    'photo_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSummary
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesDriverSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesEmergencyContact
 */
export interface ResponsesEmergencyContact {
    /**
     * 
     * @type {string}
     * @memberof ResponsesEmergencyContact
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEmergencyContact
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEmergencyContact
     */
    'relationship'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesErrorDetails
 */
export interface ResponsesErrorDetails {
    /**
     * 
     * @type {string}
     * @memberof ResponsesErrorDetails
     */
    'code'?: string;
    /**
     * 
     * @type {any}
     * @memberof ResponsesErrorDetails
     */
    'details'?: any;
    /**
     * 
     * @type {string}
     * @memberof ResponsesErrorDetails
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesErrorDetails
     */
    'statusCode'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesErrorResponse
 */
export interface ResponsesErrorResponse {
    /**
     * 
     * @type {ResponsesErrorDetails}
     * @memberof ResponsesErrorResponse
     */
    'error'?: ResponsesErrorDetails;
    /**
     * 
     * @type {string}
     * @memberof ResponsesErrorResponse
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesErrorResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesEventFormSnapshotField
 */
export interface ResponsesEventFormSnapshotField {
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventFormSnapshotField
     */
    'fieldType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventFormSnapshotField
     */
    'fieldUnid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventFormSnapshotField
     */
    'label'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesEventFormSnapshotField
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesEventFormSnapshotField
     */
    'required'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ResponsesEventFormSnapshotField
     */
    'value'?: any;
}
/**
 * 
 * @export
 * @interface ResponsesEventFormSnapshotTemplate
 */
export interface ResponsesEventFormSnapshotTemplate {
    /**
     * 
     * @type {Array<ResponsesEventFormSnapshotField>}
     * @memberof ResponsesEventFormSnapshotTemplate
     */
    'fields'?: Array<ResponsesEventFormSnapshotField>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventFormSnapshotTemplate
     */
    'templateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventFormSnapshotTemplate
     */
    'templateUnid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesEventIntelligenceEvent
 */
export interface ResponsesEventIntelligenceEvent {
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventIntelligenceEvent
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesEventIntelligenceEvent
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesExpense
 */
export interface ResponsesExpense {
    /**
     * 
     * @type {number}
     * @memberof ResponsesExpense
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'card_last_four'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'description'?: string | null;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesExpense
     */
    'driver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {ResponsesLoadSummary}
     * @memberof ResponsesExpense
     */
    'load'?: ResponsesLoadSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'payment_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'receipt_doc_id'?: string | null;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesExpense
     */
    'truck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpense
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesExpenseListResponse
 */
export interface ResponsesExpenseListResponse {
    /**
     * 
     * @type {ResponsesExpenseListResponseData}
     * @memberof ResponsesExpenseListResponse
     */
    'data'?: ResponsesExpenseListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpenseListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpenseListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesExpenseListResponseData
 */
export interface ResponsesExpenseListResponseData {
    /**
     * 
     * @type {Array<ResponsesExpense>}
     * @memberof ResponsesExpenseListResponseData
     */
    'expenses'?: Array<ResponsesExpense>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesExpenseListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {ResponsesExpenseListSummary}
     * @memberof ResponsesExpenseListResponseData
     */
    'summary'?: ResponsesExpenseListSummary;
}
/**
 * 
 * @export
 * @interface ResponsesExpenseListSummary
 */
export interface ResponsesExpenseListSummary {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResponsesExpenseListSummary
     */
    'by_category'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesExpenseListSummary
     */
    'total_amount'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesExpenseResponse
 */
export interface ResponsesExpenseResponse {
    /**
     * 
     * @type {ResponsesExpenseResponseData}
     * @memberof ResponsesExpenseResponse
     */
    'data'?: ResponsesExpenseResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpenseResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpenseResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesExpenseResponseData
 */
export interface ResponsesExpenseResponseData {
    /**
     * 
     * @type {ResponsesExpense}
     * @memberof ResponsesExpenseResponseData
     */
    'expense'?: ResponsesExpense;
}
/**
 * 
 * @export
 * @interface ResponsesExpiringItem
 */
export interface ResponsesExpiringItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesExpiringItem
     */
    'days_remaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpiringItem
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpiringItem
     */
    'driver_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpiringItem
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpiringItem
     */
    'item_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesExpiringItem
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatch
 */
export interface ResponsesFactoringBatch {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'batchNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'createdByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'documentUnid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFactoringBatch
     */
    'invoiceCount'?: number;
    /**
     * 
     * @type {Array<ResponsesFactoringBatchInvoice>}
     * @memberof ResponsesFactoringBatch
     */
    'invoices'?: Array<ResponsesFactoringBatchInvoice>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'paidAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFactoringBatch
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'zipErrorMessage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFactoringBatch
     */
    'zipReady'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatch
     */
    'zipStatus'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatchInvoice
 */
export interface ResponsesFactoringBatchInvoice {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'addedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'invoiceUnid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'loadNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'totalCharges'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchInvoice
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatchListResponse
 */
export interface ResponsesFactoringBatchListResponse {
    /**
     * 
     * @type {ResponsesFactoringBatchListResponseData}
     * @memberof ResponsesFactoringBatchListResponse
     */
    'data'?: ResponsesFactoringBatchListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatchListResponseData
 */
export interface ResponsesFactoringBatchListResponseData {
    /**
     * 
     * @type {Array<ResponsesFactoringBatch>}
     * @memberof ResponsesFactoringBatchListResponseData
     */
    'batches'?: Array<ResponsesFactoringBatch>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesFactoringBatchListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatchResponse
 */
export interface ResponsesFactoringBatchResponse {
    /**
     * 
     * @type {ResponsesFactoringBatchResponseData}
     * @memberof ResponsesFactoringBatchResponse
     */
    'data'?: ResponsesFactoringBatchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringBatchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringBatchResponseData
 */
export interface ResponsesFactoringBatchResponseData {
    /**
     * 
     * @type {ResponsesFactoringBatch}
     * @memberof ResponsesFactoringBatchResponseData
     */
    'batch'?: ResponsesFactoringBatch;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringInvoice
 */
export interface ResponsesFactoringInvoice {
    /**
     * 
     * @type {number}
     * @memberof ResponsesFactoringInvoice
     */
    'balanceDue'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'dueDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFactoringInvoice
     */
    'hasPdf'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'invoiceDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'loadNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFactoringInvoice
     */
    'totalCharges'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoice
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringInvoiceListResponse
 */
export interface ResponsesFactoringInvoiceListResponse {
    /**
     * 
     * @type {ResponsesFactoringInvoiceListResponseData}
     * @memberof ResponsesFactoringInvoiceListResponse
     */
    'data'?: ResponsesFactoringInvoiceListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoiceListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFactoringInvoiceListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFactoringInvoiceListResponseData
 */
export interface ResponsesFactoringInvoiceListResponseData {
    /**
     * 
     * @type {Array<ResponsesFactoringInvoice>}
     * @memberof ResponsesFactoringInvoiceListResponseData
     */
    'invoices'?: Array<ResponsesFactoringInvoice>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesFactoringInvoiceListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesFeatureDisplayResponse
 */
export interface ResponsesFeatureDisplayResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'categoryDisplay'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'icon'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'isHighlight'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'showInList'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFeatureDisplayResponse
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesFeatureTranslationResponse
 */
export interface ResponsesFeatureTranslationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'shortDesc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFeatureTranslationResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetDashboardResponse
 */
export interface ResponsesFleetDashboardResponse {
    /**
     * 
     * @type {ResponsesFleetDashboardResponseData}
     * @memberof ResponsesFleetDashboardResponse
     */
    'data'?: ResponsesFleetDashboardResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetDashboardResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetDashboardResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetDashboardResponseData
 */
export interface ResponsesFleetDashboardResponseData {
    /**
     * 
     * @type {ResponsesInspectionDashboardMetrics}
     * @memberof ResponsesFleetDashboardResponseData
     */
    'inspections'?: ResponsesInspectionDashboardMetrics;
    /**
     * 
     * @type {ResponsesMaintenanceDashboardMetrics}
     * @memberof ResponsesFleetDashboardResponseData
     */
    'maintenance'?: ResponsesMaintenanceDashboardMetrics;
    /**
     * 
     * @type {ResponsesTrailerDashboardMetrics}
     * @memberof ResponsesFleetDashboardResponseData
     */
    'trailers'?: ResponsesTrailerDashboardMetrics;
    /**
     * 
     * @type {ResponsesTruckDashboardMetrics}
     * @memberof ResponsesFleetDashboardResponseData
     */
    'trucks'?: ResponsesTruckDashboardMetrics;
    /**
     * 
     * @type {ResponsesUtilizationMetrics}
     * @memberof ResponsesFleetDashboardResponseData
     */
    'utilization'?: ResponsesUtilizationMetrics;
}
/**
 * 
 * @export
 * @interface ResponsesFleetLocationsData
 */
export interface ResponsesFleetLocationsData {
    /**
     * 
     * @type {Array<ResponsesDriverLocationResponse>}
     * @memberof ResponsesFleetLocationsData
     */
    'drivers'?: Array<ResponsesDriverLocationResponse>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetLocationsData
     */
    'source'?: string;
    /**
     * 
     * @type {Array<ResponsesTrailerLocationResponse>}
     * @memberof ResponsesFleetLocationsData
     */
    'trailers'?: Array<ResponsesTrailerLocationResponse>;
    /**
     * 
     * @type {Array<ResponsesTruckLocationResponse>}
     * @memberof ResponsesFleetLocationsData
     */
    'trucks'?: Array<ResponsesTruckLocationResponse>;
}
/**
 * 
 * @export
 * @interface ResponsesFleetLocationsResponse
 */
export interface ResponsesFleetLocationsResponse {
    /**
     * 
     * @type {ResponsesFleetLocationsData}
     * @memberof ResponsesFleetLocationsResponse
     */
    'data'?: ResponsesFleetLocationsData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetLocationsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetLocationsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockManualMatchResponse
 */
export interface ResponsesFleetrockManualMatchResponse {
    /**
     * 
     * @type {ResponsesFleetrockManualMatchResponseData}
     * @memberof ResponsesFleetrockManualMatchResponse
     */
    'data'?: ResponsesFleetrockManualMatchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockManualMatchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockManualMatchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockManualMatchResponseData
 */
export interface ResponsesFleetrockManualMatchResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFleetrockManualMatchResponseData
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockManualMatchResponseData
     */
    'truckUnid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockMatchResponse
 */
export interface ResponsesFleetrockMatchResponse {
    /**
     * 
     * @type {ResponsesFleetrockMatchResponseData}
     * @memberof ResponsesFleetrockMatchResponse
     */
    'data'?: ResponsesFleetrockMatchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockMatchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockMatchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockMatchResponseData
 */
export interface ResponsesFleetrockMatchResponseData {
    /**
     * 
     * @type {Array<ResponsesFleetrockUnitMatchResult>}
     * @memberof ResponsesFleetrockMatchResponseData
     */
    'matched'?: Array<ResponsesFleetrockUnitMatchResult>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockMatchResponseData
     */
    'total'?: number;
    /**
     * 
     * @type {Array<ResponsesFleetrockUnitMatchResult>}
     * @memberof ResponsesFleetrockMatchResponseData
     */
    'unmatched'?: Array<ResponsesFleetrockUnitMatchResult>;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockStatusResponse
 */
export interface ResponsesFleetrockStatusResponse {
    /**
     * 
     * @type {ResponsesFleetrockStatusResponseData}
     * @memberof ResponsesFleetrockStatusResponse
     */
    'data'?: ResponsesFleetrockStatusResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockStatusResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockStatusResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockStatusResponseData
 */
export interface ResponsesFleetrockStatusResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFleetrockStatusResponseData
     */
    'connected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockStatusResponseData
     */
    'connectedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockStatusResponseData
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockSyncResult
 */
export interface ResponsesFleetrockSyncResult {
    /**
     * 
     * @type {ResponsesFleetrockSyncResultData}
     * @memberof ResponsesFleetrockSyncResult
     */
    'data'?: ResponsesFleetrockSyncResultData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockSyncResult
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockSyncResult
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockSyncResultData
 */
export interface ResponsesFleetrockSyncResultData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockSyncResultData
     */
    'created'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockSyncResultData
     */
    'errors'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockSyncResultData
     */
    'skipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockSyncResultData
     */
    'updated'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockUnitMatchResult
 */
export interface ResponsesFleetrockUnitMatchResult {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'fleetrockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'make'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'matched'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'matchedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'truckUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'truckUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnitMatchResult
     */
    'year'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockUnmatchedUnitItem
 */
export interface ResponsesFleetrockUnmatchedUnitItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'fleetrockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'vin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitItem
     */
    'year'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockUnmatchedUnitsResponse
 */
export interface ResponsesFleetrockUnmatchedUnitsResponse {
    /**
     * 
     * @type {ResponsesFleetrockUnmatchedUnitsResponseData}
     * @memberof ResponsesFleetrockUnmatchedUnitsResponse
     */
    'data'?: ResponsesFleetrockUnmatchedUnitsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFleetrockUnmatchedUnitsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFleetrockUnmatchedUnitsResponseData
 */
export interface ResponsesFleetrockUnmatchedUnitsResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesFleetrockUnmatchedUnitsResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesFleetrockUnmatchedUnitItem>}
     * @memberof ResponsesFleetrockUnmatchedUnitsResponseData
     */
    'units'?: Array<ResponsesFleetrockUnmatchedUnitItem>;
}
/**
 * 
 * @export
 * @interface ResponsesFuelImportResponse
 */
export interface ResponsesFuelImportResponse {
    /**
     * 
     * @type {ResponsesFuelImportResponseData}
     * @memberof ResponsesFuelImportResponse
     */
    'data'?: ResponsesFuelImportResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelImportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelImportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFuelImportResponseData
 */
export interface ResponsesFuelImportResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelImportResponseData
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelImportResponseData
     */
    'imported'?: number;
    /**
     * 
     * @type {Array<ResponsesFuelPurchase>}
     * @memberof ResponsesFuelImportResponseData
     */
    'purchases'?: Array<ResponsesFuelPurchase>;
}
/**
 * 
 * @export
 * @interface ResponsesFuelListResponse
 */
export interface ResponsesFuelListResponse {
    /**
     * 
     * @type {ResponsesFuelListResponseData}
     * @memberof ResponsesFuelListResponse
     */
    'data'?: ResponsesFuelListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFuelListResponseData
 */
export interface ResponsesFuelListResponseData {
    /**
     * 
     * @type {Array<ResponsesFuelPurchase>}
     * @memberof ResponsesFuelListResponseData
     */
    'fuel_purchases'?: Array<ResponsesFuelPurchase>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesFuelListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesFuelPurchase
 */
export interface ResponsesFuelPurchase {
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'discount'?: number;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesFuelPurchase
     */
    'driver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'fuel_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'fuel_card_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'fuel_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'gallons'?: number;
    /**
     * 
     * @type {ResponsesLoadSummary}
     * @memberof ResponsesFuelPurchase
     */
    'load'?: ResponsesLoadSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'other_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'price_per_gallon'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'purchase_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesFuelPurchase
     */
    'total_amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'transaction_type'?: string | null;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesFuelPurchase
     */
    'truck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelPurchase
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesFuelResponse
 */
export interface ResponsesFuelResponse {
    /**
     * 
     * @type {ResponsesFuelResponseData}
     * @memberof ResponsesFuelResponse
     */
    'data'?: ResponsesFuelResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesFuelResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesFuelResponseData
 */
export interface ResponsesFuelResponseData {
    /**
     * 
     * @type {ResponsesFuelPurchase}
     * @memberof ResponsesFuelResponseData
     */
    'fuel_purchase'?: ResponsesFuelPurchase;
}
/**
 * 
 * @export
 * @interface ResponsesGeoLocation
 */
export interface ResponsesGeoLocation {
    /**
     * 
     * @type {string}
     * @memberof ResponsesGeoLocation
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesGeoLocation
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesGeoLocation
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesGeoLocation
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesGeoLocation
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesGeoLocation
     */
    'timestamp'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAJurisdictionEntry
 */
export interface ResponsesIFTAJurisdictionEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'jurisdiction'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'taxPaidGallons'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'taxPaidLiters'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'taxableMeters'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'taxableMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'totalMeters'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionEntry
     */
    'totalMiles'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAJurisdictionReportData
 */
export interface ResponsesIFTAJurisdictionReportData {
    /**
     * 
     * @type {Array<ResponsesIFTAJurisdictionEntry>}
     * @memberof ResponsesIFTAJurisdictionReportData
     */
    'jurisdictionReports'?: Array<ResponsesIFTAJurisdictionEntry>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAJurisdictionReportData
     */
    'month'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAJurisdictionReportData
     */
    'quarter'?: string;
    /**
     * 
     * @type {ResponsesIFTATroubleshooting}
     * @memberof ResponsesIFTAJurisdictionReportData
     */
    'troubleshooting'?: ResponsesIFTATroubleshooting;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAJurisdictionReportData
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAJurisdictionReportResponse
 */
export interface ResponsesIFTAJurisdictionReportResponse {
    /**
     * 
     * @type {ResponsesIFTAJurisdictionReportData}
     * @memberof ResponsesIFTAJurisdictionReportResponse
     */
    'data'?: ResponsesIFTAJurisdictionReportData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAJurisdictionReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAJurisdictionReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesIFTATroubleshooting
 */
export interface ResponsesIFTATroubleshooting {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesIFTATroubleshooting
     */
    'noPurchasesFound'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTATroubleshooting
     */
    'unassignedFuelTypePurchases'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTATroubleshooting
     */
    'unassignedFuelTypeVehicles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTATroubleshooting
     */
    'unassignedVehiclePurchases'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAVehicleReportData
 */
export interface ResponsesIFTAVehicleReportData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleReportData
     */
    'month'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleReportData
     */
    'quarter'?: string;
    /**
     * 
     * @type {ResponsesIFTATroubleshooting}
     * @memberof ResponsesIFTAVehicleReportData
     */
    'troubleshooting'?: ResponsesIFTATroubleshooting;
    /**
     * 
     * @type {Array<ResponsesIFTAVehicleReportEntry>}
     * @memberof ResponsesIFTAVehicleReportData
     */
    'vehicleReports'?: Array<ResponsesIFTAVehicleReportEntry>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesIFTAVehicleReportData
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAVehicleReportEntry
 */
export interface ResponsesIFTAVehicleReportEntry {
    /**
     * 
     * @type {Array<ResponsesIFTAJurisdictionEntry>}
     * @memberof ResponsesIFTAVehicleReportEntry
     */
    'jurisdictions'?: Array<ResponsesIFTAJurisdictionEntry>;
    /**
     * 
     * @type {ResponsesIFTAVehicleTiny}
     * @memberof ResponsesIFTAVehicleReportEntry
     */
    'vehicle'?: ResponsesIFTAVehicleTiny;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAVehicleReportResponse
 */
export interface ResponsesIFTAVehicleReportResponse {
    /**
     * 
     * @type {ResponsesIFTAVehicleReportData}
     * @memberof ResponsesIFTAVehicleReportResponse
     */
    'data'?: ResponsesIFTAVehicleReportData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesIFTAVehicleTiny
 */
export interface ResponsesIFTAVehicleTiny {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ResponsesIFTAVehicleTiny
     */
    'externalIds'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleTiny
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesIFTAVehicleTiny
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesInspection
 */
export interface ResponsesInspection {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesInspection
     */
    'allDefectsFixed'?: boolean;
    /**
     * 
     * @type {Array<ResponsesInspectionChecklistItem>}
     * @memberof ResponsesInspection
     */
    'checklistItems'?: Array<ResponsesInspectionChecklistItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspection
     */
    'defectCount'?: number;
    /**
     * 
     * @type {Array<ResponsesInspectionDefect>}
     * @memberof ResponsesInspection
     */
    'defects'?: Array<ResponsesInspectionDefect>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'driverName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'driverSignature'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesInspection
     */
    'hasOosDefects'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'inspectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'inspectionNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'inspectionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'loadId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'mechanicName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'mechanicSignature'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'mechanicSignedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspection
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'overallCondition'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspection
     */
    'reeferHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'trailerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'trailerNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'truckId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'truckNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspection
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionChecklistItem
 */
export interface ResponsesInspectionChecklistItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'defectUnid'?: string | null;
    /**
     * 
     * @type {Array<ResponsesDocumentMetadata>}
     * @memberof ResponsesInspectionChecklistItem
     */
    'documents'?: Array<ResponsesDocumentMetadata>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'item'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'notes'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesInspectionChecklistItem
     */
    'passed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionChecklistItem
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionDashboardMetrics
 */
export interface ResponsesInspectionDashboardMetrics {
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspectionDashboardMetrics
     */
    'dueToday'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspectionDashboardMetrics
     */
    'oosDefects'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesInspectionDashboardMetrics
     */
    'openDefects'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionDefect
 */
export interface ResponsesInspectionDefect {
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'checklistItemUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'inspectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'resolution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'resolvedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'resolvedByName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'severity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionDefect
     */
    'workOrderId'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionListResponse
 */
export interface ResponsesInspectionListResponse {
    /**
     * 
     * @type {ResponsesInspectionListResponseData}
     * @memberof ResponsesInspectionListResponse
     */
    'data'?: ResponsesInspectionListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionListResponseData
 */
export interface ResponsesInspectionListResponseData {
    /**
     * 
     * @type {Array<ResponsesInspection>}
     * @memberof ResponsesInspectionListResponseData
     */
    'inspections'?: Array<ResponsesInspection>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesInspectionListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionResponse
 */
export interface ResponsesInspectionResponse {
    /**
     * 
     * @type {ResponsesInspectionResponseData}
     * @memberof ResponsesInspectionResponse
     */
    'data'?: ResponsesInspectionResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInspectionResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesInspectionResponseData
 */
export interface ResponsesInspectionResponseData {
    /**
     * 
     * @type {ResponsesInspection}
     * @memberof ResponsesInspectionResponseData
     */
    'inspection'?: ResponsesInspection;
}
/**
 * 
 * @export
 * @interface ResponsesInvitationResponse
 */
export interface ResponsesInvitationResponse {
    /**
     * 
     * @type {ResponsesInvitationResponseData}
     * @memberof ResponsesInvitationResponse
     */
    'data'?: ResponsesInvitationResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInvitationResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInvitationResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesInvitationResponseData
 */
export interface ResponsesInvitationResponseData {
    /**
     * 
     * @type {ResponsesOrganizationInvitation}
     * @memberof ResponsesInvitationResponseData
     */
    'invitation'?: ResponsesOrganizationInvitation;
}
/**
 * 
 * @export
 * @interface ResponsesLinkDomain
 */
export interface ResponsesLinkDomain {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLinkDomain
     */
    'alternativeLinkDomain': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLinkDomain
     */
    'defaultLinkDomain': string;
}
/**
 * 
 * @export
 * @interface ResponsesLoad
 */
export interface ResponsesLoad {
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'account_manager_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'account_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'accounting_status'?: string | null;
    /**
     * 
     * @type {ResponsesCarrierSummary}
     * @memberof ResponsesLoad
     */
    'carrier'?: ResponsesCarrierSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'carrier_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'commodity_class'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoad
     */
    'covered'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'created_by'?: string | null;
    /**
     * 
     * @type {ResponsesGeoLocation}
     * @memberof ResponsesLoad
     */
    'current_location'?: ResponsesGeoLocation;
    /**
     * 
     * @type {ResponsesCustomerSummary}
     * @memberof ResponsesLoad
     */
    'customer'?: ResponsesCustomerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'customer_id'?: string;
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'customer_sale_agent_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'customer_sale_agent_user_id'?: string | null;
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'customer_service_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'customer_service_user_id'?: string | null;
    /**
     * 
     * @type {ResponsesLocationSummary}
     * @memberof ResponsesLoad
     */
    'destination'?: ResponsesLocationSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'dispatched_at'?: string | null;
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'dispatched_by_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'dispatched_by_user_id'?: string | null;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesLoad
     */
    'driver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {Array<ResponsesDriverSummary>}
     * @memberof ResponsesLoad
     */
    'drivers'?: Array<ResponsesDriverSummary>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'empty_miles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoad
     */
    'empty_miles_manually_entered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'equipment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'eta'?: string | null;
    /**
     * 
     * @type {ResponsesLoadFinancials}
     * @memberof ResponsesLoad
     */
    'financials'?: ResponsesLoadFinancials;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoad
     */
    'hazmat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'load_number'?: string;
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'load_planner_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'load_planner_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'mileage_route_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'mileage_source'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'miles'?: number | null;
    /**
     * 
     * @type {ResponsesMoneyBox}
     * @memberof ResponsesLoad
     */
    'money_box'?: ResponsesMoneyBox;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {ResponsesLocationSummary}
     * @memberof ResponsesLoad
     */
    'origin'?: ResponsesLocationSummary;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'pallet_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'piece_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'po_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'previous_stop_load_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoad
     */
    'previous_stop_manually_entered'?: boolean;
    /**
     * 
     * @type {Array<ResponsesReference>}
     * @memberof ResponsesLoad
     */
    'references'?: Array<ResponsesReference>;
    /**
     * 
     * @type {ResponsesUserSummary}
     * @memberof ResponsesLoad
     */
    'sales_manager_user'?: ResponsesUserSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'sales_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'special_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'status'?: string;
    /**
     * 
     * @type {Array<ResponsesStop>}
     * @memberof ResponsesLoad
     */
    'stops'?: Array<ResponsesStop>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoad
     */
    'team_required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {ResponsesTrailerSummary}
     * @memberof ResponsesLoad
     */
    'trailer'?: ResponsesTrailerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'trailer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'trip_number'?: string | null;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesLoad
     */
    'truck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoad
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoad
     */
    'weight_lbs'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesLoadAddress
 */
export interface ResponsesLoadAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'street1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadAddress
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadCheckCall
 */
export interface ResponsesLoadCheckCall {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'check_call_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'created_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'driver_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'note'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadCheckCall
     */
    'return_temperature'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadCheckCall
     */
    'setpoint_temperature'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'stop_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'stop_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCall
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadCheckCallListResponse
 */
export interface ResponsesLoadCheckCallListResponse {
    /**
     * 
     * @type {ResponsesLoadCheckCallListResponseData}
     * @memberof ResponsesLoadCheckCallListResponse
     */
    'data'?: ResponsesLoadCheckCallListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCallListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCallListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadCheckCallListResponseData
 */
export interface ResponsesLoadCheckCallListResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadCheckCall>}
     * @memberof ResponsesLoadCheckCallListResponseData
     */
    'check_calls'?: Array<ResponsesLoadCheckCall>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadCheckCallListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadCheckCallResponse
 */
export interface ResponsesLoadCheckCallResponse {
    /**
     * 
     * @type {ResponsesLoadCheckCallResponseData}
     * @memberof ResponsesLoadCheckCallResponse
     */
    'data'?: ResponsesLoadCheckCallResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCallResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadCheckCallResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadCheckCallResponseData
 */
export interface ResponsesLoadCheckCallResponseData {
    /**
     * 
     * @type {ResponsesLoadCheckCall}
     * @memberof ResponsesLoadCheckCallResponseData
     */
    'check_call'?: ResponsesLoadCheckCall;
}
/**
 * 
 * @export
 * @interface ResponsesLoadEstimateData
 */
export interface ResponsesLoadEstimateData {
    /**
     * 
     * @type {ResponsesAppliedRates}
     * @memberof ResponsesLoadEstimateData
     */
    'appliedRates'?: ResponsesAppliedRates;
    /**
     * 
     * @type {ResponsesCostBreakdown}
     * @memberof ResponsesLoadEstimateData
     */
    'costBreakdown'?: ResponsesCostBreakdown;
    /**
     * 
     * @type {Array<ResponsesRouteLeg>}
     * @memberof ResponsesLoadEstimateData
     */
    'legs'?: Array<ResponsesRouteLeg>;
    /**
     * 
     * @type {ResponsesRevenueEstimate}
     * @memberof ResponsesLoadEstimateData
     */
    'revenue'?: ResponsesRevenueEstimate;
    /**
     * 
     * @type {Array<ResponsesRouteOptionData>}
     * @memberof ResponsesLoadEstimateData
     */
    'routeOptions'?: Array<ResponsesRouteOptionData>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadEstimateData
     */
    'selectedRoute'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadEstimateData
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadEstimateData
     */
    'totalMiles'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesLoadEstimateResponse
 */
export interface ResponsesLoadEstimateResponse {
    /**
     * 
     * @type {ResponsesLoadEstimateData}
     * @memberof ResponsesLoadEstimateResponse
     */
    'data'?: ResponsesLoadEstimateData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadEstimateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadEstimateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadFinancials
 */
export interface ResponsesLoadFinancials {
    /**
     * 
     * @type {Array<ResponsesAccessorialCharge>}
     * @memberof ResponsesLoadFinancials
     */
    'accessorials'?: Array<ResponsesAccessorialCharge>;
    /**
     * 
     * @type {Array<ResponsesAccessorialCharge>}
     * @memberof ResponsesLoadFinancials
     */
    'carrier_accessorials'?: Array<ResponsesAccessorialCharge>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'carrier_fuel_surcharge'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'carrier_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'fuel_surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'fuel_surcharge_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'line_haul'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'margin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'margin_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'total_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadFinancials
     */
    'total_revenue'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesLoadHistory
 */
export interface ResponsesLoadHistory {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'ip_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'load_id'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesLoadHistory
     */
    'new_value'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesLoadHistory
     */
    'old_value'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistory
     */
    'user_name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadHistoryResponse
 */
export interface ResponsesLoadHistoryResponse {
    /**
     * 
     * @type {ResponsesLoadHistoryResponseData}
     * @memberof ResponsesLoadHistoryResponse
     */
    'data'?: ResponsesLoadHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadHistoryResponseData
 */
export interface ResponsesLoadHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadHistory>}
     * @memberof ResponsesLoadHistoryResponseData
     */
    'history'?: Array<ResponsesLoadHistory>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoice
 */
export interface ResponsesLoadInvoice {
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoice
     */
    'amount_paid'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoice
     */
    'balance_due'?: number;
    /**
     * 
     * @type {ResponsesCustomerAddress}
     * @memberof ResponsesLoadInvoice
     */
    'bill_to_address'?: ResponsesCustomerAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'bill_to_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'bill_to_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'customer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'invoice_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'invoice_number'?: string;
    /**
     * 
     * @type {Array<ResponsesLoadInvoiceLineItem>}
     * @memberof ResponsesLoadInvoice
     */
    'line_items'?: Array<ResponsesLoadInvoiceLineItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'load_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'load_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'paid_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'pdf_document_unid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'pdf_generated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'pdf_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'po_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoice
     */
    'revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'sent_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'status'?: string;
    /**
     * 
     * @type {Array<ResponsesLoadInvoiceStop>}
     * @memberof ResponsesLoadInvoice
     */
    'stops'?: Array<ResponsesLoadInvoiceStop>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoice
     */
    'total_charges'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'void_reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoice
     */
    'voided_at'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceLineItem
 */
export interface ResponsesLoadInvoiceLineItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceLineItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceLineItem
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceLineItem
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceLineItem
     */
    'units'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceLineItem
     */
    'uom'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceListResponse
 */
export interface ResponsesLoadInvoiceListResponse {
    /**
     * 
     * @type {ResponsesLoadInvoiceListResponseData}
     * @memberof ResponsesLoadInvoiceListResponse
     */
    'data'?: ResponsesLoadInvoiceListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceListResponseData
 */
export interface ResponsesLoadInvoiceListResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadInvoiceListSummary>}
     * @memberof ResponsesLoadInvoiceListResponseData
     */
    'invoices'?: Array<ResponsesLoadInvoiceListSummary>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadInvoiceListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceListSummary
 */
export interface ResponsesLoadInvoiceListSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'amount_paid'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'balance_due'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'bill_to_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'customer_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'invoice_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'invoice_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'load_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'load_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'total_charges'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceListSummary
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceReference
 */
export interface ResponsesLoadInvoiceReference {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceReference
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceReference
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceResponse
 */
export interface ResponsesLoadInvoiceResponse {
    /**
     * 
     * @type {ResponsesLoadInvoiceResponseData}
     * @memberof ResponsesLoadInvoiceResponse
     */
    'data'?: ResponsesLoadInvoiceResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceResponseData
 */
export interface ResponsesLoadInvoiceResponseData {
    /**
     * 
     * @type {ResponsesLoadInvoice}
     * @memberof ResponsesLoadInvoiceResponseData
     */
    'invoice'?: ResponsesLoadInvoice;
}
/**
 * 
 * @export
 * @interface ResponsesLoadInvoiceStop
 */
export interface ResponsesLoadInvoiceStop {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceStop
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceStop
     */
    'company_name'?: string;
    /**
     * 
     * @type {Array<ResponsesLoadInvoiceReference>}
     * @memberof ResponsesLoadInvoiceStop
     */
    'reference_numbers'?: Array<ResponsesLoadInvoiceReference>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadInvoiceStop
     */
    'sequence'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceStop
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceStop
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadInvoiceStop
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadListResponse
 */
export interface ResponsesLoadListResponse {
    /**
     * 
     * @type {ResponsesLoadListResponseData}
     * @memberof ResponsesLoadListResponse
     */
    'data'?: ResponsesLoadListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadListResponseData
 */
export interface ResponsesLoadListResponseData {
    /**
     * 
     * @type {Array<ResponsesLoad>}
     * @memberof ResponsesLoadListResponseData
     */
    'loads'?: Array<ResponsesLoad>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {ResponsesLoadListSummary}
     * @memberof ResponsesLoadListResponseData
     */
    'summary'?: ResponsesLoadListSummary;
}
/**
 * 
 * @export
 * @interface ResponsesLoadListSummary
 */
export interface ResponsesLoadListSummary {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResponsesLoadListSummary
     */
    'status_counts'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadListSummary
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadListSummary
     */
    'total_revenue'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLocationHistoryResponse
 */
export interface ResponsesLoadLocationHistoryResponse {
    /**
     * 
     * @type {ResponsesLoadLocationHistoryResponseData}
     * @memberof ResponsesLoadLocationHistoryResponse
     */
    'data'?: ResponsesLoadLocationHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLocationHistoryResponseData
 */
export interface ResponsesLoadLocationHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadLocationPoint>}
     * @memberof ResponsesLoadLocationHistoryResponseData
     */
    'locations'?: Array<ResponsesLoadLocationPoint>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadLocationHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLocationPoint
 */
export interface ResponsesLoadLocationPoint {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationPoint
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationPoint
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadLocationPoint
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadLocationPoint
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadLocationPoint
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationPoint
     */
    'recorded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationPoint
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadLocationPoint
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLocationPoint
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLogEntry
 */
export interface ResponsesLoadLogEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'actor_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'actor_role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'description'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesLoadLogEntry
     */
    'details'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogEntry
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLogsResponse
 */
export interface ResponsesLoadLogsResponse {
    /**
     * 
     * @type {ResponsesLoadLogsResponseData}
     * @memberof ResponsesLoadLogsResponse
     */
    'data'?: ResponsesLoadLogsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadLogsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadLogsResponseData
 */
export interface ResponsesLoadLogsResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadLogEntry>}
     * @memberof ResponsesLoadLogsResponseData
     */
    'logs'?: Array<ResponsesLoadLogEntry>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadLogsResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadResponse
 */
export interface ResponsesLoadResponse {
    /**
     * 
     * @type {ResponsesLoadResponseData}
     * @memberof ResponsesLoadResponse
     */
    'data'?: ResponsesLoadResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadResponseData
 */
export interface ResponsesLoadResponseData {
    /**
     * 
     * @type {ResponsesLoad}
     * @memberof ResponsesLoadResponseData
     */
    'load'?: ResponsesLoad;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStats
 */
export interface ResponsesLoadStats {
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'active_loads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'average_miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'average_revenue'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResponsesLoadStats
     */
    'by_status'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'delivered_loads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'on_time_percentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'pending_loads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'total_loads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'total_miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStats
     */
    'total_revenue'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatsResponse
 */
export interface ResponsesLoadStatsResponse {
    /**
     * 
     * @type {ResponsesLoadStatsResponseData}
     * @memberof ResponsesLoadStatsResponse
     */
    'data'?: ResponsesLoadStatsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatsResponseData
 */
export interface ResponsesLoadStatsResponseData {
    /**
     * 
     * @type {ResponsesLoadStats}
     * @memberof ResponsesLoadStatsResponseData
     */
    'stats'?: ResponsesLoadStats;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusLogEntry
 */
export interface ResponsesLoadStatusLogEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'changed_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'duration_seconds'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'entered_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'exited_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusLogEntry
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusQueryResponse
 */
export interface ResponsesLoadStatusQueryResponse {
    /**
     * 
     * @type {ResponsesLoadStatusQueryResponseData}
     * @memberof ResponsesLoadStatusQueryResponse
     */
    'data'?: ResponsesLoadStatusQueryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusQueryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusQueryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusQueryResponseData
 */
export interface ResponsesLoadStatusQueryResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadStatusSnapshot>}
     * @memberof ResponsesLoadStatusQueryResponseData
     */
    'loads'?: Array<ResponsesLoadStatusSnapshot>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadStatusQueryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusSnapshot
 */
export interface ResponsesLoadStatusSnapshot {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusSnapshot
     */
    'entered_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusSnapshot
     */
    'load_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusSnapshot
     */
    'load_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusSnapshot
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusTimelineResponse
 */
export interface ResponsesLoadStatusTimelineResponse {
    /**
     * 
     * @type {ResponsesLoadStatusTimelineResponseData}
     * @memberof ResponsesLoadStatusTimelineResponse
     */
    'data'?: ResponsesLoadStatusTimelineResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusTimelineResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadStatusTimelineResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadStatusTimelineResponseData
 */
export interface ResponsesLoadStatusTimelineResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadStatusLogEntry>}
     * @memberof ResponsesLoadStatusTimelineResponseData
     */
    'timeline'?: Array<ResponsesLoadStatusLogEntry>;
}
/**
 * 
 * @export
 * @interface ResponsesLoadSummary
 */
export interface ResponsesLoadSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadSummary
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadSummary
     */
    'loadNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplate
 */
export interface ResponsesLoadTemplate {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesCustomerSummary}
     * @memberof ResponsesLoadTemplate
     */
    'customer'?: ResponsesCustomerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'default_fuel_surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'default_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'delivery_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'equipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'estimated_miles'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoadTemplate
     */
    'hazmat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoadTemplate
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'pickup_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesLoadTemplate
     */
    'required_endorsements'?: Array<string>;
    /**
     * 
     * @type {Array<ResponsesLoadTemplateStop>}
     * @memberof ResponsesLoadTemplate
     */
    'stops'?: Array<ResponsesLoadTemplateStop>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'times_used'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplate
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplate
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplateListResponse
 */
export interface ResponsesLoadTemplateListResponse {
    /**
     * 
     * @type {ResponsesLoadTemplateListResponseData}
     * @memberof ResponsesLoadTemplateListResponse
     */
    'data'?: ResponsesLoadTemplateListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplateListResponseData
 */
export interface ResponsesLoadTemplateListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesLoadTemplateListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesLoadTemplate>}
     * @memberof ResponsesLoadTemplateListResponseData
     */
    'templates'?: Array<ResponsesLoadTemplate>;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplateResponse
 */
export interface ResponsesLoadTemplateResponse {
    /**
     * 
     * @type {ResponsesLoadTemplateResponseData}
     * @memberof ResponsesLoadTemplateResponse
     */
    'data'?: ResponsesLoadTemplateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplateResponseData
 */
export interface ResponsesLoadTemplateResponseData {
    /**
     * 
     * @type {ResponsesLoadTemplate}
     * @memberof ResponsesLoadTemplateResponseData
     */
    'template'?: ResponsesLoadTemplate;
}
/**
 * 
 * @export
 * @interface ResponsesLoadTemplateStop
 */
export interface ResponsesLoadTemplateStop {
    /**
     * 
     * @type {ResponsesLoadAddress}
     * @memberof ResponsesLoadTemplateStop
     */
    'address'?: ResponsesLoadAddress;
    /**
     * 
     * @type {ResponsesContact}
     * @memberof ResponsesLoadTemplateStop
     */
    'contact'?: ResponsesContact;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'default_window_end_hour'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'default_window_start_hour'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'estimated_duration'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateStop
     */
    'facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateStop
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'miles_to_next'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'photos_required'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoadTemplateStop
     */
    'pod_required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesLoadTemplateStop
     */
    'signature_required'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLoadTemplateStop
     */
    'stop_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadTemplateStop
     */
    'stop_type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoadValidationItem
 */
export interface ResponsesLoadValidationItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadValidationItem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadValidationItem
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoadValidationItem
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLocation
 */
export interface ResponsesLocation {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLocation
     */
    'address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLocation
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesLocation
     */
    'lng'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLocation
     */
    'updatedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesLocationSummary
 */
export interface ResponsesLocationSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesLocationSummary
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLocationSummary
     */
    'postal_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLocationSummary
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoginResponse
 */
export interface ResponsesLoginResponse {
    /**
     * 
     * @type {ResponsesLoginResponseData}
     * @memberof ResponsesLoginResponse
     */
    'data': ResponsesLoginResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoginResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLoginResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLoginResponseData
 */
export interface ResponsesLoginResponseData {
    /**
     * 
     * @type {ResponsesUserAuth}
     * @memberof ResponsesLoginResponseData
     */
    'auth': ResponsesUserAuth;
    /**
     * 
     * @type {ResponsesUser}
     * @memberof ResponsesLoginResponseData
     */
    'user': ResponsesUser;
}
/**
 * 
 * @export
 * @interface ResponsesLowStockPartsResponse
 */
export interface ResponsesLowStockPartsResponse {
    /**
     * 
     * @type {ResponsesLowStockPartsResponseData}
     * @memberof ResponsesLowStockPartsResponse
     */
    'data'?: ResponsesLowStockPartsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLowStockPartsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesLowStockPartsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesLowStockPartsResponseData
 */
export interface ResponsesLowStockPartsResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesLowStockPartsResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesPart>}
     * @memberof ResponsesLowStockPartsResponseData
     */
    'parts'?: Array<ResponsesPart>;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenance
 */
export interface ResponsesMaintenance {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'completedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'engineHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'equipmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'equipmentNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'intervalDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'intervalHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'intervalMiles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'maintenanceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'maintenanceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'nextDueDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'nextDueHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'nextDueOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesMaintenance
     */
    'recurring'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenance
     */
    'reeferHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'scheduledDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'status'?: string;
    /**
     * 
     * @type {ResponsesTrailerSummary}
     * @memberof ResponsesMaintenance
     */
    'trailer'?: ResponsesTrailerSummary;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesMaintenance
     */
    'truck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'vmrsDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenance
     */
    'workOrderId'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceDashboardMetrics
 */
export interface ResponsesMaintenanceDashboardMetrics {
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceDashboardMetrics
     */
    'openWorkOrders'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceDashboardMetrics
     */
    'overdue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceDashboardMetrics
     */
    'upcoming30Days'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceDashboardMetrics
     */
    'upcoming7Days'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceEquipment
 */
export interface ResponsesMaintenanceEquipment {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesMaintenanceEquipment
     */
    'checkEngineLightOn'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'currentOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'defLevel'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'engineHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'fuelLevel'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'inspectionExpiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'lastServiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'lastServiceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'nextServiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'nextServiceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'odometerUpdated'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'openWorkOrders'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'overdueMaintenance'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'registrationExpiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'scheduledMaintenance'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceEquipment
     */
    'vin'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMaintenanceEquipment
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceFleetResponse
 */
export interface ResponsesMaintenanceFleetResponse {
    /**
     * 
     * @type {ResponsesMaintenanceFleetResponseData}
     * @memberof ResponsesMaintenanceFleetResponse
     */
    'data'?: ResponsesMaintenanceFleetResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceFleetResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceFleetResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceFleetResponseData
 */
export interface ResponsesMaintenanceFleetResponseData {
    /**
     * 
     * @type {Array<ResponsesMaintenanceEquipment>}
     * @memberof ResponsesMaintenanceFleetResponseData
     */
    'equipment'?: Array<ResponsesMaintenanceEquipment>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesMaintenanceFleetResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceListResponse
 */
export interface ResponsesMaintenanceListResponse {
    /**
     * 
     * @type {ResponsesMaintenanceListResponseData}
     * @memberof ResponsesMaintenanceListResponse
     */
    'data'?: ResponsesMaintenanceListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceListResponseData
 */
export interface ResponsesMaintenanceListResponseData {
    /**
     * 
     * @type {Array<ResponsesMaintenance>}
     * @memberof ResponsesMaintenanceListResponseData
     */
    'maintenance'?: Array<ResponsesMaintenance>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesMaintenanceListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceResponse
 */
export interface ResponsesMaintenanceResponse {
    /**
     * 
     * @type {ResponsesMaintenanceResponseData}
     * @memberof ResponsesMaintenanceResponse
     */
    'data'?: ResponsesMaintenanceResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMaintenanceResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMaintenanceResponseData
 */
export interface ResponsesMaintenanceResponseData {
    /**
     * 
     * @type {ResponsesMaintenance}
     * @memberof ResponsesMaintenanceResponseData
     */
    'maintenance'?: ResponsesMaintenance;
}
/**
 * 
 * @export
 * @interface ResponsesMedicalCardInfo
 */
export interface ResponsesMedicalCardInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMedicalCardInfo
     */
    'exam_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMedicalCardInfo
     */
    'examiner_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMedicalCardInfo
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMedicalCardInfo
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMileageSourceOption
 */
export interface ResponsesMileageSourceOption {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMileageSourceOption
     */
    'label'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesMileageSourceOption
     */
    'route_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMileageSourceOption
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMileageSourceOptionsResponse
 */
export interface ResponsesMileageSourceOptionsResponse {
    /**
     * 
     * @type {ResponsesMileageSourceOptionsResponseData}
     * @memberof ResponsesMileageSourceOptionsResponse
     */
    'data'?: ResponsesMileageSourceOptionsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMileageSourceOptionsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMileageSourceOptionsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesMileageSourceOptionsResponseData
 */
export interface ResponsesMileageSourceOptionsResponseData {
    /**
     * 
     * @type {Array<ResponsesMileageSourceOption>}
     * @memberof ResponsesMileageSourceOptionsResponseData
     */
    'sources'?: Array<ResponsesMileageSourceOption>;
}
/**
 * 
 * @export
 * @interface ResponsesMoneyBox
 */
export interface ResponsesMoneyBox {
    /**
     * 
     * @type {ResponsesMoneyBoxCarrier}
     * @memberof ResponsesMoneyBox
     */
    'carrier'?: ResponsesMoneyBoxCarrier;
    /**
     * 
     * @type {ResponsesMoneyBoxCustomerRate}
     * @memberof ResponsesMoneyBox
     */
    'customer_rate'?: ResponsesMoneyBoxCustomerRate;
    /**
     * 
     * @type {Array<ResponsesMoneyBoxDriverPay>}
     * @memberof ResponsesMoneyBox
     */
    'driver_pays'?: Array<ResponsesMoneyBoxDriverPay>;
}
/**
 * 
 * @export
 * @interface ResponsesMoneyBoxCarrier
 */
export interface ResponsesMoneyBoxCarrier {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxCarrier
     */
    'carrier_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCarrier
     */
    'empty_miles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCarrier
     */
    'line_haul'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCarrier
     */
    'loaded_miles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCarrier
     */
    'payable'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesMoneyBoxCustomerRate
 */
export interface ResponsesMoneyBoxCustomerRate {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxCustomerRate
     */
    'customer_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCustomerRate
     */
    'freight_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCustomerRate
     */
    'fuel_surcharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCustomerRate
     */
    'line_haul'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxCustomerRate
     */
    'total_billable'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesMoneyBoxDriverPay
 */
export interface ResponsesMoneyBoxDriverPay {
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'driver_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'driver_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'driver_unid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'line_haul'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'load_revenue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'pay_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'pay_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'payable'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesMoneyBoxDriverPay
     */
    'total_miles'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesOTPChallengeResponse
 */
export interface ResponsesOTPChallengeResponse {
    /**
     * 
     * @type {ResponsesOTPChallengeResponseData}
     * @memberof ResponsesOTPChallengeResponse
     */
    'data': ResponsesOTPChallengeResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOTPChallengeResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOTPChallengeResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOTPChallengeResponseData
 */
export interface ResponsesOTPChallengeResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesOTPChallengeResponseData
     */
    'delivery_method'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOTPChallengeResponseData
     */
    'delivery_target'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOTPChallengeResponseData
     */
    'session'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganization
 */
export interface ResponsesOrganization {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesOrganization
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesOrganization
     */
    'addAddressToEmailFooter': boolean;
    /**
     * 
     * @type {ResponsesOrganizationAddress}
     * @memberof ResponsesOrganization
     */
    'address': ResponsesOrganizationAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'businessMode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'coverUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'dateFormat'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'dba'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'distanceUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'domainName': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'dotNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'email'?: string;
    /**
     * 
     * @type {Array<ResponsesEventIntelligenceEvent>}
     * @memberof ResponsesOrganization
     */
    'eventIntelligence'?: Array<ResponsesEventIntelligenceEvent>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesOrganization
     */
    'isOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'legalName'?: string;
    /**
     * 
     * @type {ResponsesLinkDomain}
     * @memberof ResponsesOrganization
     */
    'linkDomain': ResponsesLinkDomain;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'logo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'mcNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'phone'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesOrganization
     */
    'requiredRedirects': { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesOrganization
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'scac'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'secret': string;
    /**
     * 
     * @type {ResponsesOrganizationShareLink}
     * @memberof ResponsesOrganization
     */
    'shareLink': ResponsesOrganizationShareLink;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'slug'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesOrganization
     */
    'socialMediaPreview': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'taxId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'technicianUnid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganization
     */
    'timeZoneOffsetMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'timeZoneText': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganization
     */
    'website'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationAddress
 */
export interface ResponsesOrganizationAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationAddress
     */
    'street'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationInvitation
 */
export interface ResponsesOrganizationInvitation {
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationInvitation
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationInvitation
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationInvitation
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationInvitation
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesOrganizationInvitation
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationInvitation
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationListResponse
 */
export interface ResponsesOrganizationListResponse {
    /**
     * 
     * @type {ResponsesOrganizationListResponseData}
     * @memberof ResponsesOrganizationListResponse
     */
    'data'?: ResponsesOrganizationListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationListResponseData
 */
export interface ResponsesOrganizationListResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationListResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesOrganization>}
     * @memberof ResponsesOrganizationListResponseData
     */
    'organizations'?: Array<ResponsesOrganization>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationListResponseData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationListResponseData
     */
    'pageSize'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationMember
 */
export interface ResponsesOrganizationMember {
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'profilePictureUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesOrganizationMember
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMember
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationMembersResponse
 */
export interface ResponsesOrganizationMembersResponse {
    /**
     * 
     * @type {ResponsesOrganizationMembersResponseData}
     * @memberof ResponsesOrganizationMembersResponse
     */
    'data'?: ResponsesOrganizationMembersResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMembersResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationMembersResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationMembersResponseData
 */
export interface ResponsesOrganizationMembersResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationMembersResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesOrganizationMember>}
     * @memberof ResponsesOrganizationMembersResponseData
     */
    'members': Array<ResponsesOrganizationMember>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationMembersResponseData
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesOrganizationMembersResponseData
     */
    'pageSize'?: number;
    /**
     * 
     * @type {Array<ResponsesPendingInvite>}
     * @memberof ResponsesOrganizationMembersResponseData
     */
    'pendingInvitations': Array<ResponsesPendingInvite>;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationResponse
 */
export interface ResponsesOrganizationResponse {
    /**
     * 
     * @type {ResponsesOrganizationResponseData}
     * @memberof ResponsesOrganizationResponse
     */
    'data'?: ResponsesOrganizationResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationResponseData
 */
export interface ResponsesOrganizationResponseData {
    /**
     * 
     * @type {ResponsesOrganization}
     * @memberof ResponsesOrganizationResponseData
     */
    'organization'?: ResponsesOrganization;
}
/**
 * 
 * @export
 * @interface ResponsesOrganizationShareLink
 */
export interface ResponsesOrganizationShareLink {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesOrganizationShareLink
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesOrganizationShareLink
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface ResponsesPaginationInfo
 */
export interface ResponsesPaginationInfo {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaginationInfo
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaginationInfo
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaginationInfo
     */
    'totalItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaginationInfo
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesPart
 */
export interface ResponsesPart {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'binLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPart
     */
    'isLowStock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'maximumStock'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'minimumStock'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'partNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'preferredSupplier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'quantityOnHand'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'reorderQuantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'unid': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'unitCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPart
     */
    'vmrsDescription'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'warrantyMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPart
     */
    'warrantyMonths'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesPartListResponse
 */
export interface ResponsesPartListResponse {
    /**
     * 
     * @type {ResponsesPartListResponseData}
     * @memberof ResponsesPartListResponse
     */
    'data'?: ResponsesPartListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPartListResponseData
 */
export interface ResponsesPartListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesPartListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesPart>}
     * @memberof ResponsesPartListResponseData
     */
    'parts'?: Array<ResponsesPart>;
}
/**
 * 
 * @export
 * @interface ResponsesPartResponse
 */
export interface ResponsesPartResponse {
    /**
     * 
     * @type {ResponsesPartResponseData}
     * @memberof ResponsesPartResponse
     */
    'data'?: ResponsesPartResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPartResponseData
 */
export interface ResponsesPartResponseData {
    /**
     * 
     * @type {ResponsesPart}
     * @memberof ResponsesPartResponseData
     */
    'part'?: ResponsesPart;
}
/**
 * 
 * @export
 * @interface ResponsesPartUsageRecord
 */
export interface ResponsesPartUsageRecord {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPartUsageRecord
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPartUsageRecord
     */
    'totalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'trailerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'trailerUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'truckId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'truckUnitNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'unid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPartUsageRecord
     */
    'unitCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'usedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'workOrderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageRecord
     */
    'workOrderNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesPartUsageResponse
 */
export interface ResponsesPartUsageResponse {
    /**
     * 
     * @type {ResponsesPartUsageResponseData}
     * @memberof ResponsesPartUsageResponse
     */
    'data'?: ResponsesPartUsageResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPartUsageResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPartUsageResponseData
 */
export interface ResponsesPartUsageResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesPartUsageResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {ResponsesPart}
     * @memberof ResponsesPartUsageResponseData
     */
    'part'?: ResponsesPart;
    /**
     * 
     * @type {Array<ResponsesPartUsageRecord>}
     * @memberof ResponsesPartUsageResponseData
     */
    'usage'?: Array<ResponsesPartUsageRecord>;
}
/**
 * 
 * @export
 * @interface ResponsesPassportInfo
 */
export interface ResponsesPassportInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPassportInfo
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPassportInfo
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPassportInfo
     */
    'number'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPasswordPolicy
 */
export interface ResponsesPasswordPolicy {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPasswordPolicy
     */
    'minimumLength'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPasswordPolicy
     */
    'requireLowercase'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPasswordPolicy
     */
    'requireNumbers'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPasswordPolicy
     */
    'requireSymbols'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPasswordPolicy
     */
    'requireUppercase'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ResponsesPasswordPolicyResponse
 */
export interface ResponsesPasswordPolicyResponse {
    /**
     * 
     * @type {ResponsesPasswordPolicyResponseData}
     * @memberof ResponsesPasswordPolicyResponse
     */
    'data': ResponsesPasswordPolicyResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPasswordPolicyResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPasswordPolicyResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPasswordPolicyResponseData
 */
export interface ResponsesPasswordPolicyResponseData {
    /**
     * 
     * @type {ResponsesPasswordPolicy}
     * @memberof ResponsesPasswordPolicyResponseData
     */
    'passwordPolicy': ResponsesPasswordPolicy;
}
/**
 * 
 * @export
 * @interface ResponsesPaystub
 */
export interface ResponsesPaystub {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'driver_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'driver_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'finalized_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'paid_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'paid_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'pay_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'paystub_number'?: string;
    /**
     * 
     * @type {Array<ResponsesPaystubRecurringChargeItem>}
     * @memberof ResponsesPaystub
     */
    'recurring_charges'?: Array<ResponsesPaystubRecurringChargeItem>;
    /**
     * 
     * @type {Array<ResponsesPaystubSettlementSummary>}
     * @memberof ResponsesPaystub
     */
    'settlements'?: Array<ResponsesPaystubSettlementSummary>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'status'?: string;
    /**
     * 
     * @type {ResponsesPaystubSummary}
     * @memberof ResponsesPaystub
     */
    'summary'?: ResponsesPaystubSummary;
    /**
     * 
     * @type {Array<ResponsesPaystubTaxItem>}
     * @memberof ResponsesPaystub
     */
    'tax_items'?: Array<ResponsesPaystubTaxItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'truck_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'void_reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystub
     */
    'voided_at'?: string | null;
    /**
     * 
     * @type {ResponsesPaystubYTD}
     * @memberof ResponsesPaystub
     */
    'year_to_date'?: ResponsesPaystubYTD;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubListItem
 */
export interface ResponsesPaystubListItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'driver_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubListItem
     */
    'gross_income'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubListItem
     */
    'net_income'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'pay_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'paystub_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubListItem
     */
    'total_trips'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListItem
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubListResponse
 */
export interface ResponsesPaystubListResponse {
    /**
     * 
     * @type {ResponsesPaystubListResponseData}
     * @memberof ResponsesPaystubListResponse
     */
    'data'?: ResponsesPaystubListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubListResponseData
 */
export interface ResponsesPaystubListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesPaystubListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesPaystubListItem>}
     * @memberof ResponsesPaystubListResponseData
     */
    'paystubs'?: Array<ResponsesPaystubListItem>;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubPreviewResponse
 */
export interface ResponsesPaystubPreviewResponse {
    /**
     * 
     * @type {ResponsesPaystubPreviewResponseData}
     * @memberof ResponsesPaystubPreviewResponse
     */
    'data'?: ResponsesPaystubPreviewResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubPreviewResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubPreviewResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubPreviewResponseData
 */
export interface ResponsesPaystubPreviewResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubPreviewResponseData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubRecurringChargeItem
 */
export interface ResponsesPaystubRecurringChargeItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'excluded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubRecurringChargeItem
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubResponse
 */
export interface ResponsesPaystubResponse {
    /**
     * 
     * @type {ResponsesPaystubResponseData}
     * @memberof ResponsesPaystubResponse
     */
    'data'?: ResponsesPaystubResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubResponseData
 */
export interface ResponsesPaystubResponseData {
    /**
     * 
     * @type {ResponsesPaystub}
     * @memberof ResponsesPaystubResponseData
     */
    'paystub'?: ResponsesPaystub;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubSettlementSummary
 */
export interface ResponsesPaystubSettlementSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'accessorial_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'deductions_reimbursements'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'destination_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'destination_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'load_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'load_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'load_pay'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'origin_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'origin_state'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'pay_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'pay_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'settlement_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubSettlementSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubStatsResponse
 */
export interface ResponsesPaystubStatsResponse {
    /**
     * 
     * @type {ResponsesPaystubStatsResponseData}
     * @memberof ResponsesPaystubStatsResponse
     */
    'data'?: ResponsesPaystubStatsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubStatsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubStatsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubStatsResponseData
 */
export interface ResponsesPaystubStatsResponseData {
    /**
     * 
     * @type {ResponsesPaystubStatusStats}
     * @memberof ResponsesPaystubStatsResponseData
     */
    'draft'?: ResponsesPaystubStatusStats;
    /**
     * 
     * @type {ResponsesPaystubStatusStats}
     * @memberof ResponsesPaystubStatsResponseData
     */
    'statements'?: ResponsesPaystubStatusStats;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubStatusStats
 */
export interface ResponsesPaystubStatusStats {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubStatusStats
     */
    'paystub_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubStatusStats
     */
    'total_net_pay'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubSummary
 */
export interface ResponsesPaystubSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'accessorial_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'credits'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'deductions_reimbursements'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'driver_payment'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'gross_income'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'net_income'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'recurring_bonuses'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'recurring_deductions'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'total_miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'total_taxes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'total_trips'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubSummary
     */
    'trips_pay'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubTaxItem
 */
export interface ResponsesPaystubTaxItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubTaxItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubTaxItem
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPaystubTaxItem
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPaystubYTD
 */
export interface ResponsesPaystubYTD {
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubYTD
     */
    'total_gross'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPaystubYTD
     */
    'total_net'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesPendingInvite
 */
export interface ResponsesPendingInvite {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPendingInvite
     */
    'expired': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'expiresAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesPendingInvite
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPendingInvite
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ResponsesPlanDetailResponse
 */
export interface ResponsesPlanDetailResponse {
    /**
     * 
     * @type {ResponsesPlanDetailResponseData}
     * @memberof ResponsesPlanDetailResponse
     */
    'data'?: ResponsesPlanDetailResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanDetailResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanDetailResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPlanDetailResponseData
 */
export interface ResponsesPlanDetailResponseData {
    /**
     * 
     * @type {ResponsesPlanResponse}
     * @memberof ResponsesPlanDetailResponseData
     */
    'plan'?: ResponsesPlanResponse;
}
/**
 * 
 * @export
 * @interface ResponsesPlanFeatureResponse
 */
export interface ResponsesPlanFeatureResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'description'?: string;
    /**
     * 
     * @type {ResponsesFeatureDisplayResponse}
     * @memberof ResponsesPlanFeatureResponse
     */
    'display'?: ResponsesFeatureDisplayResponse;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPlanFeatureResponse
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'key'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanFeatureResponse
     */
    'limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ResponsesFeatureTranslationResponse>}
     * @memberof ResponsesPlanFeatureResponse
     */
    'translations'?: Array<ResponsesFeatureTranslationResponse>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanFeatureResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesPlanResponse
 */
export interface ResponsesPlanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPlanResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanResponse
     */
    'allowedOrgSeats'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanResponse
     */
    'allowedTeamSize'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'currency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPlanResponse
     */
    'discontinued'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'displayName'?: string;
    /**
     * 
     * @type {Array<ResponsesPlanFeatureResponse>}
     * @memberof ResponsesPlanResponse
     */
    'features'?: Array<ResponsesPlanFeatureResponse>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'interval'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesPlanResponse
     */
    'popular'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanResponse
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<ResponsesPlanTranslationResponse>}
     * @memberof ResponsesPlanResponse
     */
    'translations'?: Array<ResponsesPlanTranslationResponse>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPlanResponse
     */
    'trialDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesPlanTranslationResponse
 */
export interface ResponsesPlanTranslationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'tagline'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlanTranslationResponse
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesPlansResponse
 */
export interface ResponsesPlansResponse {
    /**
     * 
     * @type {ResponsesPlansResponseData}
     * @memberof ResponsesPlansResponse
     */
    'data'?: ResponsesPlansResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlansResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPlansResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPlansResponseData
 */
export interface ResponsesPlansResponseData {
    /**
     * 
     * @type {Array<ResponsesPlanResponse>}
     * @memberof ResponsesPlansResponseData
     */
    'plans'?: Array<ResponsesPlanResponse>;
}
/**
 * 
 * @export
 * @interface ResponsesPreviousStopLoadOption
 */
export interface ResponsesPreviousStopLoadOption {
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'delivery_date'?: string;
    /**
     * 
     * @type {ResponsesLocationSummary}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'destination'?: ResponsesLocationSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'driver_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'load_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'miles'?: number | null;
    /**
     * 
     * @type {ResponsesLocationSummary}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'origin'?: ResponsesLocationSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'pickup_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOption
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPreviousStopLoadOptionsResponse
 */
export interface ResponsesPreviousStopLoadOptionsResponse {
    /**
     * 
     * @type {ResponsesPreviousStopLoadOptionsResponseData}
     * @memberof ResponsesPreviousStopLoadOptionsResponse
     */
    'data'?: ResponsesPreviousStopLoadOptionsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOptionsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesPreviousStopLoadOptionsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesPreviousStopLoadOptionsResponseData
 */
export interface ResponsesPreviousStopLoadOptionsResponseData {
    /**
     * 
     * @type {Array<ResponsesPreviousStopLoadOption>}
     * @memberof ResponsesPreviousStopLoadOptionsResponseData
     */
    'loads'?: Array<ResponsesPreviousStopLoadOption>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesPreviousStopLoadOptionsResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesProfitabilityMetric
 */
export interface ResponsesProfitabilityMetric {
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityMetric
     */
    'gross_margin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityMetric
     */
    'gross_profit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityMetric
     */
    'group_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityMetric
     */
    'group_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityMetric
     */
    'load_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityMetric
     */
    'total_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityMetric
     */
    'total_revenue'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesProfitabilityReportResponse
 */
export interface ResponsesProfitabilityReportResponse {
    /**
     * 
     * @type {ResponsesProfitabilityReportResponseData}
     * @memberof ResponsesProfitabilityReportResponse
     */
    'data'?: ResponsesProfitabilityReportResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityReportResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityReportResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesProfitabilityReportResponseData
 */
export interface ResponsesProfitabilityReportResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'gross_margin'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'gross_profit'?: number;
    /**
     * 
     * @type {Array<ResponsesProfitabilityMetric>}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'metrics'?: Array<ResponsesProfitabilityMetric>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'period_end'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'period_start'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'total_cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesProfitabilityReportResponseData
     */
    'total_revenue'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBAccountMappingResp
 */
export interface ResponsesQBAccountMappingResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'category'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBAccountMappingResp
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'qbExpenseAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'qbExpenseAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'qbRevenueAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'qbRevenueAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountMappingResp
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBAccountResp
 */
export interface ResponsesQBAccountResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountResp
     */
    'accountSubType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountResp
     */
    'accountType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBAccountResp
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountResp
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountResp
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBAccountsData
 */
export interface ResponsesQBAccountsData {
    /**
     * 
     * @type {Array<ResponsesQBAccountResp>}
     * @memberof ResponsesQBAccountsData
     */
    'accounts'?: Array<ResponsesQBAccountResp>;
    /**
     * 
     * @type {Array<ResponsesQBAccountMappingResp>}
     * @memberof ResponsesQBAccountsData
     */
    'mappings'?: Array<ResponsesQBAccountMappingResp>;
    /**
     * 
     * @type {Array<ResponsesQBTMSCategoryResp>}
     * @memberof ResponsesQBAccountsData
     */
    'tmsCategories'?: Array<ResponsesQBTMSCategoryResp>;
}
/**
 * 
 * @export
 * @interface ResponsesQBAccountsResponse
 */
export interface ResponsesQBAccountsResponse {
    /**
     * 
     * @type {ResponsesQBAccountsData}
     * @memberof ResponsesQBAccountsResponse
     */
    'data'?: ResponsesQBAccountsData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAccountsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBAuthURLData
 */
export interface ResponsesQBAuthURLData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAuthURLData
     */
    'authorizationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAuthURLData
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBAuthURLResponse
 */
export interface ResponsesQBAuthURLResponse {
    /**
     * 
     * @type {ResponsesQBAuthURLData}
     * @memberof ResponsesQBAuthURLResponse
     */
    'data'?: ResponsesQBAuthURLData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAuthURLResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBAuthURLResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBCachedAccountResp
 */
export interface ResponsesQBCachedAccountResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'accountSubType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'accountType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBCachedAccountResp
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'cachedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'classification'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBCachedAccountResp
     */
    'currentBalance'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'fullyQualified'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountResp
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBCachedAccountsFetchResponse
 */
export interface ResponsesQBCachedAccountsFetchResponse {
    /**
     * 
     * @type {ResponsesQBCachedAccountsFetchResponseData}
     * @memberof ResponsesQBCachedAccountsFetchResponse
     */
    'data'?: ResponsesQBCachedAccountsFetchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsFetchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsFetchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBCachedAccountsFetchResponseData
 */
export interface ResponsesQBCachedAccountsFetchResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsFetchResponseData
     */
    'cachedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsFetchResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBCachedAccountsFetchResponseData
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBCachedAccountsFetchResponseData
     */
    'totalFetched'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBCachedAccountsListResponse
 */
export interface ResponsesQBCachedAccountsListResponse {
    /**
     * 
     * @type {ResponsesQBCachedAccountsListResponseData}
     * @memberof ResponsesQBCachedAccountsListResponse
     */
    'data'?: ResponsesQBCachedAccountsListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBCachedAccountsListResponseData
 */
export interface ResponsesQBCachedAccountsListResponseData {
    /**
     * 
     * @type {Array<ResponsesQBCachedAccountResp>}
     * @memberof ResponsesQBCachedAccountsListResponseData
     */
    'accounts'?: Array<ResponsesQBCachedAccountResp>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBCachedAccountsListResponseData
     */
    'cachedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBCachedAccountsListResponseData
     */
    'totalCached'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBDisconnectData
 */
export interface ResponsesQBDisconnectData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBDisconnectData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBDisconnectData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesQBDisconnectResponse
 */
export interface ResponsesQBDisconnectResponse {
    /**
     * 
     * @type {ResponsesQBDisconnectData}
     * @memberof ResponsesQBDisconnectResponse
     */
    'data'?: ResponsesQBDisconnectData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBDisconnectResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBDisconnectResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMapAccountsData
 */
export interface ResponsesQBMapAccountsData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMapAccountsData
     */
    'mapped'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBMapAccountsData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesQBMapAccountsResponse
 */
export interface ResponsesQBMapAccountsResponse {
    /**
     * 
     * @type {ResponsesQBMapAccountsData}
     * @memberof ResponsesQBMapAccountsResponse
     */
    'data'?: ResponsesQBMapAccountsData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMapAccountsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMapAccountsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingCategoryResp
 */
export interface ResponsesQBMappingCategoryResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'displayName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'mappedTags'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'mappingType'?: string;
    /**
     * 
     * @type {Array<ResponsesQBMappingListItemResp>}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'mappings'?: Array<ResponsesQBMappingListItemResp>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingCategoryResp
     */
    'totalTags'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingCountsResp
 */
export interface ResponsesQBMappingCountsResp {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingCountsResp
     */
    'mapped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingCountsResp
     */
    'unmapped'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingListItemResp
 */
export interface ResponsesQBMappingListItemResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBMappingListItemResp
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'qbExpenseAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'qbExpenseAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'qbRevenueAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'qbRevenueAccountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'tag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingListItemResp
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingSeededResp
 */
export interface ResponsesQBMappingSeededResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingSeededResp
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingSeededResp
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingSeededResp
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingSummaryResp
 */
export interface ResponsesQBMappingSummaryResp {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingSummaryResp
     */
    'completionPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingSummaryResp
     */
    'totalCategories'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingSummaryResp
     */
    'totalMapped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingSummaryResp
     */
    'totalTags'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingSummaryResp
     */
    'totalUnmapped'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingValidationIssue
 */
export interface ResponsesQBMappingValidationIssue {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingValidationIssue
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingValidationIssue
     */
    'issue'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingValidationIssue
     */
    'recommended'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingValidationIssue
     */
    'severity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingValidationIssue
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsBulkSaveResponse
 */
export interface ResponsesQBMappingsBulkSaveResponse {
    /**
     * 
     * @type {ResponsesQBMappingsBulkSaveResponseData}
     * @memberof ResponsesQBMappingsBulkSaveResponse
     */
    'data'?: ResponsesQBMappingsBulkSaveResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsBulkSaveResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsBulkSaveResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsBulkSaveResponseData
 */
export interface ResponsesQBMappingsBulkSaveResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'category'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'created'?: number;
    /**
     * 
     * @type {Array<ResponsesQBMappingListItemResp>}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'mappings'?: Array<ResponsesQBMappingListItemResp>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'skipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsBulkSaveResponseData
     */
    'updated'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsCategoryResponse
 */
export interface ResponsesQBMappingsCategoryResponse {
    /**
     * 
     * @type {ResponsesQBMappingCategoryResp}
     * @memberof ResponsesQBMappingsCategoryResponse
     */
    'data'?: ResponsesQBMappingCategoryResp;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsCategoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsCategoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsCreateResponse
 */
export interface ResponsesQBMappingsCreateResponse {
    /**
     * 
     * @type {ResponsesQBMappingsCreateResponseData}
     * @memberof ResponsesQBMappingsCreateResponse
     */
    'data'?: ResponsesQBMappingsCreateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsCreateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsCreateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsCreateResponseData
 */
export interface ResponsesQBMappingsCreateResponseData {
    /**
     * 
     * @type {ResponsesQBMappingListItemResp}
     * @memberof ResponsesQBMappingsCreateResponseData
     */
    'mapping'?: ResponsesQBMappingListItemResp;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsCreateResponseData
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsDeleteResponse
 */
export interface ResponsesQBMappingsDeleteResponse {
    /**
     * 
     * @type {ResponsesQBMappingsDeleteResponseData}
     * @memberof ResponsesQBMappingsDeleteResponse
     */
    'data'?: ResponsesQBMappingsDeleteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsDeleteResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsDeleteResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsDeleteResponseData
 */
export interface ResponsesQBMappingsDeleteResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsDeleteResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBMappingsDeleteResponseData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsListResponse
 */
export interface ResponsesQBMappingsListResponse {
    /**
     * 
     * @type {ResponsesQBMappingsListResponseData}
     * @memberof ResponsesQBMappingsListResponse
     */
    'data'?: ResponsesQBMappingsListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsListResponseData
 */
export interface ResponsesQBMappingsListResponseData {
    /**
     * 
     * @type {Array<ResponsesQBMappingCategoryResp>}
     * @memberof ResponsesQBMappingsListResponseData
     */
    'categories'?: Array<ResponsesQBMappingCategoryResp>;
    /**
     * 
     * @type {ResponsesQBMappingSummaryResp}
     * @memberof ResponsesQBMappingsListResponseData
     */
    'summary'?: ResponsesQBMappingSummaryResp;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsSeedResponse
 */
export interface ResponsesQBMappingsSeedResponse {
    /**
     * 
     * @type {ResponsesQBMappingsSeedResponseData}
     * @memberof ResponsesQBMappingsSeedResponse
     */
    'data'?: ResponsesQBMappingsSeedResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsSeedResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsSeedResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsSeedResponseData
 */
export interface ResponsesQBMappingsSeedResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsSeedResponseData
     */
    'categoriesSeeded'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsSeedResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ResponsesQBMappingSeededResp>}
     * @memberof ResponsesQBMappingsSeedResponseData
     */
    'seeded'?: Array<ResponsesQBMappingSeededResp>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBMappingsSeedResponseData
     */
    'success'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsSeedResponseData
     */
    'totalSeeded'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsUpdateResponse
 */
export interface ResponsesQBMappingsUpdateResponse {
    /**
     * 
     * @type {ResponsesQBMappingsCreateResponseData}
     * @memberof ResponsesQBMappingsUpdateResponse
     */
    'data'?: ResponsesQBMappingsCreateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsUpdateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsUpdateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsValidateResponse
 */
export interface ResponsesQBMappingsValidateResponse {
    /**
     * 
     * @type {ResponsesQBMappingsValidateResponseData}
     * @memberof ResponsesQBMappingsValidateResponse
     */
    'data'?: ResponsesQBMappingsValidateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsValidateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsValidateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBMappingsValidateResponseData
 */
export interface ResponsesQBMappingsValidateResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'criticalIssues'?: number;
    /**
     * 
     * @type {Array<ResponsesQBMappingValidationIssue>}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'issues'?: Array<ResponsesQBMappingValidationIssue>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'syncType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'totalIssues'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'valid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBMappingsValidateResponseData
     */
    'warningIssues'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBOAuthCallbackData
 */
export interface ResponsesQBOAuthCallbackData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBOAuthCallbackData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBOAuthCallbackData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesQBOAuthCallbackResponse
 */
export interface ResponsesQBOAuthCallbackResponse {
    /**
     * 
     * @type {ResponsesQBOAuthCallbackData}
     * @memberof ResponsesQBOAuthCallbackResponse
     */
    'data'?: ResponsesQBOAuthCallbackData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBOAuthCallbackResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBOAuthCallbackResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBStatusData
 */
export interface ResponsesQBStatusData {
    /**
     * 
     * @type {ResponsesQBMappingCountsResp}
     * @memberof ResponsesQBStatusData
     */
    'accountMappings'?: ResponsesQBMappingCountsResp;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusData
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBStatusData
     */
    'connected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusData
     */
    'connectedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusData
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBStatusData
     */
    'isExpired'?: boolean;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ResponsesQBStatusData
     */
    'lastSync'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusData
     */
    'realmId'?: string | null;
    /**
     * 
     * @type {ResponsesQBMappingCountsResp}
     * @memberof ResponsesQBStatusData
     */
    'vendorMappings'?: ResponsesQBMappingCountsResp;
}
/**
 * 
 * @export
 * @interface ResponsesQBStatusResponse
 */
export interface ResponsesQBStatusResponse {
    /**
     * 
     * @type {ResponsesQBStatusData}
     * @memberof ResponsesQBStatusResponse
     */
    'data'?: ResponsesQBStatusData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBStatusResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBSyncError
 */
export interface ResponsesQBSyncError {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBSyncError
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBSyncError
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBSyncError
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBSyncResultData
 */
export interface ResponsesQBSyncResultData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'created'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'duration'?: number;
    /**
     * 
     * @type {Array<ResponsesQBSyncError>}
     * @memberof ResponsesQBSyncResultData
     */
    'errors'?: Array<ResponsesQBSyncError>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'synced'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'updated'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQBSyncResultData
     */
    'vendorsCreated'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesQBSyncResultResponse
 */
export interface ResponsesQBSyncResultResponse {
    /**
     * 
     * @type {ResponsesQBSyncResultData}
     * @memberof ResponsesQBSyncResultResponse
     */
    'data'?: ResponsesQBSyncResultData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBSyncResultResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBSyncResultResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBTMSCategoryResp
 */
export interface ResponsesQBTMSCategoryResp {
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBTMSCategoryResp
     */
    'accountType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBTMSCategoryResp
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBTMSCategoryResp
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBTMSCategoryResp
     */
    'driverType'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQBWebhookData
 */
export interface ResponsesQBWebhookData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQBWebhookData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesQBWebhookResponse
 */
export interface ResponsesQBWebhookResponse {
    /**
     * 
     * @type {ResponsesQBWebhookData}
     * @memberof ResponsesQBWebhookResponse
     */
    'data'?: ResponsesQBWebhookData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBWebhookResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQBWebhookResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQuote
 */
export interface ResponsesQuote {
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'accessorials'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'converted_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'converted_load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesCustomerSummary}
     * @memberof ResponsesQuote
     */
    'customer'?: ResponsesCustomerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'customer_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'customer_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'customer_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'destination_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'destination_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'destination_zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'equipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'fuel_surcharge'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesQuote
     */
    'hazmat'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'origin_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'origin_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'origin_zip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'quote_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'rate_per_mile'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'responded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'sent_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'total_miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'total_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'valid_from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'valid_until'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuote
     */
    'viewed_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesQuote
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponsesQuoteListResponse
 */
export interface ResponsesQuoteListResponse {
    /**
     * 
     * @type {ResponsesQuoteListResponseData}
     * @memberof ResponsesQuoteListResponse
     */
    'data'?: ResponsesQuoteListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuoteListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuoteListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQuoteListResponseData
 */
export interface ResponsesQuoteListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesQuoteListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesQuote>}
     * @memberof ResponsesQuoteListResponseData
     */
    'quotes'?: Array<ResponsesQuote>;
}
/**
 * 
 * @export
 * @interface ResponsesQuoteResponse
 */
export interface ResponsesQuoteResponse {
    /**
     * 
     * @type {ResponsesQuoteResponseData}
     * @memberof ResponsesQuoteResponse
     */
    'data'?: ResponsesQuoteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuoteResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesQuoteResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesQuoteResponseData
 */
export interface ResponsesQuoteResponseData {
    /**
     * 
     * @type {ResponsesQuote}
     * @memberof ResponsesQuoteResponseData
     */
    'quote'?: ResponsesQuote;
}
/**
 * 
 * @export
 * @interface ResponsesRateHistoryEntry
 */
export interface ResponsesRateHistoryEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRateHistoryEntry
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRateHistoryEntry
     */
    'loadNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryEntry
     */
    'miles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryEntry
     */
    'rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryEntry
     */
    'ratePerMile'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRateHistoryStats
 */
export interface ResponsesRateHistoryStats {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryStats
     */
    'avgRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryStats
     */
    'avgRatePerMile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryStats
     */
    'loadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryStats
     */
    'maxRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRateHistoryStats
     */
    'minRate'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoad
 */
export interface ResponsesRecurringLoad {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesCustomerSummary}
     * @memberof ResponsesRecurringLoad
     */
    'customer'?: ResponsesCustomerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'customer_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'day_interval'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'default_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'delivery_time_hour'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'destination_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'destination_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'equipment_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'generate_lead_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'last_generated_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'month_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'next_generate_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'origin_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'origin_state'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'pickup_time_hour'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'recurrence_pattern'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesRecurringLoad
     */
    'skip_dates'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'status'?: string;
    /**
     * 
     * @type {Array<ResponsesRecurringLoadStop>}
     * @memberof ResponsesRecurringLoad
     */
    'stops'?: Array<ResponsesRecurringLoadStop>;
    /**
     * 
     * @type {ResponsesLoadTemplate}
     * @memberof ResponsesRecurringLoad
     */
    'template'?: ResponsesLoadTemplate;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'template_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'total_generated'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoad
     */
    'transit_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoad
     */
    'updatedAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesRecurringLoad
     */
    'week_days'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoadListResponse
 */
export interface ResponsesRecurringLoadListResponse {
    /**
     * 
     * @type {ResponsesRecurringLoadListResponseData}
     * @memberof ResponsesRecurringLoadListResponse
     */
    'data'?: ResponsesRecurringLoadListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoadListResponseData
 */
export interface ResponsesRecurringLoadListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesRecurringLoadListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesRecurringLoad>}
     * @memberof ResponsesRecurringLoadListResponseData
     */
    'recurring_loads'?: Array<ResponsesRecurringLoad>;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoadResponse
 */
export interface ResponsesRecurringLoadResponse {
    /**
     * 
     * @type {ResponsesRecurringLoadResponseData}
     * @memberof ResponsesRecurringLoadResponse
     */
    'data'?: ResponsesRecurringLoadResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoadResponseData
 */
export interface ResponsesRecurringLoadResponseData {
    /**
     * 
     * @type {ResponsesRecurringLoad}
     * @memberof ResponsesRecurringLoadResponseData
     */
    'recurring_load'?: ResponsesRecurringLoad;
}
/**
 * 
 * @export
 * @interface ResponsesRecurringLoadStop
 */
export interface ResponsesRecurringLoadStop {
    /**
     * 
     * @type {ResponsesLoadAddress}
     * @memberof ResponsesRecurringLoadStop
     */
    'address'?: ResponsesLoadAddress;
    /**
     * 
     * @type {ResponsesContact}
     * @memberof ResponsesRecurringLoadStop
     */
    'contact'?: ResponsesContact;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoadStop
     */
    'day_offset'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadStop
     */
    'facility_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadStop
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoadStop
     */
    'stop_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRecurringLoadStop
     */
    'stop_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRecurringLoadStop
     */
    'time_hour'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesReference
 */
export interface ResponsesReference {
    /**
     * 
     * @type {string}
     * @memberof ResponsesReference
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesReference
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRefreshTokenResponse
 */
export interface ResponsesRefreshTokenResponse {
    /**
     * 
     * @type {ResponsesRefreshTokenResponseData}
     * @memberof ResponsesRefreshTokenResponse
     */
    'data': ResponsesRefreshTokenResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRefreshTokenResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRefreshTokenResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRefreshTokenResponseData
 */
export interface ResponsesRefreshTokenResponseData {
    /**
     * 
     * @type {ResponsesUserAuth}
     * @memberof ResponsesRefreshTokenResponseData
     */
    'auth': ResponsesUserAuth;
}
/**
 * 
 * @export
 * @interface ResponsesRelayConfigResponse
 */
export interface ResponsesRelayConfigResponse {
    /**
     * 
     * @type {ResponsesRelayConfigResponseData}
     * @memberof ResponsesRelayConfigResponse
     */
    'data'?: ResponsesRelayConfigResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayConfigResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayConfigResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayConfigResponseData
 */
export interface ResponsesRelayConfigResponseData {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesRelayConfigResponseData
     */
    'policyIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesRelayConfigResponseData
     */
    'syncAllPolicies'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesRelayConnectResponse
 */
export interface ResponsesRelayConnectResponse {
    /**
     * 
     * @type {ResponsesQBMappingsDeleteResponseData}
     * @memberof ResponsesRelayConnectResponse
     */
    'data'?: ResponsesQBMappingsDeleteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayConnectResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayConnectResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayDisconnectResponse
 */
export interface ResponsesRelayDisconnectResponse {
    /**
     * 
     * @type {ResponsesQBMappingsDeleteResponseData}
     * @memberof ResponsesRelayDisconnectResponse
     */
    'data'?: ResponsesQBMappingsDeleteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDisconnectResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDisconnectResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayDriverMatchResponse
 */
export interface ResponsesRelayDriverMatchResponse {
    /**
     * 
     * @type {ResponsesRelayDriverMatchResponseData}
     * @memberof ResponsesRelayDriverMatchResponse
     */
    'data'?: ResponsesRelayDriverMatchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayDriverMatchResponseData
 */
export interface ResponsesRelayDriverMatchResponseData {
    /**
     * 
     * @type {Array<ResponsesRelayDriverMatchResult>}
     * @memberof ResponsesRelayDriverMatchResponseData
     */
    'matched'?: Array<ResponsesRelayDriverMatchResult>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayDriverMatchResponseData
     */
    'total'?: number;
    /**
     * 
     * @type {Array<ResponsesRelayDriverMatchResult>}
     * @memberof ResponsesRelayDriverMatchResponseData
     */
    'unmatched'?: Array<ResponsesRelayDriverMatchResult>;
}
/**
 * 
 * @export
 * @interface ResponsesRelayDriverMatchResult
 */
export interface ResponsesRelayDriverMatchResult {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'driverUnid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'matched'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'matchedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'policyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'policyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'relayDriverId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'relayEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'relayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayDriverMatchResult
     */
    'relayPhone'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayManualMatchResponse
 */
export interface ResponsesRelayManualMatchResponse {
    /**
     * 
     * @type {ResponsesRelayManualMatchResponseData}
     * @memberof ResponsesRelayManualMatchResponse
     */
    'data'?: ResponsesRelayManualMatchResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayManualMatchResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayManualMatchResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayManualMatchResponseData
 */
export interface ResponsesRelayManualMatchResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayManualMatchResponseData
     */
    'driverName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayManualMatchResponseData
     */
    'driverUnid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesRelayManualMatchResponseData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesRelayPoliciesResponse
 */
export interface ResponsesRelayPoliciesResponse {
    /**
     * 
     * @type {ResponsesRelayPoliciesResponseData}
     * @memberof ResponsesRelayPoliciesResponse
     */
    'data'?: ResponsesRelayPoliciesResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPoliciesResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPoliciesResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayPoliciesResponseData
 */
export interface ResponsesRelayPoliciesResponseData {
    /**
     * 
     * @type {Array<ResponsesRelayPolicyResponse>}
     * @memberof ResponsesRelayPoliciesResponseData
     */
    'policies'?: Array<ResponsesRelayPolicyResponse>;
}
/**
 * 
 * @export
 * @interface ResponsesRelayPolicyLimitResponse
 */
export interface ResponsesRelayPolicyLimitResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayPolicyLimitResponse
     */
    'max'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPolicyLimitResponse
     */
    'mode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPolicyLimitResponse
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayPolicyResponse
 */
export interface ResponsesRelayPolicyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesRelayPolicyResponse
     */
    'eldEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPolicyResponse
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ResponsesRelayPolicyLimitResponse>}
     * @memberof ResponsesRelayPolicyResponse
     */
    'limits'?: Array<ResponsesRelayPolicyLimitResponse>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayPolicyResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayStatsResponse
 */
export interface ResponsesRelayStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayStatsResponse
     */
    'totalAmountThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayStatsResponse
     */
    'totalGallonsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayStatsResponse
     */
    'transactionsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayStatsResponse
     */
    'transactionsToday'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayStatsResponse
     */
    'unmatchedTransactions'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRelayStatusResponse
 */
export interface ResponsesRelayStatusResponse {
    /**
     * 
     * @type {ResponsesRelayStatusResponseData}
     * @memberof ResponsesRelayStatusResponse
     */
    'data'?: ResponsesRelayStatusResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayStatusResponseData
 */
export interface ResponsesRelayStatusResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesRelayStatusResponseData
     */
    'connected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponseData
     */
    'connectedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponseData
     */
    'connectionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponseData
     */
    'lastSync'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayStatusResponseData
     */
    'lastSyncStatus'?: string;
    /**
     * 
     * @type {ResponsesRelayStatsResponse}
     * @memberof ResponsesRelayStatusResponseData
     */
    'stats'?: ResponsesRelayStatsResponse;
}
/**
 * 
 * @export
 * @interface ResponsesRelaySyncByStateResponse
 */
export interface ResponsesRelaySyncByStateResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncByStateResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncByStateResponse
     */
    'gallons'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelaySyncByStateResponse
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelaySyncByTypeResponse
 */
export interface ResponsesRelaySyncByTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncByTypeResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncByTypeResponse
     */
    'gallons'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelaySyncByTypeResponse
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelaySyncResponse
 */
export interface ResponsesRelaySyncResponse {
    /**
     * 
     * @type {ResponsesRelaySyncResponseData}
     * @memberof ResponsesRelaySyncResponse
     */
    'data'?: ResponsesRelaySyncResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelaySyncResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelaySyncResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelaySyncResponseData
 */
export interface ResponsesRelaySyncResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncResponseData
     */
    'created'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncResponseData
     */
    'duplicates'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncResponseData
     */
    'imported'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncResponseData
     */
    'matched'?: number;
    /**
     * 
     * @type {ResponsesRelaySyncSummaryResponse}
     * @memberof ResponsesRelaySyncResponseData
     */
    'summary'?: ResponsesRelaySyncSummaryResponse;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncResponseData
     */
    'unmatched'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRelaySyncSummaryResponse
 */
export interface ResponsesRelaySyncSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncSummaryResponse
     */
    'avgPricePerGal'?: number;
    /**
     * 
     * @type {Array<ResponsesRelaySyncByStateResponse>}
     * @memberof ResponsesRelaySyncSummaryResponse
     */
    'byState'?: Array<ResponsesRelaySyncByStateResponse>;
    /**
     * 
     * @type {Array<ResponsesRelaySyncByTypeResponse>}
     * @memberof ResponsesRelaySyncSummaryResponse
     */
    'byType'?: Array<ResponsesRelaySyncByTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncSummaryResponse
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelaySyncSummaryResponse
     */
    'totalGallons'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRelayTransaction
 */
export interface ResponsesRelayTransaction {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'driverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'externalId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'fuelAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'gallons'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'loadId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'loadNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'merchantCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'merchantName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'merchantState'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'otherAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'pricePerGallon'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'settledAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayTransaction
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'transactionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'transactionTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'transactionType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'truckId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'truckNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransaction
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayTransactionListResponse
 */
export interface ResponsesRelayTransactionListResponse {
    /**
     * 
     * @type {ResponsesRelayTransactionListResponseData}
     * @memberof ResponsesRelayTransactionListResponse
     */
    'data'?: ResponsesRelayTransactionListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransactionListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransactionListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayTransactionListResponseData
 */
export interface ResponsesRelayTransactionListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesRelayTransactionListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesRelayTransaction>}
     * @memberof ResponsesRelayTransactionListResponseData
     */
    'transactions'?: Array<ResponsesRelayTransaction>;
}
/**
 * 
 * @export
 * @interface ResponsesRelayTransactionResponse
 */
export interface ResponsesRelayTransactionResponse {
    /**
     * 
     * @type {ResponsesRelayTransactionResponseData}
     * @memberof ResponsesRelayTransactionResponse
     */
    'data'?: ResponsesRelayTransactionResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransactionResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayTransactionResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayTransactionResponseData
 */
export interface ResponsesRelayTransactionResponseData {
    /**
     * 
     * @type {ResponsesRelayTransaction}
     * @memberof ResponsesRelayTransactionResponseData
     */
    'transaction'?: ResponsesRelayTransaction;
}
/**
 * 
 * @export
 * @interface ResponsesRelayUnmatchedDriverItem
 */
export interface ResponsesRelayUnmatchedDriverItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'policyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'policyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'relayDriverId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriverItem
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayUnmatchedDriversResponse
 */
export interface ResponsesRelayUnmatchedDriversResponse {
    /**
     * 
     * @type {ResponsesRelayUnmatchedDriversResponseData}
     * @memberof ResponsesRelayUnmatchedDriversResponse
     */
    'data'?: ResponsesRelayUnmatchedDriversResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriversResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRelayUnmatchedDriversResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRelayUnmatchedDriversResponseData
 */
export interface ResponsesRelayUnmatchedDriversResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRelayUnmatchedDriversResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesRelayUnmatchedDriverItem>}
     * @memberof ResponsesRelayUnmatchedDriversResponseData
     */
    'drivers'?: Array<ResponsesRelayUnmatchedDriverItem>;
}
/**
 * 
 * @export
 * @interface ResponsesRevenueEstimate
 */
export interface ResponsesRevenueEstimate {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRevenueEstimate
     */
    'minimumBid'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRevenueEstimate
     */
    'profitPerMile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRevenueEstimate
     */
    'revenuePerMile'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRevenueEstimate
     */
    'suggestedBid'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRevenueEstimate
     */
    'targetMarginPercent'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRouteCalculationData
 */
export interface ResponsesRouteCalculationData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteCalculationData
     */
    'calculatedAt'?: string;
    /**
     * 
     * @type {Array<ResponsesRouteLegItem>}
     * @memberof ResponsesRouteCalculationData
     */
    'legs'?: Array<ResponsesRouteLegItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteCalculationData
     */
    'loadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteCalculationData
     */
    'routeType'?: string;
    /**
     * 
     * @type {Array<ResponsesStateBreakdownItem>}
     * @memberof ResponsesRouteCalculationData
     */
    'stateBreakdown'?: Array<ResponsesStateBreakdownItem>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteCalculationData
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteCalculationData
     */
    'totalMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteCalculationData
     */
    'totalTolls'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesRouteCalculationResponse
 */
export interface ResponsesRouteCalculationResponse {
    /**
     * 
     * @type {ResponsesRouteCalculationData}
     * @memberof ResponsesRouteCalculationResponse
     */
    'data'?: ResponsesRouteCalculationData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteCalculationResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteCalculationResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRouteLeg
 */
export interface ResponsesRouteLeg {
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteLeg
     */
    'distanceMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteLeg
     */
    'durationHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteLeg
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteLeg
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRouteLegItem
 */
export interface ResponsesRouteLegItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteLegItem
     */
    'direction'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteLegItem
     */
    'distance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteLegItem
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteLegItem
     */
    'longitude'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteLegItem
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteLegItem
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesRouteOptionData
 */
export interface ResponsesRouteOptionData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteOptionData
     */
    'label'?: string;
    /**
     * 
     * @type {Array<ResponsesRouteLeg>}
     * @memberof ResponsesRouteOptionData
     */
    'legs'?: Array<ResponsesRouteLeg>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesRouteOptionData
     */
    'summary'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteOptionData
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesRouteOptionData
     */
    'totalMiles'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraAuthURLData
 */
export interface ResponsesSamsaraAuthURLData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraAuthURLData
     */
    'authorizationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraAuthURLData
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraAuthURLResponse
 */
export interface ResponsesSamsaraAuthURLResponse {
    /**
     * 
     * @type {ResponsesSamsaraAuthURLData}
     * @memberof ResponsesSamsaraAuthURLResponse
     */
    'data'?: ResponsesSamsaraAuthURLData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraAuthURLResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraAuthURLResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraDisconnectData
 */
export interface ResponsesSamsaraDisconnectData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraDisconnectData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesSamsaraDisconnectData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraDisconnectResponse
 */
export interface ResponsesSamsaraDisconnectResponse {
    /**
     * 
     * @type {ResponsesSamsaraDisconnectData}
     * @memberof ResponsesSamsaraDisconnectResponse
     */
    'data'?: ResponsesSamsaraDisconnectData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraDisconnectResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraDisconnectResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraIntegrationStatusData
 */
export interface ResponsesSamsaraIntegrationStatusData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'connected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'connectedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'connectedByUserId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'integrationUserId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesSamsaraIntegrationStatusData
     */
    'isExpired'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraIntegrationStatusResponse
 */
export interface ResponsesSamsaraIntegrationStatusResponse {
    /**
     * 
     * @type {ResponsesSamsaraIntegrationStatusData}
     * @memberof ResponsesSamsaraIntegrationStatusResponse
     */
    'data'?: ResponsesSamsaraIntegrationStatusData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraIntegrationStatusResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraIntegrationStatusResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraOAuthCallbackData
 */
export interface ResponsesSamsaraOAuthCallbackData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraOAuthCallbackData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesSamsaraOAuthCallbackData
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesSamsaraOAuthCallbackResponse
 */
export interface ResponsesSamsaraOAuthCallbackResponse {
    /**
     * 
     * @type {ResponsesSamsaraOAuthCallbackData}
     * @memberof ResponsesSamsaraOAuthCallbackResponse
     */
    'data'?: ResponsesSamsaraOAuthCallbackData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraOAuthCallbackResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSamsaraOAuthCallbackResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSearchAvailableCarriersResponse
 */
export interface ResponsesSearchAvailableCarriersResponse {
    /**
     * 
     * @type {ResponsesSearchAvailableCarriersResponseData}
     * @memberof ResponsesSearchAvailableCarriersResponse
     */
    'data'?: ResponsesSearchAvailableCarriersResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSearchAvailableCarriersResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSearchAvailableCarriersResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSearchAvailableCarriersResponseData
 */
export interface ResponsesSearchAvailableCarriersResponseData {
    /**
     * 
     * @type {Array<ResponsesAvailableCarrier>}
     * @memberof ResponsesSearchAvailableCarriersResponseData
     */
    'carriers'?: Array<ResponsesAvailableCarrier>;
}
/**
 * 
 * @export
 * @interface ResponsesSettlement
 */
export interface ResponsesSettlement {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'approved_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<ResponsesSettlementItem>}
     * @memberof ResponsesSettlement
     */
    'deduction_items'?: Array<ResponsesSettlementItem>;
    /**
     * 
     * @type {ResponsesSettlementDriverSummary}
     * @memberof ResponsesSettlement
     */
    'driver'?: ResponsesSettlementDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'driver_id'?: string;
    /**
     * 
     * @type {Array<ResponsesSettlementItem>}
     * @memberof ResponsesSettlement
     */
    'earnings_items'?: Array<ResponsesSettlementItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'load_id'?: string;
    /**
     * 
     * @type {ResponsesSettlementLoadSummary}
     * @memberof ResponsesSettlement
     */
    'load_summary'?: ResponsesSettlementLoadSummary;
    /**
     * 
     * @type {Array<ResponsesSettlementItem>}
     * @memberof ResponsesSettlement
     */
    'reimbursement_items'?: Array<ResponsesSettlementItem>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlement
     */
    'revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'settlement_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'status'?: string;
    /**
     * 
     * @type {ResponsesSettlementFinancialSummary}
     * @memberof ResponsesSettlement
     */
    'summary'?: ResponsesSettlementFinancialSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlement
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementDriverSummary
 */
export interface ResponsesSettlementDriverSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementDriverSummary
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementDriverSummary
     */
    'last_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementDriverSummary
     */
    'pay_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementDriverSummary
     */
    'pay_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementDriverSummary
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementDriverSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementFinancialSummary
 */
export interface ResponsesSettlementFinancialSummary {
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'accessorial_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'bonus_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'gross_earnings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'load_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'net_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'total_deductions'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementFinancialSummary
     */
    'total_reimbursements'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementItem
 */
export interface ResponsesSettlementItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementItem
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'load_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementItem
     */
    'load_revenue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'pay_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementItem
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementItem
     */
    'rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementItem
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementItem
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementListResponse
 */
export interface ResponsesSettlementListResponse {
    /**
     * 
     * @type {ResponsesSettlementListResponseData}
     * @memberof ResponsesSettlementListResponse
     */
    'data'?: ResponsesSettlementListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementListResponseData
 */
export interface ResponsesSettlementListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesSettlementListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesSettlementListSummary>}
     * @memberof ResponsesSettlementListResponseData
     */
    'settlements'?: Array<ResponsesSettlementListSummary>;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementListSummary
 */
export interface ResponsesSettlementListSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'driver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'driver_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementListSummary
     */
    'gross_earnings'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'load_id'?: string;
    /**
     * 
     * @type {ResponsesSettlementLoadSummary}
     * @memberof ResponsesSettlementListSummary
     */
    'load_summary'?: ResponsesSettlementLoadSummary;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementListSummary
     */
    'net_pay'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementListSummary
     */
    'revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'settlement_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementListSummary
     */
    'total_deductions'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementListSummary
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementLoadSummary
 */
export interface ResponsesSettlementLoadSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'destination_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'destination_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'load_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'origin_city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'origin_state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesSettlementLoadSummary
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementLoadSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementResponse
 */
export interface ResponsesSettlementResponse {
    /**
     * 
     * @type {ResponsesSettlementResponseData}
     * @memberof ResponsesSettlementResponse
     */
    'data'?: ResponsesSettlementResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSettlementResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSettlementResponseData
 */
export interface ResponsesSettlementResponseData {
    /**
     * 
     * @type {ResponsesSettlement}
     * @memberof ResponsesSettlementResponseData
     */
    'settlement'?: ResponsesSettlement;
}
/**
 * 
 * @export
 * @interface ResponsesSignupResponse
 */
export interface ResponsesSignupResponse {
    /**
     * 
     * @type {ResponsesLoginResponseData}
     * @memberof ResponsesSignupResponse
     */
    'data': ResponsesLoginResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSignupResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSignupResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesStateBreakdownItem
 */
export interface ResponsesStateBreakdownItem {
    /**
     * 
     * @type {number}
     * @memberof ResponsesStateBreakdownItem
     */
    'freeMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesStateBreakdownItem
     */
    'miles'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStateBreakdownItem
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesStateBreakdownItem
     */
    'tollCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesStateBreakdownItem
     */
    'tollMiles'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesStop
 */
export interface ResponsesStop {
    /**
     * 
     * @type {ResponsesLoadAddress}
     * @memberof ResponsesStop
     */
    'address'?: ResponsesLoadAddress;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'appointment_end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'appointment_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'appointment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'arrived_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesCustomerSummary}
     * @memberof ResponsesStop
     */
    'customer'?: ResponsesCustomerSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'departed_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesStop
     */
    'detention_minutes'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'detention_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'loading_type'?: string | null;
    /**
     * 
     * @type {Array<ResponsesReference>}
     * @memberof ResponsesStop
     */
    'reference_numbers'?: Array<ResponsesReference>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesStop
     */
    'sequence'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStop
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesStripeCheckoutResponse
 */
export interface ResponsesStripeCheckoutResponse {
    /**
     * 
     * @type {ResponsesStripeCheckoutResponseData}
     * @memberof ResponsesStripeCheckoutResponse
     */
    'data'?: ResponsesStripeCheckoutResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStripeCheckoutResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStripeCheckoutResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesStripeCheckoutResponseData
 */
export interface ResponsesStripeCheckoutResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesStripeCheckoutResponseData
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesStripeCheckoutResponseData
     */
    'sessionUrl'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSubscriptionDetailResponse
 */
export interface ResponsesSubscriptionDetailResponse {
    /**
     * 
     * @type {ResponsesSubscriptionDetailResponseData}
     * @memberof ResponsesSubscriptionDetailResponse
     */
    'data'?: ResponsesSubscriptionDetailResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionDetailResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionDetailResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSubscriptionDetailResponseData
 */
export interface ResponsesSubscriptionDetailResponseData {
    /**
     * 
     * @type {ResponsesSubscriptionResponse}
     * @memberof ResponsesSubscriptionDetailResponseData
     */
    'subscription'?: ResponsesSubscriptionResponse;
}
/**
 * 
 * @export
 * @interface ResponsesSubscriptionResponse
 */
export interface ResponsesSubscriptionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesSubscriptionResponse
     */
    'cancelAtEnd'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'canceledAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'currentPeriodEnd'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'currentPeriodStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'organizationUnid'?: string | null;
    /**
     * 
     * @type {ResponsesPlanResponse}
     * @memberof ResponsesSubscriptionResponse
     */
    'plan'?: ResponsesPlanResponse;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'planUnid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'providerCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'providerProductId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'providerSubscriptionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'trialEnd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSubscriptionResponse
     */
    'userUnid'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesSuccessResponse
 */
export interface ResponsesSuccessResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSuccessResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSuccessResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSupportedAPIKeyIntegrationType
 */
export interface ResponsesSupportedAPIKeyIntegrationType {
    /**
     * 
     * @type {string}
     * @memberof ResponsesSupportedAPIKeyIntegrationType
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSupportedAPIKeyIntegrationType
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesSupportedAPIKeyIntegrationsData
 */
export interface ResponsesSupportedAPIKeyIntegrationsData {
    /**
     * 
     * @type {Array<ResponsesSupportedAPIKeyIntegrationType>}
     * @memberof ResponsesSupportedAPIKeyIntegrationsData
     */
    'integrations'?: Array<ResponsesSupportedAPIKeyIntegrationType>;
}
/**
 * 
 * @export
 * @interface ResponsesSupportedAPIKeyIntegrationsResponse
 */
export interface ResponsesSupportedAPIKeyIntegrationsResponse {
    /**
     * 
     * @type {ResponsesSupportedAPIKeyIntegrationsData}
     * @memberof ResponsesSupportedAPIKeyIntegrationsResponse
     */
    'data'?: ResponsesSupportedAPIKeyIntegrationsData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSupportedAPIKeyIntegrationsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesSupportedAPIKeyIntegrationsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTWICInfo
 */
export interface ResponsesTWICInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTWICInfo
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTWICInfo
     */
    'number'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTechnician
 */
export interface ResponsesTechnician {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'certifications'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'hireDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTechnician
     */
    'hourlyRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTechnician
     */
    'laborRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'specializations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'technicianNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'terminationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnician
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesTechnicianListResponse
 */
export interface ResponsesTechnicianListResponse {
    /**
     * 
     * @type {ResponsesTechnicianListResponseData}
     * @memberof ResponsesTechnicianListResponse
     */
    'data'?: ResponsesTechnicianListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnicianListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnicianListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTechnicianListResponseData
 */
export interface ResponsesTechnicianListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTechnicianListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesTechnician>}
     * @memberof ResponsesTechnicianListResponseData
     */
    'technicians'?: Array<ResponsesTechnician>;
}
/**
 * 
 * @export
 * @interface ResponsesTechnicianResponse
 */
export interface ResponsesTechnicianResponse {
    /**
     * 
     * @type {ResponsesTechnicianResponseData}
     * @memberof ResponsesTechnicianResponse
     */
    'data'?: ResponsesTechnicianResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnicianResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTechnicianResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTechnicianResponseData
 */
export interface ResponsesTechnicianResponseData {
    /**
     * 
     * @type {ResponsesTechnician}
     * @memberof ResponsesTechnicianResponseData
     */
    'technician'?: ResponsesTechnician;
}
/**
 * 
 * @export
 * @interface ResponsesTenderLoadResponse
 */
export interface ResponsesTenderLoadResponse {
    /**
     * 
     * @type {ResponsesTenderLoadResponseData}
     * @memberof ResponsesTenderLoadResponse
     */
    'data'?: ResponsesTenderLoadResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTenderLoadResponseData
 */
export interface ResponsesTenderLoadResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'carrierId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'loadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'tenderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTenderLoadResponseData
     */
    'tenderedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTimePeriod
 */
export interface ResponsesTimePeriod {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTimePeriod
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTimePeriod
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailer
 */
export interface ResponsesTrailer {
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesTrailer
     */
    'airRide'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'axles'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'cubicFeet'?: number | null;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesTrailer
     */
    'currentDriver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'currentDriverId'?: string | null;
    /**
     * 
     * @type {ResponsesLoadSummary}
     * @memberof ResponsesTrailer
     */
    'currentLoad'?: ResponsesLoadSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'currentLoadId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'currentTemp'?: number | null;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesTrailer
     */
    'currentTruck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'currentTruckId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'doorHeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'doorWidth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'dropLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'droppedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesTrailer
     */
    'eTracks'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'gpsDeviceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'gpsProvider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'inspectionExpiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'lastServiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'licensePlateState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesTrailer
     */
    'liftGate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'loadLocks'?: number | null;
    /**
     * 
     * @type {ResponsesLocation}
     * @memberof ResponsesTrailer
     */
    'location'?: ResponsesLocation;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'locationUpdated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'make'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'maxWeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'nextServiceDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'ownership'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'palletPositions'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'reeferHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'reeferMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'reeferModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'reeferSerial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'registrationExpiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'setTemp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'tareWeight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'tempUpdated'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'totalLoads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'totalMiles'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'trailerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesTrailer
     */
    'vented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailer
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailer
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerDashboardMetrics
 */
export interface ResponsesTrailerDashboardMetrics {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResponsesTrailerDashboardMetrics
     */
    'byStatus'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerDashboardMetrics
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerListResponse
 */
export interface ResponsesTrailerListResponse {
    /**
     * 
     * @type {ResponsesTrailerListResponseData}
     * @memberof ResponsesTrailerListResponse
     */
    'data'?: ResponsesTrailerListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerListResponseData
 */
export interface ResponsesTrailerListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTrailerListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesTrailer>}
     * @memberof ResponsesTrailerListResponseData
     */
    'trailers'?: Array<ResponsesTrailer>;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerLocationHistoryResponse
 */
export interface ResponsesTrailerLocationHistoryResponse {
    /**
     * 
     * @type {ResponsesTrailerLocationHistoryResponseData}
     * @memberof ResponsesTrailerLocationHistoryResponse
     */
    'data'?: ResponsesTrailerLocationHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerLocationHistoryResponseData
 */
export interface ResponsesTrailerLocationHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesTrailerLocationPoint>}
     * @memberof ResponsesTrailerLocationHistoryResponseData
     */
    'locations'?: Array<ResponsesTrailerLocationPoint>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTrailerLocationHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerLocationPoint
 */
export interface ResponsesTrailerLocationPoint {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationPoint
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationPoint
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'load_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'odometer_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationPoint
     */
    'recorded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationPoint
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationPoint
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationPoint
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerLocationResponse
 */
export interface ResponsesTrailerLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'currentLoadUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'currentTruckUnid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationResponse
     */
    'lengthFeet'?: number | null;
    /**
     * 
     * @type {ResponsesAssetLocationResponse}
     * @memberof ResponsesTrailerLocationResponse
     */
    'location'?: ResponsesAssetLocationResponse;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'samsaraTrailerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'trailerType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerLocationResponse
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTrailerLocationResponse
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerNote
 */
export interface ResponsesTrailerNote {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNote
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNote
     */
    'createdByName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNote
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNote
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNote
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerNoteListResponse
 */
export interface ResponsesTrailerNoteListResponse {
    /**
     * 
     * @type {ResponsesTrailerNoteListResponseData}
     * @memberof ResponsesTrailerNoteListResponse
     */
    'data'?: ResponsesTrailerNoteListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNoteListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNoteListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerNoteListResponseData
 */
export interface ResponsesTrailerNoteListResponseData {
    /**
     * 
     * @type {Array<ResponsesTrailerNote>}
     * @memberof ResponsesTrailerNoteListResponseData
     */
    'notes'?: Array<ResponsesTrailerNote>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTrailerNoteListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerNoteResponse
 */
export interface ResponsesTrailerNoteResponse {
    /**
     * 
     * @type {ResponsesTrailerNoteResponseData}
     * @memberof ResponsesTrailerNoteResponse
     */
    'data'?: ResponsesTrailerNoteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNoteResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerNoteResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerNoteResponseData
 */
export interface ResponsesTrailerNoteResponseData {
    /**
     * 
     * @type {ResponsesTrailerNote}
     * @memberof ResponsesTrailerNoteResponseData
     */
    'note'?: ResponsesTrailerNote;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerResponse
 */
export interface ResponsesTrailerResponse {
    /**
     * 
     * @type {ResponsesTrailerResponseData}
     * @memberof ResponsesTrailerResponse
     */
    'data'?: ResponsesTrailerResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerResponseData
 */
export interface ResponsesTrailerResponseData {
    /**
     * 
     * @type {ResponsesTrailer}
     * @memberof ResponsesTrailerResponseData
     */
    'trailer'?: ResponsesTrailer;
}
/**
 * 
 * @export
 * @interface ResponsesTrailerSummary
 */
export interface ResponsesTrailerSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerSummary
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerSummary
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTrailerSummary
     */
    'unit_number'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruck
 */
export interface ResponsesTruck {
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'avgMPG'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'createdAt': string;
    /**
     * 
     * @type {ResponsesDriverSummary}
     * @memberof ResponsesTruck
     */
    'currentDriver'?: ResponsesDriverSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'currentDriverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'currentDriverName'?: string | null;
    /**
     * 
     * @type {ResponsesLoadSummary}
     * @memberof ResponsesTruck
     */
    'currentLoad'?: ResponsesLoadSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'currentLoadId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'currentOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'eldDeviceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'eldProvider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'engineMake'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'engineModel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'fifthWheelHeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'fuelCapacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'fuelType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'gvwr'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'horsepower'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'inspectionExpiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'lastServiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'lastServiceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'licensePlate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'licensePlateState'?: string | null;
    /**
     * 
     * @type {ResponsesLocation}
     * @memberof ResponsesTruck
     */
    'location'?: ResponsesLocation;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'locationUpdated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'nextServiceDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'nextServiceOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'odometerUpdated'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'ownership'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'registrationExpiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'totalLoads'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'totalMiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'totalRevenue'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'transmission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'truckType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruck
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'wheelBase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruck
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTruckDashboardMetrics
 */
export interface ResponsesTruckDashboardMetrics {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ResponsesTruckDashboardMetrics
     */
    'byStatus'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckDashboardMetrics
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTruckListResponse
 */
export interface ResponsesTruckListResponse {
    /**
     * 
     * @type {ResponsesTruckListResponseData}
     * @memberof ResponsesTruckListResponse
     */
    'data'?: ResponsesTruckListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckListResponseData
 */
export interface ResponsesTruckListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTruckListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesTruck>}
     * @memberof ResponsesTruckListResponseData
     */
    'trucks'?: Array<ResponsesTruck>;
}
/**
 * 
 * @export
 * @interface ResponsesTruckLocationHistoryResponse
 */
export interface ResponsesTruckLocationHistoryResponse {
    /**
     * 
     * @type {ResponsesTruckLocationHistoryResponseData}
     * @memberof ResponsesTruckLocationHistoryResponse
     */
    'data'?: ResponsesTruckLocationHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckLocationHistoryResponseData
 */
export interface ResponsesTruckLocationHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesTruckLocationPoint>}
     * @memberof ResponsesTruckLocationHistoryResponseData
     */
    'locations'?: Array<ResponsesTruckLocationPoint>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTruckLocationHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesTruckLocationPoint
 */
export interface ResponsesTruckLocationPoint {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationPoint
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationPoint
     */
    'city'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'heading'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'load_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'odometer_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationPoint
     */
    'recorded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationPoint
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationPoint
     */
    'speed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationPoint
     */
    'state'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesTruckLocationResponse
 */
export interface ResponsesTruckLocationResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'currentDriverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'currentDriverUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'currentLoadUnid'?: string | null;
    /**
     * 
     * @type {ResponsesAssetLocationResponse}
     * @memberof ResponsesTruckLocationResponse
     */
    'location'?: ResponsesAssetLocationResponse;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'make'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'samsaraVehicleId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckLocationResponse
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesTruckLocationResponse
     */
    'year'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesTruckNote
 */
export interface ResponsesTruckNote {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNote
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNote
     */
    'createdByName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNote
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNote
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNote
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckNoteListResponse
 */
export interface ResponsesTruckNoteListResponse {
    /**
     * 
     * @type {ResponsesTruckNoteListResponseData}
     * @memberof ResponsesTruckNoteListResponse
     */
    'data'?: ResponsesTruckNoteListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNoteListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNoteListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckNoteListResponseData
 */
export interface ResponsesTruckNoteListResponseData {
    /**
     * 
     * @type {Array<ResponsesTruckNote>}
     * @memberof ResponsesTruckNoteListResponseData
     */
    'notes'?: Array<ResponsesTruckNote>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesTruckNoteListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesTruckNoteResponse
 */
export interface ResponsesTruckNoteResponse {
    /**
     * 
     * @type {ResponsesTruckNoteResponseData}
     * @memberof ResponsesTruckNoteResponse
     */
    'data'?: ResponsesTruckNoteResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNoteResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckNoteResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckNoteResponseData
 */
export interface ResponsesTruckNoteResponseData {
    /**
     * 
     * @type {ResponsesTruckNote}
     * @memberof ResponsesTruckNoteResponseData
     */
    'note'?: ResponsesTruckNote;
}
/**
 * 
 * @export
 * @interface ResponsesTruckResponse
 */
export interface ResponsesTruckResponse {
    /**
     * 
     * @type {ResponsesTruckResponseData}
     * @memberof ResponsesTruckResponse
     */
    'data'?: ResponsesTruckResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesTruckResponseData
 */
export interface ResponsesTruckResponseData {
    /**
     * 
     * @type {ResponsesTruck}
     * @memberof ResponsesTruckResponseData
     */
    'truck'?: ResponsesTruck;
}
/**
 * 
 * @export
 * @interface ResponsesTruckSummary
 */
export interface ResponsesTruckSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckSummary
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckSummary
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesTruckSummary
     */
    'unit_number'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUpcomingMaintenance
 */
export interface ResponsesUpcomingMaintenance {
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'currentHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'currentOdometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'daysUntilDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'dueHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'dueOdometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'equipmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'equipmentNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'hoursUntilDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'maintenanceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUpcomingMaintenance
     */
    'milesUntilDue'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'unid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenance
     */
    'urgency'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUpcomingMaintenanceResponse
 */
export interface ResponsesUpcomingMaintenanceResponse {
    /**
     * 
     * @type {ResponsesUpcomingMaintenanceResponseData}
     * @memberof ResponsesUpcomingMaintenanceResponse
     */
    'data'?: ResponsesUpcomingMaintenanceResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenanceResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUpcomingMaintenanceResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUpcomingMaintenanceResponseData
 */
export interface ResponsesUpcomingMaintenanceResponseData {
    /**
     * 
     * @type {Array<ResponsesUpcomingMaintenance>}
     * @memberof ResponsesUpcomingMaintenanceResponseData
     */
    'maintenance'?: Array<ResponsesUpcomingMaintenance>;
}
/**
 * 
 * @export
 * @interface ResponsesUploadUrlResponse
 */
export interface ResponsesUploadUrlResponse {
    /**
     * 
     * @type {ResponsesUploadUrlResponseData}
     * @memberof ResponsesUploadUrlResponse
     */
    'data': ResponsesUploadUrlResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUploadUrlResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUploadUrlResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUploadUrlResponseData
 */
export interface ResponsesUploadUrlResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesUploadUrlResponseData
     */
    'accessUlr': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUploadUrlResponseData
     */
    'uploadUrl': string;
}
/**
 * 
 * @export
 * @interface ResponsesUser
 */
export interface ResponsesUser {
    /**
     * 
     * @type {ResponsesUserAddress}
     * @memberof ResponsesUser
     */
    'address': ResponsesUserAddress;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'appBackgroundRefreshEnabled': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'bio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'birthdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'distanceUnits'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'email': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'enabledHealthKit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'enabledPushNotifications': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'fitbitLinked': boolean;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUser
     */
    'gpsPermission': number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'name': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'needsToConfirmAccount': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesUser
     */
    'onboardingBookList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'onboardingComplete': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesUser
     */
    'onboardingExcitedList'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesUser
     */
    'onboardingFilmList'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesUser
     */
    'onboardingPodcastList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'passwordSet': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'phone': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'profilePictureUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUser
     */
    'stepGoal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUser
     */
    'timeZoneOffsetMinutes'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'timeZoneText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUser
     */
    'username': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUser
     */
    'verifiedEmail': boolean;
}
/**
 * 
 * @export
 * @interface ResponsesUserAddress
 */
export interface ResponsesUserAddress {
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'addressLine2': string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'countryCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesUserAddress
     */
    'includeAddressInEmail': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAddress
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface ResponsesUserAuth
 */
export interface ResponsesUserAuth {
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAuth
     */
    'accessToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUserAuth
     */
    'expiresIn'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAuth
     */
    'idToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserAuth
     */
    'refreshToken'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUserInvitation
 */
export interface ResponsesUserInvitation {
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'invitedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'organizationLogo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'organizationUnid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesUserInvitation
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitation
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUserInvitationsResponse
 */
export interface ResponsesUserInvitationsResponse {
    /**
     * 
     * @type {ResponsesUserInvitationsResponseData}
     * @memberof ResponsesUserInvitationsResponse
     */
    'data'?: ResponsesUserInvitationsResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitationsResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserInvitationsResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUserInvitationsResponseData
 */
export interface ResponsesUserInvitationsResponseData {
    /**
     * 
     * @type {number}
     * @memberof ResponsesUserInvitationsResponseData
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ResponsesUserInvitation>}
     * @memberof ResponsesUserInvitationsResponseData
     */
    'invitations'?: Array<ResponsesUserInvitation>;
}
/**
 * 
 * @export
 * @interface ResponsesUserProfileResponse
 */
export interface ResponsesUserProfileResponse {
    /**
     * 
     * @type {ResponsesUserProfileResponseData}
     * @memberof ResponsesUserProfileResponse
     */
    'data': ResponsesUserProfileResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserProfileResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserProfileResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUserProfileResponseData
 */
export interface ResponsesUserProfileResponseData {
    /**
     * 
     * @type {ResponsesUser}
     * @memberof ResponsesUserProfileResponseData
     */
    'user': ResponsesUser;
}
/**
 * 
 * @export
 * @interface ResponsesUserSummary
 */
export interface ResponsesUserSummary {
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserSummary
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserSummary
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesUserSummary
     */
    'unid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesUtilizationMetrics
 */
export interface ResponsesUtilizationMetrics {
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'trailerUtilization'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'trailersOnLoad'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'trailersTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'truckUtilization'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'trucksOnLoad'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesUtilizationMetrics
     */
    'trucksTotal'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesVMRSCodeItem
 */
export interface ResponsesVMRSCodeItem {
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSCodeItem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSCodeItem
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesVMRSCodesResponse
 */
export interface ResponsesVMRSCodesResponse {
    /**
     * 
     * @type {ResponsesVMRSCodesResponseData}
     * @memberof ResponsesVMRSCodesResponse
     */
    'data'?: ResponsesVMRSCodesResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSCodesResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSCodesResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesVMRSCodesResponseData
 */
export interface ResponsesVMRSCodesResponseData {
    /**
     * 
     * @type {Array<ResponsesVMRSSystemGroup>}
     * @memberof ResponsesVMRSCodesResponseData
     */
    'systems'?: Array<ResponsesVMRSSystemGroup>;
}
/**
 * 
 * @export
 * @interface ResponsesVMRSSystemGroup
 */
export interface ResponsesVMRSSystemGroup {
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSSystemGroup
     */
    'code'?: string;
    /**
     * 
     * @type {Array<ResponsesVMRSCodeItem>}
     * @memberof ResponsesVMRSSystemGroup
     */
    'codes'?: Array<ResponsesVMRSCodeItem>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesVMRSSystemGroup
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesValidateLoadResponse
 */
export interface ResponsesValidateLoadResponse {
    /**
     * 
     * @type {ResponsesValidateLoadResponseData}
     * @memberof ResponsesValidateLoadResponse
     */
    'data'?: ResponsesValidateLoadResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesValidateLoadResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesValidateLoadResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesValidateLoadResponseData
 */
export interface ResponsesValidateLoadResponseData {
    /**
     * 
     * @type {Array<ResponsesLoadValidationItem>}
     * @memberof ResponsesValidateLoadResponseData
     */
    'errors'?: Array<ResponsesLoadValidationItem>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesValidateLoadResponseData
     */
    'valid'?: boolean;
    /**
     * 
     * @type {Array<ResponsesLoadValidationItem>}
     * @memberof ResponsesValidateLoadResponseData
     */
    'warnings'?: Array<ResponsesLoadValidationItem>;
}
/**
 * 
 * @export
 * @interface ResponsesWebhookResponse
 */
export interface ResponsesWebhookResponse {
    /**
     * 
     * @type {ResponsesWebhookResponseData}
     * @memberof ResponsesWebhookResponse
     */
    'data'?: ResponsesWebhookResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWebhookResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWebhookResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWebhookResponseData
 */
export interface ResponsesWebhookResponseData {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWebhookResponseData
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesWebhookResponseData
     */
    'processed'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrder
 */
export interface ResponsesWorkOrder {
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'actualHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'actualLaborCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'actualPartsCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'actualTaxAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'actualTotalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'assignedToTechnicianId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'assignedToTechnicianName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'equipmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'equipmentNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'estimatedHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'estimatedLaborCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'estimatedPartsCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'estimatedTotalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'inspectionDefectId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'inspectionId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesWorkOrder
     */
    'isInternal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'maintenanceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'odometerCompleted'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'odometerReported'?: number | null;
    /**
     * 
     * @type {Array<ResponsesWorkOrderPartUsage>}
     * @memberof ResponsesWorkOrder
     */
    'partsUsed'?: Array<ResponsesWorkOrderPartUsage>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'priority'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesWorkOrder
     */
    'readyToComplete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'reportedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'reportedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'resolution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'rootCause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'scheduledDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'scheduledTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'startedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'symptoms'?: string | null;
    /**
     * 
     * @type {Array<ResponsesWorkOrderTask>}
     * @memberof ResponsesWorkOrder
     */
    'tasks'?: Array<ResponsesWorkOrderTask>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'tasksCompleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrder
     */
    'tasksTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'technicianName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'title'?: string;
    /**
     * 
     * @type {ResponsesTrailerSummary}
     * @memberof ResponsesWorkOrder
     */
    'trailer'?: ResponsesTrailerSummary;
    /**
     * 
     * @type {ResponsesTruckSummary}
     * @memberof ResponsesWorkOrder
     */
    'truck'?: ResponsesTruckSummary;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vendorAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vendorContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vendorInvoice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vendorPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'vmrsDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrder
     */
    'workOrderNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderHistory
 */
export interface ResponsesWorkOrderHistory {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'eventType'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesWorkOrderHistory
     */
    'newValue'?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponsesWorkOrderHistory
     */
    'oldValue'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'workOrderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistory
     */
    'workOrderNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderHistoryResponse
 */
export interface ResponsesWorkOrderHistoryResponse {
    /**
     * 
     * @type {ResponsesWorkOrderHistoryResponseData}
     * @memberof ResponsesWorkOrderHistoryResponse
     */
    'data'?: ResponsesWorkOrderHistoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderHistoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderHistoryResponseData
 */
export interface ResponsesWorkOrderHistoryResponseData {
    /**
     * 
     * @type {Array<ResponsesWorkOrderHistory>}
     * @memberof ResponsesWorkOrderHistoryResponseData
     */
    'history'?: Array<ResponsesWorkOrderHistory>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesWorkOrderHistoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderListResponse
 */
export interface ResponsesWorkOrderListResponse {
    /**
     * 
     * @type {ResponsesWorkOrderListResponseData}
     * @memberof ResponsesWorkOrderListResponse
     */
    'data'?: ResponsesWorkOrderListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderListResponseData
 */
export interface ResponsesWorkOrderListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesWorkOrderListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesWorkOrder>}
     * @memberof ResponsesWorkOrderListResponseData
     */
    'workOrders'?: Array<ResponsesWorkOrder>;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderPartUsage
 */
export interface ResponsesWorkOrderPartUsage {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'partNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'partUnid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'totalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'unid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'unitCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderPartUsage
     */
    'usedAt'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderResponse
 */
export interface ResponsesWorkOrderResponse {
    /**
     * 
     * @type {ResponsesWorkOrderResponseData}
     * @memberof ResponsesWorkOrderResponse
     */
    'data'?: ResponsesWorkOrderResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderResponseData
 */
export interface ResponsesWorkOrderResponseData {
    /**
     * 
     * @type {ResponsesWorkOrder}
     * @memberof ResponsesWorkOrderResponseData
     */
    'workOrder'?: ResponsesWorkOrder;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTask
 */
export interface ResponsesWorkOrderTask {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'assignedToTechnicianId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'completedByTechnicianId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'estimatedCost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'estimatedHours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'inspectionDefectId'?: string | null;
    /**
     * 
     * @type {Array<ResponsesWorkOrderTaskLabor>}
     * @memberof ResponsesWorkOrderTask
     */
    'labor'?: Array<ResponsesWorkOrderTaskLabor>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'notes'?: string | null;
    /**
     * 
     * @type {Array<ResponsesWorkOrderTaskPart>}
     * @memberof ResponsesWorkOrderTask
     */
    'parts'?: Array<ResponsesWorkOrderTaskPart>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'startedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'totalCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'totalLaborCost'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTask
     */
    'totalPartsCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTask
     */
    'workOrderId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskLabor
 */
export interface ResponsesWorkOrderTaskLabor {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'addedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'addedByUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'hours'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'performedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'taskId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'technicianId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'technicianName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'totalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLabor
     */
    'workOrderId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskLaborResponse
 */
export interface ResponsesWorkOrderTaskLaborResponse {
    /**
     * 
     * @type {ResponsesWorkOrderTaskLaborResponseData}
     * @memberof ResponsesWorkOrderTaskLaborResponse
     */
    'data'?: ResponsesWorkOrderTaskLaborResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLaborResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskLaborResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskLaborResponseData
 */
export interface ResponsesWorkOrderTaskLaborResponseData {
    /**
     * 
     * @type {ResponsesWorkOrderTaskLabor}
     * @memberof ResponsesWorkOrderTaskLaborResponseData
     */
    'labor'?: ResponsesWorkOrderTaskLabor;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskListResponse
 */
export interface ResponsesWorkOrderTaskListResponse {
    /**
     * 
     * @type {ResponsesWorkOrderTaskListResponseData}
     * @memberof ResponsesWorkOrderTaskListResponse
     */
    'data'?: ResponsesWorkOrderTaskListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskListResponseData
 */
export interface ResponsesWorkOrderTaskListResponseData {
    /**
     * 
     * @type {Array<ResponsesWorkOrderTask>}
     * @memberof ResponsesWorkOrderTaskListResponseData
     */
    'tasks'?: Array<ResponsesWorkOrderTask>;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskPart
 */
export interface ResponsesWorkOrderTaskPart {
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'addedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'addedByUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'partId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'partNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'taskId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'totalCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'unid': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'unitCost'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPart
     */
    'workOrderId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskPartResponse
 */
export interface ResponsesWorkOrderTaskPartResponse {
    /**
     * 
     * @type {ResponsesWorkOrderTaskPartResponseData}
     * @memberof ResponsesWorkOrderTaskPartResponse
     */
    'data'?: ResponsesWorkOrderTaskPartResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPartResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskPartResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskPartResponseData
 */
export interface ResponsesWorkOrderTaskPartResponseData {
    /**
     * 
     * @type {ResponsesWorkOrderTaskPart}
     * @memberof ResponsesWorkOrderTaskPartResponseData
     */
    'part'?: ResponsesWorkOrderTaskPart;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskResponse
 */
export interface ResponsesWorkOrderTaskResponse {
    /**
     * 
     * @type {ResponsesWorkOrderTaskResponseData}
     * @memberof ResponsesWorkOrderTaskResponse
     */
    'data'?: ResponsesWorkOrderTaskResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesWorkOrderTaskResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesWorkOrderTaskResponseData
 */
export interface ResponsesWorkOrderTaskResponseData {
    /**
     * 
     * @type {ResponsesWorkOrderTask}
     * @memberof ResponsesWorkOrderTaskResponseData
     */
    'task'?: ResponsesWorkOrderTask;
}
/**
 * 
 * @export
 * @interface ResponsesYard
 */
export interface ResponsesYard {
    /**
     * 
     * @type {any}
     * @memberof ResponsesYard
     */
    'address'?: any;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'capacityTrailers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'capacityTrucks'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'radiusMeters'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'trailerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYard
     */
    'truckCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYard
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesYardDiscrepanciesResponse
 */
export interface ResponsesYardDiscrepanciesResponse {
    /**
     * 
     * @type {ResponsesYardDiscrepanciesResponseData}
     * @memberof ResponsesYardDiscrepanciesResponse
     */
    'data'?: ResponsesYardDiscrepanciesResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardDiscrepanciesResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardDiscrepanciesResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardDiscrepanciesResponseData
 */
export interface ResponsesYardDiscrepanciesResponseData {
    /**
     * 
     * @type {Array<ResponsesYardEvent>}
     * @memberof ResponsesYardDiscrepanciesResponseData
     */
    'discrepancies'?: Array<ResponsesYardEvent>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardDiscrepanciesResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardDiscrepanciesResponseData
     */
    'yardId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardEvent
 */
export interface ResponsesYardEvent {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'condition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesYardEvent
     */
    'documentIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'driverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'eventType'?: string;
    /**
     * 
     * @type {Array<ResponsesEventFormSnapshotTemplate>}
     * @memberof ResponsesYardEvent
     */
    'formSnapshot'?: Array<ResponsesEventFormSnapshotTemplate>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardEvent
     */
    'loaded'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'loggedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'occurredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'sealNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardEvent
     */
    'sealed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'spotName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'trailerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'truckId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'yardId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEvent
     */
    'yardName'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardEventListResponse
 */
export interface ResponsesYardEventListResponse {
    /**
     * 
     * @type {ResponsesYardEventListResponseData}
     * @memberof ResponsesYardEventListResponse
     */
    'data'?: ResponsesYardEventListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEventListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEventListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardEventListResponseData
 */
export interface ResponsesYardEventListResponseData {
    /**
     * 
     * @type {Array<ResponsesYardEvent>}
     * @memberof ResponsesYardEventListResponseData
     */
    'events'?: Array<ResponsesYardEvent>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardEventListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
}
/**
 * 
 * @export
 * @interface ResponsesYardEventResponse
 */
export interface ResponsesYardEventResponse {
    /**
     * 
     * @type {ResponsesYardEventResponseData}
     * @memberof ResponsesYardEventResponse
     */
    'data'?: ResponsesYardEventResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEventResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardEventResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardEventResponseData
 */
export interface ResponsesYardEventResponseData {
    /**
     * 
     * @type {ResponsesYardEvent}
     * @memberof ResponsesYardEventResponseData
     */
    'event'?: ResponsesYardEvent;
}
/**
 * 
 * @export
 * @interface ResponsesYardFleetOverviewEntry
 */
export interface ResponsesYardFleetOverviewEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'equipmentUnid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'hasOpenDiscrepancy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'lastYardEventAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'lastYardEventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'spotName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'unitNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'yardName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewEntry
     */
    'yardUnid'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardFleetOverviewResponse
 */
export interface ResponsesYardFleetOverviewResponse {
    /**
     * 
     * @type {ResponsesYardFleetOverviewResponseData}
     * @memberof ResponsesYardFleetOverviewResponse
     */
    'data'?: ResponsesYardFleetOverviewResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFleetOverviewResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardFleetOverviewResponseData
 */
export interface ResponsesYardFleetOverviewResponseData {
    /**
     * 
     * @type {Array<ResponsesYardFleetOverviewEntry>}
     * @memberof ResponsesYardFleetOverviewResponseData
     */
    'items'?: Array<ResponsesYardFleetOverviewEntry>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardFleetOverviewResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardFleetOverviewResponseData
     */
    'trailerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardFleetOverviewResponseData
     */
    'truckCount'?: number;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormField
 */
export interface ResponsesYardFormField {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'fieldType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'label'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesYardFormField
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardFormField
     */
    'position'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardFormField
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'templateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormField
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormTemplate
 */
export interface ResponsesYardFormTemplate {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsesYardFormTemplate
     */
    'eventTypes'?: Array<string>;
    /**
     * 
     * @type {Array<ResponsesYardFormField>}
     * @memberof ResponsesYardFormTemplate
     */
    'fields'?: Array<ResponsesYardFormField>;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardFormTemplate
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardFormTemplate
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'yardId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplate
     */
    'yardName'?: string | null;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormTemplateListResponse
 */
export interface ResponsesYardFormTemplateListResponse {
    /**
     * 
     * @type {ResponsesYardFormTemplateListResponseData}
     * @memberof ResponsesYardFormTemplateListResponse
     */
    'data'?: ResponsesYardFormTemplateListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplateListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplateListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormTemplateListResponseData
 */
export interface ResponsesYardFormTemplateListResponseData {
    /**
     * 
     * @type {Array<ResponsesYardFormTemplate>}
     * @memberof ResponsesYardFormTemplateListResponseData
     */
    'templates'?: Array<ResponsesYardFormTemplate>;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormTemplateResponse
 */
export interface ResponsesYardFormTemplateResponse {
    /**
     * 
     * @type {ResponsesYardFormTemplateResponseData}
     * @memberof ResponsesYardFormTemplateResponse
     */
    'data'?: ResponsesYardFormTemplateResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplateResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardFormTemplateResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardFormTemplateResponseData
 */
export interface ResponsesYardFormTemplateResponseData {
    /**
     * 
     * @type {ResponsesYardFormTemplate}
     * @memberof ResponsesYardFormTemplateResponseData
     */
    'template'?: ResponsesYardFormTemplate;
}
/**
 * 
 * @export
 * @interface ResponsesYardInventoryEntry
 */
export interface ResponsesYardInventoryEntry {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'equipmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'equipmentUnid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponsesYardInventoryEntry
     */
    'hasOpenDiscrepancy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'lastYardEventAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'lastYardEventType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'spotId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'spotName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryEntry
     */
    'unitNumber'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardInventoryResponse
 */
export interface ResponsesYardInventoryResponse {
    /**
     * 
     * @type {ResponsesYardInventoryResponseData}
     * @memberof ResponsesYardInventoryResponse
     */
    'data'?: ResponsesYardInventoryResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardInventoryResponseData
 */
export interface ResponsesYardInventoryResponseData {
    /**
     * 
     * @type {Array<ResponsesYardInventoryEntry>}
     * @memberof ResponsesYardInventoryResponseData
     */
    'items'?: Array<ResponsesYardInventoryEntry>;
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardInventoryResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardInventoryResponseData
     */
    'trailerCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponsesYardInventoryResponseData
     */
    'truckCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardInventoryResponseData
     */
    'yardId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardListResponse
 */
export interface ResponsesYardListResponse {
    /**
     * 
     * @type {ResponsesYardListResponseData}
     * @memberof ResponsesYardListResponse
     */
    'data'?: ResponsesYardListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardListResponseData
 */
export interface ResponsesYardListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesYard>}
     * @memberof ResponsesYardListResponseData
     */
    'yards'?: Array<ResponsesYard>;
}
/**
 * 
 * @export
 * @interface ResponsesYardResponse
 */
export interface ResponsesYardResponse {
    /**
     * 
     * @type {ResponsesYardResponseData}
     * @memberof ResponsesYardResponse
     */
    'data'?: ResponsesYardResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardResponseData
 */
export interface ResponsesYardResponseData {
    /**
     * 
     * @type {ResponsesYard}
     * @memberof ResponsesYardResponseData
     */
    'yard'?: ResponsesYard;
}
/**
 * 
 * @export
 * @interface ResponsesYardSpot
 */
export interface ResponsesYardSpot {
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'createdByRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'spotType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'unid': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpot
     */
    'yardId'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardSpotListResponse
 */
export interface ResponsesYardSpotListResponse {
    /**
     * 
     * @type {ResponsesYardSpotListResponseData}
     * @memberof ResponsesYardSpotListResponse
     */
    'data'?: ResponsesYardSpotListResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpotListResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpotListResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardSpotListResponseData
 */
export interface ResponsesYardSpotListResponseData {
    /**
     * 
     * @type {ResponsesPaginationInfo}
     * @memberof ResponsesYardSpotListResponseData
     */
    'pagination'?: ResponsesPaginationInfo;
    /**
     * 
     * @type {Array<ResponsesYardSpot>}
     * @memberof ResponsesYardSpotListResponseData
     */
    'spots'?: Array<ResponsesYardSpot>;
}
/**
 * 
 * @export
 * @interface ResponsesYardSpotResponse
 */
export interface ResponsesYardSpotResponse {
    /**
     * 
     * @type {ResponsesYardSpotResponseData}
     * @memberof ResponsesYardSpotResponse
     */
    'data'?: ResponsesYardSpotResponseData;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpotResponse
     */
    'requestID'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesYardSpotResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ResponsesYardSpotResponseData
 */
export interface ResponsesYardSpotResponseData {
    /**
     * 
     * @type {ResponsesYardSpot}
     * @memberof ResponsesYardSpotResponseData
     */
    'spot'?: ResponsesYardSpot;
}
/**
 * 
 * @export
 * @interface SeedDefaultsRequest
 */
export interface SeedDefaultsRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof SeedDefaultsRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof SeedDefaultsRequest
     */
    'overwriteExisting'?: boolean;
}
/**
 * 
 * @export
 * @interface SignUpWithEmailRequest
 */
export interface SignUpWithEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SignUpWithEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignUpWithEmailRequest
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface SocialLoginRequest
 */
export interface SocialLoginRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof SocialLoginRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsWithCognitoIDToken}
     * @memberof SocialLoginRequest
     */
    'WithCognitoIDToken'?: RequestsWithCognitoIDToken;
}
/**
 * 
 * @export
 * @interface StoreAPIKeyRequest
 */
export interface StoreAPIKeyRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof StoreAPIKeyRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof StoreAPIKeyRequest
     */
    'apiKey': string;
    /**
     * 
     * @type {string}
     * @memberof StoreAPIKeyRequest
     */
    'integration': string;
    /**
     * 
     * @type {string}
     * @memberof StoreAPIKeyRequest
     */
    'integrationUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreAPIKeyRequest
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface StoreAlvysCredentialsRequest
 */
export interface StoreAlvysCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof StoreAlvysCredentialsRequest
     */
    'clientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreAlvysCredentialsRequest
     */
    'clientSecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreAlvysCredentialsRequest
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface StoreFleetrockCredentialsRequest
 */
export interface StoreFleetrockCredentialsRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'apiKeyCustomer': string;
    /**
     * 
     * @type {string}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'apiKeyVendor'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'usernameCustomer': string;
    /**
     * 
     * @type {string}
     * @memberof StoreFleetrockCredentialsRequest
     */
    'usernameVendor'?: string;
}
/**
 * 
 * @export
 * @interface SyncCustomersRequest
 */
export interface SyncCustomersRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof SyncCustomersRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof SyncCustomersRequest
     */
    'createMissing'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncCustomersRequest
     */
    'customerIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SyncRelayRequest
 */
export interface SyncRelayRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof SyncRelayRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof SyncRelayRequest
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncRelayRequest
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface TenderLoadRequest
 */
export interface TenderLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof TenderLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof TenderLoadRequest
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof TenderLoadRequest
     */
    'loadId': string;
    /**
     * 
     * @type {string}
     * @memberof TenderLoadRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenderLoadRequest
     */
    'notifyEmail'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TenderLoadRequest
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface TokenExchangeRequest
 */
export interface TokenExchangeRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenExchangeRequest
     */
    'authorizationCode': string;
}
/**
 * 
 * @export
 * @interface TrailerAssignDriverRequest
 */
export interface TrailerAssignDriverRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof TrailerAssignDriverRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof TrailerAssignDriverRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerAssignDriverRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrailerAssignDriverRequest
     */
    'notify_driver'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TrailerUnassignDriverRequest
 */
export interface TrailerUnassignDriverRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof TrailerUnassignDriverRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof TrailerUnassignDriverRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrailerUnassignDriverRequest
     */
    'reason'?: string | null;
}
/**
 * 
 * @export
 * @interface UnassignRequest
 */
export interface UnassignRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UnassignRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UnassignRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnassignRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnassignRequest
     */
    'reason'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnassignRequest
     */
    'remove_carrier'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnassignRequest
     */
    'remove_trailer'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnassignRequest
     */
    'remove_truck'?: boolean | null;
}
/**
 * 
 * @export
 * @interface UpdateCarrierRequest
 */
export interface UpdateCarrierRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateCarrierRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof UpdateCarrierRequest
     */
    'address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'cargo_insurance_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierRequest
     */
    'cargo_insurance_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'cargo_insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'cargo_insurance_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {RequestsContact}
     * @memberof UpdateCarrierRequest
     */
    'dispatch_contact'?: RequestsContact;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'dispatch_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'dispatch_phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCarrierRequest
     */
    'equipment_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'fax'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarrierRequest
     */
    'has_hazmat'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarrierRequest
     */
    'has_team_drivers'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCarrierRequest
     */
    'has_twic'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierRequest
     */
    'internal_rating'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'legal_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'liability_insurance_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierRequest
     */
    'liability_insurance_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'liability_insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'liability_insurance_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {RequestsContact}
     * @memberof UpdateCarrierRequest
     */
    'primary_contact'?: RequestsContact;
    /**
     * 
     * @type {number}
     * @memberof UpdateCarrierRequest
     */
    'quick_pay_discount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'rating_notes'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCarrierRequest
     */
    'service_regions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'workers_comp_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'workers_comp_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCarrierRequest
     */
    'workers_comp_provider'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCustomerContactRequest
 */
export interface UpdateCustomerContactRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateCustomerContactRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerContactRequest
     */
    'is_primary'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'mobile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerContactRequest
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCustomerRequest
 */
export interface UpdateCustomerRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateCustomerRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof UpdateCustomerRequest
     */
    'billing_address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'code'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCustomerRequest
     */
    'commodity_types'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerRequest
     */
    'credit_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'dot_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'fax'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'industry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'invoice_delivery_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'legal_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'mc_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'payment_terms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {RequestsAddress}
     * @memberof UpdateCustomerRequest
     */
    'physical_address'?: RequestsAddress;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'sales_rep_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'tax_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerRequest
     */
    'website'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCustomerStatusRequest
 */
export interface UpdateCustomerStatusRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateCustomerStatusRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerStatusRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerStatusRequest
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerStatusRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateDefectRequest
 */
export interface UpdateDefectRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateDefectRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefectRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefectRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefectRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefectRequest
     */
    'position'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDefectRequest
     */
    'severity'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDriverRecurringChargeRequest
 */
export interface UpdateDriverRecurringChargeRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'effective_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'frequency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRecurringChargeRequest
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDriverRequest
 */
export interface UpdateDriverRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateDriverRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'cdl_class'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDriverRequest
     */
    'cdl_endorsements'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'cdl_expiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'cdl_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'cdl_state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverRequest
     */
    'comm_pref_email'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDriverRequest
     */
    'comm_pref_push'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'driver_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'medical_card_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'medical_expiration'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDriverRequest
     */
    'pay_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'pay_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'relay_driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'terminal_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDriverRequest
     */
    'type'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateExpenseRequest
 */
export interface UpdateExpenseRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateExpenseRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof UpdateExpenseRequest
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'card_last_four'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'load_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'payment_method'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateExpenseRequest
     */
    'vendor'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFactoringBatchStatusRequest
 */
export interface UpdateFactoringBatchStatusRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateFactoringBatchStatusRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateFactoringBatchStatusRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateFormTemplateRequest
 */
export interface UpdateFormTemplateRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateFormTemplateRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFormTemplateRequest
     */
    'event_types'?: Array<string>;
    /**
     * 
     * @type {Array<RequestsCreateYardFormFieldRequest>}
     * @memberof UpdateFormTemplateRequest
     */
    'fields'?: Array<RequestsCreateYardFormFieldRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFormTemplateRequest
     */
    'is_active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFormTemplateRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFormTemplateRequest
     */
    'yard_id'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateLoadRequest
 */
export interface UpdateLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'account_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'accounting_status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoadRequest
     */
    'clear_empty_miles'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'customer_sale_agent_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'customer_service_user_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'empty_miles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'equipment_type'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoadRequest
     */
    'hazmat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'load_planner_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'mileage_route_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'mileage_source'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'piece_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'po_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'previous_stop_load_id'?: string | null;
    /**
     * 
     * @type {Array<RequestsReference>}
     * @memberof UpdateLoadRequest
     */
    'references'?: Array<RequestsReference>;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'sales_manager_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'special_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoadRequest
     */
    'team_required'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'trailer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'trip_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadRequest
     */
    'truck_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoadRequest
     */
    'weight_lbs'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateLoadStatusRequest
 */
export interface UpdateLoadStatusRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateLoadStatusRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadStatusRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadStatusRequest
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoadStatusRequest
     */
    'stop_id'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMaintenanceRequest
 */
export interface UpdateMaintenanceRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateMaintenanceRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'completed_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'engine_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'interval_days'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'interval_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'interval_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'maintenance_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'next_due_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'next_due_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'next_due_odometer'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'odometer'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMaintenanceRequest
     */
    'recurring'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateMaintenanceRequest
     */
    'reefer_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'scheduled_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMaintenanceRequest
     */
    'vmrs_code'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMappingRequest
 */
export interface UpdateMappingRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateMappingRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMappingRequest
     */
    'isDefault'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMappingRequest
     */
    'qbExpenseAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMappingRequest
     */
    'qbExpenseAccountName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMappingRequest
     */
    'qbRevenueAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMappingRequest
     */
    'qbRevenueAccountName'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMemberRolesRequest
 */
export interface UpdateMemberRolesRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateMemberRolesRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateMemberRolesRequest
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateOrganizationRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationRequest
     */
    'addAddressToEmailFooter'?: boolean | null;
    /**
     * 
     * @type {RequestsOrganizationAddress}
     * @memberof UpdateOrganizationRequest
     */
    'address'?: RequestsOrganizationAddress;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'businessMode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'coverUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'dateFormat'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'dba'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'distanceUnit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'domainName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'dotNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {Array<RequestsEventIntelligenceEventItem>}
     * @memberof UpdateOrganizationRequest
     */
    'eventIntelligence'?: Array<RequestsEventIntelligenceEventItem>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'legalName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'mcNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationRequest
     */
    'regenerateShareLink'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateOrganizationRequest
     */
    'requiredRedirects'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'scac'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationRequest
     */
    'shareLinkEnabled'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateOrganizationRequest
     */
    'socialMediaPreview'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'taxId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrganizationRequest
     */
    'timeZoneOffsetMinutes'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'timeZoneText'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePartRequest
 */
export interface UpdatePartRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdatePartRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'binLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'maximumStock'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'minimumStock'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'partNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'preferredSupplier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'quantityOnHand'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'reorderQuantity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'unitCost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequest
     */
    'vmrsCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'warrantyMiles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePartRequest
     */
    'warrantyMonths'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdatePaystubRequest
 */
export interface UpdatePaystubRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdatePaystubRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaystubRequest
     */
    'credits'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaystubRequest
     */
    'driver_payment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaystubRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaystubRequest
     */
    'pay_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaystubRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {Array<RequestsPaystubTaxItemRequest>}
     * @memberof UpdatePaystubRequest
     */
    'tax_items'?: Array<RequestsPaystubTaxItemRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaystubRequest
     */
    'void_reason'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateQuoteRequest
 */
export interface UpdateQuoteRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateQuoteRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'accessorials'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'contact_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'contact_phone'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'customer_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'destination_city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'destination_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'destination_zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'equipment_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'fuel_surcharge'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateQuoteRequest
     */
    'hazmat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'origin_city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'origin_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'origin_zip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'pickup_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'total_miles'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'valid_from'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteRequest
     */
    'valid_until'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateQuoteRequest
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateRecurringLoadRequest
 */
export interface UpdateRecurringLoadRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateRecurringLoadRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'day_interval'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'default_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'delivery_time_hour'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'destination_city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'destination_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'equipment_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'generate_lead_days'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'month_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'origin_city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'origin_state'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'pickup_time_hour'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'recurrence_pattern'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRecurringLoadRequest
     */
    'skip_dates'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {Array<RequestsCreateRecurringLoadStopRequest>}
     * @memberof UpdateRecurringLoadRequest
     */
    'stops'?: Array<RequestsCreateRecurringLoadStopRequest>;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringLoadRequest
     */
    'template_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringLoadRequest
     */
    'transit_days'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRecurringLoadRequest
     */
    'week_days'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateRelayConfigRequest
 */
export interface UpdateRelayConfigRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateRelayConfigRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRelayConfigRequest
     */
    'policyIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRelayConfigRequest
     */
    'syncAllPolicies'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateSettlementRequest
 */
export interface UpdateSettlementRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateSettlementRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'accessorial_pay'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'bonus_pay'?: number | null;
    /**
     * 
     * @type {Array<RequestsSettlementItemRequest>}
     * @memberof UpdateSettlementRequest
     */
    'deduction_items'?: Array<RequestsSettlementItemRequest>;
    /**
     * 
     * @type {Array<RequestsSettlementItemRequest>}
     * @memberof UpdateSettlementRequest
     */
    'earnings_items'?: Array<RequestsSettlementItemRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'gross_earnings'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'load_pay'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'net_pay'?: number | null;
    /**
     * 
     * @type {Array<RequestsSettlementItemRequest>}
     * @memberof UpdateSettlementRequest
     */
    'reimbursement_items'?: Array<RequestsSettlementItemRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'total_deductions'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSettlementRequest
     */
    'total_reimbursements'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateSpotRequest
 */
export interface UpdateSpotRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateSpotRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotRequest
     */
    'spot_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSpotRequest
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateStopRequest
 */
export interface UpdateStopRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateStopRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {RequestsStopCreate}
     * @memberof UpdateStopRequest
     */
    'stop': RequestsStopCreate;
}
/**
 * 
 * @export
 * @interface UpdateTechnicianRequest
 */
export interface UpdateTechnicianRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTechnicianRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'certifications'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'hire_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTechnicianRequest
     */
    'hourly_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTechnicianRequest
     */
    'labor_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'specializations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTechnicianRequest
     */
    'termination_date'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateTemplateRequest
 */
export interface UpdateTemplateRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTemplateRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'commodity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'default_fuel_surcharge'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'default_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'delivery_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'equipment_length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'equipment_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'estimated_miles'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTemplateRequest
     */
    'hazmat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'hazmat_class'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTemplateRequest
     */
    'is_active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'pallets'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateRequest
     */
    'pickup_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'pieces'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTemplateRequest
     */
    'required_endorsements'?: Array<string>;
    /**
     * 
     * @type {Array<RequestsCreateLoadTemplateStopRequest>}
     * @memberof UpdateTemplateRequest
     */
    'stops'?: Array<RequestsCreateLoadTemplateStopRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'temperature_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'temperature_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateRequest
     */
    'weight'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTrailerRequest
 */
export interface UpdateTrailerRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTrailerRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrailerRequest
     */
    'air_ride'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'axles'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'cubic_feet'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'current_temp'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'current_value'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'door_height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'door_width'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'drop_location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'dropped_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrailerRequest
     */
    'e_tracks'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'gps_device_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'gps_provider'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'inspection_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'lease_company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'lease_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'length'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'license_plate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'license_plate_state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrailerRequest
     */
    'lift_gate'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'load_locks'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'max_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'monthly_payment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'owner_driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'ownership'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'pallet_positions'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'purchase_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'purchase_price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'reefer_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'reefer_make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'reefer_model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'reefer_serial'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'registration_expiry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'set_temp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'tare_weight'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'trailer_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrailerRequest
     */
    'vented'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrailerRequest
     */
    'year'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTrailerStatusRequest
 */
export interface UpdateTrailerStatusRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTrailerStatusRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerStatusRequest
     */
    'drop_location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerStatusRequest
     */
    'dropped_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrailerStatusRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateTruckRequest
 */
export interface UpdateTruckRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTruckRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'color'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'current_odometer'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'current_value'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'eld_device_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'eld_provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'engine_make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'engine_model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'fifth_wheel_height'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'fuel_capacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'fuel_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'gvwr'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'horsepower'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'inspection_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'insurance_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'insurance_policy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'lease_company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'lease_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'license_plate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'license_plate_state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'monthly_payment'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'owner_driver_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'ownership'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'purchase_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'purchase_price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'registration_expiry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'transmission'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'truck_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'unit_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckRequest
     */
    'vin'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'wheel_base'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTruckRequest
     */
    'year'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTruckStatusRequest
 */
export interface UpdateTruckStatusRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateTruckStatusRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckStatusRequest
     */
    'estimated_return_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckStatusRequest
     */
    'reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTruckStatusRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateUserProfileRequest
 */
export interface UpdateUserProfileRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateUserProfileRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'bio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'birthdate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserProfileRequest
     */
    'onboardingComplete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'profilePhotoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserProfileRequest
     */
    'username'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkOrderRequest
 */
export interface UpdateWorkOrderRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateWorkOrderRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'assigned_to_technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'due_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderRequest
     */
    'estimated_hours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderRequest
     */
    'estimated_labor_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderRequest
     */
    'estimated_parts_cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'internal_notes'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkOrderRequest
     */
    'is_internal'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'priority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'resolution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'root_cause'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'scheduled_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'scheduled_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'symptoms'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'vendor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'vendor_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'vendor_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderRequest
     */
    'vendor_phone'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkOrderTaskLaborRequest
 */
export interface UpdateWorkOrderTaskLaborRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'performed_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskLaborRequest
     */
    'technician_name'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkOrderTaskPartRequest
 */
export interface UpdateWorkOrderTaskPartRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateWorkOrderTaskPartRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskPartRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskPartRequest
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskPartRequest
     */
    'unit_cost'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateWorkOrderTaskRequest
 */
export interface UpdateWorkOrderTaskRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'assigned_to_technician_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'estimated_cost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'estimated_hours'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkOrderTaskRequest
     */
    'vmrs_code'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateYardRequest
 */
export interface UpdateYardRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpdateYardRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {any}
     * @memberof UpdateYardRequest
     */
    'address'?: any;
    /**
     * 
     * @type {number}
     * @memberof UpdateYardRequest
     */
    'capacity_trailers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateYardRequest
     */
    'capacity_trucks'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateYardRequest
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateYardRequest
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateYardRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateYardRequest
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateYardRequest
     */
    'radius_meters'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateYardRequest
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface UpgradeSubscriptionRequest
 */
export interface UpgradeSubscriptionRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UpgradeSubscriptionRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionRequest
     */
    'newPlanUnid': string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionRequest
     */
    'organizationUnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionRequest
     */
    'subscriptionUnid': string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionRequest
     */
    'userUnid'?: string | null;
}
/**
 * 
 * @export
 * @interface UseTemplateRequest
 */
export interface UseTemplateRequest {
    /**
     * 
     * @type {RequestsWithCognitoAuth}
     * @memberof UseTemplateRequest
     */
    'WithCognitoAuth'?: RequestsWithCognitoAuth;
    /**
     * 
     * @type {string}
     * @memberof UseTemplateRequest
     */
    'customer_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UseTemplateRequest
     */
    'delivery_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UseTemplateRequest
     */
    'pickup_date': string | null;
    /**
     * 
     * @type {RequestsLoadRateCreate}
     * @memberof UseTemplateRequest
     */
    'rate'?: RequestsLoadRateCreate;
}
/**
 * 
 * @export
 * @interface VerifyDeleteUserProfileRequest
 */
export interface VerifyDeleteUserProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyDeleteUserProfileRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface VerifyEmailSignInRequest
 */
export interface VerifyEmailSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailSignInRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailSignInRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailSignInRequest
     */
    'session': string;
}
/**
 * 
 * @export
 * @interface VerifyPhoneSignInRequest
 */
export interface VerifyPhoneSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyPhoneSignInRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPhoneSignInRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPhoneSignInRequest
     */
    'session': string;
}

/**
 * APIKeysApi - axios parameter creator
 * @export
 */
export const APIKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPIKey: async (integration: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('deleteAPIKey', 'integration', integration)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteAPIKey', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteAPIKey', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/{integration}`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPIKeyOptions: async (integration: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('deleteAPIKeyOptions', 'integration', integration)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteAPIKeyOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/{integration}`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIKey: async (integration: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('getAPIKey', 'integration', integration)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAPIKey', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAPIKey', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/{integration}`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedAPIKeyIntegrations: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSupportedAPIKeyIntegrations', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSupportedAPIKeyIntegrations', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/supported`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedAPIKeyIntegrationsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSupportedAPIKeyIntegrationsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/supported`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyIntegrations: async (integration: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('listAPIKeyIntegrations', 'integration', integration)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAPIKeyIntegrations', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listAPIKeyIntegrations', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/{integration}/list`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyIntegrationsOptions: async (integration: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('listAPIKeyIntegrationsOptions', 'integration', integration)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAPIKeyIntegrationsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys/{integration}/list`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreAPIKeyRequest} storeAPIKeyRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAPIKey: async (organizationUnid: string, authorization: string, storeAPIKeyRequest: StoreAPIKeyRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('storeAPIKey', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeAPIKey', 'authorization', authorization)
            // verify required parameter 'storeAPIKeyRequest' is not null or undefined
            assertParamExists('storeAPIKey', 'storeAPIKeyRequest', storeAPIKeyRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storeAPIKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAPIKeyOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('storeAPIKeyOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/apikeys`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APIKeysApi - functional programming interface
 * @export
 */
export const APIKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APIKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAPIKey(integration, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.deleteAPIKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAPIKeyOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAPIKeyOptions(integration, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.deleteAPIKeyOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAPIKeyIntegrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAPIKey(integration, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.getAPIKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedAPIKeyIntegrations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSupportedAPIKeyIntegrationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedAPIKeyIntegrations(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.getSupportedAPIKeyIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedAPIKeyIntegrationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedAPIKeyIntegrationsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.getSupportedAPIKeyIntegrationsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAPIKeyIntegrations(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAPIKeyIntegrationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAPIKeyIntegrations(integration, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.listAPIKeyIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAPIKeyIntegrationsOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAPIKeyIntegrationsOptions(integration, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.listAPIKeyIntegrationsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreAPIKeyRequest} storeAPIKeyRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeAPIKey(organizationUnid: string, authorization: string, storeAPIKeyRequest: StoreAPIKeyRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAPIKeyIntegrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeAPIKey(organizationUnid, authorization, storeAPIKeyRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.storeAPIKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeAPIKeyOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeAPIKeyOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APIKeysApi.storeAPIKeyOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APIKeysApi - factory interface
 * @export
 */
export const APIKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APIKeysApiFp(configuration)
    return {
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteAPIKey(integration, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAPIKeyOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteAPIKeyOptions(integration, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAPIKeyIntegrationResponse> {
            return localVarFp.getAPIKey(integration, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedAPIKeyIntegrations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSupportedAPIKeyIntegrationsResponse> {
            return localVarFp.getSupportedAPIKeyIntegrations(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedAPIKeyIntegrationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getSupportedAPIKeyIntegrationsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyIntegrations(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAPIKeyIntegrationListResponse> {
            return localVarFp.listAPIKeyIntegrations(integration, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} integration 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyIntegrationsOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listAPIKeyIntegrationsOptions(integration, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreAPIKeyRequest} storeAPIKeyRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAPIKey(organizationUnid: string, authorization: string, storeAPIKeyRequest: StoreAPIKeyRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAPIKeyIntegrationResponse> {
            return localVarFp.storeAPIKey(organizationUnid, authorization, storeAPIKeyRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAPIKeyOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.storeAPIKeyOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APIKeysApi - object-oriented interface
 * @export
 * @class APIKeysApi
 * @extends {BaseAPI}
 */
export class APIKeysApi extends BaseAPI {
    /**
     * 
     * @param {string} integration 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public deleteAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).deleteAPIKey(integration, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} integration 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public deleteAPIKeyOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).deleteAPIKeyOptions(integration, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} integration 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public getAPIKey(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).getAPIKey(integration, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public getSupportedAPIKeyIntegrations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).getSupportedAPIKeyIntegrations(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public getSupportedAPIKeyIntegrationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).getSupportedAPIKeyIntegrationsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} integration 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public listAPIKeyIntegrations(integration: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).listAPIKeyIntegrations(integration, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} integration 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public listAPIKeyIntegrationsOptions(integration: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).listAPIKeyIntegrationsOptions(integration, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {StoreAPIKeyRequest} storeAPIKeyRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public storeAPIKey(organizationUnid: string, authorization: string, storeAPIKeyRequest: StoreAPIKeyRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).storeAPIKey(organizationUnid, authorization, storeAPIKeyRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APIKeysApi
     */
    public storeAPIKeyOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return APIKeysApiFp(this.configuration).storeAPIKeyOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountingApi - axios parameter creator
 * @export
 */
export const AccountingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [accountingStatus] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingLoads: async (organizationUnid: string, authorization: string, accountingStatus?: Array<string>, limit?: number, page?: number, search?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAccountingLoads', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listAccountingLoads', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/accounting/loads`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountingStatus) {
                localVarQueryParameter['accounting_status'] = accountingStatus;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingLoadsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAccountingLoadsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/accounting/loads`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountingApi - functional programming interface
 * @export
 */
export const AccountingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [accountingStatus] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountingLoads(organizationUnid: string, authorization: string, accountingStatus?: Array<string>, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountingLoads(organizationUnid, authorization, accountingStatus, limit, page, search, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.listAccountingLoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountingLoadsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountingLoadsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.listAccountingLoadsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountingApi - factory interface
 * @export
 */
export const AccountingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountingApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [accountingStatus] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingLoads(organizationUnid: string, authorization: string, accountingStatus?: Array<string>, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadListResponse> {
            return localVarFp.listAccountingLoads(organizationUnid, authorization, accountingStatus, limit, page, search, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountingLoadsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listAccountingLoadsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountingApi - object-oriented interface
 * @export
 * @class AccountingApi
 * @extends {BaseAPI}
 */
export class AccountingApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {Array<string>} [accountingStatus] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    public listAccountingLoads(organizationUnid: string, authorization: string, accountingStatus?: Array<string>, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return AccountingApiFp(this.configuration).listAccountingLoads(organizationUnid, authorization, accountingStatus, limit, page, search, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    public listAccountingLoadsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return AccountingApiFp(this.configuration).listAccountingLoadsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlvysApi - axios parameter creator
 * @export
 */
export const AlvysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlvysCredentials: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteAlvysCredentials', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/alvys/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlvysCredentialsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteAlvysCredentialsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/alvys/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {StoreAlvysCredentialsRequest} storeAlvysCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAlvysCredentials: async (organizationUnid: string, storeAlvysCredentialsRequest: StoreAlvysCredentialsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('storeAlvysCredentials', 'organizationUnid', organizationUnid)
            // verify required parameter 'storeAlvysCredentialsRequest' is not null or undefined
            assertParamExists('storeAlvysCredentials', 'storeAlvysCredentialsRequest', storeAlvysCredentialsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/alvys/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storeAlvysCredentialsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlvysApi - functional programming interface
 * @export
 */
export const AlvysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlvysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlvysCredentials(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlvysCredentials(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlvysApi.deleteAlvysCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlvysCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlvysCredentialsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlvysApi.deleteAlvysCredentialsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {StoreAlvysCredentialsRequest} storeAlvysCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeAlvysCredentials(organizationUnid: string, storeAlvysCredentialsRequest: StoreAlvysCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeAlvysCredentials(organizationUnid, storeAlvysCredentialsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlvysApi.storeAlvysCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlvysApi - factory interface
 * @export
 */
export const AlvysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlvysApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlvysCredentials(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteAlvysCredentials(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlvysCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteAlvysCredentialsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {StoreAlvysCredentialsRequest} storeAlvysCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAlvysCredentials(organizationUnid: string, storeAlvysCredentialsRequest: StoreAlvysCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.storeAlvysCredentials(organizationUnid, storeAlvysCredentialsRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlvysApi - object-oriented interface
 * @export
 * @class AlvysApi
 * @extends {BaseAPI}
 */
export class AlvysApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlvysApi
     */
    public deleteAlvysCredentials(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return AlvysApiFp(this.configuration).deleteAlvysCredentials(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlvysApi
     */
    public deleteAlvysCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return AlvysApiFp(this.configuration).deleteAlvysCredentialsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {StoreAlvysCredentialsRequest} storeAlvysCredentialsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlvysApi
     */
    public storeAlvysCredentials(organizationUnid: string, storeAlvysCredentialsRequest: StoreAlvysCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AlvysApiFp(this.configuration).storeAlvysCredentials(organizationUnid, storeAlvysCredentialsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (authorization: string, changePasswordRequest: ChangePasswordRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changePassword', 'authorization', authorization)
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/api/v1/auth/password/change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPassword: async (confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmForgotPasswordRequest' is not null or undefined
            assertParamExists('confirmForgotPassword', 'confirmForgotPasswordRequest', confirmForgotPasswordRequest)
            const localVarPath = `/api/v1/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmForgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPasswordOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfirmSignUpRequest} confirmSignUpRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUp: async (confirmSignUpRequest: ConfirmSignUpRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmSignUpRequest' is not null or undefined
            assertParamExists('confirmSignUp', 'confirmSignUpRequest', confirmSignUpRequest)
            const localVarPath = `/api/v1/auth/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUpOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendConfirmationCodeRequest' is not null or undefined
            assertParamExists('forgotPassword', 'resendConfirmationCodeRequest', resendConfirmationCodeRequest)
            const localVarPath = `/api/v1/auth/password/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendConfirmationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/forgot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthLoginPageURL: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/oauth/login-page-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthLoginPageURLOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/oauth/login-page-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordPolicy: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordPolicyOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLoginURL: async (provider: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('getSocialLoginURL', 'provider', provider)
            const localVarPath = `/api/v1/auth/oauth/social/login-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLoginURLOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/oauth/social/login-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailSignIn: async (resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendConfirmationCodeRequest' is not null or undefined
            assertParamExists('initiateEmailSignIn', 'resendConfirmationCodeRequest', resendConfirmationCodeRequest)
            const localVarPath = `/api/v1/auth/otp/email/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendConfirmationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailSignInOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/otp/email/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InitiatePhoneSignInRequest} initiatePhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePhoneSignIn: async (initiatePhoneSignInRequest: InitiatePhoneSignInRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiatePhoneSignInRequest' is not null or undefined
            assertParamExists('initiatePhoneSignIn', 'initiatePhoneSignInRequest', initiatePhoneSignInRequest)
            const localVarPath = `/api/v1/auth/otp/phone/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiatePhoneSignInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePhoneSignInOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/otp/phone/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginInUserWithPassword: async (loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginInUserWithPasswordRequest' is not null or undefined
            assertParamExists('loginInUserWithPassword', 'loginInUserWithPasswordRequest', loginInUserWithPasswordRequest)
            const localVarPath = `/api/v1/auth/password/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginInUserWithPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginInUserWithPasswordOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequest: RefreshTokenRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequest' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest)
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCode: async (resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendConfirmationCodeRequest' is not null or undefined
            assertParamExists('resendConfirmationCode', 'resendConfirmationCodeRequest', resendConfirmationCodeRequest)
            const localVarPath = `/api/v1/auth/confirmation-code/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendConfirmationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCodeOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/confirmation-code/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpUserWithPassword: async (loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginInUserWithPasswordRequest' is not null or undefined
            assertParamExists('signUpUserWithPassword', 'loginInUserWithPasswordRequest', loginInUserWithPasswordRequest)
            const localVarPath = `/api/v1/auth/password/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginInUserWithPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpUserWithPasswordOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/password/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignUpWithEmailRequest} signUpWithEmailRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmail: async (signUpWithEmailRequest: SignUpWithEmailRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpWithEmailRequest' is not null or undefined
            assertParamExists('signUpWithEmail', 'signUpWithEmailRequest', signUpWithEmailRequest)
            const localVarPath = `/api/v1/auth/otp/email/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpWithEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmailOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/otp/email/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} xIdToken 
         * @param {SocialLoginRequest} socialLoginRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLogin: async (authorization: string, xIdToken: string, socialLoginRequest: SocialLoginRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('socialLogin', 'authorization', authorization)
            // verify required parameter 'xIdToken' is not null or undefined
            assertParamExists('socialLogin', 'xIdToken', xIdToken)
            // verify required parameter 'socialLoginRequest' is not null or undefined
            assertParamExists('socialLogin', 'socialLoginRequest', socialLoginRequest)
            const localVarPath = `/api/v1/auth/oauth/social/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            if (xIdToken != null) {
                localVarHeaderParameter['x-id-token'] = String(xIdToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/oauth/social/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TokenExchangeRequest} tokenExchangeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchange: async (tokenExchangeRequest: TokenExchangeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenExchangeRequest' is not null or undefined
            assertParamExists('tokenExchange', 'tokenExchangeRequest', tokenExchangeRequest)
            const localVarPath = `/api/v1/auth/oauth/token-exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenExchangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchangeOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/oauth/token-exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyEmailSignInRequest} verifyEmailSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailSignIn: async (verifyEmailSignInRequest: VerifyEmailSignInRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailSignInRequest' is not null or undefined
            assertParamExists('verifyEmailSignIn', 'verifyEmailSignInRequest', verifyEmailSignInRequest)
            const localVarPath = `/api/v1/auth/otp/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailSignInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailSignInOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/otp/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyPhoneSignInRequest} verifyPhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneSignIn: async (verifyPhoneSignInRequest: VerifyPhoneSignInRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPhoneSignInRequest' is not null or undefined
            assertParamExists('verifyPhoneSignIn', 'verifyPhoneSignInRequest', verifyPhoneSignInRequest)
            const localVarPath = `/api/v1/auth/otp/phone/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPhoneSignInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneSignInOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/otp/phone/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(authorization: string, changePasswordRequest: ChangePasswordRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(authorization, changePasswordRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePasswordOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePasswordOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.changePasswordOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmForgotPassword(confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmForgotPassword(confirmForgotPasswordRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.confirmForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmForgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmForgotPasswordOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.confirmForgotPasswordOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfirmSignUpRequest} confirmSignUpRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmSignUp(confirmSignUpRequest: ConfirmSignUpRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmSignUp(confirmSignUpRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.confirmSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmSignUpOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmSignUpOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.confirmSignUpOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(resendConfirmationCodeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPasswordOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.forgotPasswordOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOauthLoginPageURL(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandlersSocialLoginURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOauthLoginPageURL(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getOauthLoginPageURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOauthLoginPageURLOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOauthLoginPageURLOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getOauthLoginPageURLOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordPolicy(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPasswordPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordPolicy(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getPasswordPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordPolicyOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordPolicyOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getPasswordPolicyOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialLoginURL(provider: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandlersSocialLoginURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialLoginURL(provider, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getSocialLoginURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSocialLoginURLOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSocialLoginURLOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getSocialLoginURLOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateEmailSignIn(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOTPChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateEmailSignIn(resendConfirmationCodeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.initiateEmailSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateEmailSignInOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.initiateEmailSignInOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InitiatePhoneSignInRequest} initiatePhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiatePhoneSignIn(initiatePhoneSignInRequest: InitiatePhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOTPChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiatePhoneSignIn(initiatePhoneSignInRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.initiatePhoneSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiatePhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiatePhoneSignInOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.initiatePhoneSignInOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginInUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginInUserWithPassword(loginInUserWithPasswordRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.loginInUserWithPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginInUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginInUserWithPasswordOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.loginInUserWithPasswordOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequest: RefreshTokenRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRefreshTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokenOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokenOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshTokenOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendConfirmationCode(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendConfirmationCode(resendConfirmationCodeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resendConfirmationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendConfirmationCodeOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendConfirmationCodeOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resendConfirmationCodeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSignupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpUserWithPassword(loginInUserWithPasswordRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signUpUserWithPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpUserWithPasswordOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signUpUserWithPasswordOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignUpWithEmailRequest} signUpWithEmailRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpWithEmail(signUpWithEmailRequest: SignUpWithEmailRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOTPChallengeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpWithEmail(signUpWithEmailRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signUpWithEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpWithEmailOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpWithEmailOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signUpWithEmailOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} xIdToken 
         * @param {SocialLoginRequest} socialLoginRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialLogin(authorization: string, xIdToken: string, socialLoginRequest: SocialLoginRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialLogin(authorization, xIdToken, socialLoginRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.socialLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async socialLoginOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.socialLoginOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.socialLoginOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TokenExchangeRequest} tokenExchangeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenExchange(tokenExchangeRequest: TokenExchangeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandlersTokenExchangeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenExchange(tokenExchangeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.tokenExchange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenExchangeOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenExchangeOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.tokenExchangeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyEmailSignInRequest} verifyEmailSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmailSignIn(verifyEmailSignInRequest: VerifyEmailSignInRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmailSignIn(verifyEmailSignInRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyEmailSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmailSignInOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyEmailSignInOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyPhoneSignInRequest} verifyPhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhoneSignIn(verifyPhoneSignInRequest: VerifyPhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhoneSignIn(verifyPhoneSignInRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyPhoneSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhoneSignInOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyPhoneSignInOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(authorization: string, changePasswordRequest: ChangePasswordRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.changePassword(authorization, changePasswordRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePasswordOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.changePasswordOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPassword(confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.confirmForgotPassword(confirmForgotPasswordRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmForgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.confirmForgotPasswordOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfirmSignUpRequest} confirmSignUpRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUp(confirmSignUpRequest: ConfirmSignUpRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.confirmSignUp(confirmSignUpRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUpOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.confirmSignUpOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.forgotPassword(resendConfirmationCodeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.forgotPasswordOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthLoginPageURL(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<HandlersSocialLoginURLResponse> {
            return localVarFp.getOauthLoginPageURL(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthLoginPageURLOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getOauthLoginPageURLOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordPolicy(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPasswordPolicyResponse> {
            return localVarFp.getPasswordPolicy(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordPolicyOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPasswordPolicyOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLoginURL(provider: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<HandlersSocialLoginURLResponse> {
            return localVarFp.getSocialLoginURL(provider, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSocialLoginURLOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getSocialLoginURLOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailSignIn(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOTPChallengeResponse> {
            return localVarFp.initiateEmailSignIn(resendConfirmationCodeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.initiateEmailSignInOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InitiatePhoneSignInRequest} initiatePhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePhoneSignIn(initiatePhoneSignInRequest: InitiatePhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOTPChallengeResponse> {
            return localVarFp.initiatePhoneSignIn(initiatePhoneSignInRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiatePhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.initiatePhoneSignInOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginInUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoginResponse> {
            return localVarFp.loginInUserWithPassword(loginInUserWithPasswordRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginInUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.loginInUserWithPasswordOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RefreshTokenRequest} refreshTokenRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequest: RefreshTokenRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRefreshTokenResponse> {
            return localVarFp.refreshToken(refreshTokenRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokenOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.refreshTokenOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCode(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendConfirmationCode(resendConfirmationCodeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCodeOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendConfirmationCodeOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSignupResponse> {
            return localVarFp.signUpUserWithPassword(loginInUserWithPasswordRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.signUpUserWithPasswordOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignUpWithEmailRequest} signUpWithEmailRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmail(signUpWithEmailRequest: SignUpWithEmailRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOTPChallengeResponse> {
            return localVarFp.signUpWithEmail(signUpWithEmailRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmailOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.signUpWithEmailOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} xIdToken 
         * @param {SocialLoginRequest} socialLoginRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLogin(authorization: string, xIdToken: string, socialLoginRequest: SocialLoginRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.socialLogin(authorization, xIdToken, socialLoginRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        socialLoginOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.socialLoginOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TokenExchangeRequest} tokenExchangeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchange(tokenExchangeRequest: TokenExchangeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<HandlersTokenExchangeResponse> {
            return localVarFp.tokenExchange(tokenExchangeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenExchangeOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.tokenExchangeOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyEmailSignInRequest} verifyEmailSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailSignIn(verifyEmailSignInRequest: VerifyEmailSignInRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoginResponse> {
            return localVarFp.verifyEmailSignIn(verifyEmailSignInRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.verifyEmailSignInOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyPhoneSignInRequest} verifyPhoneSignInRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneSignIn(verifyPhoneSignInRequest: VerifyPhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoginResponse> {
            return localVarFp.verifyPhoneSignIn(verifyPhoneSignInRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.verifyPhoneSignInOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePassword(authorization: string, changePasswordRequest: ChangePasswordRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).changePassword(authorization, changePasswordRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public changePasswordOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).changePasswordOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmForgotPasswordRequest} confirmForgotPasswordRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmForgotPassword(confirmForgotPasswordRequest: ConfirmForgotPasswordRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).confirmForgotPassword(confirmForgotPasswordRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmForgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).confirmForgotPasswordOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfirmSignUpRequest} confirmSignUpRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmSignUp(confirmSignUpRequest: ConfirmSignUpRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).confirmSignUp(confirmSignUpRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmSignUpOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).confirmSignUpOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public forgotPassword(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).forgotPassword(resendConfirmationCodeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public forgotPasswordOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).forgotPasswordOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getOauthLoginPageURL(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getOauthLoginPageURL(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getOauthLoginPageURLOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getOauthLoginPageURLOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getPasswordPolicy(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getPasswordPolicy(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getPasswordPolicyOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getPasswordPolicyOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} provider 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getSocialLoginURL(provider: string, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getSocialLoginURL(provider, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getSocialLoginURLOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getSocialLoginURLOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public initiateEmailSignIn(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).initiateEmailSignIn(resendConfirmationCodeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public initiateEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).initiateEmailSignInOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InitiatePhoneSignInRequest} initiatePhoneSignInRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public initiatePhoneSignIn(initiatePhoneSignInRequest: InitiatePhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).initiatePhoneSignIn(initiatePhoneSignInRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public initiatePhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).initiatePhoneSignInOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginInUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginInUserWithPassword(loginInUserWithPasswordRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginInUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginInUserWithPasswordOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RefreshTokenRequest} refreshTokenRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshToken(refreshTokenRequest: RefreshTokenRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshToken(refreshTokenRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshTokenOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshTokenOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resendConfirmationCode(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resendConfirmationCode(resendConfirmationCodeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resendConfirmationCodeOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resendConfirmationCodeOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginInUserWithPasswordRequest} loginInUserWithPasswordRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signUpUserWithPassword(loginInUserWithPasswordRequest: LoginInUserWithPasswordRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signUpUserWithPassword(loginInUserWithPasswordRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signUpUserWithPasswordOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signUpUserWithPasswordOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignUpWithEmailRequest} signUpWithEmailRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signUpWithEmail(signUpWithEmailRequest: SignUpWithEmailRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signUpWithEmail(signUpWithEmailRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signUpWithEmailOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signUpWithEmailOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {string} xIdToken 
     * @param {SocialLoginRequest} socialLoginRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public socialLogin(authorization: string, xIdToken: string, socialLoginRequest: SocialLoginRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).socialLogin(authorization, xIdToken, socialLoginRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public socialLoginOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).socialLoginOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TokenExchangeRequest} tokenExchangeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public tokenExchange(tokenExchangeRequest: TokenExchangeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).tokenExchange(tokenExchangeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public tokenExchangeOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).tokenExchangeOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyEmailSignInRequest} verifyEmailSignInRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyEmailSignIn(verifyEmailSignInRequest: VerifyEmailSignInRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyEmailSignIn(verifyEmailSignInRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyEmailSignInOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyEmailSignInOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyPhoneSignInRequest} verifyPhoneSignInRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyPhoneSignIn(verifyPhoneSignInRequest: VerifyPhoneSignInRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyPhoneSignIn(verifyPhoneSignInRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verifyPhoneSignInOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyPhoneSignInOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CarriersApi - axios parameter creator
 * @export
 */
export const CarriersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCarrierRequest} createCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrier: async (organizationUnid: string, authorization: string, createCarrierRequest: CreateCarrierRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCarrier', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createCarrier', 'authorization', authorization)
            // verify required parameter 'createCarrierRequest' is not null or undefined
            assertParamExists('createCarrier', 'createCarrierRequest', createCarrierRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCarrierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrierOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCarrierOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrier: async (carrierId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('deleteCarrier', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCarrier', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteCarrier', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('deleteCarrierOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCarrierOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrier: async (carrierId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getCarrier', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCarrier', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCarrier', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierPerformance: async (carrierId: string, organizationUnid: string, authorization: string, from?: string | null, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getCarrierPerformance', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCarrierPerformance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCarrierPerformance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/performance`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierPerformanceOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getCarrierPerformanceOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCarrierPerformanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/performance`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetCarrierRateHistoryRequest} getCarrierRateHistoryRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierRateHistory: async (carrierId: string, organizationUnid: string, authorization: string, getCarrierRateHistoryRequest: GetCarrierRateHistoryRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getCarrierRateHistory', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCarrierRateHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCarrierRateHistory', 'authorization', authorization)
            // verify required parameter 'getCarrierRateHistoryRequest' is not null or undefined
            assertParamExists('getCarrierRateHistory', 'getCarrierRateHistoryRequest', getCarrierRateHistoryRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/rate-history`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCarrierRateHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierRateHistoryOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('getCarrierRateHistoryOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCarrierRateHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/rate-history`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [equipmentTypes] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarriers: async (organizationUnid: string, authorization: string, equipmentTypes?: Array<string>, limit?: number, page?: number, search?: string | null, status?: Array<string>, verified?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listCarriers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listCarriers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (equipmentTypes) {
                localVarQueryParameter['equipment_types'] = equipmentTypes;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (verified !== undefined) {
                localVarQueryParameter['verified'] = verified;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {RecordTenderResponseRequest} recordTenderResponseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordTenderResponse: async (carrierId: string, organizationUnid: string, authorization: string, recordTenderResponseRequest: RecordTenderResponseRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('recordTenderResponse', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('recordTenderResponse', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('recordTenderResponse', 'authorization', authorization)
            // verify required parameter 'recordTenderResponseRequest' is not null or undefined
            assertParamExists('recordTenderResponse', 'recordTenderResponseRequest', recordTenderResponseRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/tender-response`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordTenderResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordTenderResponseOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('recordTenderResponseOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('recordTenderResponseOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/tender-response`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [destState] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number | null} [minRating] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableCarriers: async (organizationUnid: string, authorization: string, destState?: string | null, equipmentType?: string | null, limit?: number, loadId?: string | null, minRating?: number | null, originState?: string | null, page?: number, verified?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('searchAvailableCarriers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('searchAvailableCarriers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/search-available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (destState !== undefined) {
                localVarQueryParameter['destState'] = destState;
            }

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipmentType'] = equipmentType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (loadId !== undefined) {
                localVarQueryParameter['loadId'] = loadId;
            }

            if (minRating !== undefined) {
                localVarQueryParameter['minRating'] = minRating;
            }

            if (originState !== undefined) {
                localVarQueryParameter['originState'] = originState;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (verified !== undefined) {
                localVarQueryParameter['verified'] = verified;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableCarriersOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('searchAvailableCarriersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/search-available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {TenderLoadRequest} tenderLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenderLoad: async (carrierId: string, organizationUnid: string, authorization: string, tenderLoadRequest: TenderLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('tenderLoad', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('tenderLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('tenderLoad', 'authorization', authorization)
            // verify required parameter 'tenderLoadRequest' is not null or undefined
            assertParamExists('tenderLoad', 'tenderLoadRequest', tenderLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/tender-load`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tenderLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenderLoadOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('tenderLoadOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('tenderLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/tender-load`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCarrierRequest} updateCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrier: async (carrierId: string, organizationUnid: string, authorization: string, updateCarrierRequest: UpdateCarrierRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('updateCarrier', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateCarrier', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateCarrier', 'authorization', authorization)
            // verify required parameter 'updateCarrierRequest' is not null or undefined
            assertParamExists('updateCarrier', 'updateCarrierRequest', updateCarrierRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCarrierRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCarrier: async (carrierId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('verifyCarrier', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('verifyCarrier', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verifyCarrier', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('verifyCarrier', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/verify`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCarrierOptions: async (carrierId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierId' is not null or undefined
            assertParamExists('verifyCarrierOptions', 'carrierId', carrierId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('verifyCarrierOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/carriers/{carrierId}/verify`
                .replace(`{${"carrierId"}}`, encodeURIComponent(String(carrierId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarriersApi - functional programming interface
 * @export
 */
export const CarriersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarriersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCarrierRequest} createCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCarrier(organizationUnid: string, authorization: string, createCarrierRequest: CreateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCarrier(organizationUnid, authorization, createCarrierRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.createCarrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCarrierOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCarrierOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.createCarrierOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCarrier(carrierId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.deleteCarrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCarrierOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.deleteCarrierOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrier(carrierId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.getCarrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrierPerformance(carrierId: string, organizationUnid: string, authorization: string, from?: string | null, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierPerformanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierPerformance(carrierId, organizationUnid, authorization, from, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.getCarrierPerformance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrierPerformanceOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierPerformanceOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.getCarrierPerformanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetCarrierRateHistoryRequest} getCarrierRateHistoryRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrierRateHistory(carrierId: string, organizationUnid: string, authorization: string, getCarrierRateHistoryRequest: GetCarrierRateHistoryRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierRateHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierRateHistory(carrierId, organizationUnid, authorization, getCarrierRateHistoryRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.getCarrierRateHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarrierRateHistoryOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarrierRateHistoryOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.getCarrierRateHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [equipmentTypes] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCarriers(organizationUnid: string, authorization: string, equipmentTypes?: Array<string>, limit?: number, page?: number, search?: string | null, status?: Array<string>, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCarriers(organizationUnid, authorization, equipmentTypes, limit, page, search, status, verified, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.listCarriers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {RecordTenderResponseRequest} recordTenderResponseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordTenderResponse(carrierId: string, organizationUnid: string, authorization: string, recordTenderResponseRequest: RecordTenderResponseRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordTenderResponse(carrierId, organizationUnid, authorization, recordTenderResponseRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.recordTenderResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordTenderResponseOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordTenderResponseOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.recordTenderResponseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [destState] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number | null} [minRating] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAvailableCarriers(organizationUnid: string, authorization: string, destState?: string | null, equipmentType?: string | null, limit?: number, loadId?: string | null, minRating?: number | null, originState?: string | null, page?: number, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSearchAvailableCarriersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAvailableCarriers(organizationUnid, authorization, destState, equipmentType, limit, loadId, minRating, originState, page, verified, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.searchAvailableCarriers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAvailableCarriersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAvailableCarriersOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.searchAvailableCarriersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {TenderLoadRequest} tenderLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenderLoad(carrierId: string, organizationUnid: string, authorization: string, tenderLoadRequest: TenderLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTenderLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenderLoad(carrierId, organizationUnid, authorization, tenderLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.tenderLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenderLoadOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenderLoadOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.tenderLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCarrierRequest} updateCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarrier(carrierId: string, organizationUnid: string, authorization: string, updateCarrierRequest: UpdateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarrier(carrierId, organizationUnid, authorization, updateCarrierRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.updateCarrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCarrier(carrierId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCarrierVerificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCarrier(carrierId, organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.verifyCarrier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCarrierOptions(carrierId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarriersApi.verifyCarrierOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarriersApi - factory interface
 * @export
 */
export const CarriersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarriersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCarrierRequest} createCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrier(organizationUnid: string, authorization: string, createCarrierRequest: CreateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierResponse> {
            return localVarFp.createCarrier(organizationUnid, authorization, createCarrierRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrierOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createCarrierOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCarrier(carrierId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCarrierOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierResponse> {
            return localVarFp.getCarrier(carrierId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierPerformance(carrierId: string, organizationUnid: string, authorization: string, from?: string | null, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierPerformanceResponse> {
            return localVarFp.getCarrierPerformance(carrierId, organizationUnid, authorization, from, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierPerformanceOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCarrierPerformanceOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetCarrierRateHistoryRequest} getCarrierRateHistoryRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierRateHistory(carrierId: string, organizationUnid: string, authorization: string, getCarrierRateHistoryRequest: GetCarrierRateHistoryRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierRateHistoryResponse> {
            return localVarFp.getCarrierRateHistory(carrierId, organizationUnid, authorization, getCarrierRateHistoryRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierRateHistoryOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCarrierRateHistoryOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [equipmentTypes] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarriers(organizationUnid: string, authorization: string, equipmentTypes?: Array<string>, limit?: number, page?: number, search?: string | null, status?: Array<string>, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierListResponse> {
            return localVarFp.listCarriers(organizationUnid, authorization, equipmentTypes, limit, page, search, status, verified, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {RecordTenderResponseRequest} recordTenderResponseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordTenderResponse(carrierId: string, organizationUnid: string, authorization: string, recordTenderResponseRequest: RecordTenderResponseRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.recordTenderResponse(carrierId, organizationUnid, authorization, recordTenderResponseRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordTenderResponseOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.recordTenderResponseOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [destState] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number | null} [minRating] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {boolean | null} [verified] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableCarriers(organizationUnid: string, authorization: string, destState?: string | null, equipmentType?: string | null, limit?: number, loadId?: string | null, minRating?: number | null, originState?: string | null, page?: number, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSearchAvailableCarriersResponse> {
            return localVarFp.searchAvailableCarriers(organizationUnid, authorization, destState, equipmentType, limit, loadId, minRating, originState, page, verified, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAvailableCarriersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.searchAvailableCarriersOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {TenderLoadRequest} tenderLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenderLoad(carrierId: string, organizationUnid: string, authorization: string, tenderLoadRequest: TenderLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTenderLoadResponse> {
            return localVarFp.tenderLoad(carrierId, organizationUnid, authorization, tenderLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenderLoadOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.tenderLoadOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCarrierRequest} updateCarrierRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrier(carrierId: string, organizationUnid: string, authorization: string, updateCarrierRequest: UpdateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierResponse> {
            return localVarFp.updateCarrier(carrierId, organizationUnid, authorization, updateCarrierRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCarrier(carrierId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCarrierVerificationResponse> {
            return localVarFp.verifyCarrier(carrierId, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} carrierId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.verifyCarrierOptions(carrierId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarriersApi - object-oriented interface
 * @export
 * @class CarriersApi
 * @extends {BaseAPI}
 */
export class CarriersApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateCarrierRequest} createCarrierRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public createCarrier(organizationUnid: string, authorization: string, createCarrierRequest: CreateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).createCarrier(organizationUnid, authorization, createCarrierRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public createCarrierOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).createCarrierOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public deleteCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).deleteCarrier(carrierId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public deleteCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).deleteCarrierOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public getCarrier(carrierId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).getCarrier(carrierId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public getCarrierPerformance(carrierId: string, organizationUnid: string, authorization: string, from?: string | null, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).getCarrierPerformance(carrierId, organizationUnid, authorization, from, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public getCarrierPerformanceOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).getCarrierPerformanceOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {GetCarrierRateHistoryRequest} getCarrierRateHistoryRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public getCarrierRateHistory(carrierId: string, organizationUnid: string, authorization: string, getCarrierRateHistoryRequest: GetCarrierRateHistoryRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).getCarrierRateHistory(carrierId, organizationUnid, authorization, getCarrierRateHistoryRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public getCarrierRateHistoryOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).getCarrierRateHistoryOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {Array<string>} [equipmentTypes] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {boolean | null} [verified] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public listCarriers(organizationUnid: string, authorization: string, equipmentTypes?: Array<string>, limit?: number, page?: number, search?: string | null, status?: Array<string>, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).listCarriers(organizationUnid, authorization, equipmentTypes, limit, page, search, status, verified, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {RecordTenderResponseRequest} recordTenderResponseRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public recordTenderResponse(carrierId: string, organizationUnid: string, authorization: string, recordTenderResponseRequest: RecordTenderResponseRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).recordTenderResponse(carrierId, organizationUnid, authorization, recordTenderResponseRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public recordTenderResponseOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).recordTenderResponseOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [destState] 
     * @param {string | null} [equipmentType] 
     * @param {number} [limit] 
     * @param {string | null} [loadId] 
     * @param {number | null} [minRating] 
     * @param {string | null} [originState] 
     * @param {number} [page] 
     * @param {boolean | null} [verified] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public searchAvailableCarriers(organizationUnid: string, authorization: string, destState?: string | null, equipmentType?: string | null, limit?: number, loadId?: string | null, minRating?: number | null, originState?: string | null, page?: number, verified?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).searchAvailableCarriers(organizationUnid, authorization, destState, equipmentType, limit, loadId, minRating, originState, page, verified, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public searchAvailableCarriersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).searchAvailableCarriersOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {TenderLoadRequest} tenderLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public tenderLoad(carrierId: string, organizationUnid: string, authorization: string, tenderLoadRequest: TenderLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).tenderLoad(carrierId, organizationUnid, authorization, tenderLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public tenderLoadOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).tenderLoadOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateCarrierRequest} updateCarrierRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public updateCarrier(carrierId: string, organizationUnid: string, authorization: string, updateCarrierRequest: UpdateCarrierRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).updateCarrier(carrierId, organizationUnid, authorization, updateCarrierRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public verifyCarrier(carrierId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).verifyCarrier(carrierId, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} carrierId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    public verifyCarrierOptions(carrierId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CarriersApiFp(this.configuration).verifyCarrierOptions(carrierId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerRequest} createCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (organizationUnid: string, authorization: string, createCustomerRequest: CreateCustomerRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCustomer', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createCustomer', 'authorization', authorization)
            // verify required parameter 'createCustomerRequest' is not null or undefined
            assertParamExists('createCustomer', 'createCustomerRequest', createCustomerRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerContactRequest} createCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerContact: async (customerId: string, organizationUnid: string, authorization: string, createCustomerContactRequest: CreateCustomerContactRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createCustomerContact', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCustomerContact', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createCustomerContact', 'authorization', authorization)
            // verify required parameter 'createCustomerContactRequest' is not null or undefined
            assertParamExists('createCustomerContact', 'createCustomerContactRequest', createCustomerContactRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerContactOptions: async (customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createCustomerContactOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCustomerContactOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createCustomerOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: async (customerId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomer', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCustomer', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteCustomer', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact: async (contactId: string, customerId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'contactId', contactId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCustomerContact', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteCustomerContact', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContactOptions: async (contactId: string, customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteCustomerContactOptions', 'contactId', contactId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerContactOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCustomerContactOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerOptions: async (customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteCustomerOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: async (customerId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomer', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomer', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCustomer', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContacts: async (customerId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerContacts', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomerContacts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCustomerContacts', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoices: async (customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerInvoices', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomerInvoices', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCustomerInvoices', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/invoices`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoicesOptions: async (customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerInvoicesOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomerInvoicesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/invoices`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoads: async (customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerLoads', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomerLoads', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getCustomerLoads', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/loads`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoadsOptions: async (customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerLoadsOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getCustomerLoadsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/loads`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [creditStatus] 
         * @param {boolean | null} [hasOpenBalance] 
         * @param {string | null} [industry] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [salesRepId] 
         * @param {string | null} [search] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers: async (organizationUnid: string, authorization: string, creditStatus?: string | null, hasOpenBalance?: boolean | null, industry?: string | null, limit?: number, page?: number, salesRepId?: string | null, search?: string | null, state?: string | null, status?: string | null, type?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listCustomers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listCustomers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (creditStatus !== undefined) {
                localVarQueryParameter['credit_status'] = creditStatus;
            }

            if (hasOpenBalance !== undefined) {
                localVarQueryParameter['has_open_balance'] = hasOpenBalance;
            }

            if (industry !== undefined) {
                localVarQueryParameter['industry'] = industry;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (salesRepId !== undefined) {
                localVarQueryParameter['sales_rep_id'] = salesRepId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (customerId: string, organizationUnid: string, authorization: string, updateCustomerRequest: UpdateCustomerRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomer', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateCustomer', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateCustomer', 'authorization', authorization)
            // verify required parameter 'updateCustomerRequest' is not null or undefined
            assertParamExists('updateCustomer', 'updateCustomerRequest', updateCustomerRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerContactRequest} updateCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerContact: async (contactId: string, customerId: string, organizationUnid: string, authorization: string, updateCustomerContactRequest: UpdateCustomerContactRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateCustomerContact', 'contactId', contactId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomerContact', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateCustomerContact', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateCustomerContact', 'authorization', authorization)
            // verify required parameter 'updateCustomerContactRequest' is not null or undefined
            assertParamExists('updateCustomerContact', 'updateCustomerContactRequest', updateCustomerContactRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/contacts/{contactId}`
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerContactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerStatus: async (customerId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomerStatus', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateCustomerStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateCustomerStatus', 'authorization', authorization)
            // verify required parameter 'updateCustomerStatusRequest' is not null or undefined
            assertParamExists('updateCustomerStatus', 'updateCustomerStatusRequest', updateCustomerStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/status`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerStatusOptions: async (customerId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomerStatusOptions', 'customerId', customerId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateCustomerStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/customers/{customerId}/status`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerRequest} createCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(organizationUnid: string, authorization: string, createCustomerRequest: CreateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(organizationUnid, authorization, createCustomerRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerContactRequest} createCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerContact(customerId: string, organizationUnid: string, authorization: string, createCustomerContactRequest: CreateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerContact(customerId, organizationUnid, authorization, createCustomerContactRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerContactOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerContactOptions(customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomerContactOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomerOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomer(customerId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerContact(contactId, customerId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerContactOptions(contactId: string, customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerContactOptions(contactId, customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteCustomerContactOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerOptions(customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteCustomerOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomer(customerId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerContacts(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerContacts(customerId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerInvoices(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerInvoices(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerInvoicesOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerInvoicesOptions(customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerInvoicesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerLoads(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerLoads(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerLoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerLoadsOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerLoadsOptions(customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerLoadsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [creditStatus] 
         * @param {boolean | null} [hasOpenBalance] 
         * @param {string | null} [industry] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [salesRepId] 
         * @param {string | null} [search] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomers(organizationUnid: string, authorization: string, creditStatus?: string | null, hasOpenBalance?: boolean | null, industry?: string | null, limit?: number, page?: number, salesRepId?: string | null, search?: string | null, state?: string | null, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCustomerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomers(organizationUnid, authorization, creditStatus, hasOpenBalance, industry, limit, page, salesRepId, search, state, status, type, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.listCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(customerId: string, organizationUnid: string, authorization: string, updateCustomerRequest: UpdateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(customerId, organizationUnid, authorization, updateCustomerRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerContactRequest} updateCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, updateCustomerContactRequest: UpdateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerContact(contactId, customerId, organizationUnid, authorization, updateCustomerContactRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerStatus(customerId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerStatus(customerId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerStatusOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerStatusOptions(customerId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomerStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerRequest} createCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(organizationUnid: string, authorization: string, createCustomerRequest: CreateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCustomerResponse> {
            return localVarFp.createCustomer(organizationUnid, authorization, createCustomerRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateCustomerContactRequest} createCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerContact(customerId: string, organizationUnid: string, authorization: string, createCustomerContactRequest: CreateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createCustomerContact(customerId, organizationUnid, authorization, createCustomerContactRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerContactOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createCustomerContactOptions(customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createCustomerOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCustomer(customerId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCustomerContact(contactId, customerId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContactOptions(contactId: string, customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCustomerContactOptions(contactId, customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteCustomerOptions(customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCustomerResponse> {
            return localVarFp.getCustomer(customerId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerContacts(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCustomerContacts(customerId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoices(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCustomerInvoices(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoicesOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCustomerInvoicesOptions(customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoads(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadListResponse> {
            return localVarFp.getCustomerLoads(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoadsOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getCustomerLoadsOptions(customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [creditStatus] 
         * @param {boolean | null} [hasOpenBalance] 
         * @param {string | null} [industry] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [salesRepId] 
         * @param {string | null} [search] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers(organizationUnid: string, authorization: string, creditStatus?: string | null, hasOpenBalance?: boolean | null, industry?: string | null, limit?: number, page?: number, salesRepId?: string | null, search?: string | null, state?: string | null, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCustomerListResponse> {
            return localVarFp.listCustomers(organizationUnid, authorization, creditStatus, hasOpenBalance, industry, limit, page, salesRepId, search, state, status, type, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerRequest} updateCustomerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(customerId: string, organizationUnid: string, authorization: string, updateCustomerRequest: UpdateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCustomerResponse> {
            return localVarFp.updateCustomer(customerId, organizationUnid, authorization, updateCustomerRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} contactId 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerContactRequest} updateCustomerContactRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, updateCustomerContactRequest: UpdateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateCustomerContact(contactId, customerId, organizationUnid, authorization, updateCustomerContactRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerStatus(customerId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesCustomerResponse> {
            return localVarFp.updateCustomerStatus(customerId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerStatusOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateCustomerStatusOptions(customerId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateCustomerRequest} createCustomerRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public createCustomer(organizationUnid: string, authorization: string, createCustomerRequest: CreateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).createCustomer(organizationUnid, authorization, createCustomerRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateCustomerContactRequest} createCustomerContactRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public createCustomerContact(customerId: string, organizationUnid: string, authorization: string, createCustomerContactRequest: CreateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).createCustomerContact(customerId, organizationUnid, authorization, createCustomerContactRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public createCustomerContactOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).createCustomerContactOptions(customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public createCustomerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).createCustomerOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public deleteCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteCustomer(customerId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} contactId 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public deleteCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteCustomerContact(contactId, customerId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} contactId 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public deleteCustomerContactOptions(contactId: string, customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteCustomerContactOptions(contactId, customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public deleteCustomerOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).deleteCustomerOptions(customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomer(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomer(customerId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerContacts(customerId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerContacts(customerId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [endDate] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [startDate] 
     * @param {string | null} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerInvoices(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerInvoices(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerInvoicesOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerInvoicesOptions(customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [endDate] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [startDate] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerLoads(customerId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerLoads(customerId, organizationUnid, authorization, endDate, limit, page, startDate, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerLoadsOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerLoadsOptions(customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [creditStatus] 
     * @param {boolean | null} [hasOpenBalance] 
     * @param {string | null} [industry] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [salesRepId] 
     * @param {string | null} [search] 
     * @param {string | null} [state] 
     * @param {string | null} [status] 
     * @param {string | null} [type] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public listCustomers(organizationUnid: string, authorization: string, creditStatus?: string | null, hasOpenBalance?: boolean | null, industry?: string | null, limit?: number, page?: number, salesRepId?: string | null, search?: string | null, state?: string | null, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).listCustomers(organizationUnid, authorization, creditStatus, hasOpenBalance, industry, limit, page, salesRepId, search, state, status, type, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateCustomerRequest} updateCustomerRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomer(customerId: string, organizationUnid: string, authorization: string, updateCustomerRequest: UpdateCustomerRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomer(customerId, organizationUnid, authorization, updateCustomerRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} contactId 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateCustomerContactRequest} updateCustomerContactRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomerContact(contactId: string, customerId: string, organizationUnid: string, authorization: string, updateCustomerContactRequest: UpdateCustomerContactRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomerContact(contactId, customerId, organizationUnid, authorization, updateCustomerContactRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomerStatus(customerId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomerStatus(customerId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomerStatusOptions(customerId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomerStatusOptions(customerId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentParseApi - axios parameter creator
 * @export
 */
export const DocumentParseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParse: async (organizationUnid: string, parseId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getParse', 'organizationUnid', organizationUnid)
            // verify required parameter 'parseId' is not null or undefined
            assertParamExists('getParse', 'parseId', parseId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getParse', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/parses/{parseId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"parseId"}}`, encodeURIComponent(String(parseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParseOptions: async (organizationUnid: string, parseId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getParseOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'parseId' is not null or undefined
            assertParamExists('getParseOptions', 'parseId', parseId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/parses/{parseId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"parseId"}}`, encodeURIComponent(String(parseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ParseDocumentRequest} parseDocumentRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocument: async (organizationUnid: string, authorization: string, parseDocumentRequest: ParseDocumentRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('parseDocument', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('parseDocument', 'authorization', authorization)
            // verify required parameter 'parseDocumentRequest' is not null or undefined
            assertParamExists('parseDocument', 'parseDocumentRequest', parseDocumentRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/parse`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parseDocumentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('parseDocumentOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/parse`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentParseApi - functional programming interface
 * @export
 */
export const DocumentParseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentParseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParse(organizationUnid: string, parseId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentParseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParse(organizationUnid, parseId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParseApi.getParse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParseOptions(organizationUnid: string, parseId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParseOptions(organizationUnid, parseId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParseApi.getParseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ParseDocumentRequest} parseDocumentRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseDocument(organizationUnid: string, authorization: string, parseDocumentRequest: ParseDocumentRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentParseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseDocument(organizationUnid, authorization, parseDocumentRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParseApi.parseDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseDocumentOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseDocumentOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentParseApi.parseDocumentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentParseApi - factory interface
 * @export
 */
export const DocumentParseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentParseApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParse(organizationUnid: string, parseId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentParseResponse> {
            return localVarFp.getParse(organizationUnid, parseId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} parseId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParseOptions(organizationUnid: string, parseId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getParseOptions(organizationUnid, parseId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ParseDocumentRequest} parseDocumentRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocument(organizationUnid: string, authorization: string, parseDocumentRequest: ParseDocumentRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentParseResponse> {
            return localVarFp.parseDocument(organizationUnid, authorization, parseDocumentRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseDocumentOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.parseDocumentOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentParseApi - object-oriented interface
 * @export
 * @class DocumentParseApi
 * @extends {BaseAPI}
 */
export class DocumentParseApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} parseId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParseApi
     */
    public getParse(organizationUnid: string, parseId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentParseApiFp(this.configuration).getParse(organizationUnid, parseId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} parseId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParseApi
     */
    public getParseOptions(organizationUnid: string, parseId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentParseApiFp(this.configuration).getParseOptions(organizationUnid, parseId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ParseDocumentRequest} parseDocumentRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParseApi
     */
    public parseDocument(organizationUnid: string, authorization: string, parseDocumentRequest: ParseDocumentRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentParseApiFp(this.configuration).parseDocument(organizationUnid, authorization, parseDocumentRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentParseApi
     */
    public parseDocumentOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentParseApiFp(this.configuration).parseDocumentOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConfirmDocumentUploadRequest} confirmDocumentUploadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentUpload: async (organizationUnid: string, authorization: string, confirmDocumentUploadRequest: ConfirmDocumentUploadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('confirmDocumentUpload', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('confirmDocumentUpload', 'authorization', authorization)
            // verify required parameter 'confirmDocumentUploadRequest' is not null or undefined
            assertParamExists('confirmDocumentUpload', 'confirmDocumentUploadRequest', confirmDocumentUploadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/confirm-upload`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmDocumentUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentUploadOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('confirmDocumentUploadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/confirm-upload`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (documentId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocument', 'documentId', documentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDocument', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteDocument', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentOptions: async (documentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteDocumentOptions', 'documentId', documentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDocumentOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (documentId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocument', 'documentId', documentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocument', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocument', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number | null} [expirationSeconds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl: async (documentId: string, organizationUnid: string, authorization: string, expirationSeconds?: number | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentDownloadUrl', 'documentId', documentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocumentDownloadUrl', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentDownloadUrl', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/{documentId}/download-url`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expirationSeconds !== undefined) {
                localVarQueryParameter['expirationSeconds'] = expirationSeconds;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrlOptions: async (documentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getDocumentDownloadUrlOptions', 'documentId', documentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocumentDownloadUrlOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/{documentId}/download-url`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetDocumentUploadUrlRequest} getDocumentUploadUrlRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadUrl: async (organizationUnid: string, authorization: string, getDocumentUploadUrlRequest: GetDocumentUploadUrlRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocumentUploadUrl', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentUploadUrl', 'authorization', authorization)
            // verify required parameter 'getDocumentUploadUrlRequest' is not null or undefined
            assertParamExists('getDocumentUploadUrl', 'getDocumentUploadUrlRequest', getDocumentUploadUrlRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDocumentUploadUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadUrlOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocumentUploadUrlOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [documentType] 
         * @param {string} [entityId] 
         * @param {string} [entityType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (organizationUnid: string, authorization: string, documentType?: string, entityId?: string, entityType?: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocuments', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocuments', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDocumentsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/documents`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConfirmDocumentUploadRequest} confirmDocumentUploadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDocumentUpload(organizationUnid: string, authorization: string, confirmDocumentUploadRequest: ConfirmDocumentUploadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmDocumentUpload(organizationUnid, authorization, confirmDocumentUploadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.confirmDocumentUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDocumentUploadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmDocumentUploadOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.confirmDocumentUploadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(documentId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.deleteDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentOptions(documentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.deleteDocumentOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(documentId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number | null} [expirationSeconds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentDownloadUrl(documentId: string, organizationUnid: string, authorization: string, expirationSeconds?: number | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentDownloadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentDownloadUrl(documentId, organizationUnid, authorization, expirationSeconds, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentDownloadUrlOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentDownloadUrlOptions(documentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentDownloadUrlOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetDocumentUploadUrlRequest} getDocumentUploadUrlRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentUploadUrl(organizationUnid: string, authorization: string, getDocumentUploadUrlRequest: GetDocumentUploadUrlRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentUploadUrl(organizationUnid, authorization, getDocumentUploadUrlRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentUploadUrlOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentUploadUrlOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [documentType] 
         * @param {string} [entityId] 
         * @param {string} [entityType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(organizationUnid: string, authorization: string, documentType?: string, entityId?: string, entityType?: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(organizationUnid, authorization, documentType, entityId, entityType, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.getDocumentsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConfirmDocumentUploadRequest} confirmDocumentUploadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentUpload(organizationUnid: string, authorization: string, confirmDocumentUploadRequest: ConfirmDocumentUploadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentResponse> {
            return localVarFp.confirmDocumentUpload(organizationUnid, authorization, confirmDocumentUploadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDocumentUploadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.confirmDocumentUploadOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDocument(documentId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDocumentOptions(documentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentResponse> {
            return localVarFp.getDocument(documentId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number | null} [expirationSeconds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl(documentId: string, organizationUnid: string, authorization: string, expirationSeconds?: number | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentDownloadUrlResponse> {
            return localVarFp.getDocumentDownloadUrl(documentId, organizationUnid, authorization, expirationSeconds, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrlOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDocumentDownloadUrlOptions(documentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GetDocumentUploadUrlRequest} getDocumentUploadUrlRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadUrl(organizationUnid: string, authorization: string, getDocumentUploadUrlRequest: GetDocumentUploadUrlRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentUploadUrlResponse> {
            return localVarFp.getDocumentUploadUrl(organizationUnid, authorization, getDocumentUploadUrlRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDocumentUploadUrlOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [documentType] 
         * @param {string} [entityId] 
         * @param {string} [entityType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(organizationUnid: string, authorization: string, documentType?: string, entityId?: string, entityType?: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDocumentsResponse> {
            return localVarFp.getDocuments(organizationUnid, authorization, documentType, entityId, entityType, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDocumentsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ConfirmDocumentUploadRequest} confirmDocumentUploadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public confirmDocumentUpload(organizationUnid: string, authorization: string, confirmDocumentUploadRequest: ConfirmDocumentUploadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).confirmDocumentUpload(organizationUnid, authorization, confirmDocumentUploadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public confirmDocumentUploadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).confirmDocumentUploadOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public deleteDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).deleteDocument(documentId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public deleteDocumentOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).deleteDocumentOptions(documentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocument(documentId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocument(documentId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number | null} [expirationSeconds] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentDownloadUrl(documentId: string, organizationUnid: string, authorization: string, expirationSeconds?: number | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentDownloadUrl(documentId, organizationUnid, authorization, expirationSeconds, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentDownloadUrlOptions(documentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentDownloadUrlOptions(documentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {GetDocumentUploadUrlRequest} getDocumentUploadUrlRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentUploadUrl(organizationUnid: string, authorization: string, getDocumentUploadUrlRequest: GetDocumentUploadUrlRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentUploadUrl(organizationUnid, authorization, getDocumentUploadUrlRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentUploadUrlOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [documentType] 
     * @param {string} [entityId] 
     * @param {string} [entityType] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocuments(organizationUnid: string, authorization: string, documentType?: string, entityId?: string, entityType?: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocuments(organizationUnid, authorization, documentType, entityId, entityType, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocumentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocumentsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DriverSettlementsApi - axios parameter creator
 * @export
 */
export const DriverSettlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementStats: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverSettlementStats', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverSettlementStats', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/driver-settlements/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementStatsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverSettlementStatsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/driver-settlements/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [cutoffDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverSettlements: async (organizationUnid: string, authorization: string, cutoffDate?: string | null, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverSettlements', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listDriverSettlements', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/driver-settlements/pending`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffDate !== undefined) {
                localVarQueryParameter['cutoff_date'] = cutoffDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverSettlementsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverSettlementsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/driver-settlements/pending`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriverSettlementsApi - functional programming interface
 * @export
 */
export const DriverSettlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriverSettlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverSettlementStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverSettlementStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverSettlementStats(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverSettlementsApi.getDriverSettlementStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverSettlementStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverSettlementStatsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverSettlementsApi.getDriverSettlementStatsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [cutoffDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverSettlements(organizationUnid: string, authorization: string, cutoffDate?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverSettlementListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverSettlements(organizationUnid, authorization, cutoffDate, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverSettlementsApi.listDriverSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverSettlementsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriverSettlementsApi.listDriverSettlementsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DriverSettlementsApi - factory interface
 * @export
 */
export const DriverSettlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriverSettlementsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverSettlementStatsResponse> {
            return localVarFp.getDriverSettlementStats(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverSettlementStatsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [cutoffDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverSettlements(organizationUnid: string, authorization: string, cutoffDate?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverSettlementListResponse> {
            return localVarFp.listDriverSettlements(organizationUnid, authorization, cutoffDate, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listDriverSettlementsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriverSettlementsApi - object-oriented interface
 * @export
 * @class DriverSettlementsApi
 * @extends {BaseAPI}
 */
export class DriverSettlementsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverSettlementsApi
     */
    public getDriverSettlementStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriverSettlementsApiFp(this.configuration).getDriverSettlementStats(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverSettlementsApi
     */
    public getDriverSettlementStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriverSettlementsApiFp(this.configuration).getDriverSettlementStatsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [cutoffDate] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverSettlementsApi
     */
    public listDriverSettlements(organizationUnid: string, authorization: string, cutoffDate?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return DriverSettlementsApiFp(this.configuration).listDriverSettlements(organizationUnid, authorization, cutoffDate, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverSettlementsApi
     */
    public listDriverSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriverSettlementsApiFp(this.configuration).listDriverSettlementsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DriversApi - axios parameter creator
 * @export
 */
export const DriversApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRequest} createDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriver: async (organizationUnid: string, authorization: string, createDriverRequest: CreateDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createDriver', 'authorization', authorization)
            // verify required parameter 'createDriverRequest' is not null or undefined
            assertParamExists('createDriver', 'createDriverRequest', createDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createDriverOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRecurringChargeRequest} createDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverRecurringCharge: async (driverId: string, organizationUnid: string, authorization: string, createDriverRecurringChargeRequest: CreateDriverRecurringChargeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('createDriverRecurringCharge', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createDriverRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createDriverRecurringCharge', 'authorization', authorization)
            // verify required parameter 'createDriverRecurringChargeRequest' is not null or undefined
            assertParamExists('createDriverRecurringCharge', 'createDriverRecurringChargeRequest', createDriverRecurringChargeRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDriverRecurringChargeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverRecurringChargeOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('createDriverRecurringChargeOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createDriverRecurringChargeOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriver: async (driverId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('deleteDriver', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteDriver', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('deleteDriverOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDriverOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverRecurringCharge: async (chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('deleteDriverRecurringCharge', 'chargeId', chargeId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('deleteDriverRecurringCharge', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDriverRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteDriverRecurringCharge', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverRecurringChargeOptions: async (chargeId: string, driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('deleteDriverRecurringChargeOptions', 'chargeId', chargeId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('deleteDriverRecurringChargeOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteDriverRecurringChargeOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [sortBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDrivers: async (organizationUnid: string, authorization: string, sortBy?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableDrivers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAvailableDrivers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDriversOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableDriversOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriver: async (driverId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriver', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriver', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include) {
                localVarQueryParameter['include'] = include;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverHOSLog: async (driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverHOSLog', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverHOSLog', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverHOSLog', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-log`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverHOSLogOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverHOSLogOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverHOSLogOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-log`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLatestHOSClock: async (driverId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverLatestHOSClock', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverLatestHOSClock', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverLatestHOSClock', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-clocks/latest`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLatestHOSClockOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverLatestHOSClockOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverLatestHOSClockOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-clocks/latest`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLoads: async (driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverLoads', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverLoads', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverLoads', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/loads`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLoadsOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverLoadsOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverLoadsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/loads`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverRecurringCharge: async (chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('getDriverRecurringCharge', 'chargeId', chargeId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverRecurringCharge', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverRecurringCharge', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlements: async (driverId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverSettlements', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverSettlements', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverSettlements', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/settlements`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementsOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverSettlementsOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverSettlementsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/settlements`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverTrucks: async (driverId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverTrucks', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverTrucks', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverTrucks', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/trucks`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverTrucksOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('getDriverTrucksOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverTrucksOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/trucks`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverHOSClockHistory: async (driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('listDriverHOSClockHistory', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverHOSClockHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listDriverHOSClockHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-clocks`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverHOSClockHistoryOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('listDriverHOSClockHistoryOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverHOSClockHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/hos-clocks`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverLocationHistory: async (driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('listDriverLocationHistory', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverLocationHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listDriverLocationHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/location-history`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverLocationHistoryOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('listDriverLocationHistoryOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverLocationHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/location-history`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverRecurringCharges: async (driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: string | null, type?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('listDriverRecurringCharges', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDriverRecurringCharges', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listDriverRecurringCharges', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number | null} [expiringDocs] 
         * @param {boolean | null} [hasLoad] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [terminalId] 
         * @param {boolean | null} [withActiveLoads] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDrivers: async (organizationUnid: string, authorization: string, equipmentType?: string | null, expiringDocs?: number | null, hasLoad?: boolean | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, terminalId?: string | null, withActiveLoads?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listDrivers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listDrivers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (expiringDocs !== undefined) {
                localVarQueryParameter['expiring_docs'] = expiringDocs;
            }

            if (hasLoad !== undefined) {
                localVarQueryParameter['has_load'] = hasLoad;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (terminalId !== undefined) {
                localVarQueryParameter['terminal_id'] = terminalId;
            }

            if (withActiveLoads !== undefined) {
                localVarQueryParameter['with_active_loads'] = withActiveLoads;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDriverInvitation: async (driverId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('resendDriverInvitation', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resendDriverInvitation', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendDriverInvitation', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('resendDriverInvitation', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/resend-invitation`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDriverInvitationOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('resendDriverInvitationOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resendDriverInvitationOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/resend-invitation`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRequest} updateDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriver: async (driverId: string, organizationUnid: string, authorization: string, updateDriverRequest: UpdateDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('updateDriver', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDriver', 'authorization', authorization)
            // verify required parameter 'updateDriverRequest' is not null or undefined
            assertParamExists('updateDriver', 'updateDriverRequest', updateDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRecurringChargeRequest} updateDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverRecurringCharge: async (chargeId: string, driverId: string, organizationUnid: string, authorization: string, updateDriverRecurringChargeRequest: UpdateDriverRecurringChargeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('updateDriverRecurringCharge', 'chargeId', chargeId)
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('updateDriverRecurringCharge', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDriverRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDriverRecurringCharge', 'authorization', authorization)
            // verify required parameter 'updateDriverRecurringChargeRequest' is not null or undefined
            assertParamExists('updateDriverRecurringCharge', 'updateDriverRecurringChargeRequest', updateDriverRecurringChargeRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDriverRecurringChargeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverStatus: async (driverId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('updateDriverStatus', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDriverStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDriverStatus', 'authorization', authorization)
            // verify required parameter 'updateCustomerStatusRequest' is not null or undefined
            assertParamExists('updateDriverStatus', 'updateCustomerStatusRequest', updateCustomerStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/status`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverStatusOptions: async (driverId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('updateDriverStatusOptions', 'driverId', driverId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDriverStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/drivers/{driverId}/status`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriversApi - functional programming interface
 * @export
 */
export const DriversApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriversApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRequest} createDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDriver(organizationUnid: string, authorization: string, createDriverRequest: CreateDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDriver(organizationUnid, authorization, createDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.createDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDriverOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.createDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRecurringChargeRequest} createDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDriverRecurringCharge(driverId: string, organizationUnid: string, authorization: string, createDriverRecurringChargeRequest: CreateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverRecurringChargeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDriverRecurringCharge(driverId, organizationUnid, authorization, createDriverRecurringChargeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.createDriverRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDriverRecurringChargeOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDriverRecurringChargeOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.createDriverRecurringChargeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDriver(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDriver(driverId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.deleteDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDriverOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDriverOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.deleteDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.deleteDriverRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDriverRecurringChargeOptions(chargeId: string, driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDriverRecurringChargeOptions(chargeId, driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.deleteDriverRecurringChargeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [sortBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableDrivers(organizationUnid: string, authorization: string, sortBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAvailableDriversResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableDrivers(organizationUnid, authorization, sortBy, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getAvailableDrivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableDriversOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getAvailableDriversOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriver(driverId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriver(driverId, organizationUnid, authorization, include, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverHOSLog(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverHOSTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverHOSLog(driverId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverHOSLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverHOSLogOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverHOSLogOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverHOSLogOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverLatestHOSClock(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverLatestHOSClockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverLatestHOSClock(driverId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverLatestHOSClock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverLatestHOSClockOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverLatestHOSClockOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverLatestHOSClockOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverLoads(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverLoads(driverId, organizationUnid, authorization, limit, page, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverLoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverLoadsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverLoadsOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverLoadsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverRecurringChargeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverSettlements(driverId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverSettlements(driverId, organizationUnid, authorization, endDate, limit, page, startDate, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverSettlementsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverSettlementsOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverSettlementsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverTrucks(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverTrucks(driverId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverTrucks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverTrucksOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverTrucksOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.getDriverTrucksOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverHOSClockHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverHOSClockHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverHOSClockHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDriverHOSClockHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverHOSClockHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverHOSClockHistoryOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDriverHOSClockHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverLocationHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverLocationHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverLocationHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDriverLocationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverLocationHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverLocationHistoryOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDriverLocationHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDriverRecurringCharges(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverRecurringChargeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDriverRecurringCharges(driverId, organizationUnid, authorization, limit, page, status, type, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDriverRecurringCharges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number | null} [expiringDocs] 
         * @param {boolean | null} [hasLoad] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [terminalId] 
         * @param {boolean | null} [withActiveLoads] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDrivers(organizationUnid: string, authorization: string, equipmentType?: string | null, expiringDocs?: number | null, hasLoad?: boolean | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, terminalId?: string | null, withActiveLoads?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDrivers(organizationUnid, authorization, equipmentType, expiringDocs, hasLoad, limit, page, search, status, terminalId, withActiveLoads, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.listDrivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendDriverInvitation(driverId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendDriverInvitation(driverId, organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.resendDriverInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendDriverInvitationOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendDriverInvitationOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.resendDriverInvitationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRequest} updateDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDriver(driverId: string, organizationUnid: string, authorization: string, updateDriverRequest: UpdateDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDriver(driverId, organizationUnid, authorization, updateDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.updateDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRecurringChargeRequest} updateDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, updateDriverRecurringChargeRequest: UpdateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverRecurringChargeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, updateDriverRecurringChargeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.updateDriverRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDriverStatus(driverId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDriverStatus(driverId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.updateDriverStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDriverStatusOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDriverStatusOptions(driverId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DriversApi.updateDriverStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DriversApi - factory interface
 * @export
 */
export const DriversApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriversApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRequest} createDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriver(organizationUnid: string, authorization: string, createDriverRequest: CreateDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverResponse> {
            return localVarFp.createDriver(organizationUnid, authorization, createDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createDriverOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateDriverRecurringChargeRequest} createDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverRecurringCharge(driverId: string, organizationUnid: string, authorization: string, createDriverRecurringChargeRequest: CreateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverRecurringChargeResponse> {
            return localVarFp.createDriverRecurringCharge(driverId, organizationUnid, authorization, createDriverRecurringChargeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriverRecurringChargeOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createDriverRecurringChargeOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriver(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDriver(driverId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDriverOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriverRecurringChargeOptions(chargeId: string, driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteDriverRecurringChargeOptions(chargeId, driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [sortBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDrivers(organizationUnid: string, authorization: string, sortBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAvailableDriversResponse> {
            return localVarFp.getAvailableDrivers(organizationUnid, authorization, sortBy, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getAvailableDriversOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriver(driverId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverDetailResponse> {
            return localVarFp.getDriver(driverId, organizationUnid, authorization, include, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverHOSLog(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverHOSTimelineResponse> {
            return localVarFp.getDriverHOSLog(driverId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverHOSLogOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverHOSLogOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLatestHOSClock(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverLatestHOSClockResponse> {
            return localVarFp.getDriverLatestHOSClock(driverId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLatestHOSClockOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverLatestHOSClockOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLoads(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadListResponse> {
            return localVarFp.getDriverLoads(driverId, organizationUnid, authorization, limit, page, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverLoadsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverLoadsOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverRecurringChargeResponse> {
            return localVarFp.getDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlements(driverId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverSettlements(driverId, organizationUnid, authorization, endDate, limit, page, startDate, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverSettlementsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverSettlementsOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverTrucks(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckListResponse> {
            return localVarFp.getDriverTrucks(driverId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverTrucksOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverTrucksOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverHOSClockHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverHOSClockHistoryResponse> {
            return localVarFp.listDriverHOSClockHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverHOSClockHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listDriverHOSClockHistoryOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverLocationHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverLocationHistoryResponse> {
            return localVarFp.listDriverLocationHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverLocationHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listDriverLocationHistoryOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDriverRecurringCharges(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverRecurringChargeListResponse> {
            return localVarFp.listDriverRecurringCharges(driverId, organizationUnid, authorization, limit, page, status, type, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number | null} [expiringDocs] 
         * @param {boolean | null} [hasLoad] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [terminalId] 
         * @param {boolean | null} [withActiveLoads] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDrivers(organizationUnid: string, authorization: string, equipmentType?: string | null, expiringDocs?: number | null, hasLoad?: boolean | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, terminalId?: string | null, withActiveLoads?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverListResponse> {
            return localVarFp.listDrivers(organizationUnid, authorization, equipmentType, expiringDocs, hasLoad, limit, page, search, status, terminalId, withActiveLoads, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDriverInvitation(driverId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendDriverInvitation(driverId, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendDriverInvitationOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendDriverInvitationOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRequest} updateDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriver(driverId: string, organizationUnid: string, authorization: string, updateDriverRequest: UpdateDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverResponse> {
            return localVarFp.updateDriver(driverId, organizationUnid, authorization, updateDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDriverRecurringChargeRequest} updateDriverRecurringChargeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, updateDriverRecurringChargeRequest: UpdateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverRecurringChargeResponse> {
            return localVarFp.updateDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, updateDriverRecurringChargeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverStatus(driverId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverResponse> {
            return localVarFp.updateDriverStatus(driverId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} driverId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriverStatusOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateDriverStatusOptions(driverId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriversApi - object-oriented interface
 * @export
 * @class DriversApi
 * @extends {BaseAPI}
 */
export class DriversApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateDriverRequest} createDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public createDriver(organizationUnid: string, authorization: string, createDriverRequest: CreateDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).createDriver(organizationUnid, authorization, createDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public createDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).createDriverOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateDriverRecurringChargeRequest} createDriverRecurringChargeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public createDriverRecurringCharge(driverId: string, organizationUnid: string, authorization: string, createDriverRecurringChargeRequest: CreateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).createDriverRecurringCharge(driverId, organizationUnid, authorization, createDriverRecurringChargeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public createDriverRecurringChargeOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).createDriverRecurringChargeOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public deleteDriver(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).deleteDriver(driverId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public deleteDriverOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).deleteDriverOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public deleteDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).deleteDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public deleteDriverRecurringChargeOptions(chargeId: string, driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).deleteDriverRecurringChargeOptions(chargeId, driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [sortBy] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getAvailableDrivers(organizationUnid: string, authorization: string, sortBy?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getAvailableDrivers(organizationUnid, authorization, sortBy, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getAvailableDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getAvailableDriversOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {Array<string>} [include] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriver(driverId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriver(driverId, organizationUnid, authorization, include, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverHOSLog(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverHOSLog(driverId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverHOSLogOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverHOSLogOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverLatestHOSClock(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverLatestHOSClock(driverId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverLatestHOSClockOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverLatestHOSClockOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverLoads(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverLoads(driverId, organizationUnid, authorization, limit, page, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverLoadsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverLoadsOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [endDate] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [startDate] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverSettlements(driverId: string, organizationUnid: string, authorization: string, endDate?: string | null, limit?: number, page?: number, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverSettlements(driverId, organizationUnid, authorization, endDate, limit, page, startDate, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverSettlementsOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverSettlementsOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverTrucks(driverId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverTrucks(driverId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public getDriverTrucksOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).getDriverTrucksOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDriverHOSClockHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDriverHOSClockHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDriverHOSClockHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDriverHOSClockHistoryOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDriverLocationHistory(driverId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDriverLocationHistory(driverId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDriverLocationHistoryOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDriverLocationHistoryOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [status] 
     * @param {string | null} [type] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDriverRecurringCharges(driverId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, status?: string | null, type?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDriverRecurringCharges(driverId, organizationUnid, authorization, limit, page, status, type, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [equipmentType] 
     * @param {number | null} [expiringDocs] 
     * @param {boolean | null} [hasLoad] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string | null} [terminalId] 
     * @param {boolean | null} [withActiveLoads] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public listDrivers(organizationUnid: string, authorization: string, equipmentType?: string | null, expiringDocs?: number | null, hasLoad?: boolean | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, terminalId?: string | null, withActiveLoads?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).listDrivers(organizationUnid, authorization, equipmentType, expiringDocs, hasLoad, limit, page, search, status, terminalId, withActiveLoads, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public resendDriverInvitation(driverId: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).resendDriverInvitation(driverId, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public resendDriverInvitationOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).resendDriverInvitationOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateDriverRequest} updateDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public updateDriver(driverId: string, organizationUnid: string, authorization: string, updateDriverRequest: UpdateDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).updateDriver(driverId, organizationUnid, authorization, updateDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateDriverRecurringChargeRequest} updateDriverRecurringChargeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public updateDriverRecurringCharge(chargeId: string, driverId: string, organizationUnid: string, authorization: string, updateDriverRecurringChargeRequest: UpdateDriverRecurringChargeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).updateDriverRecurringCharge(chargeId, driverId, organizationUnid, authorization, updateDriverRecurringChargeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateCustomerStatusRequest} updateCustomerStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public updateDriverStatus(driverId: string, organizationUnid: string, authorization: string, updateCustomerStatusRequest: UpdateCustomerStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).updateDriverStatus(driverId, organizationUnid, authorization, updateCustomerStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} driverId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    public updateDriverStatusOptions(driverId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return DriversApiFp(this.configuration).updateDriverStatusOptions(driverId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EquipmentYardHistoryApi - axios parameter creator
 * @export
 */
export const EquipmentYardHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerYardEvents: async (organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerYardEvents', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerYardEvents', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTrailerYardEvents', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/yard-events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerYardEventsOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerYardEventsOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerYardEventsOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/yard-events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckYardEvents: async (organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckYardEvents', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckYardEvents', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTruckYardEvents', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/yard-events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckYardEventsOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckYardEventsOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckYardEventsOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/yard-events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EquipmentYardHistoryApi - functional programming interface
 * @export
 */
export const EquipmentYardHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EquipmentYardHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerYardEvents(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardEventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerYardEvents(organizationUnid, trailerId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentYardHistoryApi.listTrailerYardEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerYardEventsOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerYardEventsOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentYardHistoryApi.listTrailerYardEventsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckYardEvents(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardEventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckYardEvents(organizationUnid, truckId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentYardHistoryApi.listTruckYardEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckYardEventsOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckYardEventsOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EquipmentYardHistoryApi.listTruckYardEventsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EquipmentYardHistoryApi - factory interface
 * @export
 */
export const EquipmentYardHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EquipmentYardHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerYardEvents(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardEventListResponse> {
            return localVarFp.listTrailerYardEvents(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerYardEventsOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTrailerYardEventsOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckYardEvents(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardEventListResponse> {
            return localVarFp.listTruckYardEvents(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckYardEventsOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTruckYardEventsOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EquipmentYardHistoryApi - object-oriented interface
 * @export
 * @class EquipmentYardHistoryApi
 * @extends {BaseAPI}
 */
export class EquipmentYardHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentYardHistoryApi
     */
    public listTrailerYardEvents(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return EquipmentYardHistoryApiFp(this.configuration).listTrailerYardEvents(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentYardHistoryApi
     */
    public listTrailerYardEventsOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return EquipmentYardHistoryApiFp(this.configuration).listTrailerYardEventsOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentYardHistoryApi
     */
    public listTruckYardEvents(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return EquipmentYardHistoryApiFp(this.configuration).listTruckYardEvents(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EquipmentYardHistoryApi
     */
    public listTruckYardEventsOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return EquipmentYardHistoryApiFp(this.configuration).listTruckYardEventsOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExpensesApi - axios parameter creator
 * @export
 */
export const ExpensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateExpenseRequest} createExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpense: async (organizationUnid: string, authorization: string, createExpenseRequest: CreateExpenseRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createExpense', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createExpense', 'authorization', authorization)
            // verify required parameter 'createExpenseRequest' is not null or undefined
            assertParamExists('createExpense', 'createExpenseRequest', createExpenseRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExpenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpenseOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createExpenseOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpense: async (expenseId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expenseId' is not null or undefined
            assertParamExists('deleteExpense', 'expenseId', expenseId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteExpense', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteExpense', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses/{expenseId}`
                .replace(`{${"expenseId"}}`, encodeURIComponent(String(expenseId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpenseOptions: async (expenseId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expenseId' is not null or undefined
            assertParamExists('deleteExpenseOptions', 'expenseId', expenseId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteExpenseOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses/{expenseId}`
                .replace(`{${"expenseId"}}`, encodeURIComponent(String(expenseId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpense: async (expenseId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expenseId' is not null or undefined
            assertParamExists('getExpense', 'expenseId', expenseId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getExpense', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getExpense', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses/{expenseId}`
                .replace(`{${"expenseId"}}`, encodeURIComponent(String(expenseId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpenses: async (organizationUnid: string, authorization: string, category?: string | null, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listExpenses', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listExpenses', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (loadId !== undefined) {
                localVarQueryParameter['load_id'] = loadId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateExpenseRequest} updateExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpense: async (expenseId: string, organizationUnid: string, authorization: string, updateExpenseRequest: UpdateExpenseRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expenseId' is not null or undefined
            assertParamExists('updateExpense', 'expenseId', expenseId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateExpense', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateExpense', 'authorization', authorization)
            // verify required parameter 'updateExpenseRequest' is not null or undefined
            assertParamExists('updateExpense', 'updateExpenseRequest', updateExpenseRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/expenses/{expenseId}`
                .replace(`{${"expenseId"}}`, encodeURIComponent(String(expenseId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExpenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpensesApi - functional programming interface
 * @export
 */
export const ExpensesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpensesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateExpenseRequest} createExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExpense(organizationUnid: string, authorization: string, createExpenseRequest: CreateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesExpenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExpense(organizationUnid, authorization, createExpenseRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.createExpense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExpenseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExpenseOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.createExpenseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExpense(expenseId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.deleteExpense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExpenseOptions(expenseId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExpenseOptions(expenseId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.deleteExpenseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesExpenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpense(expenseId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.getExpense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExpenses(organizationUnid: string, authorization: string, category?: string | null, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesExpenseListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExpenses(organizationUnid, authorization, category, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.listExpenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateExpenseRequest} updateExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExpense(expenseId: string, organizationUnid: string, authorization: string, updateExpenseRequest: UpdateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesExpenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExpense(expenseId, organizationUnid, authorization, updateExpenseRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.updateExpense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExpensesApi - factory interface
 * @export
 */
export const ExpensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpensesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateExpenseRequest} createExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpense(organizationUnid: string, authorization: string, createExpenseRequest: CreateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesExpenseResponse> {
            return localVarFp.createExpense(organizationUnid, authorization, createExpenseRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpenseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createExpenseOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteExpense(expenseId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpenseOptions(expenseId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteExpenseOptions(expenseId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesExpenseResponse> {
            return localVarFp.getExpense(expenseId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpenses(organizationUnid: string, authorization: string, category?: string | null, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesExpenseListResponse> {
            return localVarFp.listExpenses(organizationUnid, authorization, category, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} expenseId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateExpenseRequest} updateExpenseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExpense(expenseId: string, organizationUnid: string, authorization: string, updateExpenseRequest: UpdateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesExpenseResponse> {
            return localVarFp.updateExpense(expenseId, organizationUnid, authorization, updateExpenseRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpensesApi - object-oriented interface
 * @export
 * @class ExpensesApi
 * @extends {BaseAPI}
 */
export class ExpensesApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateExpenseRequest} createExpenseRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public createExpense(organizationUnid: string, authorization: string, createExpenseRequest: CreateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).createExpense(organizationUnid, authorization, createExpenseRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public createExpenseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).createExpenseOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} expenseId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public deleteExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).deleteExpense(expenseId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} expenseId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public deleteExpenseOptions(expenseId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).deleteExpenseOptions(expenseId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} expenseId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public getExpense(expenseId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).getExpense(expenseId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [category] 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {string | null} [driverId] 
     * @param {number} [limit] 
     * @param {string | null} [loadId] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public listExpenses(organizationUnid: string, authorization: string, category?: string | null, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).listExpenses(organizationUnid, authorization, category, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} expenseId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateExpenseRequest} updateExpenseRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    public updateExpense(expenseId: string, organizationUnid: string, authorization: string, updateExpenseRequest: UpdateExpenseRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return ExpensesApiFp(this.configuration).updateExpense(expenseId, organizationUnid, authorization, updateExpenseRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FactoringApi - axios parameter creator
 * @export
 */
export const FactoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFactoringBatchRequest} createFactoringBatchRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoringBatch: async (organizationUnid: string, authorization: string, createFactoringBatchRequest: CreateFactoringBatchRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createFactoringBatch', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createFactoringBatch', 'authorization', authorization)
            // verify required parameter 'createFactoringBatchRequest' is not null or undefined
            assertParamExists('createFactoringBatch', 'createFactoringBatchRequest', createFactoringBatchRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFactoringBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoringBatch: async (batchId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getFactoringBatch', 'batchId', batchId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFactoringBatch', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFactoringBatch', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoringBatchOptions: async (batchId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('getFactoringBatchOptions', 'batchId', batchId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFactoringBatchOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringBatches: async (organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFactoringBatches', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listFactoringBatches', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringBatchesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFactoringBatchesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringInvoices: async (organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFactoringInvoices', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listFactoringInvoices', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/invoices`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringInvoicesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFactoringInvoicesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/invoices`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoringBatchStatus: async (batchId: string, organizationUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('updateFactoringBatchStatus', 'batchId', batchId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateFactoringBatchStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateFactoringBatchStatus', 'authorization', authorization)
            // verify required parameter 'updateFactoringBatchStatusRequest' is not null or undefined
            assertParamExists('updateFactoringBatchStatus', 'updateFactoringBatchStatusRequest', updateFactoringBatchStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches/{batchId}/status`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFactoringBatchStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoringBatchStatusOptions: async (batchId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('updateFactoringBatchStatusOptions', 'batchId', batchId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateFactoringBatchStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/factoring/batches/{batchId}/status`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FactoringApi - functional programming interface
 * @export
 */
export const FactoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FactoringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFactoringBatchRequest} createFactoringBatchRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFactoringBatch(organizationUnid: string, authorization: string, createFactoringBatchRequest: CreateFactoringBatchRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFactoringBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFactoringBatch(organizationUnid, authorization, createFactoringBatchRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.createFactoringBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFactoringBatch(batchId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFactoringBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFactoringBatch(batchId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.getFactoringBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFactoringBatchOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFactoringBatchOptions(batchId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.getFactoringBatchOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoringBatches(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFactoringBatchListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoringBatches(organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.listFactoringBatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoringBatchesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoringBatchesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.listFactoringBatchesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoringInvoices(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFactoringInvoiceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoringInvoices(organizationUnid, authorization, limit, page, search, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.listFactoringInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoringInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoringInvoicesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.listFactoringInvoicesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFactoringBatchStatus(batchId: string, organizationUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFactoringBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFactoringBatchStatus(batchId, organizationUnid, authorization, updateFactoringBatchStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.updateFactoringBatchStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFactoringBatchStatusOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFactoringBatchStatusOptions(batchId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoringApi.updateFactoringBatchStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FactoringApi - factory interface
 * @export
 */
export const FactoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FactoringApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFactoringBatchRequest} createFactoringBatchRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoringBatch(organizationUnid: string, authorization: string, createFactoringBatchRequest: CreateFactoringBatchRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFactoringBatchResponse> {
            return localVarFp.createFactoringBatch(organizationUnid, authorization, createFactoringBatchRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoringBatch(batchId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFactoringBatchResponse> {
            return localVarFp.getFactoringBatch(batchId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoringBatchOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFactoringBatchOptions(batchId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringBatches(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFactoringBatchListResponse> {
            return localVarFp.listFactoringBatches(organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringBatchesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listFactoringBatchesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringInvoices(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFactoringInvoiceListResponse> {
            return localVarFp.listFactoringInvoices(organizationUnid, authorization, limit, page, search, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoringInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listFactoringInvoicesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoringBatchStatus(batchId: string, organizationUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFactoringBatchResponse> {
            return localVarFp.updateFactoringBatchStatus(batchId, organizationUnid, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoringBatchStatusOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateFactoringBatchStatusOptions(batchId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FactoringApi - object-oriented interface
 * @export
 * @class FactoringApi
 * @extends {BaseAPI}
 */
export class FactoringApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateFactoringBatchRequest} createFactoringBatchRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public createFactoringBatch(organizationUnid: string, authorization: string, createFactoringBatchRequest: CreateFactoringBatchRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).createFactoringBatch(organizationUnid, authorization, createFactoringBatchRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public getFactoringBatch(batchId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).getFactoringBatch(batchId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public getFactoringBatchOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).getFactoringBatchOptions(batchId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public listFactoringBatches(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).listFactoringBatches(organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public listFactoringBatchesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).listFactoringBatchesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public listFactoringInvoices(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).listFactoringInvoices(organizationUnid, authorization, limit, page, search, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public listFactoringInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).listFactoringInvoicesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public updateFactoringBatchStatus(batchId: string, organizationUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).updateFactoringBatchStatus(batchId, organizationUnid, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoringApi
     */
    public updateFactoringBatchStatusOptions(batchId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FactoringApiFp(this.configuration).updateFactoringBatchStatusOptions(batchId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FleetApi - axios parameter creator
 * @export
 */
export const FleetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetDashboard: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetDashboard', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFleetDashboard', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/dashboard`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetDashboardOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetDashboardOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/dashboard`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLocations: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetLocations', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFleetLocations', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/locations`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLocationsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetLocationsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/locations`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAJurisdictionReport: async (organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getIFTAJurisdictionReport', 'organizationUnid', organizationUnid)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getIFTAJurisdictionReport', 'year', year)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getIFTAJurisdictionReport', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/ifta/samsara/jurisdiction`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fuelType !== undefined) {
                localVarQueryParameter['fuelType'] = fuelType;
            }

            if (jurisdictions !== undefined) {
                localVarQueryParameter['jurisdictions'] = jurisdictions;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (parentTagIds !== undefined) {
                localVarQueryParameter['parentTagIds'] = parentTagIds;
            }

            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }

            if (tagIds !== undefined) {
                localVarQueryParameter['tagIds'] = tagIds;
            }

            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAJurisdictionReportOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getIFTAJurisdictionReportOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/ifta/samsara/jurisdiction`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAVehicleReport: async (organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getIFTAVehicleReport', 'organizationUnid', organizationUnid)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getIFTAVehicleReport', 'year', year)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getIFTAVehicleReport', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/ifta/samsara/vehicle`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fuelType !== undefined) {
                localVarQueryParameter['fuelType'] = fuelType;
            }

            if (jurisdictions !== undefined) {
                localVarQueryParameter['jurisdictions'] = jurisdictions;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (parentTagIds !== undefined) {
                localVarQueryParameter['parentTagIds'] = parentTagIds;
            }

            if (quarter !== undefined) {
                localVarQueryParameter['quarter'] = quarter;
            }

            if (tagIds !== undefined) {
                localVarQueryParameter['tagIds'] = tagIds;
            }

            if (vehicleIds !== undefined) {
                localVarQueryParameter['vehicleIds'] = vehicleIds;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAVehicleReportOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getIFTAVehicleReportOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fleet/ifta/samsara/vehicle`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetApi - functional programming interface
 * @export
 */
export const FleetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetDashboard(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetDashboard(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getFleetDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetDashboardOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getFleetDashboardOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetLocations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetLocations(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getFleetLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetLocationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetLocationsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getFleetLocationsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIFTAJurisdictionReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesIFTAJurisdictionReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIFTAJurisdictionReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getIFTAJurisdictionReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIFTAJurisdictionReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIFTAJurisdictionReportOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getIFTAJurisdictionReportOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIFTAVehicleReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesIFTAVehicleReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIFTAVehicleReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getIFTAVehicleReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIFTAVehicleReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIFTAVehicleReportOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetApi.getIFTAVehicleReportOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FleetApi - factory interface
 * @export
 */
export const FleetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetDashboard(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetDashboardResponse> {
            return localVarFp.getFleetDashboard(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFleetDashboardOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLocations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetLocationsResponse> {
            return localVarFp.getFleetLocations(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetLocationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFleetLocationsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAJurisdictionReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesIFTAJurisdictionReportResponse> {
            return localVarFp.getIFTAJurisdictionReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAJurisdictionReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getIFTAJurisdictionReportOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {number} year 
         * @param {string} authorization 
         * @param {string} [fuelType] 
         * @param {string} [jurisdictions] 
         * @param {string} [month] 
         * @param {string} [parentTagIds] 
         * @param {string} [quarter] 
         * @param {string} [tagIds] 
         * @param {string} [vehicleIds] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAVehicleReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesIFTAVehicleReportResponse> {
            return localVarFp.getIFTAVehicleReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIFTAVehicleReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getIFTAVehicleReportOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetApi - object-oriented interface
 * @export
 * @class FleetApi
 * @extends {BaseAPI}
 */
export class FleetApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getFleetDashboard(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getFleetDashboard(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getFleetDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getFleetDashboardOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getFleetLocations(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getFleetLocations(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getFleetLocationsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getFleetLocationsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {number} year 
     * @param {string} authorization 
     * @param {string} [fuelType] 
     * @param {string} [jurisdictions] 
     * @param {string} [month] 
     * @param {string} [parentTagIds] 
     * @param {string} [quarter] 
     * @param {string} [tagIds] 
     * @param {string} [vehicleIds] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getIFTAJurisdictionReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getIFTAJurisdictionReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getIFTAJurisdictionReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getIFTAJurisdictionReportOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {number} year 
     * @param {string} authorization 
     * @param {string} [fuelType] 
     * @param {string} [jurisdictions] 
     * @param {string} [month] 
     * @param {string} [parentTagIds] 
     * @param {string} [quarter] 
     * @param {string} [tagIds] 
     * @param {string} [vehicleIds] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getIFTAVehicleReport(organizationUnid: string, year: number, authorization: string, fuelType?: string, jurisdictions?: string, month?: string, parentTagIds?: string, quarter?: string, tagIds?: string, vehicleIds?: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getIFTAVehicleReport(organizationUnid, year, authorization, fuelType, jurisdictions, month, parentTagIds, quarter, tagIds, vehicleIds, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetApi
     */
    public getIFTAVehicleReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetApiFp(this.configuration).getIFTAVehicleReportOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FleetrockApi - axios parameter creator
 * @export
 */
export const FleetrockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetrockCredentials: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteFleetrockCredentials', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteFleetrockCredentials', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetrockCredentialsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteFleetrockCredentialsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetrockStatus: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetrockStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFleetrockStatus', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetrockStatusOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetrockStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedFleetrockUnits: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listUnmatchedFleetrockUnits', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listUnmatchedFleetrockUnits', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/unmatched`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedFleetrockUnitsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listUnmatchedFleetrockUnitsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/unmatched`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchFleetrockUnitRequest} manualMatchFleetrockUnitRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchFleetrockUnit: async (organizationUnid: string, authorization: string, manualMatchFleetrockUnitRequest: ManualMatchFleetrockUnitRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('manualMatchFleetrockUnit', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('manualMatchFleetrockUnit', 'authorization', authorization)
            // verify required parameter 'manualMatchFleetrockUnitRequest' is not null or undefined
            assertParamExists('manualMatchFleetrockUnit', 'manualMatchFleetrockUnitRequest', manualMatchFleetrockUnitRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/match/manual`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualMatchFleetrockUnitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchFleetrockUnitOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('manualMatchFleetrockUnitOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/match/manual`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchFleetrockUnits: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('matchFleetrockUnits', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('matchFleetrockUnits', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('matchFleetrockUnits', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/match`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchFleetrockUnitsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('matchFleetrockUnitsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/units/match`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreFleetrockCredentialsRequest} storeFleetrockCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFleetrockCredentials: async (organizationUnid: string, authorization: string, storeFleetrockCredentialsRequest: StoreFleetrockCredentialsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('storeFleetrockCredentials', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('storeFleetrockCredentials', 'authorization', authorization)
            // verify required parameter 'storeFleetrockCredentialsRequest' is not null or undefined
            assertParamExists('storeFleetrockCredentials', 'storeFleetrockCredentialsRequest', storeFleetrockCredentialsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/credentials`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(storeFleetrockCredentialsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockMaintenance: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncFleetrockMaintenance', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('syncFleetrockMaintenance', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/maintenance/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockMaintenanceOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockMaintenanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/maintenance/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockParts: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockParts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncFleetrockParts', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('syncFleetrockParts', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/parts/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockPartsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockPartsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/parts/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockRepairOrders: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockRepairOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncFleetrockRepairOrders', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('syncFleetrockRepairOrders', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/repair-orders/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockRepairOrdersOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncFleetrockRepairOrdersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/fleetrock/repair-orders/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FleetrockApi - functional programming interface
 * @export
 */
export const FleetrockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FleetrockApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFleetrockCredentials(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFleetrockCredentials(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.deleteFleetrockCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFleetrockCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFleetrockCredentialsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.deleteFleetrockCredentialsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetrockStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetrockStatus(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.getFleetrockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetrockStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetrockStatusOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.getFleetrockStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnmatchedFleetrockUnits(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockUnmatchedUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnmatchedFleetrockUnits(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.listUnmatchedFleetrockUnits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnmatchedFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnmatchedFleetrockUnitsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.listUnmatchedFleetrockUnitsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchFleetrockUnitRequest} manualMatchFleetrockUnitRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualMatchFleetrockUnit(organizationUnid: string, authorization: string, manualMatchFleetrockUnitRequest: ManualMatchFleetrockUnitRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockManualMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualMatchFleetrockUnit(organizationUnid, authorization, manualMatchFleetrockUnitRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.manualMatchFleetrockUnit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualMatchFleetrockUnitOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualMatchFleetrockUnitOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.manualMatchFleetrockUnitOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchFleetrockUnits(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchFleetrockUnits(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.matchFleetrockUnits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchFleetrockUnitsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.matchFleetrockUnitsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreFleetrockCredentialsRequest} storeFleetrockCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeFleetrockCredentials(organizationUnid: string, authorization: string, storeFleetrockCredentialsRequest: StoreFleetrockCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeFleetrockCredentials(organizationUnid, authorization, storeFleetrockCredentialsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.storeFleetrockCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockMaintenance(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockSyncResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockMaintenance(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockMaintenanceOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockParts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockSyncResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockParts(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockPartsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockPartsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockRepairOrders(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFleetrockSyncResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockRepairOrders(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockRepairOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncFleetrockRepairOrdersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncFleetrockRepairOrdersOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FleetrockApi.syncFleetrockRepairOrdersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FleetrockApi - factory interface
 * @export
 */
export const FleetrockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FleetrockApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetrockCredentials(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteFleetrockCredentials(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFleetrockCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteFleetrockCredentialsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetrockStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockStatusResponse> {
            return localVarFp.getFleetrockStatus(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetrockStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFleetrockStatusOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedFleetrockUnits(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockUnmatchedUnitsResponse> {
            return localVarFp.listUnmatchedFleetrockUnits(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listUnmatchedFleetrockUnitsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchFleetrockUnitRequest} manualMatchFleetrockUnitRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchFleetrockUnit(organizationUnid: string, authorization: string, manualMatchFleetrockUnitRequest: ManualMatchFleetrockUnitRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockManualMatchResponse> {
            return localVarFp.manualMatchFleetrockUnit(organizationUnid, authorization, manualMatchFleetrockUnitRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchFleetrockUnitOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.manualMatchFleetrockUnitOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchFleetrockUnits(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockMatchResponse> {
            return localVarFp.matchFleetrockUnits(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.matchFleetrockUnitsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {StoreFleetrockCredentialsRequest} storeFleetrockCredentialsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFleetrockCredentials(organizationUnid: string, authorization: string, storeFleetrockCredentialsRequest: StoreFleetrockCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.storeFleetrockCredentials(organizationUnid, authorization, storeFleetrockCredentialsRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockMaintenance(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockSyncResult> {
            return localVarFp.syncFleetrockMaintenance(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncFleetrockMaintenanceOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockParts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockSyncResult> {
            return localVarFp.syncFleetrockParts(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncFleetrockPartsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockRepairOrders(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFleetrockSyncResult> {
            return localVarFp.syncFleetrockRepairOrders(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncFleetrockRepairOrdersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncFleetrockRepairOrdersOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FleetrockApi - object-oriented interface
 * @export
 * @class FleetrockApi
 * @extends {BaseAPI}
 */
export class FleetrockApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public deleteFleetrockCredentials(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).deleteFleetrockCredentials(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public deleteFleetrockCredentialsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).deleteFleetrockCredentialsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public getFleetrockStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).getFleetrockStatus(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public getFleetrockStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).getFleetrockStatusOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public listUnmatchedFleetrockUnits(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).listUnmatchedFleetrockUnits(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public listUnmatchedFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).listUnmatchedFleetrockUnitsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ManualMatchFleetrockUnitRequest} manualMatchFleetrockUnitRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public manualMatchFleetrockUnit(organizationUnid: string, authorization: string, manualMatchFleetrockUnitRequest: ManualMatchFleetrockUnitRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).manualMatchFleetrockUnit(organizationUnid, authorization, manualMatchFleetrockUnitRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public manualMatchFleetrockUnitOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).manualMatchFleetrockUnitOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public matchFleetrockUnits(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).matchFleetrockUnits(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public matchFleetrockUnitsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).matchFleetrockUnitsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {StoreFleetrockCredentialsRequest} storeFleetrockCredentialsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public storeFleetrockCredentials(organizationUnid: string, authorization: string, storeFleetrockCredentialsRequest: StoreFleetrockCredentialsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).storeFleetrockCredentials(organizationUnid, authorization, storeFleetrockCredentialsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockMaintenance(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockMaintenance(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockMaintenanceOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockParts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockParts(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockPartsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockRepairOrders(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockRepairOrders(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FleetrockApi
     */
    public syncFleetrockRepairOrdersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FleetrockApiFp(this.configuration).syncFleetrockRepairOrdersOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FuelApi - axios parameter creator
 * @export
 */
export const FuelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFuelPurchaseRequest} createFuelPurchaseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelPurchase: async (organizationUnid: string, authorization: string, createFuelPurchaseRequest: CreateFuelPurchaseRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createFuelPurchase', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createFuelPurchase', 'authorization', authorization)
            // verify required parameter 'createFuelPurchaseRequest' is not null or undefined
            assertParamExists('createFuelPurchase', 'createFuelPurchaseRequest', createFuelPurchaseRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFuelPurchaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelPurchaseOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createFuelPurchaseOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelPurchase: async (fuelId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fuelId' is not null or undefined
            assertParamExists('getFuelPurchase', 'fuelId', fuelId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFuelPurchase', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFuelPurchase', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel/{fuelId}`
                .replace(`{${"fuelId"}}`, encodeURIComponent(String(fuelId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelPurchaseOptions: async (fuelId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fuelId' is not null or undefined
            assertParamExists('getFuelPurchaseOptions', 'fuelId', fuelId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFuelPurchaseOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel/{fuelId}`
                .replace(`{${"fuelId"}}`, encodeURIComponent(String(fuelId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ImportFuelPurchasesRequest} importFuelPurchasesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFuelPurchases: async (organizationUnid: string, authorization: string, importFuelPurchasesRequest: ImportFuelPurchasesRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('importFuelPurchases', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('importFuelPurchases', 'authorization', authorization)
            // verify required parameter 'importFuelPurchasesRequest' is not null or undefined
            assertParamExists('importFuelPurchases', 'importFuelPurchasesRequest', importFuelPurchasesRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel/import`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importFuelPurchasesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFuelPurchasesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('importFuelPurchasesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel/import`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFuelPurchases: async (organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFuelPurchases', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listFuelPurchases', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/fuel`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (loadId !== undefined) {
                localVarQueryParameter['load_id'] = loadId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FuelApi - functional programming interface
 * @export
 */
export const FuelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FuelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFuelPurchaseRequest} createFuelPurchaseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFuelPurchase(organizationUnid: string, authorization: string, createFuelPurchaseRequest: CreateFuelPurchaseRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFuelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFuelPurchase(organizationUnid, authorization, createFuelPurchaseRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.createFuelPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFuelPurchaseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFuelPurchaseOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.createFuelPurchaseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFuelPurchase(fuelId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFuelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFuelPurchase(fuelId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.getFuelPurchase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFuelPurchaseOptions(fuelId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFuelPurchaseOptions(fuelId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.getFuelPurchaseOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ImportFuelPurchasesRequest} importFuelPurchasesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFuelPurchases(organizationUnid: string, authorization: string, importFuelPurchasesRequest: ImportFuelPurchasesRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFuelImportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFuelPurchases(organizationUnid, authorization, importFuelPurchasesRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.importFuelPurchases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFuelPurchasesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importFuelPurchasesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.importFuelPurchasesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFuelPurchases(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesFuelListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFuelPurchases(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FuelApi.listFuelPurchases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FuelApi - factory interface
 * @export
 */
export const FuelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FuelApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFuelPurchaseRequest} createFuelPurchaseRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelPurchase(organizationUnid: string, authorization: string, createFuelPurchaseRequest: CreateFuelPurchaseRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFuelResponse> {
            return localVarFp.createFuelPurchase(organizationUnid, authorization, createFuelPurchaseRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFuelPurchaseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createFuelPurchaseOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelPurchase(fuelId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFuelResponse> {
            return localVarFp.getFuelPurchase(fuelId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fuelId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFuelPurchaseOptions(fuelId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFuelPurchaseOptions(fuelId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ImportFuelPurchasesRequest} importFuelPurchasesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFuelPurchases(organizationUnid: string, authorization: string, importFuelPurchasesRequest: ImportFuelPurchasesRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFuelImportResponse> {
            return localVarFp.importFuelPurchases(organizationUnid, authorization, importFuelPurchasesRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFuelPurchasesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.importFuelPurchasesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFuelPurchases(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesFuelListResponse> {
            return localVarFp.listFuelPurchases(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FuelApi - object-oriented interface
 * @export
 * @class FuelApi
 * @extends {BaseAPI}
 */
export class FuelApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateFuelPurchaseRequest} createFuelPurchaseRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public createFuelPurchase(organizationUnid: string, authorization: string, createFuelPurchaseRequest: CreateFuelPurchaseRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).createFuelPurchase(organizationUnid, authorization, createFuelPurchaseRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public createFuelPurchaseOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).createFuelPurchaseOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fuelId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public getFuelPurchase(fuelId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).getFuelPurchase(fuelId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fuelId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public getFuelPurchaseOptions(fuelId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).getFuelPurchaseOptions(fuelId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ImportFuelPurchasesRequest} importFuelPurchasesRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public importFuelPurchases(organizationUnid: string, authorization: string, importFuelPurchasesRequest: ImportFuelPurchasesRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).importFuelPurchases(organizationUnid, authorization, importFuelPurchasesRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public importFuelPurchasesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).importFuelPurchasesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {string | null} [driverId] 
     * @param {number} [limit] 
     * @param {string | null} [loadId] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelApi
     */
    public listFuelPurchases(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return FuelApiFp(this.configuration).listFuelPurchases(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, loadId, page, search, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/health/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/health/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.health(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.healthOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(origin?: string, options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InspectionDefectWOApi - axios parameter creator
 * @export
 */
export const InspectionDefectWOApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromDefectRequest} createWorkOrderFromDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromDefect: async (defectId: string, inspectionId: string, organizationUnid: string, authorization: string, createWorkOrderFromDefectRequest: CreateWorkOrderFromDefectRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('createWorkOrderFromDefect', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('createWorkOrderFromDefect', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderFromDefect', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createWorkOrderFromDefect', 'authorization', authorization)
            // verify required parameter 'createWorkOrderFromDefectRequest' is not null or undefined
            assertParamExists('createWorkOrderFromDefect', 'createWorkOrderFromDefectRequest', createWorkOrderFromDefectRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections/{inspectionId}/defects/{defectId}/create-work-order`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderFromDefectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromDefectOptions: async (defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('createWorkOrderFromDefectOptions', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('createWorkOrderFromDefectOptions', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderFromDefectOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections/{inspectionId}/defects/{defectId}/create-work-order`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InspectionDefectWOApi - functional programming interface
 * @export
 */
export const InspectionDefectWOApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InspectionDefectWOApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromDefectRequest} createWorkOrderFromDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderFromDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, createWorkOrderFromDefectRequest: CreateWorkOrderFromDefectRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderFromDefect(defectId, inspectionId, organizationUnid, authorization, createWorkOrderFromDefectRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionDefectWOApi.createWorkOrderFromDefect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderFromDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderFromDefectOptions(defectId, inspectionId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionDefectWOApi.createWorkOrderFromDefectOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InspectionDefectWOApi - factory interface
 * @export
 */
export const InspectionDefectWOApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InspectionDefectWOApiFp(configuration)
    return {
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromDefectRequest} createWorkOrderFromDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, createWorkOrderFromDefectRequest: CreateWorkOrderFromDefectRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.createWorkOrderFromDefect(defectId, inspectionId, organizationUnid, authorization, createWorkOrderFromDefectRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createWorkOrderFromDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InspectionDefectWOApi - object-oriented interface
 * @export
 * @class InspectionDefectWOApi
 * @extends {BaseAPI}
 */
export class InspectionDefectWOApi extends BaseAPI {
    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateWorkOrderFromDefectRequest} createWorkOrderFromDefectRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionDefectWOApi
     */
    public createWorkOrderFromDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, createWorkOrderFromDefectRequest: CreateWorkOrderFromDefectRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionDefectWOApiFp(this.configuration).createWorkOrderFromDefect(defectId, inspectionId, organizationUnid, authorization, createWorkOrderFromDefectRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionDefectWOApi
     */
    public createWorkOrderFromDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionDefectWOApiFp(this.configuration).createWorkOrderFromDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InspectionsApi - axios parameter creator
 * @export
 */
export const InspectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddDefectRequest} addDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefect: async (inspectionId: string, organizationUnid: string, authorization: string, addDefectRequest: AddDefectRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('addDefect', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addDefect', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addDefect', 'authorization', authorization)
            // verify required parameter 'addDefectRequest' is not null or undefined
            assertParamExists('addDefect', 'addDefectRequest', addDefectRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects`
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDefectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefectOptions: async (inspectionId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('addDefectOptions', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addDefectOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects`
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInspectionRequest} createInspectionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspection: async (organizationUnid: string, authorization: string, createInspectionRequest: CreateInspectionRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createInspection', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createInspection', 'authorization', authorization)
            // verify required parameter 'createInspectionRequest' is not null or undefined
            assertParamExists('createInspection', 'createInspectionRequest', createInspectionRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInspectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspectionOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createInspectionOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} inspectionType 
         * @param {string} vehicleType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTemplate: async (organizationUnid: string, inspectionType: string, vehicleType: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getChecklistTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'inspectionType' is not null or undefined
            assertParamExists('getChecklistTemplate', 'inspectionType', inspectionType)
            // verify required parameter 'vehicleType' is not null or undefined
            assertParamExists('getChecklistTemplate', 'vehicleType', vehicleType)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getChecklistTemplate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/checklist-template`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inspectionType !== undefined) {
                localVarQueryParameter['inspection_type'] = inspectionType;
            }

            if (vehicleType !== undefined) {
                localVarQueryParameter['vehicle_type'] = vehicleType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTemplateOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getChecklistTemplateOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/checklist-template`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspection: async (inspectionId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('getInspection', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInspection', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInspection', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}`
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionOptions: async (inspectionId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('getInspectionOptions', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInspectionOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}`
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {boolean | null} [hasDefects] 
         * @param {boolean | null} [hasOosDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspections: async (organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, hasDefects?: boolean | null, hasOosDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: Array<string>, trailerId?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listInspections', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listInspections', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (hasDefects !== undefined) {
                localVarQueryParameter['has_defects'] = hasDefects;
            }

            if (hasOosDefects !== undefined) {
                localVarQueryParameter['has_oos_defects'] = hasOosDefects;
            }

            if (inspectionType !== undefined) {
                localVarQueryParameter['inspection_type'] = inspectionType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (result) {
                localVarQueryParameter['result'] = result;
            }

            if (trailerId !== undefined) {
                localVarQueryParameter['trailer_id'] = trailerId;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ResolveDefectRequest} resolveDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDefect: async (defectId: string, inspectionId: string, organizationUnid: string, authorization: string, resolveDefectRequest: ResolveDefectRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('resolveDefect', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('resolveDefect', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resolveDefect', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resolveDefect', 'authorization', authorization)
            // verify required parameter 'resolveDefectRequest' is not null or undefined
            assertParamExists('resolveDefect', 'resolveDefectRequest', resolveDefectRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects/{defectId}/resolve`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveDefectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDefectOptions: async (defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('resolveDefectOptions', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('resolveDefectOptions', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resolveDefectOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects/{defectId}/resolve`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDefectRequest} updateDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefect: async (defectId: string, inspectionId: string, organizationUnid: string, authorization: string, updateDefectRequest: UpdateDefectRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('updateDefect', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('updateDefect', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDefect', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDefect', 'authorization', authorization)
            // verify required parameter 'updateDefectRequest' is not null or undefined
            assertParamExists('updateDefect', 'updateDefectRequest', updateDefectRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects/{defectId}`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDefectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefectOptions: async (defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defectId' is not null or undefined
            assertParamExists('updateDefectOptions', 'defectId', defectId)
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('updateDefectOptions', 'inspectionId', inspectionId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateDefectOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/inspections/{inspectionId}/defects/{defectId}`
                .replace(`{${"defectId"}}`, encodeURIComponent(String(defectId)))
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InspectionsApi - functional programming interface
 * @export
 */
export const InspectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InspectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddDefectRequest} addDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDefect(inspectionId: string, organizationUnid: string, authorization: string, addDefectRequest: AddDefectRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDefectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDefect(inspectionId, organizationUnid, authorization, addDefectRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.addDefect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDefectOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDefectOptions(inspectionId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.addDefectOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInspectionRequest} createInspectionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInspection(organizationUnid: string, authorization: string, createInspectionRequest: CreateInspectionRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInspection(organizationUnid, authorization, createInspectionRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.createInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInspectionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInspectionOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.createInspectionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} inspectionType 
         * @param {string} vehicleType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChecklistTemplate(organizationUnid: string, inspectionType: string, vehicleType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesChecklistTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChecklistTemplate(organizationUnid, inspectionType, vehicleType, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getChecklistTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChecklistTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChecklistTemplateOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getChecklistTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspection(inspectionId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInspectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspection(inspectionId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspectionOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspectionOptions(inspectionId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getInspectionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {boolean | null} [hasDefects] 
         * @param {boolean | null} [hasOosDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInspections(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, hasDefects?: boolean | null, hasOosDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: Array<string>, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInspectionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInspections(organizationUnid, authorization, dateFrom, dateTo, driverId, hasDefects, hasOosDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.listInspections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ResolveDefectRequest} resolveDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, resolveDefectRequest: ResolveDefectRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveDefect(defectId, inspectionId, organizationUnid, authorization, resolveDefectRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.resolveDefect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveDefectOptions(defectId, inspectionId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.resolveDefectOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDefectRequest} updateDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, updateDefectRequest: UpdateDefectRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDefectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefect(defectId, inspectionId, organizationUnid, authorization, updateDefectRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.updateDefect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefectOptions(defectId, inspectionId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.updateDefectOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InspectionsApi - factory interface
 * @export
 */
export const InspectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InspectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddDefectRequest} addDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefect(inspectionId: string, organizationUnid: string, authorization: string, addDefectRequest: AddDefectRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDefectResponse> {
            return localVarFp.addDefect(inspectionId, organizationUnid, authorization, addDefectRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDefectOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addDefectOptions(inspectionId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInspectionRequest} createInspectionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspection(organizationUnid: string, authorization: string, createInspectionRequest: CreateInspectionRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInspectionResponse> {
            return localVarFp.createInspection(organizationUnid, authorization, createInspectionRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspectionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createInspectionOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} inspectionType 
         * @param {string} vehicleType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTemplate(organizationUnid: string, inspectionType: string, vehicleType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesChecklistTemplateResponse> {
            return localVarFp.getChecklistTemplate(organizationUnid, inspectionType, vehicleType, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklistTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getChecklistTemplateOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspection(inspectionId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInspectionResponse> {
            return localVarFp.getInspection(inspectionId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getInspectionOptions(inspectionId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {boolean | null} [hasDefects] 
         * @param {boolean | null} [hasOosDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspections(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, hasDefects?: boolean | null, hasOosDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: Array<string>, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInspectionListResponse> {
            return localVarFp.listInspections(organizationUnid, authorization, dateFrom, dateTo, driverId, hasDefects, hasOosDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ResolveDefectRequest} resolveDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, resolveDefectRequest: ResolveDefectRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resolveDefect(defectId, inspectionId, organizationUnid, authorization, resolveDefectRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resolveDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateDefectRequest} updateDefectRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, updateDefectRequest: UpdateDefectRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDefectResponse> {
            return localVarFp.updateDefect(defectId, inspectionId, organizationUnid, authorization, updateDefectRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} defectId 
         * @param {string} inspectionId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InspectionsApi - object-oriented interface
 * @export
 * @class InspectionsApi
 * @extends {BaseAPI}
 */
export class InspectionsApi extends BaseAPI {
    /**
     * 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AddDefectRequest} addDefectRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public addDefect(inspectionId: string, organizationUnid: string, authorization: string, addDefectRequest: AddDefectRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).addDefect(inspectionId, organizationUnid, authorization, addDefectRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public addDefectOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).addDefectOptions(inspectionId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateInspectionRequest} createInspectionRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public createInspection(organizationUnid: string, authorization: string, createInspectionRequest: CreateInspectionRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).createInspection(organizationUnid, authorization, createInspectionRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public createInspectionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).createInspectionOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} inspectionType 
     * @param {string} vehicleType 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getChecklistTemplate(organizationUnid: string, inspectionType: string, vehicleType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getChecklistTemplate(organizationUnid, inspectionType, vehicleType, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getChecklistTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getChecklistTemplateOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getInspection(inspectionId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getInspection(inspectionId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public getInspectionOptions(inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).getInspectionOptions(inspectionId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {string | null} [driverId] 
     * @param {boolean | null} [hasDefects] 
     * @param {boolean | null} [hasOosDefects] 
     * @param {string | null} [inspectionType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {Array<string>} [result] 
     * @param {string | null} [trailerId] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public listInspections(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, hasDefects?: boolean | null, hasOosDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: Array<string>, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).listInspections(organizationUnid, authorization, dateFrom, dateTo, driverId, hasDefects, hasOosDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ResolveDefectRequest} resolveDefectRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public resolveDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, resolveDefectRequest: ResolveDefectRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).resolveDefect(defectId, inspectionId, organizationUnid, authorization, resolveDefectRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public resolveDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).resolveDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateDefectRequest} updateDefectRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public updateDefect(defectId: string, inspectionId: string, organizationUnid: string, authorization: string, updateDefectRequest: UpdateDefectRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).updateDefect(defectId, inspectionId, organizationUnid, authorization, updateDefectRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} defectId 
     * @param {string} inspectionId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    public updateDefectOptions(defectId: string, inspectionId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InspectionsApiFp(this.configuration).updateDefectOptions(defectId, inspectionId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GeneratePDFRequest} generatePDFRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePDF: async (invoiceId: string, organizationUnid: string, authorization: string, generatePDFRequest: GeneratePDFRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('generatePDF', 'invoiceId', invoiceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('generatePDF', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('generatePDF', 'authorization', authorization)
            // verify required parameter 'generatePDFRequest' is not null or undefined
            assertParamExists('generatePDF', 'generatePDFRequest', generatePDFRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices/{invoiceId}/generate-pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatePDFRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePDFOptions: async (invoiceId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('generatePDFOptions', 'invoiceId', invoiceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('generatePDFOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices/{invoiceId}/generate-pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice: async (invoiceId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoice', 'invoiceId', invoiceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInvoice', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInvoice', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceOptions: async (invoiceId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoiceOptions', 'invoiceId', invoiceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInvoiceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices: async (organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listInvoices', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listInvoices', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (loadId !== undefined) {
                localVarQueryParameter['load_id'] = loadId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listInvoicesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invoices`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GeneratePDFRequest} generatePDFRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePDF(invoiceId: string, organizationUnid: string, authorization: string, generatePDFRequest: GeneratePDFRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadInvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePDF(invoiceId, organizationUnid, authorization, generatePDFRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.generatePDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePDFOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePDFOptions(invoiceId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.generatePDFOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoice(invoiceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadInvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoice(invoiceId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceOptions(invoiceId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.getInvoiceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoices(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadInvoiceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoices(organizationUnid, authorization, customerId, limit, loadId, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.listInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoicesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicesApi.listInvoicesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {GeneratePDFRequest} generatePDFRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePDF(invoiceId: string, organizationUnid: string, authorization: string, generatePDFRequest: GeneratePDFRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadInvoiceResponse> {
            return localVarFp.generatePDF(invoiceId, organizationUnid, authorization, generatePDFRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePDFOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.generatePDFOptions(invoiceId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoice(invoiceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadInvoiceResponse> {
            return localVarFp.getInvoice(invoiceId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invoiceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getInvoiceOptions(invoiceId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {string | null} [loadId] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadInvoiceListResponse> {
            return localVarFp.listInvoices(organizationUnid, authorization, customerId, limit, loadId, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listInvoicesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     * 
     * @param {string} invoiceId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {GeneratePDFRequest} generatePDFRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public generatePDF(invoiceId: string, organizationUnid: string, authorization: string, generatePDFRequest: GeneratePDFRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).generatePDF(invoiceId, organizationUnid, authorization, generatePDFRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invoiceId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public generatePDFOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).generatePDFOptions(invoiceId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invoiceId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoice(invoiceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoice(invoiceId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invoiceId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getInvoiceOptions(invoiceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getInvoiceOptions(invoiceId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [customerId] 
     * @param {number} [limit] 
     * @param {string | null} [loadId] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public listInvoices(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, loadId?: string | null, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).listInvoices(organizationUnid, authorization, customerId, limit, loadId, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public listInvoicesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).listInvoicesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoadCalculatorApi - axios parameter creator
 * @export
 */
export const LoadCalculatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {EstimateLoadRequest} estimateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateLoad: async (organizationUnid: string, authorization: string, estimateLoadRequest: EstimateLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('estimateLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('estimateLoad', 'authorization', authorization)
            // verify required parameter 'estimateLoadRequest' is not null or undefined
            assertParamExists('estimateLoad', 'estimateLoadRequest', estimateLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/calculator/estimate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(estimateLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateLoadOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('estimateLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/calculator/estimate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoadCalculatorApi - functional programming interface
 * @export
 */
export const LoadCalculatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoadCalculatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {EstimateLoadRequest} estimateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimateLoad(organizationUnid: string, authorization: string, estimateLoadRequest: EstimateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadEstimateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimateLoad(organizationUnid, authorization, estimateLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadCalculatorApi.estimateLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimateLoadOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadCalculatorApi.estimateLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoadCalculatorApi - factory interface
 * @export
 */
export const LoadCalculatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoadCalculatorApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {EstimateLoadRequest} estimateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateLoad(organizationUnid: string, authorization: string, estimateLoadRequest: EstimateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadEstimateResponse> {
            return localVarFp.estimateLoad(organizationUnid, authorization, estimateLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.estimateLoadOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoadCalculatorApi - object-oriented interface
 * @export
 * @class LoadCalculatorApi
 * @extends {BaseAPI}
 */
export class LoadCalculatorApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {EstimateLoadRequest} estimateLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadCalculatorApi
     */
    public estimateLoad(organizationUnid: string, authorization: string, estimateLoadRequest: EstimateLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadCalculatorApiFp(this.configuration).estimateLoad(organizationUnid, authorization, estimateLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadCalculatorApi
     */
    public estimateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadCalculatorApiFp(this.configuration).estimateLoadOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoadTemplatesApi - axios parameter creator
 * @export
 */
export const LoadTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTemplateRequest} createTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (organizationUnid: string, authorization: string, createTemplateRequest: CreateTemplateRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTemplate', 'authorization', authorization)
            // verify required parameter 'createTemplateRequest' is not null or undefined
            assertParamExists('createTemplate', 'createTemplateRequest', createTemplateRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTemplateOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (organizationUnid: string, templateId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTemplate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateOptions: async (organizationUnid: string, templateId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTemplateOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplateOptions', 'templateId', templateId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (organizationUnid: string, templateId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTemplate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {boolean | null} [isActive] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (organizationUnid: string, authorization: string, customerId?: string | null, isActive?: boolean | null, limit?: number, page?: number, search?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTemplates', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTemplates', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateTemplateRequest} updateTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (organizationUnid: string, templateId: string, authorization: string, updateTemplateRequest: UpdateTemplateRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTemplate', 'authorization', authorization)
            // verify required parameter 'updateTemplateRequest' is not null or undefined
            assertParamExists('updateTemplate', 'updateTemplateRequest', updateTemplateRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UseTemplateRequest} useTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useTemplate: async (organizationUnid: string, templateId: string, authorization: string, useTemplateRequest: UseTemplateRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('useTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('useTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('useTemplate', 'authorization', authorization)
            // verify required parameter 'useTemplateRequest' is not null or undefined
            assertParamExists('useTemplate', 'useTemplateRequest', useTemplateRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}/use`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(useTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useTemplateOptions: async (organizationUnid: string, templateId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('useTemplateOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('useTemplateOptions', 'templateId', templateId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/templates/{templateId}/use`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoadTemplatesApi - functional programming interface
 * @export
 */
export const LoadTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoadTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTemplateRequest} createTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(organizationUnid: string, authorization: string, createTemplateRequest: CreateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(organizationUnid, authorization, createTemplateRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.createTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplateOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.createTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(organizationUnid, templateId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.deleteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplateOptions(organizationUnid, templateId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.deleteTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(organizationUnid, templateId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {boolean | null} [isActive] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(organizationUnid: string, authorization: string, customerId?: string | null, isActive?: boolean | null, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(organizationUnid, authorization, customerId, isActive, limit, page, search, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.listTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateTemplateRequest} updateTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(organizationUnid: string, templateId: string, authorization: string, updateTemplateRequest: UpdateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(organizationUnid, templateId, authorization, updateTemplateRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.updateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UseTemplateRequest} useTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async useTemplate(organizationUnid: string, templateId: string, authorization: string, useTemplateRequest: UseTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.useTemplate(organizationUnid, templateId, authorization, useTemplateRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.useTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async useTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.useTemplateOptions(organizationUnid, templateId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadTemplatesApi.useTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoadTemplatesApi - factory interface
 * @export
 */
export const LoadTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoadTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTemplateRequest} createTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(organizationUnid: string, authorization: string, createTemplateRequest: CreateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadTemplateResponse> {
            return localVarFp.createTemplate(organizationUnid, authorization, createTemplateRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createTemplateOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadTemplateResponse> {
            return localVarFp.getTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {boolean | null} [isActive] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(organizationUnid: string, authorization: string, customerId?: string | null, isActive?: boolean | null, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadTemplateListResponse> {
            return localVarFp.listTemplates(organizationUnid, authorization, customerId, isActive, limit, page, search, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateTemplateRequest} updateTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(organizationUnid: string, templateId: string, authorization: string, updateTemplateRequest: UpdateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadTemplateResponse> {
            return localVarFp.updateTemplate(organizationUnid, templateId, authorization, updateTemplateRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UseTemplateRequest} useTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useTemplate(organizationUnid: string, templateId: string, authorization: string, useTemplateRequest: UseTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.useTemplate(organizationUnid, templateId, authorization, useTemplateRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.useTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoadTemplatesApi - object-oriented interface
 * @export
 * @class LoadTemplatesApi
 * @extends {BaseAPI}
 */
export class LoadTemplatesApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateTemplateRequest} createTemplateRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public createTemplate(organizationUnid: string, authorization: string, createTemplateRequest: CreateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).createTemplate(organizationUnid, authorization, createTemplateRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public createTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).createTemplateOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public deleteTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).deleteTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public deleteTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).deleteTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public getTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).getTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [customerId] 
     * @param {boolean | null} [isActive] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public listTemplates(organizationUnid: string, authorization: string, customerId?: string | null, isActive?: boolean | null, limit?: number, page?: number, search?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).listTemplates(organizationUnid, authorization, customerId, isActive, limit, page, search, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {UpdateTemplateRequest} updateTemplateRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public updateTemplate(organizationUnid: string, templateId: string, authorization: string, updateTemplateRequest: UpdateTemplateRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).updateTemplate(organizationUnid, templateId, authorization, updateTemplateRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {UseTemplateRequest} useTemplateRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public useTemplate(organizationUnid: string, templateId: string, authorization: string, useTemplateRequest: UseTemplateRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).useTemplate(organizationUnid, templateId, authorization, useTemplateRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadTemplatesApi
     */
    public useTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadTemplatesApiFp(this.configuration).useTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoadsApi - axios parameter creator
 * @export
 */
export const LoadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddStopRequest} addStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStop: async (loadId: string, organizationUnid: string, authorization: string, addStopRequest: AddStopRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('addStop', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addStop', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addStop', 'authorization', authorization)
            // verify required parameter 'addStopRequest' is not null or undefined
            assertParamExists('addStop', 'addStopRequest', addStopRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addStopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStopOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('addStopOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addStopOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AssignRequest} assignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign: async (loadId: string, organizationUnid: string, authorization: string, assignRequest: AssignRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('assign', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('assign', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assign', 'authorization', authorization)
            // verify required parameter 'assignRequest' is not null or undefined
            assertParamExists('assign', 'assignRequest', assignRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/assign`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('assignOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('assignOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/assign`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CloneLoadRequest} cloneLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneLoad: async (loadId: string, organizationUnid: string, authorization: string, cloneLoadRequest: CloneLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('cloneLoad', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('cloneLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cloneLoad', 'authorization', authorization)
            // verify required parameter 'cloneLoadRequest' is not null or undefined
            assertParamExists('cloneLoad', 'cloneLoadRequest', cloneLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/clone`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneLoadOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('cloneLoadOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('cloneLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/clone`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoad: async (organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createLoad', 'authorization', authorization)
            // verify required parameter 'createLoadRequest' is not null or undefined
            assertParamExists('createLoad', 'createLoadRequest', createLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadCheckCallRequest} createLoadCheckCallRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadCheckCall: async (loadId: string, organizationUnid: string, authorization: string, createLoadCheckCallRequest: CreateLoadCheckCallRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('createLoadCheckCall', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createLoadCheckCall', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createLoadCheckCall', 'authorization', authorization)
            // verify required parameter 'createLoadCheckCallRequest' is not null or undefined
            assertParamExists('createLoadCheckCall', 'createLoadCheckCallRequest', createLoadCheckCallRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/check-calls`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoadCheckCallRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoad: async (loadId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('deleteLoad', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteLoad', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('deleteLoadOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStop: async (loadId: string, organizationUnid: string, stopId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('deleteStop', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteStop', 'organizationUnid', organizationUnid)
            // verify required parameter 'stopId' is not null or undefined
            assertParamExists('deleteStop', 'stopId', stopId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteStop', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops/{stopId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"stopId"}}`, encodeURIComponent(String(stopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStopOptions: async (loadId: string, organizationUnid: string, stopId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('deleteStopOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteStopOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'stopId' is not null or undefined
            assertParamExists('deleteStopOptions', 'stopId', stopId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops/{stopId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"stopId"}}`, encodeURIComponent(String(stopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoad: async (loadId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getLoad', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoad', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (include) {
                localVarQueryParameter['include'] = include;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [source] 
         * @param {string | null} [userId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadHistory: async (loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, source?: string | null, userId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getLoadHistory', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoadHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/history`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadHistoryOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getLoadHistoryOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/history`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadLogs: async (loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getLoadLogs', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadLogs', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoadLogs', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/logs`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadLogsOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getLoadLogsOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadLogsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/logs`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadStats: async (organizationUnid: string, authorization: string, endDate?: string | null, startDate?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadStats', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoadStats', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadStatsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadStatsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} atTime 
         * @param {Array<string>} status 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadsAtStatus: async (organizationUnid: string, atTime: string, status: Array<string>, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadsAtStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'atTime' is not null or undefined
            assertParamExists('getLoadsAtStatus', 'atTime', atTime)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getLoadsAtStatus', 'status', status)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoadsAtStatus', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/status-query`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (atTime !== undefined) {
                localVarQueryParameter['at_time'] = atTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadsAtStatusOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLoadsAtStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/status-query`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMileageSourceOptions: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getMileageSourceOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMileageSourceOptions', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/mileage-sources`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMileageSourceOptionsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getMileageSourceOptionsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/mileage-sources`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousStopLoadOptions: async (loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getPreviousStopLoadOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPreviousStopLoadOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPreviousStopLoadOptions', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/previous-stop-options`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousStopLoadOptionsOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getPreviousStopLoadOptionsOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPreviousStopLoadOptionsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/previous-stop-options`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusTimeline: async (loadId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getStatusTimeline', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getStatusTimeline', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getStatusTimeline', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/status-timeline`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusTimelineOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getStatusTimelineOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getStatusTimelineOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/status-timeline`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadCheckCalls: async (loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadCheckCalls', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadCheckCalls', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listLoadCheckCalls', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/check-calls`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadCheckCallsOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadCheckCallsOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadCheckCallsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/check-calls`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadInvoices: async (loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadInvoices', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadInvoices', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listLoadInvoices', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/invoices`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeVoided !== undefined) {
                localVarQueryParameter['include_voided'] = includeVoided;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadInvoicesOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadInvoicesOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadInvoicesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/invoices`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadLocationHistory: async (loadId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadLocationHistory', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadLocationHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listLoadLocationHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/location-history`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadLocationHistoryOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadLocationHistoryOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadLocationHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/location-history`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadSettlements: async (loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadSettlements', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadSettlements', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listLoadSettlements', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/settlements`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeVoided !== undefined) {
                localVarQueryParameter['include_voided'] = includeVoided;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadSettlementsOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('listLoadSettlementsOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoadSettlementsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/settlements`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {string | null} [deliveryDateFrom] 
         * @param {string | null} [deliveryDateTo] 
         * @param {string | null} [destinationCity] 
         * @param {string | null} [destinationState] 
         * @param {string | null} [driverId] 
         * @param {Array<string>} [equipmentType] 
         * @param {boolean | null} [hasDriver] 
         * @param {boolean | null} [includeInAccounting] 
         * @param {number} [limit] 
         * @param {string | null} [originCity] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {string | null} [pickupDateFrom] 
         * @param {string | null} [pickupDateTo] 
         * @param {string | null} [search] 
         * @param {string | null} [sort] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoads: async (organizationUnid: string, authorization: string, customerId?: string | null, deliveryDateFrom?: string | null, deliveryDateTo?: string | null, destinationCity?: string | null, destinationState?: string | null, driverId?: string | null, equipmentType?: Array<string>, hasDriver?: boolean | null, includeInAccounting?: boolean | null, limit?: number, originCity?: string | null, originState?: string | null, page?: number, pickupDateFrom?: string | null, pickupDateTo?: string | null, search?: string | null, sort?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listLoads', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listLoads', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (deliveryDateFrom !== undefined) {
                localVarQueryParameter['delivery_date_from'] = deliveryDateFrom;
            }

            if (deliveryDateTo !== undefined) {
                localVarQueryParameter['delivery_date_to'] = deliveryDateTo;
            }

            if (destinationCity !== undefined) {
                localVarQueryParameter['destination_city'] = destinationCity;
            }

            if (destinationState !== undefined) {
                localVarQueryParameter['destination_state'] = destinationState;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (equipmentType) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (hasDriver !== undefined) {
                localVarQueryParameter['has_driver'] = hasDriver;
            }

            if (includeInAccounting !== undefined) {
                localVarQueryParameter['include_in_accounting'] = includeInAccounting;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (originCity !== undefined) {
                localVarQueryParameter['origin_city'] = originCity;
            }

            if (originState !== undefined) {
                localVarQueryParameter['origin_state'] = originState;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pickupDateFrom !== undefined) {
                localVarQueryParameter['pickup_date_from'] = pickupDateFrom;
            }

            if (pickupDateTo !== undefined) {
                localVarQueryParameter['pickup_date_to'] = pickupDateTo;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ReorderStopsRequest} reorderStopsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStops: async (loadId: string, organizationUnid: string, authorization: string, reorderStopsRequest: ReorderStopsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('reorderStops', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('reorderStops', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('reorderStops', 'authorization', authorization)
            // verify required parameter 'reorderStopsRequest' is not null or undefined
            assertParamExists('reorderStops', 'reorderStopsRequest', reorderStopsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops/reorder`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderStopsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStopsOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('reorderStopsOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('reorderStopsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops/reorder`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UnassignRequest} unassignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassign: async (loadId: string, organizationUnid: string, authorization: string, unassignRequest: UnassignRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('unassign', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('unassign', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('unassign', 'authorization', authorization)
            // verify required parameter 'unassignRequest' is not null or undefined
            assertParamExists('unassign', 'unassignRequest', unassignRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/unassign`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('unassignOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('unassignOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/unassign`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoad: async (loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('updateLoad', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateLoad', 'authorization', authorization)
            // verify required parameter 'updateLoadRequest' is not null or undefined
            assertParamExists('updateLoad', 'updateLoadRequest', updateLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadStatusRequest} updateLoadStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadStatus: async (loadId: string, organizationUnid: string, authorization: string, updateLoadStatusRequest: UpdateLoadStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('updateLoadStatus', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateLoadStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateLoadStatus', 'authorization', authorization)
            // verify required parameter 'updateLoadStatusRequest' is not null or undefined
            assertParamExists('updateLoadStatus', 'updateLoadStatusRequest', updateLoadStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/status`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoadStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadStatusOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('updateLoadStatusOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateLoadStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/status`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {UpdateStopRequest} updateStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStop: async (loadId: string, organizationUnid: string, stopId: string, authorization: string, updateStopRequest: UpdateStopRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('updateStop', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateStop', 'organizationUnid', organizationUnid)
            // verify required parameter 'stopId' is not null or undefined
            assertParamExists('updateStop', 'stopId', stopId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateStop', 'authorization', authorization)
            // verify required parameter 'updateStopRequest' is not null or undefined
            assertParamExists('updateStop', 'updateStopRequest', updateStopRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/stops/{stopId}`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"stopId"}}`, encodeURIComponent(String(stopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateLoad: async (organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validateCreateLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('validateCreateLoad', 'authorization', authorization)
            // verify required parameter 'createLoadRequest' is not null or undefined
            assertParamExists('validateCreateLoad', 'createLoadRequest', createLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/validate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateLoadOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validateCreateLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/validate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateLoad: async (loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('validateUpdateLoad', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validateUpdateLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('validateUpdateLoad', 'authorization', authorization)
            // verify required parameter 'updateLoadRequest' is not null or undefined
            assertParamExists('validateUpdateLoad', 'updateLoadRequest', updateLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/validate`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateLoadOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('validateUpdateLoadOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validateUpdateLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/validate`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoadsApi - functional programming interface
 * @export
 */
export const LoadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddStopRequest} addStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStop(loadId: string, organizationUnid: string, authorization: string, addStopRequest: AddStopRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStop(loadId, organizationUnid, authorization, addStopRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.addStop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStopOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStopOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.addStopOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AssignRequest} assignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assign(loadId: string, organizationUnid: string, authorization: string, assignRequest: AssignRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assign(loadId, organizationUnid, authorization, assignRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.assign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.assignOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CloneLoadRequest} cloneLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneLoad(loadId: string, organizationUnid: string, authorization: string, cloneLoadRequest: CloneLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneLoad(loadId, organizationUnid, authorization, cloneLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.cloneLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneLoadOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.cloneLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoad(organizationUnid, authorization, createLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.createLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadCheckCallRequest} createLoadCheckCallRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoadCheckCall(loadId: string, organizationUnid: string, authorization: string, createLoadCheckCallRequest: CreateLoadCheckCallRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadCheckCallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoadCheckCall(loadId, organizationUnid, authorization, createLoadCheckCallRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.createLoadCheckCall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoadOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.createLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLoad(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLoad(loadId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.deleteLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLoadOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.deleteLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStop(loadId, organizationUnid, stopId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.deleteStop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStopOptions(loadId: string, organizationUnid: string, stopId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStopOptions(loadId, organizationUnid, stopId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.deleteStopOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoad(loadId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoad(loadId, organizationUnid, authorization, include, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [source] 
         * @param {string | null} [userId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadHistory(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, source?: string | null, userId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadHistory(loadId, organizationUnid, authorization, eventType, limit, page, source, userId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadHistoryOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadLogs(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadLogs(loadId, organizationUnid, authorization, eventType, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadLogsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadLogsOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadLogsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadStats(organizationUnid: string, authorization: string, endDate?: string | null, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadStats(organizationUnid, authorization, endDate, startDate, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadStatsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadStatsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} atTime 
         * @param {Array<string>} status 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadsAtStatus(organizationUnid: string, atTime: string, status: Array<string>, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadStatusQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadsAtStatus(organizationUnid, atTime, status, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadsAtStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoadsAtStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoadsAtStatusOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getLoadsAtStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMileageSourceOptions(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMileageSourceOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMileageSourceOptions(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getMileageSourceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMileageSourceOptionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMileageSourceOptionsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getMileageSourceOptionsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreviousStopLoadOptions(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPreviousStopLoadOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreviousStopLoadOptions(loadId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getPreviousStopLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreviousStopLoadOptionsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreviousStopLoadOptionsOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getPreviousStopLoadOptionsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusTimeline(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadStatusTimelineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatusTimeline(loadId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getStatusTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatusTimelineOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatusTimelineOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.getStatusTimelineOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadCheckCalls(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadCheckCallListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadCheckCalls(loadId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadCheckCalls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadCheckCallsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadCheckCallsOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadCheckCallsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadInvoices(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadInvoiceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadInvoices(loadId, organizationUnid, authorization, includeVoided, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadInvoicesOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadInvoicesOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadInvoicesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadLocationHistory(loadId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadLocationHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadLocationHistory(loadId, organizationUnid, authorization, from, limit, page, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadLocationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadLocationHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadLocationHistoryOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadLocationHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadSettlements(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSettlementListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadSettlements(loadId, organizationUnid, authorization, includeVoided, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoadSettlementsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoadSettlementsOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoadSettlementsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {string | null} [deliveryDateFrom] 
         * @param {string | null} [deliveryDateTo] 
         * @param {string | null} [destinationCity] 
         * @param {string | null} [destinationState] 
         * @param {string | null} [driverId] 
         * @param {Array<string>} [equipmentType] 
         * @param {boolean | null} [hasDriver] 
         * @param {boolean | null} [includeInAccounting] 
         * @param {number} [limit] 
         * @param {string | null} [originCity] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {string | null} [pickupDateFrom] 
         * @param {string | null} [pickupDateTo] 
         * @param {string | null} [search] 
         * @param {string | null} [sort] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoads(organizationUnid: string, authorization: string, customerId?: string | null, deliveryDateFrom?: string | null, deliveryDateTo?: string | null, destinationCity?: string | null, destinationState?: string | null, driverId?: string | null, equipmentType?: Array<string>, hasDriver?: boolean | null, includeInAccounting?: boolean | null, limit?: number, originCity?: string | null, originState?: string | null, page?: number, pickupDateFrom?: string | null, pickupDateTo?: string | null, search?: string | null, sort?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoads(organizationUnid, authorization, customerId, deliveryDateFrom, deliveryDateTo, destinationCity, destinationState, driverId, equipmentType, hasDriver, includeInAccounting, limit, originCity, originState, page, pickupDateFrom, pickupDateTo, search, sort, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.listLoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ReorderStopsRequest} reorderStopsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderStops(loadId: string, organizationUnid: string, authorization: string, reorderStopsRequest: ReorderStopsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderStops(loadId, organizationUnid, authorization, reorderStopsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.reorderStops']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderStopsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderStopsOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.reorderStopsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UnassignRequest} unassignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassign(loadId: string, organizationUnid: string, authorization: string, unassignRequest: UnassignRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassign(loadId, organizationUnid, authorization, unassignRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.unassign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.unassignOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.updateLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadStatusRequest} updateLoadStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoadStatus(loadId: string, organizationUnid: string, authorization: string, updateLoadStatusRequest: UpdateLoadStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoadStatus(loadId, organizationUnid, authorization, updateLoadStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.updateLoadStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoadStatusOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoadStatusOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.updateLoadStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {UpdateStopRequest} updateStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, updateStopRequest: UpdateStopRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStop(loadId, organizationUnid, stopId, authorization, updateStopRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.updateStop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCreateLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesValidateLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCreateLoad(organizationUnid, authorization, createLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.validateCreateLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCreateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCreateLoadOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.validateCreateLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateUpdateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesValidateLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateUpdateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.validateUpdateLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateUpdateLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateUpdateLoadOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoadsApi.validateUpdateLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoadsApi - factory interface
 * @export
 */
export const LoadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoadsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddStopRequest} addStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStop(loadId: string, organizationUnid: string, authorization: string, addStopRequest: AddStopRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.addStop(loadId, organizationUnid, authorization, addStopRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStopOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addStopOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AssignRequest} assignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign(loadId: string, organizationUnid: string, authorization: string, assignRequest: AssignRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.assign(loadId, organizationUnid, authorization, assignRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.assignOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CloneLoadRequest} cloneLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneLoad(loadId: string, organizationUnid: string, authorization: string, cloneLoadRequest: CloneLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.cloneLoad(loadId, organizationUnid, authorization, cloneLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.cloneLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.createLoad(organizationUnid, authorization, createLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadCheckCallRequest} createLoadCheckCallRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadCheckCall(loadId: string, organizationUnid: string, authorization: string, createLoadCheckCallRequest: CreateLoadCheckCallRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadCheckCallResponse> {
            return localVarFp.createLoadCheckCall(loadId, organizationUnid, authorization, createLoadCheckCallRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createLoadOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoad(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteLoad(loadId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.deleteStop(loadId, organizationUnid, stopId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStopOptions(loadId: string, organizationUnid: string, stopId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteStopOptions(loadId, organizationUnid, stopId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {Array<string>} [include] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoad(loadId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.getLoad(loadId, organizationUnid, authorization, include, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [source] 
         * @param {string | null} [userId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadHistory(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, source?: string | null, userId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadHistoryResponse> {
            return localVarFp.getLoadHistory(loadId, organizationUnid, authorization, eventType, limit, page, source, userId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getLoadHistoryOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadLogs(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadLogsResponse> {
            return localVarFp.getLoadLogs(loadId, organizationUnid, authorization, eventType, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadLogsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getLoadLogsOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [endDate] 
         * @param {string | null} [startDate] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadStats(organizationUnid: string, authorization: string, endDate?: string | null, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadStatsResponse> {
            return localVarFp.getLoadStats(organizationUnid, authorization, endDate, startDate, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getLoadStatsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} atTime 
         * @param {Array<string>} status 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadsAtStatus(organizationUnid: string, atTime: string, status: Array<string>, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadStatusQueryResponse> {
            return localVarFp.getLoadsAtStatus(organizationUnid, atTime, status, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoadsAtStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getLoadsAtStatusOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMileageSourceOptions(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMileageSourceOptionsResponse> {
            return localVarFp.getMileageSourceOptions(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMileageSourceOptionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getMileageSourceOptionsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousStopLoadOptions(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPreviousStopLoadOptionsResponse> {
            return localVarFp.getPreviousStopLoadOptions(loadId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousStopLoadOptionsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPreviousStopLoadOptionsOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusTimeline(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadStatusTimelineResponse> {
            return localVarFp.getStatusTimeline(loadId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusTimelineOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getStatusTimelineOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadCheckCalls(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadCheckCallListResponse> {
            return localVarFp.listLoadCheckCalls(loadId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadCheckCallsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listLoadCheckCallsOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadInvoices(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadInvoiceListResponse> {
            return localVarFp.listLoadInvoices(loadId, organizationUnid, authorization, includeVoided, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadInvoicesOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listLoadInvoicesOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadLocationHistory(loadId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadLocationHistoryResponse> {
            return localVarFp.listLoadLocationHistory(loadId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadLocationHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listLoadLocationHistoryOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [includeVoided] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadSettlements(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSettlementListResponse> {
            return localVarFp.listLoadSettlements(loadId, organizationUnid, authorization, includeVoided, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoadSettlementsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listLoadSettlementsOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {string | null} [deliveryDateFrom] 
         * @param {string | null} [deliveryDateTo] 
         * @param {string | null} [destinationCity] 
         * @param {string | null} [destinationState] 
         * @param {string | null} [driverId] 
         * @param {Array<string>} [equipmentType] 
         * @param {boolean | null} [hasDriver] 
         * @param {boolean | null} [includeInAccounting] 
         * @param {number} [limit] 
         * @param {string | null} [originCity] 
         * @param {string | null} [originState] 
         * @param {number} [page] 
         * @param {string | null} [pickupDateFrom] 
         * @param {string | null} [pickupDateTo] 
         * @param {string | null} [search] 
         * @param {string | null} [sort] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoads(organizationUnid: string, authorization: string, customerId?: string | null, deliveryDateFrom?: string | null, deliveryDateTo?: string | null, destinationCity?: string | null, destinationState?: string | null, driverId?: string | null, equipmentType?: Array<string>, hasDriver?: boolean | null, includeInAccounting?: boolean | null, limit?: number, originCity?: string | null, originState?: string | null, page?: number, pickupDateFrom?: string | null, pickupDateTo?: string | null, search?: string | null, sort?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadListResponse> {
            return localVarFp.listLoads(organizationUnid, authorization, customerId, deliveryDateFrom, deliveryDateTo, destinationCity, destinationState, driverId, equipmentType, hasDriver, includeInAccounting, limit, originCity, originState, page, pickupDateFrom, pickupDateTo, search, sort, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ReorderStopsRequest} reorderStopsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStops(loadId: string, organizationUnid: string, authorization: string, reorderStopsRequest: ReorderStopsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.reorderStops(loadId, organizationUnid, authorization, reorderStopsRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStopsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.reorderStopsOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UnassignRequest} unassignRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassign(loadId: string, organizationUnid: string, authorization: string, unassignRequest: UnassignRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.unassign(loadId, organizationUnid, authorization, unassignRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.unassignOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.updateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadStatusRequest} updateLoadStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadStatus(loadId: string, organizationUnid: string, authorization: string, updateLoadStatusRequest: UpdateLoadStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.updateLoadStatus(loadId, organizationUnid, authorization, updateLoadStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoadStatusOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateLoadStatusOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} stopId 
         * @param {string} authorization 
         * @param {UpdateStopRequest} updateStopRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, updateStopRequest: UpdateStopRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.updateStop(loadId, organizationUnid, stopId, authorization, updateStopRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateLoadRequest} createLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesValidateLoadResponse> {
            return localVarFp.validateCreateLoad(organizationUnid, authorization, createLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCreateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.validateCreateLoadOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateLoadRequest} updateLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesValidateLoadResponse> {
            return localVarFp.validateUpdateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUpdateLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.validateUpdateLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoadsApi - object-oriented interface
 * @export
 * @class LoadsApi
 * @extends {BaseAPI}
 */
export class LoadsApi extends BaseAPI {
    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AddStopRequest} addStopRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public addStop(loadId: string, organizationUnid: string, authorization: string, addStopRequest: AddStopRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).addStop(loadId, organizationUnid, authorization, addStopRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public addStopOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).addStopOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AssignRequest} assignRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public assign(loadId: string, organizationUnid: string, authorization: string, assignRequest: AssignRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).assign(loadId, organizationUnid, authorization, assignRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public assignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).assignOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CloneLoadRequest} cloneLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public cloneLoad(loadId: string, organizationUnid: string, authorization: string, cloneLoadRequest: CloneLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).cloneLoad(loadId, organizationUnid, authorization, cloneLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public cloneLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).cloneLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateLoadRequest} createLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public createLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).createLoad(organizationUnid, authorization, createLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateLoadCheckCallRequest} createLoadCheckCallRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public createLoadCheckCall(loadId: string, organizationUnid: string, authorization: string, createLoadCheckCallRequest: CreateLoadCheckCallRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).createLoadCheckCall(loadId, organizationUnid, authorization, createLoadCheckCallRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public createLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).createLoadOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public deleteLoad(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).deleteLoad(loadId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public deleteLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).deleteLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} stopId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public deleteStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).deleteStop(loadId, organizationUnid, stopId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} stopId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public deleteStopOptions(loadId: string, organizationUnid: string, stopId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).deleteStopOptions(loadId, organizationUnid, stopId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {Array<string>} [include] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoad(loadId: string, organizationUnid: string, authorization: string, include?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoad(loadId, organizationUnid, authorization, include, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [eventType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [source] 
     * @param {string | null} [userId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadHistory(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, source?: string | null, userId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadHistory(loadId, organizationUnid, authorization, eventType, limit, page, source, userId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadHistoryOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [eventType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadLogs(loadId: string, organizationUnid: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadLogs(loadId, organizationUnid, authorization, eventType, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadLogsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadLogsOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [endDate] 
     * @param {string | null} [startDate] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadStats(organizationUnid: string, authorization: string, endDate?: string | null, startDate?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadStats(organizationUnid, authorization, endDate, startDate, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadStatsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} atTime 
     * @param {Array<string>} status 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadsAtStatus(organizationUnid: string, atTime: string, status: Array<string>, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadsAtStatus(organizationUnid, atTime, status, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getLoadsAtStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getLoadsAtStatusOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getMileageSourceOptions(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getMileageSourceOptions(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getMileageSourceOptionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getMileageSourceOptionsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getPreviousStopLoadOptions(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getPreviousStopLoadOptions(loadId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getPreviousStopLoadOptionsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getPreviousStopLoadOptionsOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getStatusTimeline(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getStatusTimeline(loadId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public getStatusTimelineOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).getStatusTimelineOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadCheckCalls(loadId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadCheckCalls(loadId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadCheckCallsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadCheckCallsOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [includeVoided] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadInvoices(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadInvoices(loadId, organizationUnid, authorization, includeVoided, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadInvoicesOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadInvoicesOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadLocationHistory(loadId: string, organizationUnid: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadLocationHistory(loadId, organizationUnid, authorization, from, limit, page, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadLocationHistoryOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadLocationHistoryOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [includeVoided] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadSettlements(loadId: string, organizationUnid: string, authorization: string, includeVoided?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadSettlements(loadId, organizationUnid, authorization, includeVoided, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoadSettlementsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoadSettlementsOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [customerId] 
     * @param {string | null} [deliveryDateFrom] 
     * @param {string | null} [deliveryDateTo] 
     * @param {string | null} [destinationCity] 
     * @param {string | null} [destinationState] 
     * @param {string | null} [driverId] 
     * @param {Array<string>} [equipmentType] 
     * @param {boolean | null} [hasDriver] 
     * @param {boolean | null} [includeInAccounting] 
     * @param {number} [limit] 
     * @param {string | null} [originCity] 
     * @param {string | null} [originState] 
     * @param {number} [page] 
     * @param {string | null} [pickupDateFrom] 
     * @param {string | null} [pickupDateTo] 
     * @param {string | null} [search] 
     * @param {string | null} [sort] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public listLoads(organizationUnid: string, authorization: string, customerId?: string | null, deliveryDateFrom?: string | null, deliveryDateTo?: string | null, destinationCity?: string | null, destinationState?: string | null, driverId?: string | null, equipmentType?: Array<string>, hasDriver?: boolean | null, includeInAccounting?: boolean | null, limit?: number, originCity?: string | null, originState?: string | null, page?: number, pickupDateFrom?: string | null, pickupDateTo?: string | null, search?: string | null, sort?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).listLoads(organizationUnid, authorization, customerId, deliveryDateFrom, deliveryDateTo, destinationCity, destinationState, driverId, equipmentType, hasDriver, includeInAccounting, limit, originCity, originState, page, pickupDateFrom, pickupDateTo, search, sort, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ReorderStopsRequest} reorderStopsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public reorderStops(loadId: string, organizationUnid: string, authorization: string, reorderStopsRequest: ReorderStopsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).reorderStops(loadId, organizationUnid, authorization, reorderStopsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public reorderStopsOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).reorderStopsOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UnassignRequest} unassignRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public unassign(loadId: string, organizationUnid: string, authorization: string, unassignRequest: UnassignRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).unassign(loadId, organizationUnid, authorization, unassignRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public unassignOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).unassignOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateLoadRequest} updateLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public updateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).updateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateLoadStatusRequest} updateLoadStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public updateLoadStatus(loadId: string, organizationUnid: string, authorization: string, updateLoadStatusRequest: UpdateLoadStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).updateLoadStatus(loadId, organizationUnid, authorization, updateLoadStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public updateLoadStatusOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).updateLoadStatusOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} stopId 
     * @param {string} authorization 
     * @param {UpdateStopRequest} updateStopRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public updateStop(loadId: string, organizationUnid: string, stopId: string, authorization: string, updateStopRequest: UpdateStopRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).updateStop(loadId, organizationUnid, stopId, authorization, updateStopRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateLoadRequest} createLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public validateCreateLoad(organizationUnid: string, authorization: string, createLoadRequest: CreateLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).validateCreateLoad(organizationUnid, authorization, createLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public validateCreateLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).validateCreateLoadOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateLoadRequest} updateLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public validateUpdateLoad(loadId: string, organizationUnid: string, authorization: string, updateLoadRequest: UpdateLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).validateUpdateLoad(loadId, organizationUnid, authorization, updateLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadsApi
     */
    public validateUpdateLoadOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return LoadsApiFp(this.configuration).validateUpdateLoadOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaintenanceApi - axios parameter creator
 * @export
 */
export const MaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMaintenanceRequest} createMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenance: async (organizationUnid: string, authorization: string, createMaintenanceRequest: CreateMaintenanceRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createMaintenance', 'authorization', authorization)
            // verify required parameter 'createMaintenanceRequest' is not null or undefined
            assertParamExists('createMaintenance', 'createMaintenanceRequest', createMaintenanceRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMaintenanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createMaintenanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromMaintenanceRequest} createWorkOrderFromMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromMaintenance: async (maintenanceId: string, organizationUnid: string, authorization: string, createWorkOrderFromMaintenanceRequest: CreateWorkOrderFromMaintenanceRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenance', 'authorization', authorization)
            // verify required parameter 'createWorkOrderFromMaintenanceRequest' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenance', 'createWorkOrderFromMaintenanceRequest', createWorkOrderFromMaintenanceRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/{maintenanceId}/create-work-order`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderFromMaintenanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromMaintenanceOptions: async (maintenanceId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenanceOptions', 'maintenanceId', maintenanceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderFromMaintenanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/{maintenanceId}/create-work-order`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenance: async (maintenanceId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('getMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMaintenance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [days] 
         * @param {boolean | null} [includeOverdue] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingMaintenance: async (organizationUnid: string, authorization: string, days?: number, includeOverdue?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getUpcomingMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUpcomingMaintenance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/upcoming`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (includeOverdue !== undefined) {
                localVarQueryParameter['include_overdue'] = includeOverdue;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingMaintenanceOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getUpcomingMaintenanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/upcoming`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {boolean | null} [unresolvedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionableInspections: async (organizationUnid: string, authorization: string, limit?: number, page?: number, result?: string | null, unresolvedOnly?: boolean | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listActionableInspections', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listActionableInspections', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (unresolvedOnly !== undefined) {
                localVarQueryParameter['unresolved_only'] = unresolvedOnly;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionableInspectionsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listActionableInspectionsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {boolean | null} [hasDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspectionHistory: async (organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, hasDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listInspectionHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listInspectionHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections/history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (hasDefects !== undefined) {
                localVarQueryParameter['has_defects'] = hasDefects;
            }

            if (inspectionType !== undefined) {
                localVarQueryParameter['inspection_type'] = inspectionType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (trailerId !== undefined) {
                localVarQueryParameter['trailer_id'] = trailerId;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspectionHistoryOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listInspectionHistoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/inspections/history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [maintenanceType] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaintenance: async (organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, maintenanceType?: string | null, page?: number, status?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listMaintenance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (equipmentId !== undefined) {
                localVarQueryParameter['equipment_id'] = equipmentId;
            }

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (maintenanceType !== undefined) {
                localVarQueryParameter['maintenance_type'] = maintenanceType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMaintenanceRequest} updateMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenance: async (maintenanceId: string, organizationUnid: string, authorization: string, updateMaintenanceRequest: UpdateMaintenanceRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('updateMaintenance', 'maintenanceId', maintenanceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateMaintenance', 'authorization', authorization)
            // verify required parameter 'updateMaintenanceRequest' is not null or undefined
            assertParamExists('updateMaintenance', 'updateMaintenanceRequest', updateMaintenanceRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaintenanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceOptions: async (maintenanceId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceId' is not null or undefined
            assertParamExists('updateMaintenanceOptions', 'maintenanceId', maintenanceId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateMaintenanceOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/{maintenanceId}`
                .replace(`{${"maintenanceId"}}`, encodeURIComponent(String(maintenanceId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceApi - functional programming interface
 * @export
 */
export const MaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMaintenanceRequest} createMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaintenance(organizationUnid: string, authorization: string, createMaintenanceRequest: CreateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaintenance(organizationUnid, authorization, createMaintenanceRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.createMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaintenanceOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.createMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromMaintenanceRequest} createWorkOrderFromMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderFromMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, createWorkOrderFromMaintenanceRequest: CreateWorkOrderFromMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderFromMaintenance(maintenanceId, organizationUnid, authorization, createWorkOrderFromMaintenanceRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.createWorkOrderFromMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderFromMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderFromMaintenanceOptions(maintenanceId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.createWorkOrderFromMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenance(maintenanceId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.getMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [days] 
         * @param {boolean | null} [includeOverdue] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingMaintenance(organizationUnid: string, authorization: string, days?: number, includeOverdue?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUpcomingMaintenanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpcomingMaintenance(organizationUnid, authorization, days, includeOverdue, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.getUpcomingMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpcomingMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpcomingMaintenanceOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.getUpcomingMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {boolean | null} [unresolvedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActionableInspections(organizationUnid: string, authorization: string, limit?: number, page?: number, result?: string | null, unresolvedOnly?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInspectionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActionableInspections(organizationUnid, authorization, limit, page, result, unresolvedOnly, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.listActionableInspections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActionableInspectionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActionableInspectionsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.listActionableInspectionsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {boolean | null} [hasDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInspectionHistory(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, hasDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInspectionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInspectionHistory(organizationUnid, authorization, dateFrom, dateTo, hasDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.listInspectionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInspectionHistoryOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInspectionHistoryOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.listInspectionHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [maintenanceType] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMaintenance(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, maintenanceType?: string | null, page?: number, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMaintenance(organizationUnid, authorization, dateFrom, dateTo, equipmentId, equipmentType, limit, maintenanceType, page, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.listMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMaintenanceRequest} updateMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, updateMaintenanceRequest: UpdateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaintenance(maintenanceId, organizationUnid, authorization, updateMaintenanceRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.updateMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMaintenanceOptions(maintenanceId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceApi.updateMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaintenanceApi - factory interface
 * @export
 */
export const MaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMaintenanceRequest} createMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenance(organizationUnid: string, authorization: string, createMaintenanceRequest: CreateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceResponse> {
            return localVarFp.createMaintenance(organizationUnid, authorization, createMaintenanceRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createMaintenanceOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderFromMaintenanceRequest} createWorkOrderFromMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, createWorkOrderFromMaintenanceRequest: CreateWorkOrderFromMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceResponse> {
            return localVarFp.createWorkOrderFromMaintenance(maintenanceId, organizationUnid, authorization, createWorkOrderFromMaintenanceRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderFromMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createWorkOrderFromMaintenanceOptions(maintenanceId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceResponse> {
            return localVarFp.getMaintenance(maintenanceId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [days] 
         * @param {boolean | null} [includeOverdue] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingMaintenance(organizationUnid: string, authorization: string, days?: number, includeOverdue?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUpcomingMaintenanceResponse> {
            return localVarFp.getUpcomingMaintenance(organizationUnid, authorization, days, includeOverdue, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpcomingMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getUpcomingMaintenanceOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {boolean | null} [unresolvedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionableInspections(organizationUnid: string, authorization: string, limit?: number, page?: number, result?: string | null, unresolvedOnly?: boolean | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInspectionListResponse> {
            return localVarFp.listActionableInspections(organizationUnid, authorization, limit, page, result, unresolvedOnly, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActionableInspectionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listActionableInspectionsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {boolean | null} [hasDefects] 
         * @param {string | null} [inspectionType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [result] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspectionHistory(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, hasDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInspectionListResponse> {
            return localVarFp.listInspectionHistory(organizationUnid, authorization, dateFrom, dateTo, hasDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspectionHistoryOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listInspectionHistoryOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {string | null} [maintenanceType] 
         * @param {number} [page] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaintenance(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, maintenanceType?: string | null, page?: number, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceListResponse> {
            return localVarFp.listMaintenance(organizationUnid, authorization, dateFrom, dateTo, equipmentId, equipmentType, limit, maintenanceType, page, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMaintenanceRequest} updateMaintenanceRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, updateMaintenanceRequest: UpdateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceResponse> {
            return localVarFp.updateMaintenance(maintenanceId, organizationUnid, authorization, updateMaintenanceRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} maintenanceId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateMaintenanceOptions(maintenanceId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceApi - object-oriented interface
 * @export
 * @class MaintenanceApi
 * @extends {BaseAPI}
 */
export class MaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateMaintenanceRequest} createMaintenanceRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public createMaintenance(organizationUnid: string, authorization: string, createMaintenanceRequest: CreateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).createMaintenance(organizationUnid, authorization, createMaintenanceRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public createMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).createMaintenanceOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} maintenanceId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateWorkOrderFromMaintenanceRequest} createWorkOrderFromMaintenanceRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public createWorkOrderFromMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, createWorkOrderFromMaintenanceRequest: CreateWorkOrderFromMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).createWorkOrderFromMaintenance(maintenanceId, organizationUnid, authorization, createWorkOrderFromMaintenanceRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} maintenanceId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public createWorkOrderFromMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).createWorkOrderFromMaintenanceOptions(maintenanceId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} maintenanceId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public getMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).getMaintenance(maintenanceId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [days] 
     * @param {boolean | null} [includeOverdue] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public getUpcomingMaintenance(organizationUnid: string, authorization: string, days?: number, includeOverdue?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).getUpcomingMaintenance(organizationUnid, authorization, days, includeOverdue, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public getUpcomingMaintenanceOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).getUpcomingMaintenanceOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [result] 
     * @param {boolean | null} [unresolvedOnly] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public listActionableInspections(organizationUnid: string, authorization: string, limit?: number, page?: number, result?: string | null, unresolvedOnly?: boolean | null, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).listActionableInspections(organizationUnid, authorization, limit, page, result, unresolvedOnly, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public listActionableInspectionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).listActionableInspectionsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {boolean | null} [hasDefects] 
     * @param {string | null} [inspectionType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [result] 
     * @param {string | null} [trailerId] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public listInspectionHistory(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, hasDefects?: boolean | null, inspectionType?: string | null, limit?: number, page?: number, result?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).listInspectionHistory(organizationUnid, authorization, dateFrom, dateTo, hasDefects, inspectionType, limit, page, result, trailerId, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public listInspectionHistoryOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).listInspectionHistoryOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {string | null} [equipmentId] 
     * @param {string | null} [equipmentType] 
     * @param {number} [limit] 
     * @param {string | null} [maintenanceType] 
     * @param {number} [page] 
     * @param {string | null} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public listMaintenance(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, maintenanceType?: string | null, page?: number, status?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).listMaintenance(organizationUnid, authorization, dateFrom, dateTo, equipmentId, equipmentType, limit, maintenanceType, page, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} maintenanceId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateMaintenanceRequest} updateMaintenanceRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public updateMaintenance(maintenanceId: string, organizationUnid: string, authorization: string, updateMaintenanceRequest: UpdateMaintenanceRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).updateMaintenance(maintenanceId, organizationUnid, authorization, updateMaintenanceRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} maintenanceId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public updateMaintenanceOptions(maintenanceId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).updateMaintenanceOptions(maintenanceId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MaintenanceFleetApi - axios parameter creator
 * @export
 */
export const MaintenanceFleetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasOverdue] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceFleet: async (equipmentType: string, organizationUnid: string, authorization: string, hasOverdue?: boolean | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('getMaintenanceFleet', 'equipmentType', equipmentType)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getMaintenanceFleet', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMaintenanceFleet', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/fleet/{equipmentType}`
                .replace(`{${"equipmentType"}}`, encodeURIComponent(String(equipmentType)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hasOverdue !== undefined) {
                localVarQueryParameter['has_overdue'] = hasOverdue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceFleetOptions: async (equipmentType: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentType' is not null or undefined
            assertParamExists('getMaintenanceFleetOptions', 'equipmentType', equipmentType)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getMaintenanceFleetOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/fleet/{equipmentType}`
                .replace(`{${"equipmentType"}}`, encodeURIComponent(String(equipmentType)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceFleetApi - functional programming interface
 * @export
 */
export const MaintenanceFleetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceFleetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasOverdue] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceFleet(equipmentType: string, organizationUnid: string, authorization: string, hasOverdue?: boolean | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceFleetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceFleet(equipmentType, organizationUnid, authorization, hasOverdue, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceFleetApi.getMaintenanceFleet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceFleetOptions(equipmentType: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceFleetOptions(equipmentType, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MaintenanceFleetApi.getMaintenanceFleetOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MaintenanceFleetApi - factory interface
 * @export
 */
export const MaintenanceFleetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceFleetApiFp(configuration)
    return {
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasOverdue] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceFleet(equipmentType: string, organizationUnid: string, authorization: string, hasOverdue?: boolean | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceFleetResponse> {
            return localVarFp.getMaintenanceFleet(equipmentType, organizationUnid, authorization, hasOverdue, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentType 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceFleetOptions(equipmentType: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getMaintenanceFleetOptions(equipmentType, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceFleetApi - object-oriented interface
 * @export
 * @class MaintenanceFleetApi
 * @extends {BaseAPI}
 */
export class MaintenanceFleetApi extends BaseAPI {
    /**
     * 
     * @param {string} equipmentType 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [hasOverdue] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceFleetApi
     */
    public getMaintenanceFleet(equipmentType: string, organizationUnid: string, authorization: string, hasOverdue?: boolean | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceFleetApiFp(this.configuration).getMaintenanceFleet(equipmentType, organizationUnid, authorization, hasOverdue, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentType 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceFleetApi
     */
    public getMaintenanceFleetOptions(equipmentType: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MaintenanceFleetApiFp(this.configuration).getMaintenanceFleetOptions(equipmentType, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MileageApi - axios parameter creator
 * @export
 */
export const MileageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute: async (loadId: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getRoute', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRoute', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRoute', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/mileage/route`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteOptions: async (loadId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadId' is not null or undefined
            assertParamExists('getRouteOptions', 'loadId', loadId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRouteOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/{loadId}/mileage/route`
                .replace(`{${"loadId"}}`, encodeURIComponent(String(loadId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MileageApi - functional programming interface
 * @export
 */
export const MileageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MileageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoute(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRouteCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoute(loadId, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MileageApi.getRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRouteOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRouteOptions(loadId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MileageApi.getRouteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MileageApi - factory interface
 * @export
 */
export const MileageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MileageApiFp(configuration)
    return {
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoute(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRouteCalculationResponse> {
            return localVarFp.getRoute(loadId, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} loadId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRouteOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getRouteOptions(loadId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MileageApi - object-oriented interface
 * @export
 * @class MileageApi
 * @extends {BaseAPI}
 */
export class MileageApi extends BaseAPI {
    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MileageApi
     */
    public getRoute(loadId: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MileageApiFp(this.configuration).getRoute(loadId, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} loadId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MileageApi
     */
    public getRouteOptions(loadId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return MileageApiFp(this.configuration).getRouteOptions(loadId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (token: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('acceptInvitation', 'token', token)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('acceptInvitation', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('acceptInvitation', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/invitations/{token}/accept`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitationOptions: async (token: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('acceptInvitationOptions', 'token', token)
            const localVarPath = `/api/v1/organizations/invitations/{token}/accept`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddMemberRequest} addMemberRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMember: async (organizationUnid: string, authorization: string, addMemberRequest: AddMemberRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addMember', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addMember', 'authorization', authorization)
            // verify required parameter 'addMemberRequest' is not null or undefined
            assertParamExists('addMember', 'addMemberRequest', addMemberRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMemberOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addMemberOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation: async (organizationUnid: string, authorization: string, createInvitationRequest: CreateInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createInvitation', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createInvitation', 'authorization', authorization)
            // verify required parameter 'createInvitationRequest' is not null or undefined
            assertParamExists('createInvitation', 'createInvitationRequest', createInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitationOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createInvitationOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (authorization: string, createOrganizationRequest: CreateOrganizationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createOrganization', 'authorization', authorization)
            // verify required parameter 'createOrganizationRequest' is not null or undefined
            assertParamExists('createOrganization', 'createOrganizationRequest', createOrganizationRequest)
            const localVarPath = `/api/v1/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation: async (invitationUnid: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUnid' is not null or undefined
            assertParamExists('deleteInvitation', 'invitationUnid', invitationUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteInvitation', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteInvitation', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations/{invitationUnid}`
                .replace(`{${"invitationUnid"}}`, encodeURIComponent(String(invitationUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitationOptions: async (invitationUnid: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUnid' is not null or undefined
            assertParamExists('deleteInvitationOptions', 'invitationUnid', invitationUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteInvitationOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations/{invitationUnid}`
                .replace(`{${"invitationUnid"}}`, encodeURIComponent(String(invitationUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteOrganization', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteOrganization', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteOrganizationOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations: async (authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyInvitations', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/invitations/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitationsOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/organizations/invitations/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganization', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOrganization', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLogoUploadUrl: async (organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationLogoUploadUrl', 'organizationUnid', organizationUnid)
            // verify required parameter 'fileExtension' is not null or undefined
            assertParamExists('getOrganizationLogoUploadUrl', 'fileExtension', fileExtension)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOrganizationLogoUploadUrl', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/logo/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileExtension !== undefined) {
                localVarQueryParameter['fileExtension'] = fileExtension;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLogoUploadUrlOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationLogoUploadUrlOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/logo/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMembers: async (organizationUnid: string, authorization: string, page?: number, pageSize?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationMembers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOrganizationMembers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSocialMediaPreviewUploadUrl: async (organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationSocialMediaPreviewUploadUrl', 'organizationUnid', organizationUnid)
            // verify required parameter 'fileExtension' is not null or undefined
            assertParamExists('getOrganizationSocialMediaPreviewUploadUrl', 'fileExtension', fileExtension)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOrganizationSocialMediaPreviewUploadUrl', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/social-media-preview/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileExtension !== undefined) {
                localVarQueryParameter['fileExtension'] = fileExtension;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSocialMediaPreviewUploadUrlOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationSocialMediaPreviewUploadUrlOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/social-media-preview/upload-url`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSubscription: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationSubscription', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOrganizationSubscription', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/subscription`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSubscriptionOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getOrganizationSubscriptionOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/subscription`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: async (organizationUnid: string, userUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeMember', 'organizationUnid', organizationUnid)
            // verify required parameter 'userUnid' is not null or undefined
            assertParamExists('removeMember', 'userUnid', userUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('removeMember', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members/{userUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"userUnid"}}`, encodeURIComponent(String(userUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMemberOptions: async (organizationUnid: string, userUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeMemberOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'userUnid' is not null or undefined
            assertParamExists('removeMemberOptions', 'userUnid', userUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members/{userUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"userUnid"}}`, encodeURIComponent(String(userUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation: async (invitationUnid: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUnid' is not null or undefined
            assertParamExists('resendInvitation', 'invitationUnid', invitationUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resendInvitation', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resendInvitation', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('resendInvitation', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations/{invitationUnid}/resend`
                .replace(`{${"invitationUnid"}}`, encodeURIComponent(String(invitationUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitationOptions: async (invitationUnid: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationUnid' is not null or undefined
            assertParamExists('resendInvitationOptions', 'invitationUnid', invitationUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resendInvitationOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/invitations/{invitationUnid}/resend`
                .replace(`{${"invitationUnid"}}`, encodeURIComponent(String(invitationUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {UpdateMemberRolesRequest} updateMemberRolesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRoles: async (organizationUnid: string, userUnid: string, authorization: string, updateMemberRolesRequest: UpdateMemberRolesRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateMemberRoles', 'organizationUnid', organizationUnid)
            // verify required parameter 'userUnid' is not null or undefined
            assertParamExists('updateMemberRoles', 'userUnid', userUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateMemberRoles', 'authorization', authorization)
            // verify required parameter 'updateMemberRolesRequest' is not null or undefined
            assertParamExists('updateMemberRoles', 'updateMemberRolesRequest', updateMemberRolesRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/members/{userUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"userUnid"}}`, encodeURIComponent(String(userUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberRolesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (organizationUnid: string, authorization: string, updateOrganizationRequest: UpdateOrganizationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateOrganization', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateOrganization', 'authorization', authorization)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganization', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(token: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(token, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.acceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitationOptions(token: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitationOptions(token, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.acceptInvitationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddMemberRequest} addMemberRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMember(organizationUnid: string, authorization: string, addMemberRequest: AddMemberRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMember(organizationUnid, authorization, addMemberRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.addMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMemberOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMemberOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.addMemberOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitation(organizationUnid: string, authorization: string, createInvitationRequest: CreateInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitation(organizationUnid, authorization, createInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvitationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvitationOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createInvitationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(authorization: string, createOrganizationRequest: CreateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(authorization, createOrganizationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganizationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvitation(invitationUnid: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvitation(invitationUnid, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInvitationOptions(invitationUnid, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteInvitationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganization(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganizationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyInvitations(authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUserInvitationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyInvitations(authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getMyInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyInvitationsOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyInvitationsOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getMyInvitationsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationLogoUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationLogoUploadUrl(organizationUnid, fileExtension, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationLogoUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationLogoUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationLogoUploadUrlOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationLogoUploadUrlOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMembers(organizationUnid: string, authorization: string, page?: number, pageSize?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOrganizationMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMembers(organizationUnid, authorization, page, pageSize, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSocialMediaPreviewUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSocialMediaPreviewUploadUrl(organizationUnid, fileExtension, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationSocialMediaPreviewUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationSocialMediaPreviewUploadUrlOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSubscription(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSubscriptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSubscription(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSubscriptionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSubscriptionOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationSubscriptionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMember(organizationUnid: string, userUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMember(organizationUnid, userUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.removeMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMemberOptions(organizationUnid: string, userUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMemberOptions(organizationUnid, userUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.removeMemberOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvitation(invitationUnid: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvitation(invitationUnid, organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.resendInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvitationOptions(invitationUnid, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.resendInvitationOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {UpdateMemberRolesRequest} updateMemberRolesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberRoles(organizationUnid: string, userUnid: string, authorization: string, updateMemberRolesRequest: UpdateMemberRolesRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberRoles(organizationUnid, userUnid, authorization, updateMemberRolesRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateMemberRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(organizationUnid: string, authorization: string, updateOrganizationRequest: UpdateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(organizationUnid, authorization, updateOrganizationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(token: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.acceptInvitation(token, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitationOptions(token: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.acceptInvitationOptions(token, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AddMemberRequest} addMemberRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMember(organizationUnid: string, authorization: string, addMemberRequest: AddMemberRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addMember(organizationUnid, authorization, addMemberRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMemberOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addMemberOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateInvitationRequest} createInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitation(organizationUnid: string, authorization: string, createInvitationRequest: CreateInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesInvitationResponse> {
            return localVarFp.createInvitation(organizationUnid, authorization, createInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvitationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createInvitationOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(authorization: string, createOrganizationRequest: CreateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOrganizationResponse> {
            return localVarFp.createOrganization(authorization, createOrganizationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createOrganizationOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitation(invitationUnid: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteInvitation(invitationUnid, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteInvitationOptions(invitationUnid, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteOrganization(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteOrganizationOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUserInvitationsResponse> {
            return localVarFp.getMyInvitations(authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitationsOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getMyInvitationsOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOrganizationResponse> {
            return localVarFp.getOrganization(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLogoUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUploadUrlResponse> {
            return localVarFp.getOrganizationLogoUploadUrl(organizationUnid, fileExtension, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationLogoUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getOrganizationLogoUploadUrlOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMembers(organizationUnid: string, authorization: string, page?: number, pageSize?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOrganizationMembersResponse> {
            return localVarFp.getOrganizationMembers(organizationUnid, authorization, page, pageSize, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSocialMediaPreviewUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUploadUrlResponse> {
            return localVarFp.getOrganizationSocialMediaPreviewUploadUrl(organizationUnid, fileExtension, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSubscription(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSubscriptionDetailResponse> {
            return localVarFp.getOrganizationSubscription(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSubscriptionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getOrganizationSubscriptionOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember(organizationUnid: string, userUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeMember(organizationUnid, userUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMemberOptions(organizationUnid: string, userUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeMemberOptions(organizationUnid, userUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitation(invitationUnid: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendInvitation(invitationUnid, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resendInvitationOptions(invitationUnid, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} userUnid 
         * @param {string} authorization 
         * @param {UpdateMemberRolesRequest} updateMemberRolesRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRoles(organizationUnid: string, userUnid: string, authorization: string, updateMemberRolesRequest: UpdateMemberRolesRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateMemberRoles(organizationUnid, userUnid, authorization, updateMemberRolesRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(organizationUnid: string, authorization: string, updateOrganizationRequest: UpdateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOrganizationResponse> {
            return localVarFp.updateOrganization(organizationUnid, authorization, updateOrganizationRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @param {string} token 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public acceptInvitation(token: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).acceptInvitation(token, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public acceptInvitationOptions(token: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).acceptInvitationOptions(token, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AddMemberRequest} addMemberRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public addMember(organizationUnid: string, authorization: string, addMemberRequest: AddMemberRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).addMember(organizationUnid, authorization, addMemberRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public addMemberOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).addMemberOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateInvitationRequest} createInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createInvitation(organizationUnid: string, authorization: string, createInvitationRequest: CreateInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createInvitation(organizationUnid, authorization, createInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createInvitationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createInvitationOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {CreateOrganizationRequest} createOrganizationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createOrganization(authorization: string, createOrganizationRequest: CreateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganization(authorization, createOrganizationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createOrganizationOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganizationOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationUnid 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteInvitation(invitationUnid: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteInvitation(invitationUnid, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationUnid 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteInvitationOptions(invitationUnid, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganization(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteOrganizationOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganizationOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getMyInvitations(authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getMyInvitations(authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getMyInvitationsOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getMyInvitationsOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganization(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganization(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} fileExtension 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationLogoUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationLogoUploadUrl(organizationUnid, fileExtension, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationLogoUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationLogoUploadUrlOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationMembers(organizationUnid: string, authorization: string, page?: number, pageSize?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationMembers(organizationUnid, authorization, page, pageSize, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} fileExtension 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationSocialMediaPreviewUploadUrl(organizationUnid: string, fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationSocialMediaPreviewUploadUrl(organizationUnid, fileExtension, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationSocialMediaPreviewUploadUrlOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationSubscription(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationSubscription(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationSubscriptionOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationSubscriptionOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} userUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public removeMember(organizationUnid: string, userUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).removeMember(organizationUnid, userUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} userUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public removeMemberOptions(organizationUnid: string, userUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).removeMemberOptions(organizationUnid, userUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationUnid 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public resendInvitation(invitationUnid: string, organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).resendInvitation(invitationUnid, organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationUnid 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public resendInvitationOptions(invitationUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).resendInvitationOptions(invitationUnid, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} userUnid 
     * @param {string} authorization 
     * @param {UpdateMemberRolesRequest} updateMemberRolesRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateMemberRoles(organizationUnid: string, userUnid: string, authorization: string, updateMemberRolesRequest: UpdateMemberRolesRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateMemberRoles(organizationUnid, userUnid, authorization, updateMemberRolesRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateOrganizationRequest} updateOrganizationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganization(organizationUnid: string, authorization: string, updateOrganizationRequest: UpdateOrganizationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganization(organizationUnid, authorization, updateOrganizationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartsApi - axios parameter creator
 * @export
 */
export const PartsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePartRequest} createPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPart: async (organizationUnid: string, authorization: string, createPartRequest: CreatePartRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createPart', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPart', 'authorization', authorization)
            // verify required parameter 'createPartRequest' is not null or undefined
            assertParamExists('createPart', 'createPartRequest', createPartRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createPartOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart: async (organizationUnid: string, partId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deletePart', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('deletePart', 'partId', partId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePart', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartOptions: async (organizationUnid: string, partId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deletePartOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('deletePartOptions', 'partId', partId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLowStockParts: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLowStockParts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLowStockParts', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/low-stock`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLowStockPartsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getLowStockPartsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/low-stock`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart: async (organizationUnid: string, partId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPart', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('getPart', 'partId', partId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPart', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [truckId] 
         * @param {string | null} [workOrderId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartUsage: async (organizationUnid: string, partId: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, limit?: number, page?: number, truckId?: string | null, workOrderId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPartUsage', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('getPartUsage', 'partId', partId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPartUsage', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}/usage`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }

            if (workOrderId !== undefined) {
                localVarQueryParameter['work_order_id'] = workOrderId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartUsageOptions: async (organizationUnid: string, partId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPartUsageOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('getPartUsageOptions', 'partId', partId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}/usage`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParts: async (organizationUnid: string, authorization: string, category?: string | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listParts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listParts', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {UpdatePartRequest} updatePartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePart: async (organizationUnid: string, partId: string, authorization: string, updatePartRequest: UpdatePartRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updatePart', 'organizationUnid', organizationUnid)
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('updatePart', 'partId', partId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePart', 'authorization', authorization)
            // verify required parameter 'updatePartRequest' is not null or undefined
            assertParamExists('updatePart', 'updatePartRequest', updatePartRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/parts/{partId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partId"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartsApi - functional programming interface
 * @export
 */
export const PartsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePartRequest} createPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPart(organizationUnid: string, authorization: string, createPartRequest: CreatePartRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPart(organizationUnid, authorization, createPartRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.createPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.createPartOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePart(organizationUnid, partId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.deletePart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartOptions(organizationUnid, partId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.deletePartOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLowStockParts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLowStockPartsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLowStockParts(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getLowStockParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLowStockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLowStockPartsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getLowStockPartsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPart(organizationUnid, partId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [truckId] 
         * @param {string | null} [workOrderId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartUsage(organizationUnid: string, partId: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, limit?: number, page?: number, truckId?: string | null, workOrderId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPartUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartUsage(organizationUnid, partId, authorization, dateFrom, dateTo, limit, page, truckId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPartUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartUsageOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartUsageOptions(organizationUnid, partId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPartUsageOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listParts(organizationUnid: string, authorization: string, category?: string | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPartListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listParts(organizationUnid, authorization, category, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.listParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {UpdatePartRequest} updatePartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePart(organizationUnid: string, partId: string, authorization: string, updatePartRequest: UpdatePartRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePart(organizationUnid, partId, authorization, updatePartRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.updatePart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartsApi - factory interface
 * @export
 */
export const PartsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePartRequest} createPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPart(organizationUnid: string, authorization: string, createPartRequest: CreatePartRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPartResponse> {
            return localVarFp.createPart(organizationUnid, authorization, createPartRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createPartOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deletePart(organizationUnid, partId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deletePartOptions(organizationUnid, partId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLowStockParts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLowStockPartsResponse> {
            return localVarFp.getLowStockParts(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLowStockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getLowStockPartsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPartResponse> {
            return localVarFp.getPart(organizationUnid, partId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [truckId] 
         * @param {string | null} [workOrderId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartUsage(organizationUnid: string, partId: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, limit?: number, page?: number, truckId?: string | null, workOrderId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPartUsageResponse> {
            return localVarFp.getPartUsage(organizationUnid, partId, authorization, dateFrom, dateTo, limit, page, truckId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartUsageOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPartUsageOptions(organizationUnid, partId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [category] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listParts(organizationUnid: string, authorization: string, category?: string | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPartListResponse> {
            return localVarFp.listParts(organizationUnid, authorization, category, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partId 
         * @param {string} authorization 
         * @param {UpdatePartRequest} updatePartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePart(organizationUnid: string, partId: string, authorization: string, updatePartRequest: UpdatePartRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPartResponse> {
            return localVarFp.updatePart(organizationUnid, partId, authorization, updatePartRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartsApi - object-oriented interface
 * @export
 * @class PartsApi
 * @extends {BaseAPI}
 */
export class PartsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreatePartRequest} createPartRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public createPart(organizationUnid: string, authorization: string, createPartRequest: CreatePartRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).createPart(organizationUnid, authorization, createPartRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public createPartOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).createPartOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public deletePart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).deletePart(organizationUnid, partId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public deletePartOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).deletePartOptions(organizationUnid, partId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getLowStockParts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).getLowStockParts(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getLowStockPartsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).getLowStockPartsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getPart(organizationUnid: string, partId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).getPart(organizationUnid, partId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [truckId] 
     * @param {string | null} [workOrderId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getPartUsage(organizationUnid: string, partId: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, limit?: number, page?: number, truckId?: string | null, workOrderId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).getPartUsage(organizationUnid, partId, authorization, dateFrom, dateTo, limit, page, truckId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public getPartUsageOptions(organizationUnid: string, partId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).getPartUsageOptions(organizationUnid, partId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [category] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public listParts(organizationUnid: string, authorization: string, category?: string | null, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).listParts(organizationUnid, authorization, category, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partId 
     * @param {string} authorization 
     * @param {UpdatePartRequest} updatePartRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    public updatePart(organizationUnid: string, partId: string, authorization: string, updatePartRequest: UpdatePartRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PartsApiFp(this.configuration).updatePart(organizationUnid, partId, authorization, updatePartRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaystubsApi - axios parameter creator
 * @export
 */
export const PaystubsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AddSettlementsRequest} addSettlementsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSettlements: async (organizationUnid: string, paystubId: string, authorization: string, addSettlementsRequest: AddSettlementsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addSettlements', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('addSettlements', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addSettlements', 'authorization', authorization)
            // verify required parameter 'addSettlementsRequest' is not null or undefined
            assertParamExists('addSettlements', 'addSettlementsRequest', addSettlementsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/settlements`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSettlementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSettlementsOptions: async (organizationUnid: string, paystubId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addSettlementsOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('addSettlementsOptions', 'paystubId', paystubId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/settlements`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePaystubRequest} createPaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaystub: async (organizationUnid: string, authorization: string, createPaystubRequest: CreatePaystubRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createPaystub', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPaystub', 'authorization', authorization)
            // verify required parameter 'createPaystubRequest' is not null or undefined
            assertParamExists('createPaystub', 'createPaystubRequest', createPaystubRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaystubRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaystubOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createPaystubOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaystub: async (organizationUnid: string, paystubId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deletePaystub', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('deletePaystub', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePaystub', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaystubOptions: async (organizationUnid: string, paystubId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deletePaystubOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('deletePaystubOptions', 'paystubId', paystubId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeRecurringCharge: async (chargeId: string, organizationUnid: string, paystubId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('excludeRecurringCharge', 'chargeId', chargeId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('excludeRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('excludeRecurringCharge', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('excludeRecurringCharge', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystub: async (organizationUnid: string, paystubId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPaystub', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('getPaystub', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPaystub', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystubStats: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPaystubStats', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPaystubStats', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystubStatsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getPaystubStatsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/stats`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeRecurringCharge: async (chargeId: string, organizationUnid: string, paystubId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('includeRecurringCharge', 'chargeId', chargeId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('includeRecurringCharge', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('includeRecurringCharge', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('includeRecurringCharge', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('includeRecurringCharge', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeRecurringChargeOptions: async (chargeId: string, organizationUnid: string, paystubId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeId' is not null or undefined
            assertParamExists('includeRecurringChargeOptions', 'chargeId', chargeId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('includeRecurringChargeOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('includeRecurringChargeOptions', 'paystubId', paystubId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/recurring-charges/{chargeId}`
                .replace(`{${"chargeId"}}`, encodeURIComponent(String(chargeId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPaystubs: async (organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listPaystubs', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listPaystubs', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPDF: async (organizationUnid: string, paystubId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('previewPDF', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('previewPDF', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('previewPDF', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/preview-pdf`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPDFOptions: async (organizationUnid: string, paystubId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('previewPDFOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('previewPDFOptions', 'paystubId', paystubId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/preview-pdf`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSettlement: async (organizationUnid: string, paystubId: string, settlementId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeSettlement', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('removeSettlement', 'paystubId', paystubId)
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('removeSettlement', 'settlementId', settlementId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('removeSettlement', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/settlements/{settlementId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)))
                .replace(`{${"settlementId"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSettlementOptions: async (organizationUnid: string, paystubId: string, settlementId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeSettlementOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('removeSettlementOptions', 'paystubId', paystubId)
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('removeSettlementOptions', 'settlementId', settlementId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}/settlements/{settlementId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)))
                .replace(`{${"settlementId"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {UpdatePaystubRequest} updatePaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaystub: async (organizationUnid: string, paystubId: string, authorization: string, updatePaystubRequest: UpdatePaystubRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updatePaystub', 'organizationUnid', organizationUnid)
            // verify required parameter 'paystubId' is not null or undefined
            assertParamExists('updatePaystub', 'paystubId', paystubId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePaystub', 'authorization', authorization)
            // verify required parameter 'updatePaystubRequest' is not null or undefined
            assertParamExists('updatePaystub', 'updatePaystubRequest', updatePaystubRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/paystubs/{paystubId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"paystubId"}}`, encodeURIComponent(String(paystubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaystubRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaystubsApi - functional programming interface
 * @export
 */
export const PaystubsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaystubsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AddSettlementsRequest} addSettlementsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSettlements(organizationUnid: string, paystubId: string, authorization: string, addSettlementsRequest: AddSettlementsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSettlements(organizationUnid, paystubId, authorization, addSettlementsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.addSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSettlementsOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSettlementsOptions(organizationUnid, paystubId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.addSettlementsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePaystubRequest} createPaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaystub(organizationUnid: string, authorization: string, createPaystubRequest: CreatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaystub(organizationUnid, authorization, createPaystubRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.createPaystub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaystubOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaystubOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.createPaystubOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaystub(organizationUnid, paystubId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.deletePaystub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePaystubOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePaystubOptions(organizationUnid, paystubId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.deletePaystubOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async excludeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.excludeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.excludeRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaystub(organizationUnid, paystubId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.getPaystub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaystubStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaystubStats(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.getPaystubStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaystubStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaystubStatsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.getPaystubStatsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async includeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.includeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.includeRecurringCharge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async includeRecurringChargeOptions(chargeId: string, organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.includeRecurringChargeOptions(chargeId, organizationUnid, paystubId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.includeRecurringChargeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPaystubs(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPaystubs(organizationUnid, authorization, driverId, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.listPaystubs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPDF(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPDF(organizationUnid, paystubId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.previewPDF']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPDFOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPDFOptions(organizationUnid, paystubId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.previewPDFOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSettlement(organizationUnid: string, paystubId: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSettlement(organizationUnid, paystubId, settlementId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.removeSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSettlementOptions(organizationUnid: string, paystubId: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSettlementOptions(organizationUnid, paystubId, settlementId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.removeSettlementOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {UpdatePaystubRequest} updatePaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaystub(organizationUnid: string, paystubId: string, authorization: string, updatePaystubRequest: UpdatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPaystubResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaystub(organizationUnid, paystubId, authorization, updatePaystubRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaystubsApi.updatePaystub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaystubsApi - factory interface
 * @export
 */
export const PaystubsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaystubsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AddSettlementsRequest} addSettlementsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSettlements(organizationUnid: string, paystubId: string, authorization: string, addSettlementsRequest: AddSettlementsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.addSettlements(organizationUnid, paystubId, authorization, addSettlementsRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSettlementsOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addSettlementsOptions(organizationUnid, paystubId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreatePaystubRequest} createPaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaystub(organizationUnid: string, authorization: string, createPaystubRequest: CreatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.createPaystub(organizationUnid, authorization, createPaystubRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaystubOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createPaystubOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deletePaystub(organizationUnid, paystubId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaystubOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deletePaystubOptions(organizationUnid, paystubId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.excludeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.getPaystub(organizationUnid, paystubId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystubStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubStatsResponse> {
            return localVarFp.getPaystubStats(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaystubStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPaystubStatsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.includeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} chargeId 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        includeRecurringChargeOptions(chargeId: string, organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.includeRecurringChargeOptions(chargeId, organizationUnid, paystubId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPaystubs(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubListResponse> {
            return localVarFp.listPaystubs(organizationUnid, authorization, driverId, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPDF(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubPreviewResponse> {
            return localVarFp.previewPDF(organizationUnid, paystubId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPDFOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.previewPDFOptions(organizationUnid, paystubId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSettlement(organizationUnid: string, paystubId: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.removeSettlement(organizationUnid, paystubId, settlementId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSettlementOptions(organizationUnid: string, paystubId: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeSettlementOptions(organizationUnid, paystubId, settlementId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} paystubId 
         * @param {string} authorization 
         * @param {UpdatePaystubRequest} updatePaystubRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaystub(organizationUnid: string, paystubId: string, authorization: string, updatePaystubRequest: UpdatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPaystubResponse> {
            return localVarFp.updatePaystub(organizationUnid, paystubId, authorization, updatePaystubRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaystubsApi - object-oriented interface
 * @export
 * @class PaystubsApi
 * @extends {BaseAPI}
 */
export class PaystubsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {AddSettlementsRequest} addSettlementsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public addSettlements(organizationUnid: string, paystubId: string, authorization: string, addSettlementsRequest: AddSettlementsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).addSettlements(organizationUnid, paystubId, authorization, addSettlementsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public addSettlementsOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).addSettlementsOptions(organizationUnid, paystubId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreatePaystubRequest} createPaystubRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public createPaystub(organizationUnid: string, authorization: string, createPaystubRequest: CreatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).createPaystub(organizationUnid, authorization, createPaystubRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public createPaystubOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).createPaystubOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public deletePaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).deletePaystub(organizationUnid, paystubId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public deletePaystubOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).deletePaystubOptions(organizationUnid, paystubId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public excludeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).excludeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public getPaystub(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).getPaystub(organizationUnid, paystubId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public getPaystubStats(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).getPaystubStats(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public getPaystubStatsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).getPaystubStatsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public includeRecurringCharge(chargeId: string, organizationUnid: string, paystubId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).includeRecurringCharge(chargeId, organizationUnid, paystubId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} chargeId 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public includeRecurringChargeOptions(chargeId: string, organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).includeRecurringChargeOptions(chargeId, organizationUnid, paystubId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [driverId] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public listPaystubs(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).listPaystubs(organizationUnid, authorization, driverId, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public previewPDF(organizationUnid: string, paystubId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).previewPDF(organizationUnid, paystubId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public previewPDFOptions(organizationUnid: string, paystubId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).previewPDFOptions(organizationUnid, paystubId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} settlementId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public removeSettlement(organizationUnid: string, paystubId: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).removeSettlement(organizationUnid, paystubId, settlementId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} settlementId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public removeSettlementOptions(organizationUnid: string, paystubId: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).removeSettlementOptions(organizationUnid, paystubId, settlementId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} paystubId 
     * @param {string} authorization 
     * @param {UpdatePaystubRequest} updatePaystubRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaystubsApi
     */
    public updatePaystub(organizationUnid: string, paystubId: string, authorization: string, updatePaystubRequest: UpdatePaystubRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return PaystubsApiFp(this.configuration).updatePaystub(organizationUnid, paystubId, authorization, updatePaystubRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlansApi - axios parameter creator
 * @export
 */
export const PlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planUnid 
         * @param {string} authorization 
         * @param {string | null} [language] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan: async (planUnid: string, authorization: string, language?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUnid' is not null or undefined
            assertParamExists('getPlan', 'planUnid', planUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPlan', 'authorization', authorization)
            const localVarPath = `/api/v1/plans/{planUnid}`
                .replace(`{${"planUnid"}}`, encodeURIComponent(String(planUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOptions: async (planUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planUnid' is not null or undefined
            assertParamExists('getPlanOptions', 'planUnid', planUnid)
            const localVarPath = `/api/v1/plans/{planUnid}`
                .replace(`{${"planUnid"}}`, encodeURIComponent(String(planUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string | null} [language] 
         * @param {string | null} [planType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans: async (authorization: string, active?: boolean | null, language?: string | null, planType?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPlans', 'authorization', authorization)
            const localVarPath = `/api/v1/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (planType !== undefined) {
                localVarQueryParameter['planType'] = planType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlansOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlansApi - functional programming interface
 * @export
 */
export const PlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planUnid 
         * @param {string} authorization 
         * @param {string | null} [language] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlan(planUnid: string, authorization: string, language?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPlanDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlan(planUnid, authorization, language, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanOptions(planUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanOptions(planUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlanOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string | null} [language] 
         * @param {string | null} [planType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlans(authorization: string, active?: boolean | null, language?: string | null, planType?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlans(authorization, active, language, planType, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlansOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlansOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.getPlansOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlansApi - factory interface
 * @export
 */
export const PlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlansApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planUnid 
         * @param {string} authorization 
         * @param {string | null} [language] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlan(planUnid: string, authorization: string, language?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPlanDetailResponse> {
            return localVarFp.getPlan(planUnid, authorization, language, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanOptions(planUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPlanOptions(planUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string | null} [language] 
         * @param {string | null} [planType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlans(authorization: string, active?: boolean | null, language?: string | null, planType?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesPlansResponse> {
            return localVarFp.getPlans(authorization, active, language, planType, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlansOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getPlansOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlansApi - object-oriented interface
 * @export
 * @class PlansApi
 * @extends {BaseAPI}
 */
export class PlansApi extends BaseAPI {
    /**
     * 
     * @param {string} planUnid 
     * @param {string} authorization 
     * @param {string | null} [language] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlan(planUnid: string, authorization: string, language?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlan(planUnid, authorization, language, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlanOptions(planUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlanOptions(planUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {boolean | null} [active] 
     * @param {string | null} [language] 
     * @param {string | null} [planType] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlans(authorization: string, active?: boolean | null, language?: string | null, planType?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlans(authorization, active, language, planType, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public getPlansOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).getPlansOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QBCachedAccountsApi - axios parameter creator
 * @export
 */
export const QBCachedAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccounts: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('fetchAccounts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fetchAccounts', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('fetchAccounts', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/cached-accounts/fetch`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccountsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('fetchAccountsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/cached-accounts/fetch`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCachedAccounts: async (organizationUnid: string, authorization: string, active?: boolean | null, search?: string, type?: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listCachedAccounts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listCachedAccounts', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/cached-accounts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCachedAccountsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listCachedAccountsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/cached-accounts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QBCachedAccountsApi - functional programming interface
 * @export
 */
export const QBCachedAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QBCachedAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAccounts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBCachedAccountsFetchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAccounts(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBCachedAccountsApi.fetchAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchAccountsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBCachedAccountsApi.fetchAccountsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCachedAccounts(organizationUnid: string, authorization: string, active?: boolean | null, search?: string, type?: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBCachedAccountsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCachedAccounts(organizationUnid, authorization, active, search, type, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBCachedAccountsApi.listCachedAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCachedAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCachedAccountsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBCachedAccountsApi.listCachedAccountsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QBCachedAccountsApi - factory interface
 * @export
 */
export const QBCachedAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QBCachedAccountsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccounts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBCachedAccountsFetchResponse> {
            return localVarFp.fetchAccounts(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.fetchAccountsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [active] 
         * @param {string} [search] 
         * @param {string} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCachedAccounts(organizationUnid: string, authorization: string, active?: boolean | null, search?: string, type?: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBCachedAccountsListResponse> {
            return localVarFp.listCachedAccounts(organizationUnid, authorization, active, search, type, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCachedAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listCachedAccountsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QBCachedAccountsApi - object-oriented interface
 * @export
 * @class QBCachedAccountsApi
 * @extends {BaseAPI}
 */
export class QBCachedAccountsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBCachedAccountsApi
     */
    public fetchAccounts(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QBCachedAccountsApiFp(this.configuration).fetchAccounts(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBCachedAccountsApi
     */
    public fetchAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBCachedAccountsApiFp(this.configuration).fetchAccountsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [active] 
     * @param {string} [search] 
     * @param {string} [type] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBCachedAccountsApi
     */
    public listCachedAccounts(organizationUnid: string, authorization: string, active?: boolean | null, search?: string, type?: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBCachedAccountsApiFp(this.configuration).listCachedAccounts(organizationUnid, authorization, active, search, type, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBCachedAccountsApi
     */
    public listCachedAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBCachedAccountsApiFp(this.configuration).listCachedAccountsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QBMappingsApi - axios parameter creator
 * @export
 */
export const QBMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {BulkSaveRequest} bulkSaveRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSave: async (organizationUnid: string, authorization: string, bulkSaveRequest: BulkSaveRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('bulkSave', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('bulkSave', 'authorization', authorization)
            // verify required parameter 'bulkSaveRequest' is not null or undefined
            assertParamExists('bulkSave', 'bulkSaveRequest', bulkSaveRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/bulk`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('bulkSaveOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/bulk`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMappingRequest} createMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMapping: async (organizationUnid: string, authorization: string, createMappingRequest: CreateMappingRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createMapping', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createMapping', 'authorization', authorization)
            // verify required parameter 'createMappingRequest' is not null or undefined
            assertParamExists('createMapping', 'createMappingRequest', createMappingRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMappingOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createMappingOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [hard] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMapping: async (mappingUnid: string, organizationUnid: string, authorization: string, hard?: boolean, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingUnid' is not null or undefined
            assertParamExists('deleteMapping', 'mappingUnid', mappingUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteMapping', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteMapping', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/{mappingUnid}`
                .replace(`{${"mappingUnid"}}`, encodeURIComponent(String(mappingUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hard !== undefined) {
                localVarQueryParameter['hard'] = hard;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMappingOptions: async (mappingUnid: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingUnid' is not null or undefined
            assertParamExists('deleteMappingOptions', 'mappingUnid', mappingUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteMappingOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/{mappingUnid}`
                .replace(`{${"mappingUnid"}}`, encodeURIComponent(String(mappingUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [mappedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllMappings: async (organizationUnid: string, authorization: string, mappedOnly?: boolean, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAllMappings', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listAllMappings', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mappedOnly !== undefined) {
                localVarQueryParameter['mapped_only'] = mappedOnly;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByCategory: async (category: string, organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('listByCategory', 'category', category)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listByCategory', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listByCategory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/category/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByCategoryOptions: async (category: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('listByCategoryOptions', 'category', category)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listByCategoryOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/category/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SeedDefaultsRequest} seedDefaultsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedDefaults: async (organizationUnid: string, authorization: string, seedDefaultsRequest: SeedDefaultsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('seedDefaults', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('seedDefaults', 'authorization', authorization)
            // verify required parameter 'seedDefaultsRequest' is not null or undefined
            assertParamExists('seedDefaults', 'seedDefaultsRequest', seedDefaultsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/seed`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seedDefaultsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedDefaultsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('seedDefaultsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/seed`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMappingRequest} updateMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMapping: async (mappingUnid: string, organizationUnid: string, authorization: string, updateMappingRequest: UpdateMappingRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingUnid' is not null or undefined
            assertParamExists('updateMapping', 'mappingUnid', mappingUnid)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateMapping', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateMapping', 'authorization', authorization)
            // verify required parameter 'updateMappingRequest' is not null or undefined
            assertParamExists('updateMapping', 'updateMappingRequest', updateMappingRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/{mappingUnid}`
                .replace(`{${"mappingUnid"}}`, encodeURIComponent(String(mappingUnid)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} syncType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (organizationUnid: string, syncType: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validate', 'organizationUnid', organizationUnid)
            // verify required parameter 'syncType' is not null or undefined
            assertParamExists('validate', 'syncType', syncType)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('validate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/validate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (syncType !== undefined) {
                localVarQueryParameter['sync_type'] = syncType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('validateOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/qb-mappings/validate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QBMappingsApi - functional programming interface
 * @export
 */
export const QBMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QBMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {BulkSaveRequest} bulkSaveRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSave(organizationUnid: string, authorization: string, bulkSaveRequest: BulkSaveRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsBulkSaveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSave(organizationUnid, authorization, bulkSaveRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.bulkSave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkSaveOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkSaveOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.bulkSaveOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMappingRequest} createMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMapping(organizationUnid: string, authorization: string, createMappingRequest: CreateMappingRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMapping(organizationUnid, authorization, createMappingRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.createMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMappingOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMappingOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.createMappingOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [hard] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMapping(mappingUnid: string, organizationUnid: string, authorization: string, hard?: boolean, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMapping(mappingUnid, organizationUnid, authorization, hard, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.deleteMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMappingOptions(mappingUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMappingOptions(mappingUnid, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.deleteMappingOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [mappedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllMappings(organizationUnid: string, authorization: string, mappedOnly?: boolean, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllMappings(organizationUnid, authorization, mappedOnly, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.listAllMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByCategory(category: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByCategory(category, organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.listByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByCategoryOptions(category: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByCategoryOptions(category, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.listByCategoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SeedDefaultsRequest} seedDefaultsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seedDefaults(organizationUnid: string, authorization: string, seedDefaultsRequest: SeedDefaultsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsSeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seedDefaults(organizationUnid, authorization, seedDefaultsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.seedDefaults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seedDefaultsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seedDefaultsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.seedDefaultsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMappingRequest} updateMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMapping(mappingUnid: string, organizationUnid: string, authorization: string, updateMappingRequest: UpdateMappingRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMapping(mappingUnid, organizationUnid, authorization, updateMappingRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.updateMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} syncType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(organizationUnid: string, syncType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMappingsValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(organizationUnid, syncType, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.validate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QBMappingsApi.validateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QBMappingsApi - factory interface
 * @export
 */
export const QBMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QBMappingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {BulkSaveRequest} bulkSaveRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSave(organizationUnid: string, authorization: string, bulkSaveRequest: BulkSaveRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsBulkSaveResponse> {
            return localVarFp.bulkSave(organizationUnid, authorization, bulkSaveRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkSaveOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.bulkSaveOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateMappingRequest} createMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMapping(organizationUnid: string, authorization: string, createMappingRequest: CreateMappingRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsCreateResponse> {
            return localVarFp.createMapping(organizationUnid, authorization, createMappingRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMappingOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createMappingOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [hard] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMapping(mappingUnid: string, organizationUnid: string, authorization: string, hard?: boolean, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsDeleteResponse> {
            return localVarFp.deleteMapping(mappingUnid, organizationUnid, authorization, hard, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMappingOptions(mappingUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteMappingOptions(mappingUnid, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean} [mappedOnly] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllMappings(organizationUnid: string, authorization: string, mappedOnly?: boolean, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsListResponse> {
            return localVarFp.listAllMappings(organizationUnid, authorization, mappedOnly, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByCategory(category: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsCategoryResponse> {
            return localVarFp.listByCategory(category, organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByCategoryOptions(category: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listByCategoryOptions(category, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SeedDefaultsRequest} seedDefaultsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedDefaults(organizationUnid: string, authorization: string, seedDefaultsRequest: SeedDefaultsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsSeedResponse> {
            return localVarFp.seedDefaults(organizationUnid, authorization, seedDefaultsRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedDefaultsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.seedDefaultsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mappingUnid 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateMappingRequest} updateMappingRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMapping(mappingUnid: string, organizationUnid: string, authorization: string, updateMappingRequest: UpdateMappingRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsUpdateResponse> {
            return localVarFp.updateMapping(mappingUnid, organizationUnid, authorization, updateMappingRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} syncType 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(organizationUnid: string, syncType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMappingsValidateResponse> {
            return localVarFp.validate(organizationUnid, syncType, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.validateOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QBMappingsApi - object-oriented interface
 * @export
 * @class QBMappingsApi
 * @extends {BaseAPI}
 */
export class QBMappingsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {BulkSaveRequest} bulkSaveRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public bulkSave(organizationUnid: string, authorization: string, bulkSaveRequest: BulkSaveRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).bulkSave(organizationUnid, authorization, bulkSaveRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public bulkSaveOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).bulkSaveOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateMappingRequest} createMappingRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public createMapping(organizationUnid: string, authorization: string, createMappingRequest: CreateMappingRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).createMapping(organizationUnid, authorization, createMappingRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public createMappingOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).createMappingOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mappingUnid 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean} [hard] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public deleteMapping(mappingUnid: string, organizationUnid: string, authorization: string, hard?: boolean, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).deleteMapping(mappingUnid, organizationUnid, authorization, hard, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mappingUnid 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public deleteMappingOptions(mappingUnid: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).deleteMappingOptions(mappingUnid, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean} [mappedOnly] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public listAllMappings(organizationUnid: string, authorization: string, mappedOnly?: boolean, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).listAllMappings(organizationUnid, authorization, mappedOnly, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public listByCategory(category: string, organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).listByCategory(category, organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public listByCategoryOptions(category: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).listByCategoryOptions(category, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {SeedDefaultsRequest} seedDefaultsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public seedDefaults(organizationUnid: string, authorization: string, seedDefaultsRequest: SeedDefaultsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).seedDefaults(organizationUnid, authorization, seedDefaultsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public seedDefaultsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).seedDefaultsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mappingUnid 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateMappingRequest} updateMappingRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public updateMapping(mappingUnid: string, organizationUnid: string, authorization: string, updateMappingRequest: UpdateMappingRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).updateMapping(mappingUnid, organizationUnid, authorization, updateMappingRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} syncType 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public validate(organizationUnid: string, syncType: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).validate(organizationUnid, syncType, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QBMappingsApi
     */
    public validateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QBMappingsApiFp(this.configuration).validateOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuickBooksApi - axios parameter creator
 * @export
 */
export const QuickBooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectQB: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectQB', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('disconnectQB', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectQBOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectQBOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBAuthURL: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getQBAuthURL', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQBAuthURL', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/auth`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBAuthURLOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getQBAuthURLOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/auth`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBStatus: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getQBStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQBStatus', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBStatusOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getQBStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAccounts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listAccounts', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/accounts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listAccountsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/accounts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {MapAccountsRequest} mapAccountsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapAccounts: async (organizationUnid: string, authorization: string, mapAccountsRequest: MapAccountsRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('mapAccounts', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('mapAccounts', 'authorization', authorization)
            // verify required parameter 'mapAccountsRequest' is not null or undefined
            assertParamExists('mapAccounts', 'mapAccountsRequest', mapAccountsRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/accounts/map`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mapAccountsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapAccountsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('mapAccountsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/accounts/map`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncCustomersRequest} syncCustomersRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomers: async (organizationUnid: string, authorization: string, syncCustomersRequest: SyncCustomersRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncCustomers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncCustomers', 'authorization', authorization)
            // verify required parameter 'syncCustomersRequest' is not null or undefined
            assertParamExists('syncCustomers', 'syncCustomersRequest', syncCustomersRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/sync/customers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncCustomersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomersOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncCustomersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/sync/customers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPayments: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncPayments', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncPayments', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('syncPayments', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/sync/payments`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPaymentsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncPaymentsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/quickbooks/sync/payments`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickBooksApi - functional programming interface
 * @export
 */
export const QuickBooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickBooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectQB(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBDisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectQB(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.disconnectQB']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectQBOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectQBOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.disconnectQBOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQBAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBAuthURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQBAuthURL(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.getQBAuthURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQBAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQBAuthURLOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.getQBAuthURLOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQBStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQBStatus(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.getQBStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQBStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQBStatusOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.getQBStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccounts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccounts(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.listAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.listAccountsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {MapAccountsRequest} mapAccountsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapAccounts(organizationUnid: string, authorization: string, mapAccountsRequest: MapAccountsRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBMapAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapAccounts(organizationUnid, authorization, mapAccountsRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.mapAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapAccountsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.mapAccountsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncCustomersRequest} syncCustomersRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCustomers(organizationUnid: string, authorization: string, syncCustomersRequest: SyncCustomersRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBSyncResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCustomers(organizationUnid, authorization, syncCustomersRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.syncCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCustomersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCustomersOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.syncCustomersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPayments(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBSyncResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPayments(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.syncPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPaymentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPaymentsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksApi.syncPaymentsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuickBooksApi - factory interface
 * @export
 */
export const QuickBooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickBooksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectQB(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBDisconnectResponse> {
            return localVarFp.disconnectQB(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectQBOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.disconnectQBOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBAuthURLResponse> {
            return localVarFp.getQBAuthURL(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getQBAuthURLOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBStatusResponse> {
            return localVarFp.getQBStatus(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQBStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getQBStatusOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBAccountsResponse> {
            return localVarFp.listAccounts(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listAccountsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {MapAccountsRequest} mapAccountsRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapAccounts(organizationUnid: string, authorization: string, mapAccountsRequest: MapAccountsRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBMapAccountsResponse> {
            return localVarFp.mapAccounts(organizationUnid, authorization, mapAccountsRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.mapAccountsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncCustomersRequest} syncCustomersRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomers(organizationUnid: string, authorization: string, syncCustomersRequest: SyncCustomersRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBSyncResultResponse> {
            return localVarFp.syncCustomers(organizationUnid, authorization, syncCustomersRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncCustomersOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPayments(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBSyncResultResponse> {
            return localVarFp.syncPayments(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPaymentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncPaymentsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickBooksApi - object-oriented interface
 * @export
 * @class QuickBooksApi
 * @extends {BaseAPI}
 */
export class QuickBooksApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public disconnectQB(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).disconnectQB(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public disconnectQBOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).disconnectQBOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public getQBAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).getQBAuthURL(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public getQBAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).getQBAuthURLOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public getQBStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).getQBStatus(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public getQBStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).getQBStatusOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public listAccounts(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).listAccounts(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public listAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).listAccountsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {MapAccountsRequest} mapAccountsRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public mapAccounts(organizationUnid: string, authorization: string, mapAccountsRequest: MapAccountsRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).mapAccounts(organizationUnid, authorization, mapAccountsRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public mapAccountsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).mapAccountsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {SyncCustomersRequest} syncCustomersRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public syncCustomers(organizationUnid: string, authorization: string, syncCustomersRequest: SyncCustomersRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).syncCustomers(organizationUnid, authorization, syncCustomersRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public syncCustomersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).syncCustomersOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public syncPayments(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).syncPayments(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksApi
     */
    public syncPaymentsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksApiFp(this.configuration).syncPaymentsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuickBooksCallbackApi - axios parameter creator
 * @export
 */
export const QuickBooksCallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {HandleQBCallbackRequest} handleQBCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBCallback: async (handleQBCallbackRequest: HandleQBCallbackRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'handleQBCallbackRequest' is not null or undefined
            assertParamExists('handleQBCallback', 'handleQBCallbackRequest', handleQBCallbackRequest)
            const localVarPath = `/api/v1/integrations/quickbooks/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(handleQBCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBCallbackOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/quickbooks/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickBooksCallbackApi - functional programming interface
 * @export
 */
export const QuickBooksCallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickBooksCallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {HandleQBCallbackRequest} handleQBCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleQBCallback(handleQBCallbackRequest: HandleQBCallbackRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBOAuthCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleQBCallback(handleQBCallbackRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksCallbackApi.handleQBCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleQBCallbackOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleQBCallbackOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksCallbackApi.handleQBCallbackOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuickBooksCallbackApi - factory interface
 * @export
 */
export const QuickBooksCallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickBooksCallbackApiFp(configuration)
    return {
        /**
         * 
         * @param {HandleQBCallbackRequest} handleQBCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBCallback(handleQBCallbackRequest: HandleQBCallbackRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBOAuthCallbackResponse> {
            return localVarFp.handleQBCallback(handleQBCallbackRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBCallbackOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.handleQBCallbackOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickBooksCallbackApi - object-oriented interface
 * @export
 * @class QuickBooksCallbackApi
 * @extends {BaseAPI}
 */
export class QuickBooksCallbackApi extends BaseAPI {
    /**
     * 
     * @param {HandleQBCallbackRequest} handleQBCallbackRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksCallbackApi
     */
    public handleQBCallback(handleQBCallbackRequest: HandleQBCallbackRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksCallbackApiFp(this.configuration).handleQBCallback(handleQBCallbackRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksCallbackApi
     */
    public handleQBCallbackOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksCallbackApiFp(this.configuration).handleQBCallbackOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuickBooksWebhookApi - axios parameter creator
 * @export
 */
export const QuickBooksWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [intuitSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBWebhook: async (origin?: string, intuitSignature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks/quickbooks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            if (intuitSignature != null) {
                localVarHeaderParameter['intuit-signature'] = String(intuitSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBWebhookOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks/quickbooks/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuickBooksWebhookApi - functional programming interface
 * @export
 */
export const QuickBooksWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuickBooksWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [intuitSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleQBWebhook(origin?: string, intuitSignature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQBWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleQBWebhook(origin, intuitSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksWebhookApi.handleQBWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleQBWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleQBWebhookOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuickBooksWebhookApi.handleQBWebhookOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuickBooksWebhookApi - factory interface
 * @export
 */
export const QuickBooksWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuickBooksWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [intuitSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBWebhook(origin?: string, intuitSignature?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQBWebhookResponse> {
            return localVarFp.handleQBWebhook(origin, intuitSignature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleQBWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.handleQBWebhookOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuickBooksWebhookApi - object-oriented interface
 * @export
 * @class QuickBooksWebhookApi
 * @extends {BaseAPI}
 */
export class QuickBooksWebhookApi extends BaseAPI {
    /**
     * 
     * @param {string} [origin] 
     * @param {string} [intuitSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksWebhookApi
     */
    public handleQBWebhook(origin?: string, intuitSignature?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksWebhookApiFp(this.configuration).handleQBWebhook(origin, intuitSignature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuickBooksWebhookApi
     */
    public handleQBWebhookOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return QuickBooksWebhookApiFp(this.configuration).handleQBWebhookOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuotesApi - axios parameter creator
 * @export
 */
export const QuotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {ConvertQuoteRequest} convertQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuote: async (organizationUnid: string, quoteId: string, authorization: string, convertQuoteRequest: ConvertQuoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('convertQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('convertQuote', 'quoteId', quoteId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('convertQuote', 'authorization', authorization)
            // verify required parameter 'convertQuoteRequest' is not null or undefined
            assertParamExists('convertQuote', 'convertQuoteRequest', convertQuoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}/convert`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(convertQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuoteOptions: async (organizationUnid: string, quoteId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('convertQuoteOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('convertQuoteOptions', 'quoteId', quoteId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}/convert`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateQuoteRequest} createQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote: async (organizationUnid: string, authorization: string, createQuoteRequest: CreateQuoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createQuote', 'authorization', authorization)
            // verify required parameter 'createQuoteRequest' is not null or undefined
            assertParamExists('createQuote', 'createQuoteRequest', createQuoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuoteOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createQuoteOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuote: async (organizationUnid: string, quoteId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('deleteQuote', 'quoteId', quoteId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteQuote', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuoteOptions: async (organizationUnid: string, quoteId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteQuoteOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('deleteQuoteOptions', 'quoteId', quoteId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote: async (organizationUnid: string, quoteId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('getQuote', 'quoteId', quoteId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQuote', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes: async (organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listQuotes', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listQuotes', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQuote: async (organizationUnid: string, quoteId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('sendQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('sendQuote', 'quoteId', quoteId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('sendQuote', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('sendQuote', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}/send`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQuoteOptions: async (organizationUnid: string, quoteId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('sendQuoteOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('sendQuoteOptions', 'quoteId', quoteId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}/send`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuote: async (organizationUnid: string, quoteId: string, authorization: string, updateQuoteRequest: UpdateQuoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateQuote', 'organizationUnid', organizationUnid)
            // verify required parameter 'quoteId' is not null or undefined
            assertParamExists('updateQuote', 'quoteId', quoteId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateQuote', 'authorization', authorization)
            // verify required parameter 'updateQuoteRequest' is not null or undefined
            assertParamExists('updateQuote', 'updateQuoteRequest', updateQuoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/quotes/{quoteId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuotesApi - functional programming interface
 * @export
 */
export const QuotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {ConvertQuoteRequest} convertQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertQuote(organizationUnid: string, quoteId: string, authorization: string, convertQuoteRequest: ConvertQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertQuote(organizationUnid, quoteId, authorization, convertQuoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.convertQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertQuoteOptions(organizationUnid, quoteId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.convertQuoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateQuoteRequest} createQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuote(organizationUnid: string, authorization: string, createQuoteRequest: CreateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuote(organizationUnid, authorization, createQuoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.createQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuoteOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuoteOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.createQuoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuote(organizationUnid, quoteId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.deleteQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuoteOptions(organizationUnid, quoteId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.deleteQuoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote(organizationUnid, quoteId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.getQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuotes(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQuoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuotes(organizationUnid, authorization, customerId, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.listQuotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendQuote(organizationUnid: string, quoteId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendQuote(organizationUnid, quoteId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.sendQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendQuoteOptions(organizationUnid, quoteId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.sendQuoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuote(organizationUnid: string, quoteId: string, authorization: string, updateQuoteRequest: UpdateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuote(organizationUnid, quoteId, authorization, updateQuoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuotesApi.updateQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuotesApi - factory interface
 * @export
 */
export const QuotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuotesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {ConvertQuoteRequest} convertQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuote(organizationUnid: string, quoteId: string, authorization: string, convertQuoteRequest: ConvertQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.convertQuote(organizationUnid, quoteId, authorization, convertQuoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.convertQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateQuoteRequest} createQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuote(organizationUnid: string, authorization: string, createQuoteRequest: CreateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQuoteResponse> {
            return localVarFp.createQuote(organizationUnid, authorization, createQuoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuoteOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createQuoteOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuote(organizationUnid, quoteId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQuoteResponse> {
            return localVarFp.getQuote(organizationUnid, quoteId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuotes(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQuoteListResponse> {
            return localVarFp.listQuotes(organizationUnid, authorization, customerId, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQuote(organizationUnid: string, quoteId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQuoteResponse> {
            return localVarFp.sendQuote(organizationUnid, quoteId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.sendQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} quoteId 
         * @param {string} authorization 
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuote(organizationUnid: string, quoteId: string, authorization: string, updateQuoteRequest: UpdateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesQuoteResponse> {
            return localVarFp.updateQuote(organizationUnid, quoteId, authorization, updateQuoteRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuotesApi - object-oriented interface
 * @export
 * @class QuotesApi
 * @extends {BaseAPI}
 */
export class QuotesApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} authorization 
     * @param {ConvertQuoteRequest} convertQuoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public convertQuote(organizationUnid: string, quoteId: string, authorization: string, convertQuoteRequest: ConvertQuoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).convertQuote(organizationUnid, quoteId, authorization, convertQuoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public convertQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).convertQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateQuoteRequest} createQuoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public createQuote(organizationUnid: string, authorization: string, createQuoteRequest: CreateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).createQuote(organizationUnid, authorization, createQuoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public createQuoteOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).createQuoteOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public deleteQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).deleteQuote(organizationUnid, quoteId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public deleteQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).deleteQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public getQuote(organizationUnid: string, quoteId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).getQuote(organizationUnid, quoteId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [customerId] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public listQuotes(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).listQuotes(organizationUnid, authorization, customerId, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public sendQuote(organizationUnid: string, quoteId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).sendQuote(organizationUnid, quoteId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public sendQuoteOptions(organizationUnid: string, quoteId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).sendQuoteOptions(organizationUnid, quoteId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} quoteId 
     * @param {string} authorization 
     * @param {UpdateQuoteRequest} updateQuoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotesApi
     */
    public updateQuote(organizationUnid: string, quoteId: string, authorization: string, updateQuoteRequest: UpdateQuoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return QuotesApiFp(this.configuration).updateQuote(organizationUnid, quoteId, authorization, updateQuoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecurringLoadsApi - axios parameter creator
 * @export
 */
export const RecurringLoadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateRecurringLoadRequest} createRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringLoad: async (organizationUnid: string, authorization: string, createRecurringLoadRequest: CreateRecurringLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createRecurringLoad', 'authorization', authorization)
            // verify required parameter 'createRecurringLoadRequest' is not null or undefined
            assertParamExists('createRecurringLoad', 'createRecurringLoadRequest', createRecurringLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecurringLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringLoadOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createRecurringLoadOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('deleteRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteRecurringLoad', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurringLoadOptions: async (organizationUnid: string, recurringLoadId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteRecurringLoadOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('deleteRecurringLoadOptions', 'recurringLoadId', recurringLoadId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {GenerateRecurringLoadRequest} generateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, generateRecurringLoadRequest: GenerateRecurringLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('generateRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('generateRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('generateRecurringLoad', 'authorization', authorization)
            // verify required parameter 'generateRecurringLoadRequest' is not null or undefined
            assertParamExists('generateRecurringLoad', 'generateRecurringLoadRequest', generateRecurringLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/generate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateRecurringLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecurringLoadOptions: async (organizationUnid: string, recurringLoadId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('generateRecurringLoadOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('generateRecurringLoadOptions', 'recurringLoadId', recurringLoadId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/generate`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('getRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRecurringLoad', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [recurrencePattern] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecurringLoads: async (organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, recurrencePattern?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listRecurringLoads', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listRecurringLoads', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (recurrencePattern !== undefined) {
                localVarQueryParameter['recurrence_pattern'] = recurrencePattern;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('pauseRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('pauseRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('pauseRecurringLoad', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('pauseRecurringLoad', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/pause`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringLoadOptions: async (organizationUnid: string, recurringLoadId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('pauseRecurringLoadOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('pauseRecurringLoadOptions', 'recurringLoadId', recurringLoadId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/pause`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resumeRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('resumeRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resumeRecurringLoad', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('resumeRecurringLoad', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/resume`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringLoadOptions: async (organizationUnid: string, recurringLoadId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resumeRecurringLoadOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('resumeRecurringLoadOptions', 'recurringLoadId', recurringLoadId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}/resume`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {UpdateRecurringLoadRequest} updateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecurringLoad: async (organizationUnid: string, recurringLoadId: string, authorization: string, updateRecurringLoadRequest: UpdateRecurringLoadRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateRecurringLoad', 'organizationUnid', organizationUnid)
            // verify required parameter 'recurringLoadId' is not null or undefined
            assertParamExists('updateRecurringLoad', 'recurringLoadId', recurringLoadId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRecurringLoad', 'authorization', authorization)
            // verify required parameter 'updateRecurringLoadRequest' is not null or undefined
            assertParamExists('updateRecurringLoad', 'updateRecurringLoadRequest', updateRecurringLoadRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/loads/recurring/{recurringLoadId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"recurringLoadId"}}`, encodeURIComponent(String(recurringLoadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRecurringLoadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecurringLoadsApi - functional programming interface
 * @export
 */
export const RecurringLoadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecurringLoadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateRecurringLoadRequest} createRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecurringLoad(organizationUnid: string, authorization: string, createRecurringLoadRequest: CreateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecurringLoad(organizationUnid, authorization, createRecurringLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.createRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecurringLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecurringLoadOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.createRecurringLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.deleteRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.deleteRecurringLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {GenerateRecurringLoadRequest} generateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, generateRecurringLoadRequest: GenerateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRecurringLoad(organizationUnid, recurringLoadId, authorization, generateRecurringLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.generateRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.generateRecurringLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.getRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [recurrencePattern] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecurringLoads(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, recurrencePattern?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecurringLoads(organizationUnid, authorization, customerId, limit, page, recurrencePattern, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.listRecurringLoads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.pauseRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.pauseRecurringLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.resumeRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.resumeRecurringLoadOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {UpdateRecurringLoadRequest} updateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, updateRecurringLoadRequest: UpdateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRecurringLoadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecurringLoad(organizationUnid, recurringLoadId, authorization, updateRecurringLoadRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringLoadsApi.updateRecurringLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecurringLoadsApi - factory interface
 * @export
 */
export const RecurringLoadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecurringLoadsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateRecurringLoadRequest} createRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringLoad(organizationUnid: string, authorization: string, createRecurringLoadRequest: CreateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadResponse> {
            return localVarFp.createRecurringLoad(organizationUnid, authorization, createRecurringLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createRecurringLoadOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {GenerateRecurringLoadRequest} generateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, generateRecurringLoadRequest: GenerateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesLoadResponse> {
            return localVarFp.generateRecurringLoad(organizationUnid, recurringLoadId, authorization, generateRecurringLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.generateRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadResponse> {
            return localVarFp.getRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [customerId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [recurrencePattern] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecurringLoads(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, recurrencePattern?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadListResponse> {
            return localVarFp.listRecurringLoads(organizationUnid, authorization, customerId, limit, page, recurrencePattern, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadResponse> {
            return localVarFp.pauseRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.pauseRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadResponse> {
            return localVarFp.resumeRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resumeRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} recurringLoadId 
         * @param {string} authorization 
         * @param {UpdateRecurringLoadRequest} updateRecurringLoadRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, updateRecurringLoadRequest: UpdateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRecurringLoadResponse> {
            return localVarFp.updateRecurringLoad(organizationUnid, recurringLoadId, authorization, updateRecurringLoadRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecurringLoadsApi - object-oriented interface
 * @export
 * @class RecurringLoadsApi
 * @extends {BaseAPI}
 */
export class RecurringLoadsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateRecurringLoadRequest} createRecurringLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public createRecurringLoad(organizationUnid: string, authorization: string, createRecurringLoadRequest: CreateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).createRecurringLoad(organizationUnid, authorization, createRecurringLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public createRecurringLoadOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).createRecurringLoadOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public deleteRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).deleteRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public deleteRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).deleteRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {GenerateRecurringLoadRequest} generateRecurringLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public generateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, generateRecurringLoadRequest: GenerateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).generateRecurringLoad(organizationUnid, recurringLoadId, authorization, generateRecurringLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public generateRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).generateRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public getRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).getRecurringLoad(organizationUnid, recurringLoadId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [customerId] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [recurrencePattern] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public listRecurringLoads(organizationUnid: string, authorization: string, customerId?: string | null, limit?: number, page?: number, recurrencePattern?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).listRecurringLoads(organizationUnid, authorization, customerId, limit, page, recurrencePattern, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public pauseRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).pauseRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public pauseRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).pauseRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public resumeRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).resumeRecurringLoad(organizationUnid, recurringLoadId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public resumeRecurringLoadOptions(organizationUnid: string, recurringLoadId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).resumeRecurringLoadOptions(organizationUnid, recurringLoadId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} recurringLoadId 
     * @param {string} authorization 
     * @param {UpdateRecurringLoadRequest} updateRecurringLoadRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringLoadsApi
     */
    public updateRecurringLoad(organizationUnid: string, recurringLoadId: string, authorization: string, updateRecurringLoadRequest: UpdateRecurringLoadRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RecurringLoadsApiFp(this.configuration).updateRecurringLoad(organizationUnid, recurringLoadId, authorization, updateRecurringLoadRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RelayApi - axios parameter creator
 * @export
 */
export const RelayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AssignRelayTransactionRequest} assignRelayTransactionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRelayTransaction: async (organizationUnid: string, transactionUnid: string, authorization: string, assignRelayTransactionRequest: AssignRelayTransactionRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('assignRelayTransaction', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('assignRelayTransaction', 'transactionUnid', transactionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('assignRelayTransaction', 'authorization', authorization)
            // verify required parameter 'assignRelayTransactionRequest' is not null or undefined
            assertParamExists('assignRelayTransaction', 'assignRelayTransactionRequest', assignRelayTransactionRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignRelayTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRelayTransactionOptions: async (organizationUnid: string, transactionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('assignRelayTransactionOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('assignRelayTransactionOptions', 'transactionUnid', transactionUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConnectRelayRequest} connectRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectRelay: async (organizationUnid: string, authorization: string, connectRelayRequest: ConnectRelayRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('connectRelay', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('connectRelay', 'authorization', authorization)
            // verify required parameter 'connectRelayRequest' is not null or undefined
            assertParamExists('connectRelay', 'connectRelayRequest', connectRelayRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/connect`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectRelayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectRelayOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('connectRelayOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/connect`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectRelay: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectRelay', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('disconnectRelay', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/disconnect`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectRelayOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectRelayOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/disconnect`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayConfig: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayConfig', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRelayConfig', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/config`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayPolicies: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayPolicies', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRelayPolicies', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/policies`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayPoliciesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayPoliciesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/policies`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayStatus: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRelayStatus', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayStatusOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayTransaction: async (organizationUnid: string, transactionUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayTransaction', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('getRelayTransaction', 'transactionUnid', transactionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRelayTransaction', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayTransactionOptions: async (organizationUnid: string, transactionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getRelayTransactionOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('getRelayTransactionOptions', 'transactionUnid', transactionUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [transactionType] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayTransactions: async (organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, page?: number, state?: string | null, status?: string | null, transactionType?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listRelayTransactions', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listRelayTransactions', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }

            if (driverId !== undefined) {
                localVarQueryParameter['driverId'] = driverId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truckId'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayTransactionsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listRelayTransactionsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedRelayDrivers: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listUnmatchedRelayDrivers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listUnmatchedRelayDrivers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/unmatched`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedRelayDriversOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listUnmatchedRelayDriversOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/unmatched`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchRelayDriverRequest} manualMatchRelayDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchRelayDriver: async (organizationUnid: string, authorization: string, manualMatchRelayDriverRequest: ManualMatchRelayDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('manualMatchRelayDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('manualMatchRelayDriver', 'authorization', authorization)
            // verify required parameter 'manualMatchRelayDriverRequest' is not null or undefined
            assertParamExists('manualMatchRelayDriver', 'manualMatchRelayDriverRequest', manualMatchRelayDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/match/manual`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manualMatchRelayDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchRelayDriverOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('manualMatchRelayDriverOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/match/manual`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchRelayDrivers: async (organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('matchRelayDrivers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('matchRelayDrivers', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('matchRelayDrivers', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/match`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchRelayDriversOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('matchRelayDriversOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/drivers/match`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rematchRelayTransaction: async (organizationUnid: string, transactionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('rematchRelayTransaction', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('rematchRelayTransaction', 'transactionUnid', transactionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('rematchRelayTransaction', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('rematchRelayTransaction', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/rematch`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rematchRelayTransactionOptions: async (organizationUnid: string, transactionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('rematchRelayTransactionOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('rematchRelayTransactionOptions', 'transactionUnid', transactionUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/rematch`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncRelayRequest} syncRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRelay: async (organizationUnid: string, authorization: string, syncRelayRequest: SyncRelayRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncRelay', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('syncRelay', 'authorization', authorization)
            // verify required parameter 'syncRelayRequest' is not null or undefined
            assertParamExists('syncRelay', 'syncRelayRequest', syncRelayRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncRelayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRelayOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('syncRelayOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/sync`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateRelayConfigRequest} updateRelayConfigRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayConfig: async (organizationUnid: string, authorization: string, updateRelayConfigRequest: UpdateRelayConfigRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateRelayConfig', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRelayConfig', 'authorization', authorization)
            // verify required parameter 'updateRelayConfigRequest' is not null or undefined
            assertParamExists('updateRelayConfig', 'updateRelayConfigRequest', updateRelayConfigRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/config`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRelayConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayConfigOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateRelayConfigOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/config`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayTransactionStatus: async (organizationUnid: string, transactionUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateRelayTransactionStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('updateRelayTransactionStatus', 'transactionUnid', transactionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRelayTransactionStatus', 'authorization', authorization)
            // verify required parameter 'updateFactoringBatchStatusRequest' is not null or undefined
            assertParamExists('updateRelayTransactionStatus', 'updateFactoringBatchStatusRequest', updateFactoringBatchStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFactoringBatchStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayTransactionStatusOptions: async (organizationUnid: string, transactionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateRelayTransactionStatusOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'transactionUnid' is not null or undefined
            assertParamExists('updateRelayTransactionStatusOptions', 'transactionUnid', transactionUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/relay/transactions/{transactionUnid}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"transactionUnid"}}`, encodeURIComponent(String(transactionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelayApi - functional programming interface
 * @export
 */
export const RelayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelayApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AssignRelayTransactionRequest} assignRelayTransactionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, assignRelayTransactionRequest: AssignRelayTransactionRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRelayTransaction(organizationUnid, transactionUnid, authorization, assignRelayTransactionRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.assignRelayTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRelayTransactionOptions(organizationUnid, transactionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.assignRelayTransactionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConnectRelayRequest} connectRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectRelay(organizationUnid: string, authorization: string, connectRelayRequest: ConnectRelayRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayConnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectRelay(organizationUnid, authorization, connectRelayRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.connectRelay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectRelayOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.connectRelayOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectRelay(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayDisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectRelay(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.disconnectRelay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectRelayOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.disconnectRelayOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayConfig(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayConfig(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayPolicies(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayPoliciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayPolicies(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayPoliciesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayPoliciesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayPoliciesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayStatus(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayStatusOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayTransaction(organizationUnid, transactionUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelayTransactionOptions(organizationUnid, transactionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.getRelayTransactionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [transactionType] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRelayTransactions(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, page?: number, state?: string | null, status?: string | null, transactionType?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayTransactionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRelayTransactions(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, page, state, status, transactionType, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.listRelayTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRelayTransactionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRelayTransactionsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.listRelayTransactionsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnmatchedRelayDrivers(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayUnmatchedDriversResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnmatchedRelayDrivers(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.listUnmatchedRelayDrivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnmatchedRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnmatchedRelayDriversOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.listUnmatchedRelayDriversOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchRelayDriverRequest} manualMatchRelayDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualMatchRelayDriver(organizationUnid: string, authorization: string, manualMatchRelayDriverRequest: ManualMatchRelayDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayManualMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualMatchRelayDriver(organizationUnid, authorization, manualMatchRelayDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.manualMatchRelayDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualMatchRelayDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualMatchRelayDriverOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.manualMatchRelayDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchRelayDrivers(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayDriverMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchRelayDrivers(organizationUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.matchRelayDrivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchRelayDriversOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.matchRelayDriversOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rematchRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rematchRelayTransaction(organizationUnid, transactionUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.rematchRelayTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rematchRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rematchRelayTransactionOptions(organizationUnid, transactionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.rematchRelayTransactionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncRelayRequest} syncRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRelay(organizationUnid: string, authorization: string, syncRelayRequest: SyncRelayRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelaySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRelay(organizationUnid, authorization, syncRelayRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.syncRelay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRelayOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.syncRelayOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateRelayConfigRequest} updateRelayConfigRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelayConfig(organizationUnid: string, authorization: string, updateRelayConfigRequest: UpdateRelayConfigRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelayConfig(organizationUnid, authorization, updateRelayConfigRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.updateRelayConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelayConfigOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelayConfigOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.updateRelayConfigOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelayTransactionStatus(organizationUnid: string, transactionUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesRelayTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelayTransactionStatus(organizationUnid, transactionUnid, authorization, updateFactoringBatchStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.updateRelayTransactionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelayTransactionStatusOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelayTransactionStatusOptions(organizationUnid, transactionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelayApi.updateRelayTransactionStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RelayApi - factory interface
 * @export
 */
export const RelayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelayApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AssignRelayTransactionRequest} assignRelayTransactionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, assignRelayTransactionRequest: AssignRelayTransactionRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayTransactionResponse> {
            return localVarFp.assignRelayTransaction(organizationUnid, transactionUnid, authorization, assignRelayTransactionRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.assignRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ConnectRelayRequest} connectRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectRelay(organizationUnid: string, authorization: string, connectRelayRequest: ConnectRelayRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayConnectResponse> {
            return localVarFp.connectRelay(organizationUnid, authorization, connectRelayRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.connectRelayOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectRelay(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayDisconnectResponse> {
            return localVarFp.disconnectRelay(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.disconnectRelayOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayConfig(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayConfigResponse> {
            return localVarFp.getRelayConfig(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayPolicies(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayPoliciesResponse> {
            return localVarFp.getRelayPolicies(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayPoliciesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getRelayPoliciesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayStatusResponse> {
            return localVarFp.getRelayStatus(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getRelayStatusOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayTransactionResponse> {
            return localVarFp.getRelayTransaction(organizationUnid, transactionUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [dateFrom] 
         * @param {string | null} [dateTo] 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [state] 
         * @param {string | null} [status] 
         * @param {string | null} [transactionType] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayTransactions(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, page?: number, state?: string | null, status?: string | null, transactionType?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayTransactionListResponse> {
            return localVarFp.listRelayTransactions(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, page, state, status, transactionType, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayTransactionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listRelayTransactionsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedRelayDrivers(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayUnmatchedDriversResponse> {
            return localVarFp.listUnmatchedRelayDrivers(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnmatchedRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listUnmatchedRelayDriversOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {ManualMatchRelayDriverRequest} manualMatchRelayDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchRelayDriver(organizationUnid: string, authorization: string, manualMatchRelayDriverRequest: ManualMatchRelayDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayManualMatchResponse> {
            return localVarFp.manualMatchRelayDriver(organizationUnid, authorization, manualMatchRelayDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualMatchRelayDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.manualMatchRelayDriverOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchRelayDrivers(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayDriverMatchResponse> {
            return localVarFp.matchRelayDrivers(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.matchRelayDriversOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rematchRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayTransactionResponse> {
            return localVarFp.rematchRelayTransaction(organizationUnid, transactionUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rematchRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.rematchRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {SyncRelayRequest} syncRelayRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRelay(organizationUnid: string, authorization: string, syncRelayRequest: SyncRelayRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelaySyncResponse> {
            return localVarFp.syncRelay(organizationUnid, authorization, syncRelayRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.syncRelayOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {UpdateRelayConfigRequest} updateRelayConfigRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayConfig(organizationUnid: string, authorization: string, updateRelayConfigRequest: UpdateRelayConfigRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayConfigResponse> {
            return localVarFp.updateRelayConfig(organizationUnid, authorization, updateRelayConfigRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayConfigOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateRelayConfigOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayTransactionStatus(organizationUnid: string, transactionUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesRelayTransactionResponse> {
            return localVarFp.updateRelayTransactionStatus(organizationUnid, transactionUnid, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} transactionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelayTransactionStatusOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateRelayTransactionStatusOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelayApi - object-oriented interface
 * @export
 * @class RelayApi
 * @extends {BaseAPI}
 */
export class RelayApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} authorization 
     * @param {AssignRelayTransactionRequest} assignRelayTransactionRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public assignRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, assignRelayTransactionRequest: AssignRelayTransactionRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).assignRelayTransaction(organizationUnid, transactionUnid, authorization, assignRelayTransactionRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public assignRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).assignRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ConnectRelayRequest} connectRelayRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public connectRelay(organizationUnid: string, authorization: string, connectRelayRequest: ConnectRelayRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).connectRelay(organizationUnid, authorization, connectRelayRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public connectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).connectRelayOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public disconnectRelay(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).disconnectRelay(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public disconnectRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).disconnectRelayOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayConfig(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayConfig(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayPolicies(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayPolicies(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayPoliciesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayPoliciesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayStatus(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayStatusOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayTransaction(organizationUnid, transactionUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public getRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).getRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [dateFrom] 
     * @param {string | null} [dateTo] 
     * @param {string | null} [driverId] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [state] 
     * @param {string | null} [status] 
     * @param {string | null} [transactionType] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public listRelayTransactions(organizationUnid: string, authorization: string, dateFrom?: string | null, dateTo?: string | null, driverId?: string | null, limit?: number, page?: number, state?: string | null, status?: string | null, transactionType?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).listRelayTransactions(organizationUnid, authorization, dateFrom, dateTo, driverId, limit, page, state, status, transactionType, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public listRelayTransactionsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).listRelayTransactionsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public listUnmatchedRelayDrivers(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).listUnmatchedRelayDrivers(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public listUnmatchedRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).listUnmatchedRelayDriversOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {ManualMatchRelayDriverRequest} manualMatchRelayDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public manualMatchRelayDriver(organizationUnid: string, authorization: string, manualMatchRelayDriverRequest: ManualMatchRelayDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).manualMatchRelayDriver(organizationUnid, authorization, manualMatchRelayDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public manualMatchRelayDriverOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).manualMatchRelayDriverOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public matchRelayDrivers(organizationUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).matchRelayDrivers(organizationUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public matchRelayDriversOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).matchRelayDriversOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public rematchRelayTransaction(organizationUnid: string, transactionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).rematchRelayTransaction(organizationUnid, transactionUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public rematchRelayTransactionOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).rematchRelayTransactionOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {SyncRelayRequest} syncRelayRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public syncRelay(organizationUnid: string, authorization: string, syncRelayRequest: SyncRelayRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).syncRelay(organizationUnid, authorization, syncRelayRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public syncRelayOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).syncRelayOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {UpdateRelayConfigRequest} updateRelayConfigRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public updateRelayConfig(organizationUnid: string, authorization: string, updateRelayConfigRequest: UpdateRelayConfigRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).updateRelayConfig(organizationUnid, authorization, updateRelayConfigRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public updateRelayConfigOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).updateRelayConfigOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} authorization 
     * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public updateRelayTransactionStatus(organizationUnid: string, transactionUnid: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).updateRelayTransactionStatus(organizationUnid, transactionUnid, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} transactionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelayApi
     */
    public updateRelayTransactionStatusOptions(organizationUnid: string, transactionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return RelayApiFp(this.configuration).updateRelayTransactionStatusOptions(organizationUnid, transactionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [asOfDate] 
         * @param {string | null} [customerId] 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgingReport: async (organizationUnid: string, authorization: string, asOfDate?: string | null, customerId?: string | null, groupBy?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAgingReport', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAgingReport', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/aging`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (asOfDate !== undefined) {
                localVarQueryParameter['as_of_date'] = asOfDate;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgingReportOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAgingReportOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/aging`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [month] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (organizationUnid: string, authorization: string, month?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDashboard', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDashboard', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/dashboard`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDashboardOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/dashboard`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {string | null} [periodEnd] 
         * @param {string | null} [periodStart] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPerformanceReport: async (organizationUnid: string, authorization: string, driverId?: string | null, periodEnd?: string | null, periodStart?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverPerformanceReport', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDriverPerformanceReport', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/driver-performance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['period_end'] = periodEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['period_start'] = periodStart;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPerformanceReportOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDriverPerformanceReportOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/driver-performance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} periodEnd 
         * @param {string} periodStart 
         * @param {string} authorization 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitabilityReport: async (organizationUnid: string, periodEnd: string, periodStart: string, authorization: string, groupBy?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getProfitabilityReport', 'organizationUnid', organizationUnid)
            // verify required parameter 'periodEnd' is not null or undefined
            assertParamExists('getProfitabilityReport', 'periodEnd', periodEnd)
            // verify required parameter 'periodStart' is not null or undefined
            assertParamExists('getProfitabilityReport', 'periodStart', periodStart)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getProfitabilityReport', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/profitability`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }

            if (periodEnd !== undefined) {
                localVarQueryParameter['period_end'] = periodEnd;
            }

            if (periodStart !== undefined) {
                localVarQueryParameter['period_start'] = periodStart;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitabilityReportOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getProfitabilityReportOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/reports/profitability`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [asOfDate] 
         * @param {string | null} [customerId] 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgingReport(organizationUnid: string, authorization: string, asOfDate?: string | null, customerId?: string | null, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAgingReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgingReport(organizationUnid, authorization, asOfDate, customerId, groupBy, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getAgingReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgingReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgingReportOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getAgingReportOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [month] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(organizationUnid: string, authorization: string, month?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDashboardReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(organizationUnid, authorization, month, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDashboardOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {string | null} [periodEnd] 
         * @param {string | null} [periodStart] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverPerformanceReport(organizationUnid: string, authorization: string, driverId?: string | null, periodEnd?: string | null, periodStart?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesDriverPerformanceReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverPerformanceReport(organizationUnid, authorization, driverId, periodEnd, periodStart, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDriverPerformanceReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriverPerformanceReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriverPerformanceReportOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getDriverPerformanceReportOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} periodEnd 
         * @param {string} periodStart 
         * @param {string} authorization 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitabilityReport(organizationUnid: string, periodEnd: string, periodStart: string, authorization: string, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesProfitabilityReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitabilityReport(organizationUnid, periodEnd, periodStart, authorization, groupBy, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getProfitabilityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitabilityReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitabilityReportOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.getProfitabilityReportOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [asOfDate] 
         * @param {string | null} [customerId] 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgingReport(organizationUnid: string, authorization: string, asOfDate?: string | null, customerId?: string | null, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAgingReportResponse> {
            return localVarFp.getAgingReport(organizationUnid, authorization, asOfDate, customerId, groupBy, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgingReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getAgingReportOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [month] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(organizationUnid: string, authorization: string, month?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDashboardReportResponse> {
            return localVarFp.getDashboard(organizationUnid, authorization, month, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDashboardOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {string | null} [periodEnd] 
         * @param {string | null} [periodStart] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPerformanceReport(organizationUnid: string, authorization: string, driverId?: string | null, periodEnd?: string | null, periodStart?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesDriverPerformanceReportResponse> {
            return localVarFp.getDriverPerformanceReport(organizationUnid, authorization, driverId, periodEnd, periodStart, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriverPerformanceReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDriverPerformanceReportOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} periodEnd 
         * @param {string} periodStart 
         * @param {string} authorization 
         * @param {string | null} [groupBy] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitabilityReport(organizationUnid: string, periodEnd: string, periodStart: string, authorization: string, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesProfitabilityReportResponse> {
            return localVarFp.getProfitabilityReport(organizationUnid, periodEnd, periodStart, authorization, groupBy, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitabilityReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getProfitabilityReportOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [asOfDate] 
     * @param {string | null} [customerId] 
     * @param {string | null} [groupBy] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getAgingReport(organizationUnid: string, authorization: string, asOfDate?: string | null, customerId?: string | null, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getAgingReport(organizationUnid, authorization, asOfDate, customerId, groupBy, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getAgingReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getAgingReportOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [month] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getDashboard(organizationUnid: string, authorization: string, month?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getDashboard(organizationUnid, authorization, month, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getDashboardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getDashboardOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [driverId] 
     * @param {string | null} [periodEnd] 
     * @param {string | null} [periodStart] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getDriverPerformanceReport(organizationUnid: string, authorization: string, driverId?: string | null, periodEnd?: string | null, periodStart?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getDriverPerformanceReport(organizationUnid, authorization, driverId, periodEnd, periodStart, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getDriverPerformanceReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getDriverPerformanceReportOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} periodEnd 
     * @param {string} periodStart 
     * @param {string} authorization 
     * @param {string | null} [groupBy] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getProfitabilityReport(organizationUnid: string, periodEnd: string, periodStart: string, authorization: string, groupBy?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getProfitabilityReport(organizationUnid, periodEnd, periodStart, authorization, groupBy, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public getProfitabilityReportOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).getProfitabilityReportOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SamsaraApi - axios parameter creator
 * @export
 */
export const SamsaraApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSamsara: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectSamsara', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('disconnectSamsara', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSamsaraOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('disconnectSamsaraOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraAuthURL: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSamsaraAuthURL', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSamsaraAuthURL', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara/auth`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraAuthURLOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSamsaraAuthURLOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara/auth`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraStatus: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSamsaraStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSamsaraStatus', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraStatusOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSamsaraStatusOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/integrations/samsara/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SamsaraApi - functional programming interface
 * @export
 */
export const SamsaraApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SamsaraApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectSamsara(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSamsaraDisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectSamsara(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.disconnectSamsara']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectSamsaraOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectSamsaraOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.disconnectSamsaraOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamsaraAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSamsaraAuthURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamsaraAuthURL(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.getSamsaraAuthURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamsaraAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamsaraAuthURLOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.getSamsaraAuthURLOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamsaraStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSamsaraIntegrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamsaraStatus(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.getSamsaraStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamsaraStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamsaraStatusOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraApi.getSamsaraStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SamsaraApi - factory interface
 * @export
 */
export const SamsaraApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SamsaraApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSamsara(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSamsaraDisconnectResponse> {
            return localVarFp.disconnectSamsara(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectSamsaraOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.disconnectSamsaraOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSamsaraAuthURLResponse> {
            return localVarFp.getSamsaraAuthURL(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getSamsaraAuthURLOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSamsaraIntegrationStatusResponse> {
            return localVarFp.getSamsaraStatus(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamsaraStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getSamsaraStatusOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SamsaraApi - object-oriented interface
 * @export
 * @class SamsaraApi
 * @extends {BaseAPI}
 */
export class SamsaraApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public disconnectSamsara(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).disconnectSamsara(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public disconnectSamsaraOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).disconnectSamsaraOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public getSamsaraAuthURL(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).getSamsaraAuthURL(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public getSamsaraAuthURLOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).getSamsaraAuthURLOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public getSamsaraStatus(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).getSamsaraStatus(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraApi
     */
    public getSamsaraStatusOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraApiFp(this.configuration).getSamsaraStatusOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SamsaraCallbackApi - axios parameter creator
 * @export
 */
export const SamsaraCallbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {HandleSamsaraCallbackRequest} handleSamsaraCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSamsaraCallback: async (handleSamsaraCallbackRequest: HandleSamsaraCallbackRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'handleSamsaraCallbackRequest' is not null or undefined
            assertParamExists('handleSamsaraCallback', 'handleSamsaraCallbackRequest', handleSamsaraCallbackRequest)
            const localVarPath = `/api/v1/integrations/samsara/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(handleSamsaraCallbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSamsaraCallbackOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/integrations/samsara/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SamsaraCallbackApi - functional programming interface
 * @export
 */
export const SamsaraCallbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SamsaraCallbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {HandleSamsaraCallbackRequest} handleSamsaraCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleSamsaraCallback(handleSamsaraCallbackRequest: HandleSamsaraCallbackRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSamsaraOAuthCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleSamsaraCallback(handleSamsaraCallbackRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraCallbackApi.handleSamsaraCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleSamsaraCallbackOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleSamsaraCallbackOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraCallbackApi.handleSamsaraCallbackOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SamsaraCallbackApi - factory interface
 * @export
 */
export const SamsaraCallbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SamsaraCallbackApiFp(configuration)
    return {
        /**
         * 
         * @param {HandleSamsaraCallbackRequest} handleSamsaraCallbackRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSamsaraCallback(handleSamsaraCallbackRequest: HandleSamsaraCallbackRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSamsaraOAuthCallbackResponse> {
            return localVarFp.handleSamsaraCallback(handleSamsaraCallbackRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleSamsaraCallbackOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.handleSamsaraCallbackOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SamsaraCallbackApi - object-oriented interface
 * @export
 * @class SamsaraCallbackApi
 * @extends {BaseAPI}
 */
export class SamsaraCallbackApi extends BaseAPI {
    /**
     * 
     * @param {HandleSamsaraCallbackRequest} handleSamsaraCallbackRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraCallbackApi
     */
    public handleSamsaraCallback(handleSamsaraCallbackRequest: HandleSamsaraCallbackRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraCallbackApiFp(this.configuration).handleSamsaraCallback(handleSamsaraCallbackRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraCallbackApi
     */
    public handleSamsaraCallbackOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraCallbackApiFp(this.configuration).handleSamsaraCallbackOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SamsaraWebhooksApi - axios parameter creator
 * @export
 */
export const SamsaraWebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [xSamsaraEventType] 
         * @param {string} [xSamsaraOrgId] 
         * @param {string} [xSamsaraRequest] 
         * @param {string} [xSamsaraSignature] 
         * @param {string} [xSamsaraTimestamp] 
         * @param {string} [xZuzhqOrganizationUnid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook: async (origin?: string, xSamsaraEventType?: string, xSamsaraOrgId?: string, xSamsaraRequest?: string, xSamsaraSignature?: string, xSamsaraTimestamp?: string, xZuzhqOrganizationUnid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks/samsara/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            if (xSamsaraEventType != null) {
                localVarHeaderParameter['X-Samsara-Event-Type'] = String(xSamsaraEventType);
            }
            if (xSamsaraOrgId != null) {
                localVarHeaderParameter['X-Samsara-Org-Id'] = String(xSamsaraOrgId);
            }
            if (xSamsaraRequest != null) {
                localVarHeaderParameter['X-Samsara-Request'] = String(xSamsaraRequest);
            }
            if (xSamsaraSignature != null) {
                localVarHeaderParameter['X-Samsara-Signature'] = String(xSamsaraSignature);
            }
            if (xSamsaraTimestamp != null) {
                localVarHeaderParameter['X-Samsara-Timestamp'] = String(xSamsaraTimestamp);
            }
            if (xZuzhqOrganizationUnid != null) {
                localVarHeaderParameter['x-zuzhq-organization-unid'] = String(xZuzhqOrganizationUnid);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks/samsara/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SamsaraWebhooksApi - functional programming interface
 * @export
 */
export const SamsaraWebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SamsaraWebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [xSamsaraEventType] 
         * @param {string} [xSamsaraOrgId] 
         * @param {string} [xSamsaraRequest] 
         * @param {string} [xSamsaraSignature] 
         * @param {string} [xSamsaraTimestamp] 
         * @param {string} [xZuzhqOrganizationUnid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook(origin?: string, xSamsaraEventType?: string, xSamsaraOrgId?: string, xSamsaraRequest?: string, xSamsaraSignature?: string, xSamsaraTimestamp?: string, xZuzhqOrganizationUnid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook(origin, xSamsaraEventType, xSamsaraOrgId, xSamsaraRequest, xSamsaraSignature, xSamsaraTimestamp, xZuzhqOrganizationUnid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraWebhooksApi.handleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhookOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SamsaraWebhooksApi.handleWebhookOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SamsaraWebhooksApi - factory interface
 * @export
 */
export const SamsaraWebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SamsaraWebhooksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [origin] 
         * @param {string} [xSamsaraEventType] 
         * @param {string} [xSamsaraOrgId] 
         * @param {string} [xSamsaraRequest] 
         * @param {string} [xSamsaraSignature] 
         * @param {string} [xSamsaraTimestamp] 
         * @param {string} [xZuzhqOrganizationUnid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook(origin?: string, xSamsaraEventType?: string, xSamsaraOrgId?: string, xSamsaraRequest?: string, xSamsaraSignature?: string, xSamsaraTimestamp?: string, xZuzhqOrganizationUnid?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWebhookResponse> {
            return localVarFp.handleWebhook(origin, xSamsaraEventType, xSamsaraOrgId, xSamsaraRequest, xSamsaraSignature, xSamsaraTimestamp, xZuzhqOrganizationUnid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.handleWebhookOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SamsaraWebhooksApi - object-oriented interface
 * @export
 * @class SamsaraWebhooksApi
 * @extends {BaseAPI}
 */
export class SamsaraWebhooksApi extends BaseAPI {
    /**
     * 
     * @param {string} [origin] 
     * @param {string} [xSamsaraEventType] 
     * @param {string} [xSamsaraOrgId] 
     * @param {string} [xSamsaraRequest] 
     * @param {string} [xSamsaraSignature] 
     * @param {string} [xSamsaraTimestamp] 
     * @param {string} [xZuzhqOrganizationUnid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraWebhooksApi
     */
    public handleWebhook(origin?: string, xSamsaraEventType?: string, xSamsaraOrgId?: string, xSamsaraRequest?: string, xSamsaraSignature?: string, xSamsaraTimestamp?: string, xZuzhqOrganizationUnid?: string, options?: RawAxiosRequestConfig) {
        return SamsaraWebhooksApiFp(this.configuration).handleWebhook(origin, xSamsaraEventType, xSamsaraOrgId, xSamsaraRequest, xSamsaraSignature, xSamsaraTimestamp, xZuzhqOrganizationUnid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamsaraWebhooksApi
     */
    public handleWebhookOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return SamsaraWebhooksApiFp(this.configuration).handleWebhookOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettlementsApi - axios parameter creator
 * @export
 */
export const SettlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlement: async (organizationUnid: string, settlementId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getSettlement', 'organizationUnid', organizationUnid)
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('getSettlement', 'settlementId', settlementId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSettlement', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/settlements/{settlementId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"settlementId"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSettlements: async (organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listSettlements', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listSettlements', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/settlements`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverId !== undefined) {
                localVarQueryParameter['driver_id'] = driverId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSettlementsOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listSettlementsOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/settlements`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {UpdateSettlementRequest} updateSettlementRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlement: async (organizationUnid: string, settlementId: string, authorization: string, updateSettlementRequest: UpdateSettlementRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateSettlement', 'organizationUnid', organizationUnid)
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('updateSettlement', 'settlementId', settlementId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateSettlement', 'authorization', authorization)
            // verify required parameter 'updateSettlementRequest' is not null or undefined
            assertParamExists('updateSettlement', 'updateSettlementRequest', updateSettlementRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/settlements/{settlementId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"settlementId"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettlementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementOptions: async (organizationUnid: string, settlementId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateSettlementOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('updateSettlementOptions', 'settlementId', settlementId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/settlements/{settlementId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"settlementId"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettlementsApi - functional programming interface
 * @export
 */
export const SettlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettlement(organizationUnid: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSettlementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettlement(organizationUnid, settlementId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettlementsApi.getSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSettlements(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSettlementListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSettlements(organizationUnid, authorization, driverId, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettlementsApi.listSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSettlementsOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettlementsApi.listSettlementsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {UpdateSettlementRequest} updateSettlementRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettlement(organizationUnid: string, settlementId: string, authorization: string, updateSettlementRequest: UpdateSettlementRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSettlementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettlement(organizationUnid, settlementId, authorization, updateSettlementRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettlementsApi.updateSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettlementOptions(organizationUnid: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettlementOptions(organizationUnid, settlementId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettlementsApi.updateSettlementOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettlementsApi - factory interface
 * @export
 */
export const SettlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettlementsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlement(organizationUnid: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSettlementResponse> {
            return localVarFp.getSettlement(organizationUnid, settlementId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [driverId] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSettlements(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSettlementListResponse> {
            return localVarFp.listSettlements(organizationUnid, authorization, driverId, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listSettlementsOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} authorization 
         * @param {UpdateSettlementRequest} updateSettlementRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlement(organizationUnid: string, settlementId: string, authorization: string, updateSettlementRequest: UpdateSettlementRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSettlementResponse> {
            return localVarFp.updateSettlement(organizationUnid, settlementId, authorization, updateSettlementRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} settlementId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementOptions(organizationUnid: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateSettlementOptions(organizationUnid, settlementId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettlementsApi - object-oriented interface
 * @export
 * @class SettlementsApi
 * @extends {BaseAPI}
 */
export class SettlementsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} settlementId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementsApi
     */
    public getSettlement(organizationUnid: string, settlementId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SettlementsApiFp(this.configuration).getSettlement(organizationUnid, settlementId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [driverId] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementsApi
     */
    public listSettlements(organizationUnid: string, authorization: string, driverId?: string | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, origin?: string, options?: RawAxiosRequestConfig) {
        return SettlementsApiFp(this.configuration).listSettlements(organizationUnid, authorization, driverId, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementsApi
     */
    public listSettlementsOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SettlementsApiFp(this.configuration).listSettlementsOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} settlementId 
     * @param {string} authorization 
     * @param {UpdateSettlementRequest} updateSettlementRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementsApi
     */
    public updateSettlement(organizationUnid: string, settlementId: string, authorization: string, updateSettlementRequest: UpdateSettlementRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return SettlementsApiFp(this.configuration).updateSettlement(organizationUnid, settlementId, authorization, updateSettlementRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} settlementId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementsApi
     */
    public updateSettlementOptions(organizationUnid: string, settlementId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SettlementsApiFp(this.configuration).updateSettlementOptions(organizationUnid, settlementId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionUnid' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionUnid', subscriptionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('cancelSubscription', 'authorization', authorization)
            const localVarPath = `/api/v1/subscriptions/{subscriptionUnid}`
                .replace(`{${"subscriptionUnid"}}`, encodeURIComponent(String(subscriptionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscriptionOptions: async (subscriptionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionUnid' is not null or undefined
            assertParamExists('cancelSubscriptionOptions', 'subscriptionUnid', subscriptionUnid)
            const localVarPath = `/api/v1/subscriptions/{subscriptionUnid}`
                .replace(`{${"subscriptionUnid"}}`, encodeURIComponent(String(subscriptionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateStripeCheckoutRequest} createStripeCheckoutRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckout: async (authorization: string, createStripeCheckoutRequest: CreateStripeCheckoutRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createStripeCheckout', 'authorization', authorization)
            // verify required parameter 'createStripeCheckoutRequest' is not null or undefined
            assertParamExists('createStripeCheckout', 'createStripeCheckoutRequest', createStripeCheckoutRequest)
            const localVarPath = `/api/v1/subscriptions/stripe/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStripeCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckoutOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/stripe/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscription: async (subscriptionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionUnid' is not null or undefined
            assertParamExists('resumeSubscription', 'subscriptionUnid', subscriptionUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resumeSubscription', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('resumeSubscription', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/subscriptions/{subscriptionUnid}/resume`
                .replace(`{${"subscriptionUnid"}}`, encodeURIComponent(String(subscriptionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscriptionOptions: async (subscriptionUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionUnid' is not null or undefined
            assertParamExists('resumeSubscriptionOptions', 'subscriptionUnid', subscriptionUnid)
            const localVarPath = `/api/v1/subscriptions/{subscriptionUnid}/resume`
                .replace(`{${"subscriptionUnid"}}`, encodeURIComponent(String(subscriptionUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpgradeSubscriptionRequest} upgradeSubscriptionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscription: async (authorization: string, upgradeSubscriptionRequest: UpgradeSubscriptionRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('upgradeSubscription', 'authorization', authorization)
            // verify required parameter 'upgradeSubscriptionRequest' is not null or undefined
            assertParamExists('upgradeSubscription', 'upgradeSubscriptionRequest', upgradeSubscriptionRequest)
            const localVarPath = `/api/v1/subscriptions/upgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscriptionOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/upgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscriptionOptions(subscriptionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.cancelSubscriptionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateStripeCheckoutRequest} createStripeCheckoutRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeCheckout(authorization: string, createStripeCheckoutRequest: CreateStripeCheckoutRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesStripeCheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeCheckout(authorization, createStripeCheckoutRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.createStripeCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeCheckoutOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeCheckoutOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.createStripeCheckoutOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeSubscription(subscriptionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeSubscription(subscriptionUnid, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.resumeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeSubscriptionOptions(subscriptionUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.resumeSubscriptionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpgradeSubscriptionRequest} upgradeSubscriptionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upgradeSubscription(authorization: string, upgradeSubscriptionRequest: UpgradeSubscriptionRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upgradeSubscription(authorization, upgradeSubscriptionRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.upgradeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upgradeSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upgradeSubscriptionOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.upgradeSubscriptionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.cancelSubscription(subscriptionUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.cancelSubscriptionOptions(subscriptionUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {CreateStripeCheckoutRequest} createStripeCheckoutRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckout(authorization: string, createStripeCheckoutRequest: CreateStripeCheckoutRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesStripeCheckoutResponse> {
            return localVarFp.createStripeCheckout(authorization, createStripeCheckoutRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCheckoutOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createStripeCheckoutOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscription(subscriptionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resumeSubscription(subscriptionUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resumeSubscriptionOptions(subscriptionUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpgradeSubscriptionRequest} upgradeSubscriptionRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscription(authorization: string, upgradeSubscriptionRequest: UpgradeSubscriptionRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.upgradeSubscription(authorization, upgradeSubscriptionRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.upgradeSubscriptionOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI {
    /**
     * 
     * @param {string} subscriptionUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public cancelSubscription(subscriptionUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).cancelSubscription(subscriptionUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public cancelSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).cancelSubscriptionOptions(subscriptionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {CreateStripeCheckoutRequest} createStripeCheckoutRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public createStripeCheckout(authorization: string, createStripeCheckoutRequest: CreateStripeCheckoutRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).createStripeCheckout(authorization, createStripeCheckoutRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public createStripeCheckoutOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).createStripeCheckoutOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionUnid 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public resumeSubscription(subscriptionUnid: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).resumeSubscription(subscriptionUnid, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public resumeSubscriptionOptions(subscriptionUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).resumeSubscriptionOptions(subscriptionUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {UpgradeSubscriptionRequest} upgradeSubscriptionRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public upgradeSubscription(authorization: string, upgradeSubscriptionRequest: UpgradeSubscriptionRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).upgradeSubscription(authorization, upgradeSubscriptionRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public upgradeSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).upgradeSubscriptionOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TechniciansApi - axios parameter creator
 * @export
 */
export const TechniciansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTechnicianRequest} createTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnician: async (organizationUnid: string, authorization: string, createTechnicianRequest: CreateTechnicianRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTechnician', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTechnician', 'authorization', authorization)
            // verify required parameter 'createTechnicianRequest' is not null or undefined
            assertParamExists('createTechnician', 'createTechnicianRequest', createTechnicianRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTechnicianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicianOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTechnicianOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnician: async (organizationUnid: string, technicianId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTechnician', 'organizationUnid', organizationUnid)
            // verify required parameter 'technicianId' is not null or undefined
            assertParamExists('getTechnician', 'technicianId', technicianId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTechnician', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians/{technicianId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"technicianId"}}`, encodeURIComponent(String(technicianId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTechnicians: async (organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTechnicians', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTechnicians', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {UpdateTechnicianRequest} updateTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTechnician: async (organizationUnid: string, technicianId: string, authorization: string, updateTechnicianRequest: UpdateTechnicianRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTechnician', 'organizationUnid', organizationUnid)
            // verify required parameter 'technicianId' is not null or undefined
            assertParamExists('updateTechnician', 'technicianId', technicianId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTechnician', 'authorization', authorization)
            // verify required parameter 'updateTechnicianRequest' is not null or undefined
            assertParamExists('updateTechnician', 'updateTechnicianRequest', updateTechnicianRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians/{technicianId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"technicianId"}}`, encodeURIComponent(String(technicianId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTechnicianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTechnicianOptions: async (organizationUnid: string, technicianId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTechnicianOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'technicianId' is not null or undefined
            assertParamExists('updateTechnicianOptions', 'technicianId', technicianId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/technicians/{technicianId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"technicianId"}}`, encodeURIComponent(String(technicianId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TechniciansApi - functional programming interface
 * @export
 */
export const TechniciansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TechniciansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTechnicianRequest} createTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTechnician(organizationUnid: string, authorization: string, createTechnicianRequest: CreateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTechnicianResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTechnician(organizationUnid, authorization, createTechnicianRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.createTechnician']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTechnicianOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTechnicianOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.createTechnicianOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnician(organizationUnid: string, technicianId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTechnicianResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnician(organizationUnid, technicianId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.getTechnician']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTechnicians(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTechnicianListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTechnicians(organizationUnid, authorization, limit, page, search, status, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.listTechnicians']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {UpdateTechnicianRequest} updateTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTechnician(organizationUnid: string, technicianId: string, authorization: string, updateTechnicianRequest: UpdateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTechnicianResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTechnician(organizationUnid, technicianId, authorization, updateTechnicianRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.updateTechnician']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTechnicianOptions(organizationUnid: string, technicianId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTechnicianOptions(organizationUnid, technicianId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechniciansApi.updateTechnicianOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TechniciansApi - factory interface
 * @export
 */
export const TechniciansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TechniciansApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTechnicianRequest} createTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnician(organizationUnid: string, authorization: string, createTechnicianRequest: CreateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTechnicianResponse> {
            return localVarFp.createTechnician(organizationUnid, authorization, createTechnicianRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTechnicianOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createTechnicianOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnician(organizationUnid: string, technicianId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTechnicianResponse> {
            return localVarFp.getTechnician(organizationUnid, technicianId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTechnicians(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTechnicianListResponse> {
            return localVarFp.listTechnicians(organizationUnid, authorization, limit, page, search, status, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} authorization 
         * @param {UpdateTechnicianRequest} updateTechnicianRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTechnician(organizationUnid: string, technicianId: string, authorization: string, updateTechnicianRequest: UpdateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTechnicianResponse> {
            return localVarFp.updateTechnician(organizationUnid, technicianId, authorization, updateTechnicianRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} technicianId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTechnicianOptions(organizationUnid: string, technicianId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateTechnicianOptions(organizationUnid, technicianId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TechniciansApi - object-oriented interface
 * @export
 * @class TechniciansApi
 * @extends {BaseAPI}
 */
export class TechniciansApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateTechnicianRequest} createTechnicianRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public createTechnician(organizationUnid: string, authorization: string, createTechnicianRequest: CreateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).createTechnician(organizationUnid, authorization, createTechnicianRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public createTechnicianOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).createTechnicianOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} technicianId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public getTechnician(organizationUnid: string, technicianId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).getTechnician(organizationUnid, technicianId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [status] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public listTechnicians(organizationUnid: string, authorization: string, limit?: number, page?: number, search?: string | null, status?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).listTechnicians(organizationUnid, authorization, limit, page, search, status, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} technicianId 
     * @param {string} authorization 
     * @param {UpdateTechnicianRequest} updateTechnicianRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public updateTechnician(organizationUnid: string, technicianId: string, authorization: string, updateTechnicianRequest: UpdateTechnicianRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).updateTechnician(organizationUnid, technicianId, authorization, updateTechnicianRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} technicianId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechniciansApi
     */
    public updateTechnicianOptions(organizationUnid: string, technicianId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TechniciansApiFp(this.configuration).updateTechnicianOptions(organizationUnid, technicianId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrailerMaintenanceApi - axios parameter creator
 * @export
 */
export const TrailerMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenance: async (organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('getTrailerMaintenance', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTrailerMaintenance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerMaintenanceOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('getTrailerMaintenanceOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerMaintenanceApi - functional programming interface
 * @export
 */
export const TrailerMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerMaintenance(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerMaintenance(organizationUnid, trailerId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceApi.getTrailerMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerMaintenanceOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerMaintenanceOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceApi.getTrailerMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrailerMaintenanceApi - factory interface
 * @export
 */
export const TrailerMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenance(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceListResponse> {
            return localVarFp.getTrailerMaintenance(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTrailerMaintenanceOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerMaintenanceApi - object-oriented interface
 * @export
 * @class TrailerMaintenanceApi
 * @extends {BaseAPI}
 */
export class TrailerMaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceApi
     */
    public getTrailerMaintenance(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceApiFp(this.configuration).getTrailerMaintenance(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceApi
     */
    public getTrailerMaintenanceOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceApiFp(this.configuration).getTrailerMaintenanceOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrailerMaintenanceDetailApi - axios parameter creator
 * @export
 */
export const TrailerMaintenanceDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerCompletedWorkOrders: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerCompletedWorkOrders', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerCompletedWorkOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTrailerCompletedWorkOrders', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/work-orders/completed`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerCompletedWorkOrdersOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerCompletedWorkOrdersOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerCompletedWorkOrdersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/work-orders/completed`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceSchedules: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerMaintenanceSchedules', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerMaintenanceSchedules', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTrailerMaintenanceSchedules', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/schedules`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceSchedulesOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerMaintenanceSchedulesOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerMaintenanceSchedulesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/schedules`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerOpenWorkOrders: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerOpenWorkOrders', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerOpenWorkOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTrailerOpenWorkOrders', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/work-orders/open`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerOpenWorkOrdersOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTrailerOpenWorkOrdersOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailerOpenWorkOrdersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trailers/{equipmentId}/work-orders/open`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailerMaintenanceDetailApi - functional programming interface
 * @export
 */
export const TrailerMaintenanceDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailerMaintenanceDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerCompletedWorkOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerCompletedWorkOrdersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerMaintenanceSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerMaintenanceSchedulesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerOpenWorkOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailerOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailerOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailerMaintenanceDetailApi.getTrailerOpenWorkOrdersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrailerMaintenanceDetailApi - factory interface
 * @export
 */
export const TrailerMaintenanceDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailerMaintenanceDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderListResponse> {
            return localVarFp.getTrailerCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTrailerCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceListResponse> {
            return localVarFp.getTrailerMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTrailerMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderListResponse> {
            return localVarFp.getTrailerOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailerOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTrailerOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailerMaintenanceDetailApi - object-oriented interface
 * @export
 * @class TrailerMaintenanceDetailApi
 * @extends {BaseAPI}
 */
export class TrailerMaintenanceDetailApi extends BaseAPI {
    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [type] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailerMaintenanceDetailApi
     */
    public getTrailerOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailerMaintenanceDetailApiFp(this.configuration).getTrailerOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrailersApi - axios parameter creator
 * @export
 */
export const TrailersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTrailerRequest} createTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailer: async (organizationUnid: string, authorization: string, createTrailerRequest: CreateTrailerRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTrailer', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTrailer', 'authorization', authorization)
            // verify required parameter 'createTrailerRequest' is not null or undefined
            assertParamExists('createTrailer', 'createTrailerRequest', createTrailerRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrailerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailerNote: async (organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTrailerNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('createTrailerNote', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTrailerNote', 'authorization', authorization)
            // verify required parameter 'createTrailerNoteRequest' is not null or undefined
            assertParamExists('createTrailerNote', 'createTrailerNoteRequest', createTrailerNoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrailerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailerOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTrailerOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailer: async (organizationUnid: string, trailerId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTrailer', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('deleteTrailer', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTrailer', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerNote: async (noteId: string, organizationUnid: string, trailerId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteTrailerNote', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTrailerNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('deleteTrailerNote', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTrailerNote', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerNoteOptions: async (noteId: string, organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteTrailerNoteOptions', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTrailerNoteOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('deleteTrailerNoteOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTrailerOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('deleteTrailerOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrailers: async (organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, trailerType?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableTrailers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAvailableTrailers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hasLiftGate !== undefined) {
                localVarQueryParameter['has_lift_gate'] = hasLiftGate;
            }

            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }

            if (trailerType !== undefined) {
                localVarQueryParameter['trailer_type'] = trailerType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrailersOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableTrailersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailer: async (organizationUnid: string, trailerId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTrailer', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('getTrailer', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTrailer', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerLocationHistory: async (organizationUnid: string, trailerId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerLocationHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerLocationHistory', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTrailerLocationHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/location-history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerLocationHistoryOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerLocationHistoryOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerLocationHistoryOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/location-history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerNotes: async (organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerNotes', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerNotes', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTrailerNotes', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerNotesOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailerNotesOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('listTrailerNotesOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailers: async (organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, trailerType?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrailers', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTrailers', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hasLiftGate !== undefined) {
                localVarQueryParameter['has_lift_gate'] = hasLiftGate;
            }

            if (length !== undefined) {
                localVarQueryParameter['length'] = length;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (trailerType !== undefined) {
                localVarQueryParameter['trailer_type'] = trailerType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerAssignDriver: async (organizationUnid: string, trailerId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('trailerAssignDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('trailerAssignDriver', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('trailerAssignDriver', 'authorization', authorization)
            // verify required parameter 'trailerAssignDriverRequest' is not null or undefined
            assertParamExists('trailerAssignDriver', 'trailerAssignDriverRequest', trailerAssignDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trailerAssignDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerAssignDriverOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('trailerAssignDriverOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('trailerAssignDriverOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerUnassignDriver: async (organizationUnid: string, trailerId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('trailerUnassignDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('trailerUnassignDriver', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('trailerUnassignDriver', 'authorization', authorization)
            // verify required parameter 'trailerUnassignDriverRequest' is not null or undefined
            assertParamExists('trailerUnassignDriver', 'trailerUnassignDriverRequest', trailerUnassignDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/unassign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trailerUnassignDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerUnassignDriverOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('trailerUnassignDriverOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('trailerUnassignDriverOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/unassign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerRequest} updateTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailer: async (organizationUnid: string, trailerId: string, authorization: string, updateTrailerRequest: UpdateTrailerRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTrailer', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('updateTrailer', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTrailer', 'authorization', authorization)
            // verify required parameter 'updateTrailerRequest' is not null or undefined
            assertParamExists('updateTrailer', 'updateTrailerRequest', updateTrailerRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrailerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerNote: async (noteId: string, organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('updateTrailerNote', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTrailerNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('updateTrailerNote', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTrailerNote', 'authorization', authorization)
            // verify required parameter 'createTrailerNoteRequest' is not null or undefined
            assertParamExists('updateTrailerNote', 'createTrailerNoteRequest', createTrailerNoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrailerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerStatusRequest} updateTrailerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerStatus: async (organizationUnid: string, trailerId: string, authorization: string, updateTrailerStatusRequest: UpdateTrailerStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTrailerStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('updateTrailerStatus', 'trailerId', trailerId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTrailerStatus', 'authorization', authorization)
            // verify required parameter 'updateTrailerStatusRequest' is not null or undefined
            assertParamExists('updateTrailerStatus', 'updateTrailerStatusRequest', updateTrailerStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrailerStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerStatusOptions: async (organizationUnid: string, trailerId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTrailerStatusOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'trailerId' is not null or undefined
            assertParamExists('updateTrailerStatusOptions', 'trailerId', trailerId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trailers/{trailerId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"trailerId"}}`, encodeURIComponent(String(trailerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrailersApi - functional programming interface
 * @export
 */
export const TrailersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrailersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTrailerRequest} createTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrailer(organizationUnid: string, authorization: string, createTrailerRequest: CreateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrailer(organizationUnid, authorization, createTrailerRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.createTrailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrailerNote(organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrailerNote(organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.createTrailerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrailerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrailerOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.createTrailerOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrailer(organizationUnid, trailerId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.deleteTrailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrailerNote(noteId, organizationUnid, trailerId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.deleteTrailerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrailerNoteOptions(noteId: string, organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrailerNoteOptions(noteId, organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.deleteTrailerNoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrailerOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrailerOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.deleteTrailerOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAvailableTrailersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTrailers(organizationUnid, authorization, hasLiftGate, length, trailerType, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.getAvailableTrailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTrailersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTrailersOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.getAvailableTrailersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrailer(organizationUnid, trailerId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.getTrailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerLocationHistory(organizationUnid: string, trailerId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerLocationHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerLocationHistory(organizationUnid, trailerId, authorization, from, limit, page, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.listTrailerLocationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerLocationHistoryOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerLocationHistoryOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.listTrailerLocationHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerNotes(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerNoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerNotes(organizationUnid, trailerId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.listTrailerNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailerNotesOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailerNotesOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.listTrailerNotesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrailers(organizationUnid, authorization, hasLiftGate, length, limit, page, search, status, trailerType, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.listTrailers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trailerAssignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trailerAssignDriver(organizationUnid, trailerId, authorization, trailerAssignDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.trailerAssignDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trailerAssignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trailerAssignDriverOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.trailerAssignDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trailerUnassignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trailerUnassignDriver(organizationUnid, trailerId, authorization, trailerUnassignDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.trailerUnassignDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trailerUnassignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trailerUnassignDriverOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.trailerUnassignDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerRequest} updateTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrailer(organizationUnid: string, trailerId: string, authorization: string, updateTrailerRequest: UpdateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrailer(organizationUnid, trailerId, authorization, updateTrailerRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.updateTrailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrailerNote(noteId, organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.updateTrailerNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerStatusRequest} updateTrailerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrailerStatus(organizationUnid: string, trailerId: string, authorization: string, updateTrailerStatusRequest: UpdateTrailerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTrailerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrailerStatus(organizationUnid, trailerId, authorization, updateTrailerStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.updateTrailerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrailerStatusOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrailerStatusOptions(organizationUnid, trailerId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrailersApi.updateTrailerStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrailersApi - factory interface
 * @export
 */
export const TrailersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrailersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTrailerRequest} createTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailer(organizationUnid: string, authorization: string, createTrailerRequest: CreateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.createTrailer(organizationUnid, authorization, createTrailerRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailerNote(organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerNoteResponse> {
            return localVarFp.createTrailerNote(organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrailerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createTrailerOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTrailer(organizationUnid, trailerId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTrailerNote(noteId, organizationUnid, trailerId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerNoteOptions(noteId: string, organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTrailerNoteOptions(noteId, organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrailerOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTrailerOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAvailableTrailersResponse> {
            return localVarFp.getAvailableTrailers(organizationUnid, authorization, hasLiftGate, length, trailerType, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrailersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getAvailableTrailersOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.getTrailer(organizationUnid, trailerId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerLocationHistory(organizationUnid: string, trailerId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerLocationHistoryResponse> {
            return localVarFp.listTrailerLocationHistory(organizationUnid, trailerId, authorization, from, limit, page, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerLocationHistoryOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTrailerLocationHistoryOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerNotes(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerNoteListResponse> {
            return localVarFp.listTrailerNotes(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailerNotesOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTrailerNotesOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasLiftGate] 
         * @param {number | null} [length] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [trailerType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerListResponse> {
            return localVarFp.listTrailers(organizationUnid, authorization, hasLiftGate, length, limit, page, search, status, trailerType, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerAssignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.trailerAssignDriver(organizationUnid, trailerId, authorization, trailerAssignDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerAssignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.trailerAssignDriverOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerUnassignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.trailerUnassignDriver(organizationUnid, trailerId, authorization, trailerUnassignDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trailerUnassignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.trailerUnassignDriverOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerRequest} updateTrailerRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailer(organizationUnid: string, trailerId: string, authorization: string, updateTrailerRequest: UpdateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.updateTrailer(organizationUnid, trailerId, authorization, updateTrailerRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerNoteResponse> {
            return localVarFp.updateTrailerNote(noteId, organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} authorization 
         * @param {UpdateTrailerStatusRequest} updateTrailerStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerStatus(organizationUnid: string, trailerId: string, authorization: string, updateTrailerStatusRequest: UpdateTrailerStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTrailerResponse> {
            return localVarFp.updateTrailerStatus(organizationUnid, trailerId, authorization, updateTrailerStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} trailerId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrailerStatusOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateTrailerStatusOptions(organizationUnid, trailerId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrailersApi - object-oriented interface
 * @export
 * @class TrailersApi
 * @extends {BaseAPI}
 */
export class TrailersApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateTrailerRequest} createTrailerRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public createTrailer(organizationUnid: string, authorization: string, createTrailerRequest: CreateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).createTrailer(organizationUnid, authorization, createTrailerRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public createTrailerNote(organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).createTrailerNote(organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public createTrailerOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).createTrailerOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public deleteTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).deleteTrailer(organizationUnid, trailerId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public deleteTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).deleteTrailerNote(noteId, organizationUnid, trailerId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public deleteTrailerNoteOptions(noteId: string, organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).deleteTrailerNoteOptions(noteId, organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public deleteTrailerOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).deleteTrailerOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [hasLiftGate] 
     * @param {number | null} [length] 
     * @param {string | null} [trailerType] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public getAvailableTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).getAvailableTrailers(organizationUnid, authorization, hasLiftGate, length, trailerType, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public getAvailableTrailersOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).getAvailableTrailersOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public getTrailer(organizationUnid: string, trailerId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).getTrailer(organizationUnid, trailerId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public listTrailerLocationHistory(organizationUnid: string, trailerId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).listTrailerLocationHistory(organizationUnid, trailerId, authorization, from, limit, page, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public listTrailerLocationHistoryOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).listTrailerLocationHistoryOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public listTrailerNotes(organizationUnid: string, trailerId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).listTrailerNotes(organizationUnid, trailerId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public listTrailerNotesOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).listTrailerNotesOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [hasLiftGate] 
     * @param {number | null} [length] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string | null} [trailerType] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public listTrailers(organizationUnid: string, authorization: string, hasLiftGate?: boolean | null, length?: number | null, limit?: number, page?: number, search?: string | null, status?: Array<string>, trailerType?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).listTrailers(organizationUnid, authorization, hasLiftGate, length, limit, page, search, status, trailerType, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public trailerAssignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).trailerAssignDriver(organizationUnid, trailerId, authorization, trailerAssignDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public trailerAssignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).trailerAssignDriverOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public trailerUnassignDriver(organizationUnid: string, trailerId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).trailerUnassignDriver(organizationUnid, trailerId, authorization, trailerUnassignDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public trailerUnassignDriverOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).trailerUnassignDriverOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {UpdateTrailerRequest} updateTrailerRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public updateTrailer(organizationUnid: string, trailerId: string, authorization: string, updateTrailerRequest: UpdateTrailerRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).updateTrailer(organizationUnid, trailerId, authorization, updateTrailerRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public updateTrailerNote(noteId: string, organizationUnid: string, trailerId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).updateTrailerNote(noteId, organizationUnid, trailerId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} authorization 
     * @param {UpdateTrailerStatusRequest} updateTrailerStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public updateTrailerStatus(organizationUnid: string, trailerId: string, authorization: string, updateTrailerStatusRequest: UpdateTrailerStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).updateTrailerStatus(organizationUnid, trailerId, authorization, updateTrailerStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} trailerId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrailersApi
     */
    public updateTrailerStatusOptions(organizationUnid: string, trailerId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrailersApiFp(this.configuration).updateTrailerStatusOptions(organizationUnid, trailerId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TruckMaintenanceApi - axios parameter creator
 * @export
 */
export const TruckMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenance: async (organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckMaintenance', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('getTruckMaintenance', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTruckMaintenance', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckMaintenanceOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('getTruckMaintenanceOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/maintenance`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TruckMaintenanceApi - functional programming interface
 * @export
 */
export const TruckMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TruckMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckMaintenance(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckMaintenance(organizationUnid, truckId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceApi.getTruckMaintenance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckMaintenanceOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckMaintenanceOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceApi.getTruckMaintenanceOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TruckMaintenanceApi - factory interface
 * @export
 */
export const TruckMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TruckMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenance(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceListResponse> {
            return localVarFp.getTruckMaintenance(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTruckMaintenanceOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TruckMaintenanceApi - object-oriented interface
 * @export
 * @class TruckMaintenanceApi
 * @extends {BaseAPI}
 */
export class TruckMaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceApi
     */
    public getTruckMaintenance(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceApiFp(this.configuration).getTruckMaintenance(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceApi
     */
    public getTruckMaintenanceOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceApiFp(this.configuration).getTruckMaintenanceOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TruckMaintenanceDetailApi - axios parameter creator
 * @export
 */
export const TruckMaintenanceDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckCompletedWorkOrders: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckCompletedWorkOrders', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckCompletedWorkOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTruckCompletedWorkOrders', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/work-orders/completed`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckCompletedWorkOrdersOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckCompletedWorkOrdersOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckCompletedWorkOrdersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/work-orders/completed`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceSchedules: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckMaintenanceSchedules', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckMaintenanceSchedules', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTruckMaintenanceSchedules', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/schedules`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceSchedulesOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckMaintenanceSchedulesOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckMaintenanceSchedulesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/schedules`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckOpenWorkOrders: async (equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckOpenWorkOrders', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckOpenWorkOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTruckOpenWorkOrders', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/work-orders/open`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckOpenWorkOrdersOptions: async (equipmentId: string, organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'equipmentId' is not null or undefined
            assertParamExists('getTruckOpenWorkOrdersOptions', 'equipmentId', equipmentId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruckOpenWorkOrdersOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/maintenance/trucks/{equipmentId}/work-orders/open`
                .replace(`{${"equipmentId"}}`, encodeURIComponent(String(equipmentId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TruckMaintenanceDetailApi - functional programming interface
 * @export
 */
export const TruckMaintenanceDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TruckMaintenanceDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckCompletedWorkOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckCompletedWorkOrdersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesMaintenanceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckMaintenanceSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckMaintenanceSchedulesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckOpenWorkOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruckOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruckOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckMaintenanceDetailApi.getTruckOpenWorkOrdersOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TruckMaintenanceDetailApi - factory interface
 * @export
 */
export const TruckMaintenanceDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TruckMaintenanceDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderListResponse> {
            return localVarFp.getTruckCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTruckCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [type] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesMaintenanceListResponse> {
            return localVarFp.getTruckMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTruckMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderListResponse> {
            return localVarFp.getTruckOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} equipmentId 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruckOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getTruckOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TruckMaintenanceDetailApi - object-oriented interface
 * @export
 * @class TruckMaintenanceDetailApi
 * @extends {BaseAPI}
 */
export class TruckMaintenanceDetailApi extends BaseAPI {
    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckCompletedWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckCompletedWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckCompletedWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckCompletedWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [type] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckMaintenanceSchedules(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, type?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckMaintenanceSchedules(equipmentId, organizationUnid, authorization, limit, page, type, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckMaintenanceSchedulesOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckMaintenanceSchedulesOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckOpenWorkOrders(equipmentId: string, organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckOpenWorkOrders(equipmentId, organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} equipmentId 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckMaintenanceDetailApi
     */
    public getTruckOpenWorkOrdersOptions(equipmentId: string, organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TruckMaintenanceDetailApiFp(this.configuration).getTruckOpenWorkOrdersOptions(equipmentId, organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrucksApi - axios parameter creator
 * @export
 */
export const TrucksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTruckRequest} createTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruck: async (organizationUnid: string, authorization: string, createTruckRequest: CreateTruckRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTruck', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTruck', 'authorization', authorization)
            // verify required parameter 'createTruckRequest' is not null or undefined
            assertParamExists('createTruck', 'createTruckRequest', createTruckRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTruckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruckNote: async (organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTruckNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('createTruckNote', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createTruckNote', 'authorization', authorization)
            // verify required parameter 'createTrailerNoteRequest' is not null or undefined
            assertParamExists('createTruckNote', 'createTrailerNoteRequest', createTrailerNoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrailerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruckOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createTruckOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruck: async (organizationUnid: string, truckId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTruck', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('deleteTruck', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTruck', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckNote: async (noteId: string, organizationUnid: string, truckId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteTruckNote', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTruckNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('deleteTruckNote', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteTruckNote', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckNoteOptions: async (noteId: string, organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteTruckNoteOptions', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTruckNoteOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('deleteTruckNoteOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteTruckOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('deleteTruckOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrucks: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableTrucks', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAvailableTrucks', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrucksOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getAvailableTrucksOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/available`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruck: async (organizationUnid: string, truckId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getTruck', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('getTruck', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTruck', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckLocationHistory: async (organizationUnid: string, truckId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckLocationHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckLocationHistory', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTruckLocationHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/location-history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckLocationHistoryOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckLocationHistoryOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckLocationHistoryOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/location-history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckNotes: async (organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckNotes', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckNotes', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTruckNotes', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckNotesOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTruckNotesOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('listTruckNotesOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasDriver] 
         * @param {number} [limit] 
         * @param {boolean | null} [needsService] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [truckType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrucks: async (organizationUnid: string, authorization: string, hasDriver?: boolean | null, limit?: number, needsService?: boolean | null, page?: number, search?: string | null, status?: Array<string>, truckType?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listTrucks', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listTrucks', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hasDriver !== undefined) {
                localVarQueryParameter['has_driver'] = hasDriver;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (needsService !== undefined) {
                localVarQueryParameter['needs_service'] = needsService;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (truckType !== undefined) {
                localVarQueryParameter['truck_type'] = truckType;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckAssignDriver: async (organizationUnid: string, truckId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('truckAssignDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('truckAssignDriver', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('truckAssignDriver', 'authorization', authorization)
            // verify required parameter 'trailerAssignDriverRequest' is not null or undefined
            assertParamExists('truckAssignDriver', 'trailerAssignDriverRequest', trailerAssignDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trailerAssignDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckAssignDriverOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('truckAssignDriverOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('truckAssignDriverOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/assign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckUnassignDriver: async (organizationUnid: string, truckId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('truckUnassignDriver', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('truckUnassignDriver', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('truckUnassignDriver', 'authorization', authorization)
            // verify required parameter 'trailerUnassignDriverRequest' is not null or undefined
            assertParamExists('truckUnassignDriver', 'trailerUnassignDriverRequest', trailerUnassignDriverRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/unassign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trailerUnassignDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckUnassignDriverOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('truckUnassignDriverOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('truckUnassignDriverOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/unassign`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckRequest} updateTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruck: async (organizationUnid: string, truckId: string, authorization: string, updateTruckRequest: UpdateTruckRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTruck', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('updateTruck', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTruck', 'authorization', authorization)
            // verify required parameter 'updateTruckRequest' is not null or undefined
            assertParamExists('updateTruck', 'updateTruckRequest', updateTruckRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTruckRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckNote: async (noteId: string, organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('updateTruckNote', 'noteId', noteId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTruckNote', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('updateTruckNote', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTruckNote', 'authorization', authorization)
            // verify required parameter 'createTrailerNoteRequest' is not null or undefined
            assertParamExists('updateTruckNote', 'createTrailerNoteRequest', createTrailerNoteRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrailerNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckStatusRequest} updateTruckStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckStatus: async (organizationUnid: string, truckId: string, authorization: string, updateTruckStatusRequest: UpdateTruckStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTruckStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('updateTruckStatus', 'truckId', truckId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateTruckStatus', 'authorization', authorization)
            // verify required parameter 'updateTruckStatusRequest' is not null or undefined
            assertParamExists('updateTruckStatus', 'updateTruckStatusRequest', updateTruckStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTruckStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckStatusOptions: async (organizationUnid: string, truckId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateTruckStatusOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'truckId' is not null or undefined
            assertParamExists('updateTruckStatusOptions', 'truckId', truckId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/trucks/{truckId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"truckId"}}`, encodeURIComponent(String(truckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrucksApi - functional programming interface
 * @export
 */
export const TrucksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrucksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTruckRequest} createTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTruck(organizationUnid: string, authorization: string, createTruckRequest: CreateTruckRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTruck(organizationUnid, authorization, createTruckRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.createTruck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTruckNote(organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTruckNote(organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.createTruckNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTruckOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTruckOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.createTruckOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTruck(organizationUnid, truckId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.deleteTruck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTruckNote(noteId, organizationUnid, truckId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.deleteTruckNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTruckNoteOptions(noteId: string, organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTruckNoteOptions(noteId, organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.deleteTruckNoteOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTruckOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTruckOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.deleteTruckOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTrucks(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesAvailableTrucksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTrucks(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.getAvailableTrucks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableTrucksOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableTrucksOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.getAvailableTrucksOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTruck(organizationUnid, truckId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.getTruck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckLocationHistory(organizationUnid: string, truckId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckLocationHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckLocationHistory(organizationUnid, truckId, authorization, from, limit, page, to, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.listTruckLocationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckLocationHistoryOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckLocationHistoryOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.listTruckLocationHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckNotes(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckNoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckNotes(organizationUnid, truckId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.listTruckNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTruckNotesOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTruckNotesOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.listTruckNotesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasDriver] 
         * @param {number} [limit] 
         * @param {boolean | null} [needsService] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [truckType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrucks(organizationUnid: string, authorization: string, hasDriver?: boolean | null, limit?: number, needsService?: boolean | null, page?: number, search?: string | null, status?: Array<string>, truckType?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrucks(organizationUnid, authorization, hasDriver, limit, needsService, page, search, status, truckType, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.listTrucks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckAssignDriver(organizationUnid: string, truckId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckAssignDriver(organizationUnid, truckId, authorization, trailerAssignDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.truckAssignDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckAssignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckAssignDriverOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.truckAssignDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckUnassignDriver(organizationUnid: string, truckId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckUnassignDriver(organizationUnid, truckId, authorization, trailerUnassignDriverRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.truckUnassignDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckUnassignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckUnassignDriverOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.truckUnassignDriverOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckRequest} updateTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTruck(organizationUnid: string, truckId: string, authorization: string, updateTruckRequest: UpdateTruckRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTruck(organizationUnid, truckId, authorization, updateTruckRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.updateTruck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTruckNote(noteId, organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.updateTruckNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckStatusRequest} updateTruckStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTruckStatus(organizationUnid: string, truckId: string, authorization: string, updateTruckStatusRequest: UpdateTruckStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesTruckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTruckStatus(organizationUnid, truckId, authorization, updateTruckStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.updateTruckStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTruckStatusOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTruckStatusOptions(organizationUnid, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrucksApi.updateTruckStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrucksApi - factory interface
 * @export
 */
export const TrucksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrucksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateTruckRequest} createTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruck(organizationUnid: string, authorization: string, createTruckRequest: CreateTruckRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.createTruck(organizationUnid, authorization, createTruckRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruckNote(organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckNoteResponse> {
            return localVarFp.createTruckNote(organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTruckOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createTruckOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTruck(organizationUnid, truckId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTruckNote(noteId, organizationUnid, truckId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckNoteOptions(noteId: string, organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTruckNoteOptions(noteId, organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTruckOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteTruckOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrucks(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesAvailableTrucksResponse> {
            return localVarFp.getAvailableTrucks(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableTrucksOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getAvailableTrucksOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.getTruck(organizationUnid, truckId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {string | null} [from] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [to] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckLocationHistory(organizationUnid: string, truckId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckLocationHistoryResponse> {
            return localVarFp.listTruckLocationHistory(organizationUnid, truckId, authorization, from, limit, page, to, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckLocationHistoryOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTruckLocationHistoryOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckNotes(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckNoteListResponse> {
            return localVarFp.listTruckNotes(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTruckNotesOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listTruckNotesOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {boolean | null} [hasDriver] 
         * @param {number} [limit] 
         * @param {boolean | null} [needsService] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [truckType] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrucks(organizationUnid: string, authorization: string, hasDriver?: boolean | null, limit?: number, needsService?: boolean | null, page?: number, search?: string | null, status?: Array<string>, truckType?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckListResponse> {
            return localVarFp.listTrucks(organizationUnid, authorization, hasDriver, limit, needsService, page, search, status, truckType, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckAssignDriver(organizationUnid: string, truckId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.truckAssignDriver(organizationUnid, truckId, authorization, trailerAssignDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckAssignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.truckAssignDriverOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckUnassignDriver(organizationUnid: string, truckId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.truckUnassignDriver(organizationUnid, truckId, authorization, trailerUnassignDriverRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckUnassignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.truckUnassignDriverOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckRequest} updateTruckRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruck(organizationUnid: string, truckId: string, authorization: string, updateTruckRequest: UpdateTruckRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.updateTruck(organizationUnid, truckId, authorization, updateTruckRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckNoteResponse> {
            return localVarFp.updateTruckNote(noteId, organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} authorization 
         * @param {UpdateTruckStatusRequest} updateTruckStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckStatus(organizationUnid: string, truckId: string, authorization: string, updateTruckStatusRequest: UpdateTruckStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesTruckResponse> {
            return localVarFp.updateTruckStatus(organizationUnid, truckId, authorization, updateTruckStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} truckId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTruckStatusOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateTruckStatusOptions(organizationUnid, truckId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrucksApi - object-oriented interface
 * @export
 * @class TrucksApi
 * @extends {BaseAPI}
 */
export class TrucksApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateTruckRequest} createTruckRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public createTruck(organizationUnid: string, authorization: string, createTruckRequest: CreateTruckRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).createTruck(organizationUnid, authorization, createTruckRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public createTruckNote(organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).createTruckNote(organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public createTruckOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).createTruckOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public deleteTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).deleteTruck(organizationUnid, truckId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public deleteTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).deleteTruckNote(noteId, organizationUnid, truckId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public deleteTruckNoteOptions(noteId: string, organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).deleteTruckNoteOptions(noteId, organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public deleteTruckOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).deleteTruckOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public getAvailableTrucks(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).getAvailableTrucks(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public getAvailableTrucksOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).getAvailableTrucksOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public getTruck(organizationUnid: string, truckId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).getTruck(organizationUnid, truckId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {string | null} [from] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [to] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public listTruckLocationHistory(organizationUnid: string, truckId: string, authorization: string, from?: string | null, limit?: number, page?: number, to?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).listTruckLocationHistory(organizationUnid, truckId, authorization, from, limit, page, to, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public listTruckLocationHistoryOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).listTruckLocationHistoryOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public listTruckNotes(organizationUnid: string, truckId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).listTruckNotes(organizationUnid, truckId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public listTruckNotesOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).listTruckNotesOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {boolean | null} [hasDriver] 
     * @param {number} [limit] 
     * @param {boolean | null} [needsService] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string | null} [truckType] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public listTrucks(organizationUnid: string, authorization: string, hasDriver?: boolean | null, limit?: number, needsService?: boolean | null, page?: number, search?: string | null, status?: Array<string>, truckType?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).listTrucks(organizationUnid, authorization, hasDriver, limit, needsService, page, search, status, truckType, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {TrailerAssignDriverRequest} trailerAssignDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public truckAssignDriver(organizationUnid: string, truckId: string, authorization: string, trailerAssignDriverRequest: TrailerAssignDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).truckAssignDriver(organizationUnid, truckId, authorization, trailerAssignDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public truckAssignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).truckAssignDriverOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {TrailerUnassignDriverRequest} trailerUnassignDriverRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public truckUnassignDriver(organizationUnid: string, truckId: string, authorization: string, trailerUnassignDriverRequest: TrailerUnassignDriverRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).truckUnassignDriver(organizationUnid, truckId, authorization, trailerUnassignDriverRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public truckUnassignDriverOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).truckUnassignDriverOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {UpdateTruckRequest} updateTruckRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public updateTruck(organizationUnid: string, truckId: string, authorization: string, updateTruckRequest: UpdateTruckRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).updateTruck(organizationUnid, truckId, authorization, updateTruckRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {CreateTrailerNoteRequest} createTrailerNoteRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public updateTruckNote(noteId: string, organizationUnid: string, truckId: string, authorization: string, createTrailerNoteRequest: CreateTrailerNoteRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).updateTruckNote(noteId, organizationUnid, truckId, authorization, createTrailerNoteRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} authorization 
     * @param {UpdateTruckStatusRequest} updateTruckStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public updateTruckStatus(organizationUnid: string, truckId: string, authorization: string, updateTruckStatusRequest: UpdateTruckStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).updateTruckStatus(organizationUnid, truckId, authorization, updateTruckStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} truckId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrucksApi
     */
    public updateTruckStatusOptions(organizationUnid: string, truckId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return TrucksApiFp(this.configuration).updateTruckStatusOptions(organizationUnid, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrganizations: async (authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getMyOrganizations', 'authorization', authorization)
            const localVarPath = `/api/v1/users/me/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrganizationsOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUploadUrl: async (fileExtension: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileExtension' is not null or undefined
            assertParamExists('getProfilePictureUploadUrl', 'fileExtension', fileExtension)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getProfilePictureUploadUrl', 'authorization', authorization)
            const localVarPath = `/api/v1/users/me/profile-picture/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileExtension !== undefined) {
                localVarQueryParameter['fileExtension'] = fileExtension;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUploadUrlOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/profile-picture/upload-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUserProfile', 'authorization', authorization)
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscription: async (authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUserSubscription', 'authorization', authorization)
            const localVarPath = `/api/v1/users/me/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscriptionOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteUserProfile: async (resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendConfirmationCodeRequest' is not null or undefined
            assertParamExists('requestDeleteUserProfile', 'resendConfirmationCodeRequest', resendConfirmationCodeRequest)
            const localVarPath = `/api/v1/users/requests/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendConfirmationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteUserProfileOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/requests/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (authorization: string, updateUserProfileRequest: UpdateUserProfileRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUserProfile', 'authorization', authorization)
            // verify required parameter 'updateUserProfileRequest' is not null or undefined
            assertParamExists('updateUserProfile', 'updateUserProfileRequest', updateUserProfileRequest)
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfileOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyDeleteUserProfileRequest} verifyDeleteUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDeleteUserProfile: async (verifyDeleteUserProfileRequest: VerifyDeleteUserProfileRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyDeleteUserProfileRequest' is not null or undefined
            assertParamExists('verifyDeleteUserProfile', 'verifyDeleteUserProfileRequest', verifyDeleteUserProfileRequest)
            const localVarPath = `/api/v1/users/requests/delete/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyDeleteUserProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDeleteUserProfileOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/requests/delete/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyOrganizations(authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesOrganizationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyOrganizations(authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getMyOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyOrganizationsOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyOrganizationsOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getMyOrganizationsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfilePictureUploadUrl(fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfilePictureUploadUrl(fileExtension, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getProfilePictureUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfilePictureUploadUrlOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfilePictureUploadUrlOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getProfilePictureUploadUrlOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSubscription(authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSubscriptionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSubscription(authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSubscriptionOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserSubscriptionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDeleteUserProfile(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDeleteUserProfile(resendConfirmationCodeRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.requestDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDeleteUserProfileOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.requestDeleteUserProfileOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(authorization: string, updateUserProfileRequest: UpdateUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(authorization, updateUserProfileRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfileOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserProfileOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyDeleteUserProfileRequest} verifyDeleteUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyDeleteUserProfile(verifyDeleteUserProfileRequest: VerifyDeleteUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyDeleteUserProfile(verifyDeleteUserProfileRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.verifyDeleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyDeleteUserProfileOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.verifyDeleteUserProfileOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrganizations(authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesOrganizationListResponse> {
            return localVarFp.getMyOrganizations(authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOrganizationsOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getMyOrganizationsOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileExtension 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUploadUrl(fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUploadUrlResponse> {
            return localVarFp.getProfilePictureUploadUrl(fileExtension, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePictureUploadUrlOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getProfilePictureUploadUrlOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUserProfileResponse> {
            return localVarFp.getUserProfile(authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscription(authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSubscriptionDetailResponse> {
            return localVarFp.getUserSubscription(authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getUserSubscriptionOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteUserProfile(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.requestDeleteUserProfile(resendConfirmationCodeRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.requestDeleteUserProfileOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization 
         * @param {UpdateUserProfileRequest} updateUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(authorization: string, updateUserProfileRequest: UpdateUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesUserProfileResponse> {
            return localVarFp.updateUserProfile(authorization, updateUserProfileRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateUserProfileOptions(origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyDeleteUserProfileRequest} verifyDeleteUserProfileRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDeleteUserProfile(verifyDeleteUserProfileRequest: VerifyDeleteUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.verifyDeleteUserProfile(verifyDeleteUserProfileRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.verifyDeleteUserProfileOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMyOrganizations(authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getMyOrganizations(authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getMyOrganizationsOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getMyOrganizationsOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileExtension 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getProfilePictureUploadUrl(fileExtension: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getProfilePictureUploadUrl(fileExtension, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getProfilePictureUploadUrlOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getProfilePictureUploadUrlOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserProfile(authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserProfile(authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserSubscription(authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserSubscription(authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserSubscriptionOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserSubscriptionOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestDeleteUserProfile(resendConfirmationCodeRequest: ResendConfirmationCodeRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestDeleteUserProfile(resendConfirmationCodeRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestDeleteUserProfileOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization 
     * @param {UpdateUserProfileRequest} updateUserProfileRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserProfile(authorization: string, updateUserProfileRequest: UpdateUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserProfile(authorization, updateUserProfileRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserProfileOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyDeleteUserProfileRequest} verifyDeleteUserProfileRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verifyDeleteUserProfile(verifyDeleteUserProfileRequest: VerifyDeleteUserProfileRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).verifyDeleteUserProfile(verifyDeleteUserProfileRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verifyDeleteUserProfileOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).verifyDeleteUserProfileOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VMRSApi - axios parameter creator
 * @export
 */
export const VMRSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [system] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVMRSCodes: async (authorization: string, system?: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listVMRSCodes', 'authorization', authorization)
            const localVarPath = `/api/v1/vmrs-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (system !== undefined) {
                localVarQueryParameter['system'] = system;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVMRSCodesOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/vmrs-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VMRSApi - functional programming interface
 * @export
 */
export const VMRSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VMRSApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [system] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVMRSCodes(authorization: string, system?: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesVMRSCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVMRSCodes(authorization, system, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMRSApi.listVMRSCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVMRSCodesOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVMRSCodesOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMRSApi.listVMRSCodesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VMRSApi - factory interface
 * @export
 */
export const VMRSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VMRSApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization 
         * @param {string} [system] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVMRSCodes(authorization: string, system?: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesVMRSCodesResponse> {
            return localVarFp.listVMRSCodes(authorization, system, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVMRSCodesOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.listVMRSCodesOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VMRSApi - object-oriented interface
 * @export
 * @class VMRSApi
 * @extends {BaseAPI}
 */
export class VMRSApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization 
     * @param {string} [system] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMRSApi
     */
    public listVMRSCodes(authorization: string, system?: string, origin?: string, options?: RawAxiosRequestConfig) {
        return VMRSApiFp(this.configuration).listVMRSCodes(authorization, system, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMRSApi
     */
    public listVMRSCodesOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return VMRSApiFp(this.configuration).listVMRSCodesOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhooksApi - axios parameter creator
 * @export
 */
export const WebhooksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Lambda|arn:aws:apigateway:us-east-1:lambda:path/2015-03-31/functions/arn:aws:lambda:us-east-1:267753040347:function:zuzhq-stripe-event-intake-dev/invocations
         * @param {HandleStripeWebhookRequest} handleStripeWebhookRequest 
         * @param {string} [origin] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook: async (handleStripeWebhookRequest: HandleStripeWebhookRequest, origin?: string, stripeSignature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'handleStripeWebhookRequest' is not null or undefined
            assertParamExists('handleStripeWebhook', 'handleStripeWebhookRequest', handleStripeWebhookRequest)
            const localVarPath = `/api/v1/webhooks/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            if (stripeSignature != null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(handleStripeWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhookOptions: async (origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhooks/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhooksApi - functional programming interface
 * @export
 */
export const WebhooksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhooksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Lambda|arn:aws:apigateway:us-east-1:lambda:path/2015-03-31/functions/arn:aws:lambda:us-east-1:267753040347:function:zuzhq-stripe-event-intake-dev/invocations
         * @param {HandleStripeWebhookRequest} handleStripeWebhookRequest 
         * @param {string} [origin] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStripeWebhook(handleStripeWebhookRequest: HandleStripeWebhookRequest, origin?: string, stripeSignature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStripeWebhook(handleStripeWebhookRequest, origin, stripeSignature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.handleStripeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStripeWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStripeWebhookOptions(origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhooksApi.handleStripeWebhookOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhooksApi - factory interface
 * @export
 */
export const WebhooksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhooksApiFp(configuration)
    return {
        /**
         * 
         * @summary Lambda|arn:aws:apigateway:us-east-1:lambda:path/2015-03-31/functions/arn:aws:lambda:us-east-1:267753040347:function:zuzhq-stripe-event-intake-dev/invocations
         * @param {HandleStripeWebhookRequest} handleStripeWebhookRequest 
         * @param {string} [origin] 
         * @param {string} [stripeSignature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhook(handleStripeWebhookRequest: HandleStripeWebhookRequest, origin?: string, stripeSignature?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWebhookResponse> {
            return localVarFp.handleStripeWebhook(handleStripeWebhookRequest, origin, stripeSignature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStripeWebhookOptions(origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.handleStripeWebhookOptions(origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhooksApi - object-oriented interface
 * @export
 * @class WebhooksApi
 * @extends {BaseAPI}
 */
export class WebhooksApi extends BaseAPI {
    /**
     * 
     * @summary Lambda|arn:aws:apigateway:us-east-1:lambda:path/2015-03-31/functions/arn:aws:lambda:us-east-1:267753040347:function:zuzhq-stripe-event-intake-dev/invocations
     * @param {HandleStripeWebhookRequest} handleStripeWebhookRequest 
     * @param {string} [origin] 
     * @param {string} [stripeSignature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public handleStripeWebhook(handleStripeWebhookRequest: HandleStripeWebhookRequest, origin?: string, stripeSignature?: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).handleStripeWebhook(handleStripeWebhookRequest, origin, stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhooksApi
     */
    public handleStripeWebhookOptions(origin?: string, options?: RawAxiosRequestConfig) {
        return WebhooksApiFp(this.configuration).handleStripeWebhookOptions(origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkOrderTasksApi - axios parameter creator
 * @export
 */
export const WorkOrderTasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskLaborRequest} addWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskLabor: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskLaborRequest: AddWorkOrderTaskLaborRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addWorkOrderTaskLabor', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('addWorkOrderTaskLabor', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('addWorkOrderTaskLabor', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addWorkOrderTaskLabor', 'authorization', authorization)
            // verify required parameter 'addWorkOrderTaskLaborRequest' is not null or undefined
            assertParamExists('addWorkOrderTaskLabor', 'addWorkOrderTaskLaborRequest', addWorkOrderTaskLaborRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/labor`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkOrderTaskLaborRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskLaborOptions: async (organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addWorkOrderTaskLaborOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('addWorkOrderTaskLaborOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('addWorkOrderTaskLaborOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/labor`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskPartRequest} addWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskPart: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskPartRequest: AddWorkOrderTaskPartRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addWorkOrderTaskPart', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('addWorkOrderTaskPart', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('addWorkOrderTaskPart', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addWorkOrderTaskPart', 'authorization', authorization)
            // verify required parameter 'addWorkOrderTaskPartRequest' is not null or undefined
            assertParamExists('addWorkOrderTaskPart', 'addWorkOrderTaskPartRequest', addWorkOrderTaskPartRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/parts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkOrderTaskPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskPartOptions: async (organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('addWorkOrderTaskPartOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('addWorkOrderTaskPartOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('addWorkOrderTaskPartOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/parts`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderTask: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('completeWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('completeWorkOrderTask', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('completeWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('completeWorkOrderTask', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('completeWorkOrderTask', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/complete`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderTaskOptions: async (organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('completeWorkOrderTaskOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('completeWorkOrderTaskOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('completeWorkOrderTaskOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/complete`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CreateWorkOrderTaskRequest} createWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderTask: async (organizationUnid: string, workOrderId: string, authorization: string, createWorkOrderTaskRequest: CreateWorkOrderTaskRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('createWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createWorkOrderTask', 'authorization', authorization)
            // verify required parameter 'createWorkOrderTaskRequest' is not null or undefined
            assertParamExists('createWorkOrderTask', 'createWorkOrderTaskRequest', createWorkOrderTaskRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderTaskOptions: async (organizationUnid: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderTaskOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('createWorkOrderTaskOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderTask: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteWorkOrderTask', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('deleteWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteWorkOrderTask', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderTaskOptions: async (organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteWorkOrderTaskOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteWorkOrderTaskOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('deleteWorkOrderTaskOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderTask: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getWorkOrderTask', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('getWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getWorkOrderTask', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkOrderTasks: async (organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listWorkOrderTasks', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('listWorkOrderTasks', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listWorkOrderTasks', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskLabor: async (laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'laborId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLabor', 'laborId', laborId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeWorkOrderTaskLabor', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLabor', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLabor', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('removeWorkOrderTaskLabor', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/labor/{laborId}`
                .replace(`{${"laborId"}}`, encodeURIComponent(String(laborId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskLaborOptions: async (laborId: string, organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'laborId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLaborOptions', 'laborId', laborId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeWorkOrderTaskLaborOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLaborOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('removeWorkOrderTaskLaborOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/labor/{laborId}`
                .replace(`{${"laborId"}}`, encodeURIComponent(String(laborId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskPart: async (organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeWorkOrderTaskPart', 'organizationUnid', organizationUnid)
            // verify required parameter 'partUsageId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPart', 'partUsageId', partUsageId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPart', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPart', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('removeWorkOrderTaskPart', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/parts/{partUsageId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partUsageId"}}`, encodeURIComponent(String(partUsageId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskPartOptions: async (organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('removeWorkOrderTaskPartOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'partUsageId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPartOptions', 'partUsageId', partUsageId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPartOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('removeWorkOrderTaskPartOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/parts/{partUsageId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partUsageId"}}`, encodeURIComponent(String(partUsageId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenWorkOrderTask: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('reopenWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('reopenWorkOrderTask', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('reopenWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('reopenWorkOrderTask', 'authorization', authorization)
            // verify required parameter 'acceptInvitationRequest' is not null or undefined
            assertParamExists('reopenWorkOrderTask', 'acceptInvitationRequest', acceptInvitationRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/reopen`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenWorkOrderTaskOptions: async (organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('reopenWorkOrderTaskOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('reopenWorkOrderTaskOptions', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('reopenWorkOrderTaskOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/reopen`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskRequest} updateWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTask: async (organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskRequest: UpdateWorkOrderTaskRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderTask', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateWorkOrderTask', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderTask', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateWorkOrderTask', 'authorization', authorization)
            // verify required parameter 'updateWorkOrderTaskRequest' is not null or undefined
            assertParamExists('updateWorkOrderTask', 'updateWorkOrderTaskRequest', updateWorkOrderTaskRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkOrderTaskRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskLaborRequest} updateWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTaskLabor: async (laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskLaborRequest: UpdateWorkOrderTaskLaborRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'laborId' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'laborId', laborId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'organizationUnid', organizationUnid)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'authorization', authorization)
            // verify required parameter 'updateWorkOrderTaskLaborRequest' is not null or undefined
            assertParamExists('updateWorkOrderTaskLabor', 'updateWorkOrderTaskLaborRequest', updateWorkOrderTaskLaborRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/labor/{laborId}`
                .replace(`{${"laborId"}}`, encodeURIComponent(String(laborId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkOrderTaskLaborRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskPartRequest} updateWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTaskPart: async (organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskPartRequest: UpdateWorkOrderTaskPartRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'organizationUnid', organizationUnid)
            // verify required parameter 'partUsageId' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'partUsageId', partUsageId)
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'taskId', taskId)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'authorization', authorization)
            // verify required parameter 'updateWorkOrderTaskPartRequest' is not null or undefined
            assertParamExists('updateWorkOrderTaskPart', 'updateWorkOrderTaskPartRequest', updateWorkOrderTaskPartRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/tasks/{taskId}/parts/{partUsageId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"partUsageId"}}`, encodeURIComponent(String(partUsageId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkOrderTaskPartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkOrderTasksApi - functional programming interface
 * @export
 */
export const WorkOrderTasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkOrderTasksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskLaborRequest} addWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWorkOrderTaskLabor(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskLaborRequest: AddWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskLaborResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWorkOrderTaskLabor(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskLaborRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.addWorkOrderTaskLabor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWorkOrderTaskLaborOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWorkOrderTaskLaborOptions(organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.addWorkOrderTaskLaborOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskPartRequest} addWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWorkOrderTaskPart(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskPartRequest: AddWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskPartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWorkOrderTaskPart(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskPartRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.addWorkOrderTaskPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addWorkOrderTaskPartOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addWorkOrderTaskPartOptions(organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.addWorkOrderTaskPartOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.completeWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.completeWorkOrderTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CreateWorkOrderTaskRequest} createWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderTask(organizationUnid: string, workOrderId: string, authorization: string, createWorkOrderTaskRequest: CreateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderTask(organizationUnid, workOrderId, authorization, createWorkOrderTaskRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.createWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderTaskOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderTaskOptions(organizationUnid, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.createWorkOrderTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.deleteWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.deleteWorkOrderTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.getWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkOrderTasks(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkOrderTasks(organizationUnid, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.listWorkOrderTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.removeWorkOrderTaskLabor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWorkOrderTaskLaborOptions(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWorkOrderTaskLaborOptions(laborId, organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.removeWorkOrderTaskLaborOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.removeWorkOrderTaskPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeWorkOrderTaskPartOptions(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeWorkOrderTaskPartOptions(organizationUnid, partUsageId, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.removeWorkOrderTaskPartOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopenWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopenWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.reopenWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopenWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopenWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.reopenWorkOrderTaskOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskRequest} updateWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskRequest: UpdateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.updateWorkOrderTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskLaborRequest} updateWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskLaborRequest: UpdateWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskLaborResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskLaborRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.updateWorkOrderTaskLabor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskPartRequest} updateWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskPartRequest: UpdateWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderTaskPartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, updateWorkOrderTaskPartRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrderTasksApi.updateWorkOrderTaskPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkOrderTasksApi - factory interface
 * @export
 */
export const WorkOrderTasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkOrderTasksApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskLaborRequest} addWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskLabor(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskLaborRequest: AddWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskLaborResponse> {
            return localVarFp.addWorkOrderTaskLabor(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskLaborRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskLaborOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addWorkOrderTaskLaborOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AddWorkOrderTaskPartRequest} addWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskPart(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskPartRequest: AddWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskPartResponse> {
            return localVarFp.addWorkOrderTaskPart(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskPartRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWorkOrderTaskPartOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.addWorkOrderTaskPartOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskResponse> {
            return localVarFp.completeWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.completeWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CreateWorkOrderTaskRequest} createWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderTask(organizationUnid: string, workOrderId: string, authorization: string, createWorkOrderTaskRequest: CreateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskResponse> {
            return localVarFp.createWorkOrderTask(organizationUnid, workOrderId, authorization, createWorkOrderTaskRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderTaskOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createWorkOrderTaskOptions(organizationUnid, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskResponse> {
            return localVarFp.getWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkOrderTasks(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskListResponse> {
            return localVarFp.listWorkOrderTasks(organizationUnid, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskLaborOptions(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeWorkOrderTaskLaborOptions(laborId, organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWorkOrderTaskPartOptions(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.removeWorkOrderTaskPartOptions(organizationUnid, partUsageId, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {AcceptInvitationRequest} acceptInvitationRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskResponse> {
            return localVarFp.reopenWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.reopenWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskRequest} updateWorkOrderTaskRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskRequest: UpdateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskResponse> {
            return localVarFp.updateWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} laborId 
         * @param {string} organizationUnid 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskLaborRequest} updateWorkOrderTaskLaborRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskLaborRequest: UpdateWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskLaborResponse> {
            return localVarFp.updateWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskLaborRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} partUsageId 
         * @param {string} taskId 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderTaskPartRequest} updateWorkOrderTaskPartRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskPartRequest: UpdateWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderTaskPartResponse> {
            return localVarFp.updateWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, updateWorkOrderTaskPartRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkOrderTasksApi - object-oriented interface
 * @export
 * @class WorkOrderTasksApi
 * @extends {BaseAPI}
 */
export class WorkOrderTasksApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {AddWorkOrderTaskLaborRequest} addWorkOrderTaskLaborRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public addWorkOrderTaskLabor(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskLaborRequest: AddWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).addWorkOrderTaskLabor(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskLaborRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public addWorkOrderTaskLaborOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).addWorkOrderTaskLaborOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {AddWorkOrderTaskPartRequest} addWorkOrderTaskPartRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public addWorkOrderTaskPart(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, addWorkOrderTaskPartRequest: AddWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).addWorkOrderTaskPart(organizationUnid, taskId, workOrderId, authorization, addWorkOrderTaskPartRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public addWorkOrderTaskPartOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).addWorkOrderTaskPartOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public completeWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).completeWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public completeWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).completeWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {CreateWorkOrderTaskRequest} createWorkOrderTaskRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public createWorkOrderTask(organizationUnid: string, workOrderId: string, authorization: string, createWorkOrderTaskRequest: CreateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).createWorkOrderTask(organizationUnid, workOrderId, authorization, createWorkOrderTaskRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public createWorkOrderTaskOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).createWorkOrderTaskOptions(organizationUnid, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public deleteWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).deleteWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public deleteWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).deleteWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public getWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).getWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public listWorkOrderTasks(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).listWorkOrderTasks(organizationUnid, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} laborId 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public removeWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).removeWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} laborId 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public removeWorkOrderTaskLaborOptions(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).removeWorkOrderTaskLaborOptions(laborId, organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partUsageId 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public removeWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).removeWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partUsageId 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public removeWorkOrderTaskPartOptions(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).removeWorkOrderTaskPartOptions(organizationUnid, partUsageId, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {AcceptInvitationRequest} acceptInvitationRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public reopenWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, acceptInvitationRequest: AcceptInvitationRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).reopenWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, acceptInvitationRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public reopenWorkOrderTaskOptions(organizationUnid: string, taskId: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).reopenWorkOrderTaskOptions(organizationUnid, taskId, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {UpdateWorkOrderTaskRequest} updateWorkOrderTaskRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public updateWorkOrderTask(organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskRequest: UpdateWorkOrderTaskRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).updateWorkOrderTask(organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} laborId 
     * @param {string} organizationUnid 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {UpdateWorkOrderTaskLaborRequest} updateWorkOrderTaskLaborRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public updateWorkOrderTaskLabor(laborId: string, organizationUnid: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskLaborRequest: UpdateWorkOrderTaskLaborRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).updateWorkOrderTaskLabor(laborId, organizationUnid, taskId, workOrderId, authorization, updateWorkOrderTaskLaborRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} partUsageId 
     * @param {string} taskId 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {UpdateWorkOrderTaskPartRequest} updateWorkOrderTaskPartRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrderTasksApi
     */
    public updateWorkOrderTaskPart(organizationUnid: string, partUsageId: string, taskId: string, workOrderId: string, authorization: string, updateWorkOrderTaskPartRequest: UpdateWorkOrderTaskPartRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrderTasksApiFp(this.configuration).updateWorkOrderTaskPart(organizationUnid, partUsageId, taskId, workOrderId, authorization, updateWorkOrderTaskPartRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkOrdersApi - axios parameter creator
 * @export
 */
export const WorkOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CompleteWorkOrderRequest} completeWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrder: async (organizationUnid: string, workOrderId: string, authorization: string, completeWorkOrderRequest: CompleteWorkOrderRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('completeWorkOrder', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('completeWorkOrder', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('completeWorkOrder', 'authorization', authorization)
            // verify required parameter 'completeWorkOrderRequest' is not null or undefined
            assertParamExists('completeWorkOrder', 'completeWorkOrderRequest', completeWorkOrderRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/complete`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWorkOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderOptions: async (organizationUnid: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('completeWorkOrderOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('completeWorkOrderOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/complete`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderRequest} createWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrder: async (organizationUnid: string, authorization: string, createWorkOrderRequest: CreateWorkOrderRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrder', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createWorkOrder', 'authorization', authorization)
            // verify required parameter 'createWorkOrderRequest' is not null or undefined
            assertParamExists('createWorkOrder', 'createWorkOrderRequest', createWorkOrderRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createWorkOrderOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrder: async (organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getWorkOrder', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('getWorkOrder', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getWorkOrder', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderHistory: async (organizationUnid: string, workOrderId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getWorkOrderHistory', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('getWorkOrderHistory', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getWorkOrderHistory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderHistoryOptions: async (organizationUnid: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getWorkOrderHistoryOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('getWorkOrderHistoryOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/history`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [assignedTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [priority] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [vendor] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkOrders: async (organizationUnid: string, authorization: string, assignedTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, page?: number, priority?: Array<string>, search?: string | null, status?: Array<string>, vendor?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listWorkOrders', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listWorkOrders', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assignedTo !== undefined) {
                localVarQueryParameter['assigned_to'] = assignedTo;
            }

            if (equipmentId !== undefined) {
                localVarQueryParameter['equipment_id'] = equipmentId;
            }

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (priority) {
                localVarQueryParameter['priority'] = priority;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (vendor !== undefined) {
                localVarQueryParameter['vendor'] = vendor;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderRequest} updateWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrder: async (organizationUnid: string, workOrderId: string, authorization: string, updateWorkOrderRequest: UpdateWorkOrderRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrder', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrder', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateWorkOrder', 'authorization', authorization)
            // verify required parameter 'updateWorkOrderRequest' is not null or undefined
            assertParamExists('updateWorkOrder', 'updateWorkOrderRequest', updateWorkOrderRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderOptions: async (organizationUnid: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderStatus: async (organizationUnid: string, workOrderId: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderStatus', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderStatus', 'workOrderId', workOrderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateWorkOrderStatus', 'authorization', authorization)
            // verify required parameter 'updateFactoringBatchStatusRequest' is not null or undefined
            assertParamExists('updateWorkOrderStatus', 'updateFactoringBatchStatusRequest', updateFactoringBatchStatusRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFactoringBatchStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderStatusOptions: async (organizationUnid: string, workOrderId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateWorkOrderStatusOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'workOrderId' is not null or undefined
            assertParamExists('updateWorkOrderStatusOptions', 'workOrderId', workOrderId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/work-orders/{workOrderId}/status`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkOrdersApi - functional programming interface
 * @export
 */
export const WorkOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CompleteWorkOrderRequest} completeWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, completeWorkOrderRequest: CompleteWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWorkOrder(organizationUnid, workOrderId, authorization, completeWorkOrderRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.completeWorkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeWorkOrderOptions(organizationUnid, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.completeWorkOrderOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderRequest} createWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrder(organizationUnid: string, authorization: string, createWorkOrderRequest: CreateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrder(organizationUnid, authorization, createWorkOrderRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.createWorkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkOrderOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkOrderOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.createWorkOrderOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrder(organizationUnid, workOrderId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.getWorkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkOrderHistory(organizationUnid: string, workOrderId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderHistory(organizationUnid, workOrderId, authorization, eventType, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.getWorkOrderHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkOrderHistoryOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderHistoryOptions(organizationUnid, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.getWorkOrderHistoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [assignedTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [priority] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [vendor] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkOrders(organizationUnid: string, authorization: string, assignedTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, page?: number, priority?: Array<string>, search?: string | null, status?: Array<string>, vendor?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkOrders(organizationUnid, authorization, assignedTo, equipmentId, equipmentType, limit, page, priority, search, status, vendor, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.listWorkOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderRequest} updateWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, updateWorkOrderRequest: UpdateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrder(organizationUnid, workOrderId, authorization, updateWorkOrderRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.updateWorkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderOptions(organizationUnid, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.updateWorkOrderOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderStatus(organizationUnid: string, workOrderId: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesWorkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderStatus(organizationUnid, workOrderId, authorization, updateFactoringBatchStatusRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.updateWorkOrderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkOrderStatusOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkOrderStatusOptions(organizationUnid, workOrderId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.updateWorkOrderStatusOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkOrdersApi - factory interface
 * @export
 */
export const WorkOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {CompleteWorkOrderRequest} completeWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, completeWorkOrderRequest: CompleteWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.completeWorkOrder(organizationUnid, workOrderId, authorization, completeWorkOrderRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.completeWorkOrderOptions(organizationUnid, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateWorkOrderRequest} createWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrder(organizationUnid: string, authorization: string, createWorkOrderRequest: CreateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.createWorkOrder(organizationUnid, authorization, createWorkOrderRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkOrderOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createWorkOrderOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.getWorkOrder(organizationUnid, workOrderId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderHistory(organizationUnid: string, workOrderId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderHistoryResponse> {
            return localVarFp.getWorkOrderHistory(organizationUnid, workOrderId, authorization, eventType, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderHistoryOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getWorkOrderHistoryOptions(organizationUnid, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [assignedTo] 
         * @param {string | null} [equipmentId] 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {Array<string>} [priority] 
         * @param {string | null} [search] 
         * @param {Array<string>} [status] 
         * @param {string | null} [vendor] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkOrders(organizationUnid: string, authorization: string, assignedTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, page?: number, priority?: Array<string>, search?: string | null, status?: Array<string>, vendor?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderListResponse> {
            return localVarFp.listWorkOrders(organizationUnid, authorization, assignedTo, equipmentId, equipmentType, limit, page, priority, search, status, vendor, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateWorkOrderRequest} updateWorkOrderRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, updateWorkOrderRequest: UpdateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.updateWorkOrder(organizationUnid, workOrderId, authorization, updateWorkOrderRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateWorkOrderOptions(organizationUnid, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} authorization 
         * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderStatus(organizationUnid: string, workOrderId: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesWorkOrderResponse> {
            return localVarFp.updateWorkOrderStatus(organizationUnid, workOrderId, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} workOrderId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkOrderStatusOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.updateWorkOrderStatusOptions(organizationUnid, workOrderId, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkOrdersApi - object-oriented interface
 * @export
 * @class WorkOrdersApi
 * @extends {BaseAPI}
 */
export class WorkOrdersApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {CompleteWorkOrderRequest} completeWorkOrderRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public completeWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, completeWorkOrderRequest: CompleteWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).completeWorkOrder(organizationUnid, workOrderId, authorization, completeWorkOrderRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public completeWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).completeWorkOrderOptions(organizationUnid, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateWorkOrderRequest} createWorkOrderRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public createWorkOrder(organizationUnid: string, authorization: string, createWorkOrderRequest: CreateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).createWorkOrder(organizationUnid, authorization, createWorkOrderRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public createWorkOrderOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).createWorkOrderOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public getWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).getWorkOrder(organizationUnid, workOrderId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {string | null} [eventType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public getWorkOrderHistory(organizationUnid: string, workOrderId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).getWorkOrderHistory(organizationUnid, workOrderId, authorization, eventType, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public getWorkOrderHistoryOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).getWorkOrderHistoryOptions(organizationUnid, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [assignedTo] 
     * @param {string | null} [equipmentId] 
     * @param {string | null} [equipmentType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {Array<string>} [priority] 
     * @param {string | null} [search] 
     * @param {Array<string>} [status] 
     * @param {string | null} [vendor] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public listWorkOrders(organizationUnid: string, authorization: string, assignedTo?: string | null, equipmentId?: string | null, equipmentType?: string | null, limit?: number, page?: number, priority?: Array<string>, search?: string | null, status?: Array<string>, vendor?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).listWorkOrders(organizationUnid, authorization, assignedTo, equipmentId, equipmentType, limit, page, priority, search, status, vendor, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {UpdateWorkOrderRequest} updateWorkOrderRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public updateWorkOrder(organizationUnid: string, workOrderId: string, authorization: string, updateWorkOrderRequest: UpdateWorkOrderRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).updateWorkOrder(organizationUnid, workOrderId, authorization, updateWorkOrderRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public updateWorkOrderOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).updateWorkOrderOptions(organizationUnid, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} authorization 
     * @param {UpdateFactoringBatchStatusRequest} updateFactoringBatchStatusRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public updateWorkOrderStatus(organizationUnid: string, workOrderId: string, authorization: string, updateFactoringBatchStatusRequest: UpdateFactoringBatchStatusRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).updateWorkOrderStatus(organizationUnid, workOrderId, authorization, updateFactoringBatchStatusRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} workOrderId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public updateWorkOrderStatusOptions(organizationUnid: string, workOrderId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).updateWorkOrderStatusOptions(organizationUnid, workOrderId, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * YardsApi - axios parameter creator
 * @export
 */
export const YardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTemplate: async (organizationUnid: string, authorization: string, createFormTemplateRequest: CreateFormTemplateRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createFormTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createFormTemplate', 'authorization', authorization)
            // verify required parameter 'createFormTemplateRequest' is not null or undefined
            assertParamExists('createFormTemplate', 'createFormTemplateRequest', createFormTemplateRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTemplateOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createFormTemplateOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {CreateSpotRequest} createSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpot: async (organizationUnid: string, yardId: string, authorization: string, createSpotRequest: CreateSpotRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createSpot', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('createSpot', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createSpot', 'authorization', authorization)
            // verify required parameter 'createSpotRequest' is not null or undefined
            assertParamExists('createSpot', 'createSpotRequest', createSpotRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSpotRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpotOptions: async (organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createSpotOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('createSpotOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateYardRequest} createYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYard: async (organizationUnid: string, authorization: string, createYardRequest: CreateYardRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createYard', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createYard', 'authorization', authorization)
            // verify required parameter 'createYardRequest' is not null or undefined
            assertParamExists('createYard', 'createYardRequest', createYardRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYardOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('createYardOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEvent', 'eventId', eventId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteEvent', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteEvent', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteEvent', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventOptions: async (eventId: string, organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteEventOptions', 'eventId', eventId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteEventOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteEventOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTemplate: async (organizationUnid: string, templateId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteFormTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteFormTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteFormTemplate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTemplateOptions: async (organizationUnid: string, templateId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteFormTemplateOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteFormTemplateOptions', 'templateId', templateId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpot: async (organizationUnid: string, spotId: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteSpot', 'organizationUnid', organizationUnid)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('deleteSpot', 'spotId', spotId)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteSpot', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteSpot', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots/{spotId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpotOptions: async (organizationUnid: string, spotId: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteSpotOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('deleteSpotOptions', 'spotId', spotId)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteSpotOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots/{spotId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYard: async (organizationUnid: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteYard', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteYard', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteYard', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYardOptions: async (organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('deleteYardOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('deleteYardOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscrepancies: async (organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDiscrepancies', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getDiscrepancies', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDiscrepancies', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/discrepancies`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscrepanciesOptions: async (organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getDiscrepanciesOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getDiscrepanciesOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/discrepancies`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent: async (eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEvent', 'eventId', eventId)
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getEvent', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getEvent', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getEvent', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [yardId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetYardOverview: async (organizationUnid: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, search?: string | null, yardId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetYardOverview', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFleetYardOverview', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/fleet-overview`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (yardId !== undefined) {
                localVarQueryParameter['yard_id'] = yardId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetYardOverviewOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFleetYardOverviewOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/fleet-overview`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormTemplate: async (organizationUnid: string, templateId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getFormTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getFormTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getFormTemplate', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory: async (organizationUnid: string, yardId: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInventory', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getInventory', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getInventory', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/inventory`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (equipmentType !== undefined) {
                localVarQueryParameter['equipment_type'] = equipmentType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOptions: async (organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getInventoryOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getInventoryOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/inventory`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYard: async (organizationUnid: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('getYard', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('getYard', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getYard', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [spotId] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents: async (organizationUnid: string, yardId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, spotId?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listEvents', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('listEvents', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listEvents', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (spotId !== undefined) {
                localVarQueryParameter['spot_id'] = spotId;
            }

            if (trailerId !== undefined) {
                localVarQueryParameter['trailer_id'] = trailerId;
            }

            if (truckId !== undefined) {
                localVarQueryParameter['truck_id'] = truckId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormTemplates: async (organizationUnid: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listFormTemplates', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listFormTemplates', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSpots: async (organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listSpots', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('listSpots', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listSpots', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listYards: async (organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('listYards', 'organizationUnid', organizationUnid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('listYards', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {LogEventRequest} logEventRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent: async (organizationUnid: string, yardId: string, authorization: string, logEventRequest: LogEventRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('logEvent', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('logEvent', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('logEvent', 'authorization', authorization)
            // verify required parameter 'logEventRequest' is not null or undefined
            assertParamExists('logEvent', 'logEventRequest', logEventRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEventOptions: async (organizationUnid: string, yardId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('logEventOptions', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('logEventOptions', 'yardId', yardId)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/events`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} eventType 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveFormTemplates: async (organizationUnid: string, eventType: string, yardId: string, authorization: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resolveFormTemplates', 'organizationUnid', organizationUnid)
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('resolveFormTemplates', 'eventType', eventType)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('resolveFormTemplates', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('resolveFormTemplates', 'authorization', authorization)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/resolve`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (yardId !== undefined) {
                localVarQueryParameter['yard_id'] = yardId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveFormTemplatesOptions: async (organizationUnid: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('resolveFormTemplatesOptions', 'organizationUnid', organizationUnid)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/resolve`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateFormTemplateRequest} updateFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormTemplate: async (organizationUnid: string, templateId: string, authorization: string, updateFormTemplateRequest: UpdateFormTemplateRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateFormTemplate', 'organizationUnid', organizationUnid)
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateFormTemplate', 'templateId', templateId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateFormTemplate', 'authorization', authorization)
            // verify required parameter 'updateFormTemplateRequest' is not null or undefined
            assertParamExists('updateFormTemplate', 'updateFormTemplateRequest', updateFormTemplateRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/form-templates/{templateId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFormTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateSpotRequest} updateSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpot: async (organizationUnid: string, spotId: string, yardId: string, authorization: string, updateSpotRequest: UpdateSpotRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateSpot', 'organizationUnid', organizationUnid)
            // verify required parameter 'spotId' is not null or undefined
            assertParamExists('updateSpot', 'spotId', spotId)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('updateSpot', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateSpot', 'authorization', authorization)
            // verify required parameter 'updateSpotRequest' is not null or undefined
            assertParamExists('updateSpot', 'updateSpotRequest', updateSpotRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}/spots/{spotId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"spotId"}}`, encodeURIComponent(String(spotId)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSpotRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateYardRequest} updateYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYard: async (organizationUnid: string, yardId: string, authorization: string, updateYardRequest: UpdateYardRequest, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUnid' is not null or undefined
            assertParamExists('updateYard', 'organizationUnid', organizationUnid)
            // verify required parameter 'yardId' is not null or undefined
            assertParamExists('updateYard', 'yardId', yardId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateYard', 'authorization', authorization)
            // verify required parameter 'updateYardRequest' is not null or undefined
            assertParamExists('updateYard', 'updateYardRequest', updateYardRequest)
            const localVarPath = `/api/v1/organizations/{organizationUnid}/yards/{yardId}`
                .replace(`{${"organizationUnid"}}`, encodeURIComponent(String(organizationUnid)))
                .replace(`{${"yardId"}}`, encodeURIComponent(String(yardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (origin != null) {
                localVarHeaderParameter['Origin'] = String(origin);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateYardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardsApi - functional programming interface
 * @export
 */
export const YardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormTemplate(organizationUnid: string, authorization: string, createFormTemplateRequest: CreateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormTemplate(organizationUnid, authorization, createFormTemplateRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFormTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFormTemplateOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createFormTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {CreateSpotRequest} createSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpot(organizationUnid: string, yardId: string, authorization: string, createSpotRequest: CreateSpotRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardSpotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpot(organizationUnid, yardId, authorization, createSpotRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createSpot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpotOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpotOptions(organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createSpotOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateYardRequest} createYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createYard(organizationUnid: string, authorization: string, createYardRequest: CreateYardRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createYard(organizationUnid, authorization, createYardRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createYard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createYardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createYardOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.createYardOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(eventId, organizationUnid, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventOptions(eventId: string, organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventOptions(eventId, organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteEventOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormTemplate(organizationUnid, templateId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFormTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFormTemplateOptions(organizationUnid, templateId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteFormTemplateOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSpot(organizationUnid, spotId, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteSpot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSpotOptions(organizationUnid: string, spotId: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSpotOptions(organizationUnid, spotId, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteSpotOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteYard(organizationUnid, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteYard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteYardOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteYardOptions(organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.deleteYardOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscrepancies(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardDiscrepanciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscrepancies(organizationUnid, yardId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getDiscrepancies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscrepanciesOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscrepanciesOptions(organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getDiscrepanciesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvent(eventId, organizationUnid, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [yardId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetYardOverview(organizationUnid: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, search?: string | null, yardId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFleetOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetYardOverview(organizationUnid, authorization, equipmentType, limit, page, search, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getFleetYardOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFleetYardOverviewOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFleetYardOverviewOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getFleetYardOverviewOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormTemplate(organizationUnid, templateId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventory(organizationUnid: string, yardId: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardInventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventory(organizationUnid, yardId, authorization, equipmentType, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getInventory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInventoryOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryOptions(organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getInventoryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getYard(organizationUnid, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.getYard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [spotId] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvents(organizationUnid: string, yardId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, spotId?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardEventListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(organizationUnid, yardId, authorization, eventType, limit, page, spotId, trailerId, truckId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.listEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormTemplates(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFormTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormTemplates(organizationUnid, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.listFormTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSpots(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardSpotListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSpots(organizationUnid, yardId, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.listSpots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listYards(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listYards(organizationUnid, authorization, limit, page, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.listYards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {LogEventRequest} logEventRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logEvent(organizationUnid: string, yardId: string, authorization: string, logEventRequest: LogEventRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logEvent(organizationUnid, yardId, authorization, logEventRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.logEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logEventOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logEventOptions(organizationUnid, yardId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.logEventOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} eventType 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveFormTemplates(organizationUnid: string, eventType: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFormTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveFormTemplates(organizationUnid, eventType, yardId, authorization, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.resolveFormTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveFormTemplatesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveFormTemplatesOptions(organizationUnid, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.resolveFormTemplatesOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateFormTemplateRequest} updateFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormTemplate(organizationUnid: string, templateId: string, authorization: string, updateFormTemplateRequest: UpdateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardFormTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFormTemplate(organizationUnid, templateId, authorization, updateFormTemplateRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.updateFormTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateSpotRequest} updateSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, updateSpotRequest: UpdateSpotRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardSpotResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpot(organizationUnid, spotId, yardId, authorization, updateSpotRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.updateSpot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateYardRequest} updateYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateYard(organizationUnid: string, yardId: string, authorization: string, updateYardRequest: UpdateYardRequest, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsesYardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateYard(organizationUnid, yardId, authorization, updateYardRequest, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardsApi.updateYard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardsApi - factory interface
 * @export
 */
export const YardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateFormTemplateRequest} createFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTemplate(organizationUnid: string, authorization: string, createFormTemplateRequest: CreateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFormTemplateResponse> {
            return localVarFp.createFormTemplate(organizationUnid, authorization, createFormTemplateRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFormTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createFormTemplateOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {CreateSpotRequest} createSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpot(organizationUnid: string, yardId: string, authorization: string, createSpotRequest: CreateSpotRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardSpotResponse> {
            return localVarFp.createSpot(organizationUnid, yardId, authorization, createSpotRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpotOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createSpotOptions(organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {CreateYardRequest} createYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYard(organizationUnid: string, authorization: string, createYardRequest: CreateYardRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardResponse> {
            return localVarFp.createYard(organizationUnid, authorization, createYardRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createYardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.createYardOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteEvent(eventId, organizationUnid, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventOptions(eventId: string, organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteEventOptions(eventId, organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteFormTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFormTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteFormTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteSpot(organizationUnid, spotId, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSpotOptions(organizationUnid: string, spotId: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteSpotOptions(organizationUnid, spotId, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteYard(organizationUnid, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteYardOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.deleteYardOptions(organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscrepancies(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardDiscrepanciesResponse> {
            return localVarFp.getDiscrepancies(organizationUnid, yardId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscrepanciesOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getDiscrepanciesOptions(organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eventId 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardEventResponse> {
            return localVarFp.getEvent(eventId, organizationUnid, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [search] 
         * @param {string | null} [yardId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetYardOverview(organizationUnid: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, search?: string | null, yardId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFleetOverviewResponse> {
            return localVarFp.getFleetYardOverview(organizationUnid, authorization, equipmentType, limit, page, search, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFleetYardOverviewOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getFleetYardOverviewOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFormTemplateResponse> {
            return localVarFp.getFormTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [equipmentType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory(organizationUnid: string, yardId: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardInventoryResponse> {
            return localVarFp.getInventory(organizationUnid, yardId, authorization, equipmentType, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.getInventoryOptions(organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardResponse> {
            return localVarFp.getYard(organizationUnid, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string | null} [eventType] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string | null} [spotId] 
         * @param {string | null} [trailerId] 
         * @param {string | null} [truckId] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents(organizationUnid: string, yardId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, spotId?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardEventListResponse> {
            return localVarFp.listEvents(organizationUnid, yardId, authorization, eventType, limit, page, spotId, trailerId, truckId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormTemplates(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFormTemplateListResponse> {
            return localVarFp.listFormTemplates(organizationUnid, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSpots(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardSpotListResponse> {
            return localVarFp.listSpots(organizationUnid, yardId, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listYards(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardListResponse> {
            return localVarFp.listYards(organizationUnid, authorization, limit, page, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {LogEventRequest} logEventRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEvent(organizationUnid: string, yardId: string, authorization: string, logEventRequest: LogEventRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardEventResponse> {
            return localVarFp.logEvent(organizationUnid, yardId, authorization, logEventRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logEventOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.logEventOptions(organizationUnid, yardId, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} eventType 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveFormTemplates(organizationUnid: string, eventType: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFormTemplateListResponse> {
            return localVarFp.resolveFormTemplates(organizationUnid, eventType, yardId, authorization, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveFormTemplatesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesSuccessResponse> {
            return localVarFp.resolveFormTemplatesOptions(organizationUnid, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} templateId 
         * @param {string} authorization 
         * @param {UpdateFormTemplateRequest} updateFormTemplateRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormTemplate(organizationUnid: string, templateId: string, authorization: string, updateFormTemplateRequest: UpdateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardFormTemplateResponse> {
            return localVarFp.updateFormTemplate(organizationUnid, templateId, authorization, updateFormTemplateRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} spotId 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateSpotRequest} updateSpotRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, updateSpotRequest: UpdateSpotRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardSpotResponse> {
            return localVarFp.updateSpot(organizationUnid, spotId, yardId, authorization, updateSpotRequest, origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} organizationUnid 
         * @param {string} yardId 
         * @param {string} authorization 
         * @param {UpdateYardRequest} updateYardRequest 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYard(organizationUnid: string, yardId: string, authorization: string, updateYardRequest: UpdateYardRequest, origin?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsesYardResponse> {
            return localVarFp.updateYard(organizationUnid, yardId, authorization, updateYardRequest, origin, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YardsApi - object-oriented interface
 * @export
 * @class YardsApi
 * @extends {BaseAPI}
 */
export class YardsApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateFormTemplateRequest} createFormTemplateRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createFormTemplate(organizationUnid: string, authorization: string, createFormTemplateRequest: CreateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createFormTemplate(organizationUnid, authorization, createFormTemplateRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createFormTemplateOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createFormTemplateOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {CreateSpotRequest} createSpotRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createSpot(organizationUnid: string, yardId: string, authorization: string, createSpotRequest: CreateSpotRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createSpot(organizationUnid, yardId, authorization, createSpotRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createSpotOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createSpotOptions(organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {CreateYardRequest} createYardRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createYard(organizationUnid: string, authorization: string, createYardRequest: CreateYardRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createYard(organizationUnid, authorization, createYardRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public createYardOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).createYardOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eventId 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteEvent(eventId, organizationUnid, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eventId 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteEventOptions(eventId: string, organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteEventOptions(eventId, organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteFormTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteFormTemplateOptions(organizationUnid: string, templateId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteFormTemplateOptions(organizationUnid, templateId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} spotId 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteSpot(organizationUnid, spotId, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} spotId 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteSpotOptions(organizationUnid: string, spotId: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteSpotOptions(organizationUnid, spotId, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteYard(organizationUnid, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public deleteYardOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).deleteYardOptions(organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getDiscrepancies(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getDiscrepancies(organizationUnid, yardId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getDiscrepanciesOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getDiscrepanciesOptions(organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eventId 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getEvent(eventId: string, organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getEvent(eventId, organizationUnid, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string | null} [equipmentType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [search] 
     * @param {string | null} [yardId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getFleetYardOverview(organizationUnid: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, search?: string | null, yardId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getFleetYardOverview(organizationUnid, authorization, equipmentType, limit, page, search, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getFleetYardOverviewOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getFleetYardOverviewOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getFormTemplate(organizationUnid: string, templateId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getFormTemplate(organizationUnid, templateId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string | null} [equipmentType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getInventory(organizationUnid: string, yardId: string, authorization: string, equipmentType?: string | null, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getInventory(organizationUnid, yardId, authorization, equipmentType, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getInventoryOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getInventoryOptions(organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public getYard(organizationUnid: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).getYard(organizationUnid, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string | null} [eventType] 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string | null} [spotId] 
     * @param {string | null} [trailerId] 
     * @param {string | null} [truckId] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public listEvents(organizationUnid: string, yardId: string, authorization: string, eventType?: string | null, limit?: number, page?: number, spotId?: string | null, trailerId?: string | null, truckId?: string | null, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).listEvents(organizationUnid, yardId, authorization, eventType, limit, page, spotId, trailerId, truckId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public listFormTemplates(organizationUnid: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).listFormTemplates(organizationUnid, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public listSpots(organizationUnid: string, yardId: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).listSpots(organizationUnid, yardId, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public listYards(organizationUnid: string, authorization: string, limit?: number, page?: number, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).listYards(organizationUnid, authorization, limit, page, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {LogEventRequest} logEventRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public logEvent(organizationUnid: string, yardId: string, authorization: string, logEventRequest: LogEventRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).logEvent(organizationUnid, yardId, authorization, logEventRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public logEventOptions(organizationUnid: string, yardId: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).logEventOptions(organizationUnid, yardId, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} eventType 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public resolveFormTemplates(organizationUnid: string, eventType: string, yardId: string, authorization: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).resolveFormTemplates(organizationUnid, eventType, yardId, authorization, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public resolveFormTemplatesOptions(organizationUnid: string, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).resolveFormTemplatesOptions(organizationUnid, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} templateId 
     * @param {string} authorization 
     * @param {UpdateFormTemplateRequest} updateFormTemplateRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public updateFormTemplate(organizationUnid: string, templateId: string, authorization: string, updateFormTemplateRequest: UpdateFormTemplateRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).updateFormTemplate(organizationUnid, templateId, authorization, updateFormTemplateRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} spotId 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {UpdateSpotRequest} updateSpotRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public updateSpot(organizationUnid: string, spotId: string, yardId: string, authorization: string, updateSpotRequest: UpdateSpotRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).updateSpot(organizationUnid, spotId, yardId, authorization, updateSpotRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} organizationUnid 
     * @param {string} yardId 
     * @param {string} authorization 
     * @param {UpdateYardRequest} updateYardRequest 
     * @param {string} [origin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YardsApi
     */
    public updateYard(organizationUnid: string, yardId: string, authorization: string, updateYardRequest: UpdateYardRequest, origin?: string, options?: RawAxiosRequestConfig) {
        return YardsApiFp(this.configuration).updateYard(organizationUnid, yardId, authorization, updateYardRequest, origin, options).then((request) => request(this.axios, this.basePath));
    }
}



